(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './KMP-library-engine.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./KMP-library-engine.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'org.androidworks.engine:shared'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'org.androidworks.engine:shared'.");
    }
    if (typeof this['KMP-library-engine'] === 'undefined') {
      throw new Error("Error loading module 'org.androidworks.engine:shared'. Its dependency 'KMP-library-engine' was not found. Please, check whether 'KMP-library-engine' is loaded prior to 'org.androidworks.engine:shared'.");
    }
    root['org.androidworks.engine:shared'] = factory(typeof this['org.androidworks.engine:shared'] === 'undefined' ? {} : this['org.androidworks.engine:shared'], this['kotlin-kotlin-stdlib'], this['KMP-library-engine']);
  }
}(this, function (_, kotlin_kotlin, kotlin_org_androidworks_engine_engine) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.g1;
  var classMeta = kotlin_kotlin.$_$.v;
  var setMetadataFor = kotlin_kotlin.$_$.h1;
  var VOID = kotlin_kotlin.$_$.b;
  var Vec3 = kotlin_org_androidworks_engine_engine.$_$.a3;
  var TextureAnimationChunked = kotlin_org_androidworks_engine_engine.$_$.f2;
  var objectMeta = kotlin_kotlin.$_$.f1;
  var CameraPosition = kotlin_org_androidworks_engine_engine.$_$.i2;
  var CameraPositionPair = kotlin_org_androidworks_engine_engine.$_$.h2;
  var getBooleanHashCode = kotlin_kotlin.$_$.y;
  var THROW_CCE = kotlin_kotlin.$_$.m1;
  var Vec4 = kotlin_org_androidworks_engine_engine.$_$.b3;
  var AttributeType_VERTEX_getInstance = kotlin_org_androidworks_engine_engine.$_$.p;
  var VertexFormat_HALF3_getInstance = kotlin_org_androidworks_engine_engine.$_$.n1;
  var MeshAttribute = kotlin_org_androidworks_engine_engine.$_$.n3;
  var AttributeType_U0_getInstance = kotlin_org_androidworks_engine_engine.$_$.m;
  var VertexFormat_HALF_getInstance = kotlin_org_androidworks_engine_engine.$_$.o1;
  var listOf = kotlin_kotlin.$_$.q;
  var MeshAttributes = kotlin_org_androidworks_engine_engine.$_$.m3;
  var VertexFormat_FLOAT3_getInstance = kotlin_org_androidworks_engine_engine.$_$.l1;
  var AttributeType_UV0_getInstance = kotlin_org_androidworks_engine_engine.$_$.n;
  var VertexFormat_HALF2_getInstance = kotlin_org_androidworks_engine_engine.$_$.m1;
  var listOf_0 = kotlin_kotlin.$_$.p;
  var VertexFormat_UBYTE_NORMALIZED_getInstance = kotlin_org_androidworks_engine_engine.$_$.q1;
  var VertexFormat_FLOAT2_getInstance = kotlin_org_androidworks_engine_engine.$_$.k1;
  var MeshConstructor2 = kotlin_org_androidworks_engine_engine.$_$.w1;
  var mutableListOf = kotlin_kotlin.$_$.t;
  var setUniform = kotlin_org_androidworks_engine_engine.$_$.y3;
  var setUniform_0 = kotlin_org_androidworks_engine_engine.$_$.w3;
  var setUniform_1 = kotlin_org_androidworks_engine_engine.$_$.u3;
  var List = kotlin_kotlin.$_$.k;
  var isInterface = kotlin_kotlin.$_$.c1;
  var Unit_instance = kotlin_kotlin.$_$.j;
  var setUniform_2 = kotlin_org_androidworks_engine_engine.$_$.v3;
  var ensureNotNull = kotlin_kotlin.$_$.o1;
  var Scene = kotlin_org_androidworks_engine_engine.$_$.o3;
  var TimersMap = kotlin_org_androidworks_engine_engine.$_$.c3;
  var get_HINT_VRS_4X4 = kotlin_org_androidworks_engine_engine.$_$.v2;
  var UniformTextureValue = kotlin_org_androidworks_engine_engine.$_$.r3;
  var CameraPathAnimator = kotlin_org_androidworks_engine_engine.$_$.g2;
  var ClearColorCommand = kotlin_org_androidworks_engine_engine.$_$.l2;
  var get_BLENDING_NONE = kotlin_org_androidworks_engine_engine.$_$.i3;
  var get_DEPTH_TEST_ENABLED = kotlin_org_androidworks_engine_engine.$_$.l3;
  var CullFace_BACK_getInstance = kotlin_org_androidworks_engine_engine.$_$.u;
  var VertexAttribute = kotlin_org_androidworks_engine_engine.$_$.t3;
  var VertexAttributesDescriptor = kotlin_org_androidworks_engine_engine.$_$.s3;
  var DrawMeshState = kotlin_org_androidworks_engine_engine.$_$.q2;
  var AffineTranformation = kotlin_org_androidworks_engine_engine.$_$.j2;
  var UniformFloatValueWithArray = kotlin_org_androidworks_engine_engine.$_$.y1;
  var DrawStaticMeshCommandConstructor = kotlin_org_androidworks_engine_engine.$_$.s1;
  var GroupCommand = kotlin_org_androidworks_engine_engine.$_$.t2;
  var DrawTransformedMeshCommand = kotlin_org_androidworks_engine_engine.$_$.s2;
  var UniformIntValueWithArray = kotlin_org_androidworks_engine_engine.$_$.z1;
  var GroupCommandArr = kotlin_org_androidworks_engine_engine.$_$.t1;
  var ClearCommand = kotlin_org_androidworks_engine_engine.$_$.m2;
  var ClearCommandClearType_COLOR_AND_DEPTH_getInstance = kotlin_org_androidworks_engine_engine.$_$.f;
  var VignetteCommand = kotlin_org_androidworks_engine_engine.$_$.y2;
  var MainPassCommandArr = kotlin_org_androidworks_engine_engine.$_$.u1;
  var BlurredPassCommand = kotlin_org_androidworks_engine_engine.$_$.k2;
  var BlurSize_KERNEL_4_getInstance = kotlin_org_androidworks_engine_engine.$_$.d;
  var DrawBlurredCommand = kotlin_org_androidworks_engine_engine.$_$.o2;
  var Default_getInstance = kotlin_kotlin.$_$.i;
  var Matrix_getInstance = kotlin_org_androidworks_engine_engine.$_$.d2;
  var CameraState_TRANSITIONING_getInstance = kotlin_org_androidworks_engine_engine.$_$.a;
  var Spline3D_init_$Create$ = kotlin_org_androidworks_engine_engine.$_$.r1;
  var THROW_IAE = kotlin_kotlin.$_$.n1;
  var Enum = kotlin_kotlin.$_$.l1;
  var defineProp = kotlin_kotlin.$_$.w;
  var Shader = kotlin_org_androidworks_engine_engine.$_$.p3;
  var Texture = kotlin_org_androidworks_engine_engine.$_$.q3;
  var TextureFormat_RGBA8_getInstance = kotlin_org_androidworks_engine_engine.$_$.d1;
  var TextureFiltering_NEAREST_getInstance = kotlin_org_androidworks_engine_engine.$_$.a1;
  var TextureWrapping_CLAMP_TO_EDGE_getInstance = kotlin_org_androidworks_engine_engine.$_$.g1;
  var TextureFiltering_LINEAR_getInstance = kotlin_org_androidworks_engine_engine.$_$.z;
  var TextureFormat_ASTC_getInstance = kotlin_org_androidworks_engine_engine.$_$.b1;
  var TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance = kotlin_org_androidworks_engine_engine.$_$.x;
  var TextureFormat_RGBA16F_getInstance = kotlin_org_androidworks_engine_engine.$_$.c1;
  var Command = kotlin_org_androidworks_engine_engine.$_$.n2;
  var CommandType_CUSTOM_getInstance = kotlin_org_androidworks_engine_engine.$_$.g;
  var get_HINT_VRS_NONE = kotlin_org_androidworks_engine_engine.$_$.w2;
  var ColorMode_Normal_getInstance = kotlin_org_androidworks_engine_engine.$_$.j;
  var MeshConstructor1 = kotlin_org_androidworks_engine_engine.$_$.v1;
  var BlurSize_KERNEL_5_getInstance = kotlin_org_androidworks_engine_engine.$_$.e;
  var Blending = kotlin_org_androidworks_engine_engine.$_$.j3;
  var BlendingEquation_ADD_getInstance = kotlin_org_androidworks_engine_engine.$_$.q;
  var BlendingFactor_ONE_getInstance = kotlin_org_androidworks_engine_engine.$_$.s;
  var BlurSize_KERNEL_3_getInstance = kotlin_org_androidworks_engine_engine.$_$.c;
  var get_HINT_VRS_2X2 = kotlin_org_androidworks_engine_engine.$_$.u2;
  var ColorMode_Sepia_getInstance = kotlin_org_androidworks_engine_engine.$_$.k;
  var arrayConcat = kotlin_kotlin.$_$.a;
  var BlurSize_KERNEL_2_getInstance = kotlin_org_androidworks_engine_engine.$_$.b;
  var setUniform_3 = kotlin_org_androidworks_engine_engine.$_$.z3;
  var MathUtils_instance = kotlin_org_androidworks_engine_engine.$_$.c2;
  var setUniform_4 = kotlin_org_androidworks_engine_engine.$_$.x3;
  var OrbitingCameraConfig = kotlin_org_androidworks_engine_engine.$_$.e3;
  var OrbitingCamera = kotlin_org_androidworks_engine_engine.$_$.f3;
  var CullFace_DISABLED_getInstance = kotlin_org_androidworks_engine_engine.$_$.v;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.c;
  var copyToArray = kotlin_kotlin.$_$.m;
  var get_DEPTH_NO_WRITE = kotlin_org_androidworks_engine_engine.$_$.k3;
  var PrimitiveDrawType_NON_INDEXED_getInstance = kotlin_org_androidworks_engine_engine.$_$.h;
  var getStringHashCode = kotlin_kotlin.$_$.a1;
  var TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance = kotlin_org_androidworks_engine_engine.$_$.y;
  var TextureWrapping_REPEAT_getInstance = kotlin_org_androidworks_engine_engine.$_$.h1;
  var AttributeType_NORMAL_getInstance = kotlin_org_androidworks_engine_engine.$_$.l;
  var CullFace_FRONT_getInstance = kotlin_org_androidworks_engine_engine.$_$.w;
  var BlendingFactor_SRC_ALPHA_getInstance = kotlin_org_androidworks_engine_engine.$_$.t;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.d;
  var Companion_instance = kotlin_org_androidworks_engine_engine.$_$.e2;
  var BlendingFactor_ONE_MINUS_SRC_ALPHA_getInstance = kotlin_org_androidworks_engine_engine.$_$.r;
  var TextureType_SSAO_getInstance = kotlin_org_androidworks_engine_engine.$_$.f1;
  var Aabb = kotlin_org_androidworks_engine_engine.$_$.d3;
  var Companion_instance_0 = kotlin_org_androidworks_engine_engine.$_$.a2;
  var Companion_instance_1 = kotlin_org_androidworks_engine_engine.$_$.b2;
  var VertexFormat_UBYTE2_NORMALIZED_getInstance = kotlin_org_androidworks_engine_engine.$_$.p1;
  var VertexFormat_BYTE3_NORMALIZED_getInstance = kotlin_org_androidworks_engine_engine.$_$.j1;
  var getNumberHashCode = kotlin_kotlin.$_$.z;
  var equals = kotlin_kotlin.$_$.x;
  var get_PI = kotlin_kotlin.$_$.j1;
  var coerceIn = kotlin_kotlin.$_$.k1;
  var AttributeType_UV1_getInstance = kotlin_org_androidworks_engine_engine.$_$.o;
  var cullDrawCalls = kotlin_org_androidworks_engine_engine.$_$.h3;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.p1;
  var get_PIf = kotlin_org_androidworks_engine_engine.$_$.g3;
  var DrawMeshCommand = kotlin_org_androidworks_engine_engine.$_$.p2;
  var SsaoPassCommand = kotlin_org_androidworks_engine_engine.$_$.x2;
  var DrawSsaoCommand = kotlin_org_androidworks_engine_engine.$_$.r2;
  var to = kotlin_kotlin.$_$.q1;
  var mapOf = kotlin_kotlin.$_$.s;
  var ShaderConstructor2 = kotlin_org_androidworks_engine_engine.$_$.x1;
  var mapOf_0 = kotlin_kotlin.$_$.r;
  var Vec2 = kotlin_org_androidworks_engine_engine.$_$.z2;
  var setUniform_5 = kotlin_org_androidworks_engine_engine.$_$.b4;
  var VertexFormat_BYTE2_NORMALIZED_getInstance = kotlin_org_androidworks_engine_engine.$_$.i1;
  var PrimitiveType_POINTS_getInstance = kotlin_org_androidworks_engine_engine.$_$.i;
  var setUniform_6 = kotlin_org_androidworks_engine_engine.$_$.a4;
  var TextureType_CUBEMAP_getInstance = kotlin_org_androidworks_engine_engine.$_$.e1;
  var toString = kotlin_kotlin.$_$.i1;
  var hashCode = kotlin_kotlin.$_$.b1;
  var objectCreate = kotlin_kotlin.$_$.e1;
  //endregion
  //region block: pre-declaration
  setMetadataFor(AnimatedObjectInfoBase, 'AnimatedObjectInfoBase', classMeta, VOID, VOID, AnimatedObjectInfoBase);
  setMetadataFor(AnimatedObjectInfo, 'AnimatedObjectInfo', classMeta, AnimatedObjectInfoBase, VOID, AnimatedObjectInfo);
  setMetadataFor(SplineAnimatedObjectInfo, 'SplineAnimatedObjectInfo', classMeta, AnimatedObjectInfoBase, VOID, SplineAnimatedObjectInfo);
  setMetadataFor(Animations, 'Animations', objectMeta);
  setMetadataFor(Cameras, 'Cameras', objectMeta);
  setMetadataFor(SceneColors, 'SceneColors', classMeta);
  setMetadataFor(Colors, 'Colors', objectMeta);
  setMetadataFor(Meshes, 'Meshes', objectMeta);
  setMetadataFor(Penguins, 'Penguins', objectMeta);
  setMetadataFor(ArcticScene, 'ArcticScene', classMeta, Scene, VOID, ArcticScene);
  setMetadataFor(Seals, 'Seals', objectMeta);
  setMetadataFor(TimeOfDay, 'TimeOfDay', classMeta, Enum);
  setMetadataFor(ArcticSettings, 'ArcticSettings', classMeta, VOID, VOID, ArcticSettings);
  setMetadataFor(Shaders, 'Shaders', objectMeta);
  setMetadataFor(ShipConfig, 'ShipConfig', classMeta);
  setMetadataFor(ShipsConfig, 'ShipsConfig', objectMeta);
  setMetadataFor(Textures, 'Textures', objectMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(Timers, 'Timers', classMeta, Enum);
  setMetadataFor(Cameras_0, 'Cameras', objectMeta);
  setMetadataFor(DrawClockCommand, 'DrawClockCommand', classMeta, Command, VOID, DrawClockCommand);
  setMetadataFor(BrutalismScene, 'BrutalismScene', classMeta, Scene, VOID, BrutalismScene);
  setMetadataFor(BrutalismSettings, 'BrutalismSettings', classMeta, VOID, VOID, BrutalismSettings);
  setMetadataFor(Cameras_1, 'Cameras', objectMeta);
  setMetadataFor(Meshes_0, 'Meshes', objectMeta);
  setMetadataFor(Preset, 'Preset', classMeta, VOID, VOID, Preset);
  setMetadataFor(Presets, 'Presets', objectMeta);
  setMetadataFor(CartoonLighthouseScene, 'CartoonLighthouseScene', classMeta, Scene, VOID, CartoonLighthouseScene);
  setMetadataFor(TimeOfDay_0, 'TimeOfDay', classMeta, Enum);
  setMetadataFor(CameraMode, 'CameraMode', classMeta, Enum);
  setMetadataFor(ColorMode, 'ColorMode', classMeta, Enum);
  setMetadataFor(CartoonLighthouseSettings, 'CartoonLighthouseSettings', classMeta, VOID, VOID, CartoonLighthouseSettings);
  setMetadataFor(Shaders_0, 'Shaders', objectMeta);
  setMetadataFor(SimpleTexture, 'SimpleTexture', classMeta);
  setMetadataFor(Textures_0, 'Textures', objectMeta);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(Timers_0, 'Timers', classMeta, Enum);
  setMetadataFor(Meshes_1, 'Meshes', objectMeta);
  setMetadataFor(Props, 'Props', objectMeta);
  setMetadataFor(CartoonPlanesScene, 'CartoonPlanesScene', classMeta, Scene, VOID, CartoonPlanesScene);
  setMetadataFor(TimeOfDay_1, 'TimeOfDay', classMeta, Enum);
  setMetadataFor(CartoonPlanesSettings, 'CartoonPlanesSettings', classMeta, VOID, VOID, CartoonPlanesSettings);
  setMetadataFor(Shaders_1, 'Shaders', objectMeta);
  setMetadataFor(Textures_1, 'Textures', objectMeta);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(Timers_1, 'Timers', classMeta, Enum);
  setMetadataFor(Animations_0, 'Animations', objectMeta);
  setMetadataFor(Cameras_2, 'Cameras', objectMeta);
  setMetadataFor(CommonAssetForgeTextures, 'CommonAssetForgeTextures', objectMeta);
  setMetadataFor(Flames, 'Flames', objectMeta);
  setMetadataFor(Ghosts, 'Ghosts', objectMeta);
  setMetadataFor(ImportedAssetForgeCommands, 'ImportedAssetForgeCommands', objectMeta);
  setMetadataFor(ImportedAssetForgeMeshes, 'ImportedAssetForgeMeshes', objectMeta);
  setMetadataFor(ImportedAssetForgeTextures, 'ImportedAssetForgeTextures', objectMeta);
  setMetadataFor(LeavesParticleSystemConfig, 'LeavesParticleSystemConfig', classMeta, VOID, VOID, LeavesParticleSystemConfig);
  setMetadataFor(Particle, 'Particle', classMeta);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(LeavesParticleSystem, 'LeavesParticleSystem', classMeta);
  setMetadataFor(Meshes_2, 'Meshes', objectMeta);
  setMetadataFor(Preset_0, 'Preset', classMeta);
  setMetadataFor(Presets_0, 'Presets', objectMeta);
  setMetadataFor(CemeteryScene, 'CemeteryScene', classMeta, Scene, VOID, CemeteryScene);
  setMetadataFor(TimeOfDay_2, 'TimeOfDay', classMeta, Enum);
  setMetadataFor(CameraMode_0, 'CameraMode', classMeta, Enum);
  setMetadataFor(ColorMode_0, 'ColorMode', classMeta, Enum);
  setMetadataFor(RenderMode, 'RenderMode', classMeta, Enum);
  setMetadataFor(CemeterySettings, 'CemeterySettings', classMeta, VOID, VOID, CemeterySettings);
  setMetadataFor(Shaders_2, 'Shaders', objectMeta);
  setMetadataFor(Textures_2, 'Textures', objectMeta);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor(Timers_2, 'Timers', classMeta, Enum);
  setMetadataFor(Animations_1, 'Animations', objectMeta);
  setMetadataFor(Cameras_3, 'Cameras', objectMeta);
  setMetadataFor(CommonAssetForgeTextures_0, 'CommonAssetForgeTextures', objectMeta);
  setMetadataFor(Flames_0, 'Flames', objectMeta);
  setMetadataFor(Ghosts_0, 'Ghosts', objectMeta);
  setMetadataFor(ImportedAssetForgeCommands_0, 'ImportedAssetForgeCommands', objectMeta);
  setMetadataFor(ImportedAssetForgeMeshes_0, 'ImportedAssetForgeMeshes', objectMeta);
  setMetadataFor(ImportedAssetForgeTextures_0, 'ImportedAssetForgeTextures', objectMeta);
  setMetadataFor(LeavesParticleSystemConfig_0, 'LeavesParticleSystemConfig', classMeta, VOID, VOID, LeavesParticleSystemConfig_0);
  setMetadataFor(Particle_0, 'Particle', classMeta);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor(LeavesParticleSystem_0, 'LeavesParticleSystem', classMeta);
  setMetadataFor(Meshes_3, 'Meshes', objectMeta);
  setMetadataFor(ExampleScene, 'ExampleScene', classMeta, Scene, VOID, ExampleScene);
  setMetadataFor(TimeOfDay_3, 'TimeOfDay', classMeta, Enum);
  setMetadataFor(CameraMode_1, 'CameraMode', classMeta, Enum);
  setMetadataFor(ColorMode_1, 'ColorMode', classMeta, Enum);
  setMetadataFor(RenderMode_0, 'RenderMode', classMeta, Enum);
  setMetadataFor(ShipwreckSettings, 'ShipwreckSettings', classMeta, VOID, VOID, ShipwreckSettings);
  setMetadataFor(Shaders_3, 'Shaders', objectMeta);
  setMetadataFor(Textures_3, 'Textures', objectMeta);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor(Timers_3, 'Timers', classMeta, Enum);
  setMetadataFor(CommonAssetForgeShaders, 'CommonAssetForgeShaders', objectMeta);
  setMetadataFor(Cameras_4, 'Cameras', objectMeta);
  setMetadataFor(Lantern, 'Lantern', classMeta);
  setMetadataFor(Meshes_4, 'Meshes', objectMeta);
  setMetadataFor(Preset_1, 'Preset', classMeta);
  setMetadataFor(Presets_1, 'Presets', objectMeta);
  setMetadataFor(ShipwreckScene, 'ShipwreckScene', classMeta, Scene, VOID, ShipwreckScene);
  setMetadataFor(TimeOfDay_4, 'TimeOfDay', classMeta, Enum);
  setMetadataFor(CameraMode_2, 'CameraMode', classMeta, Enum);
  setMetadataFor(ColorMode_2, 'ColorMode', classMeta, Enum);
  setMetadataFor(ShipwreckSettings_0, 'ShipwreckSettings', classMeta, VOID, VOID, ShipwreckSettings_0);
  setMetadataFor(Shaders_4, 'Shaders', objectMeta);
  setMetadataFor(Textures_4, 'Textures', objectMeta);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor(Timers_4, 'Timers', classMeta, Enum);
  setMetadataFor(Cameras_5, 'Cameras', objectMeta);
  setMetadataFor(Meshes_5, 'Meshes', objectMeta);
  setMetadataFor(SkyscrapersScene, 'SkyscrapersScene', classMeta, Scene, VOID, SkyscrapersScene);
  setMetadataFor(SkyscrapersSettings, 'SkyscrapersSettings', classMeta, VOID, VOID, SkyscrapersSettings);
  setMetadataFor(Shaders_5, 'Shaders', objectMeta);
  setMetadataFor(Textures_5, 'Textures', objectMeta);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(Timers_5, 'Timers', classMeta, Enum);
  setMetadataFor(WindParams, 'WindParams', classMeta);
  setMetadataFor(Wind, 'Wind', classMeta);
  //endregion
  function AnimatedObjectInfoBase() {
    this.hk_1 = 0.0;
    this.ik_1 = 0.0;
  }
  function AnimatedObjectInfo() {
    AnimatedObjectInfoBase.call(this);
    this.lk_1 = new Vec3();
    this.mk_1 = new Vec3();
  }
  function SplineAnimatedObjectInfo() {
    AnimatedObjectInfoBase.call(this);
    this.pk_1 = null;
  }
  function Animations() {
    Animations_instance = this;
    this.qk_1 = new TextureAnimationChunked(133, 133, 3);
    this.rk_1 = new TextureAnimationChunked(341, 341, 15);
    this.sk_1 = new TextureAnimationChunked(238, 238, 10);
    this.tk_1 = new TextureAnimationChunked(263, 263, 9);
    this.uk_1 = new TextureAnimationChunked(263, 263, 12);
  }
  var Animations_instance;
  function Animations_getInstance() {
    if (Animations_instance == null)
      new Animations();
    return Animations_instance;
  }
  function Cameras() {
    Cameras_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.vk_1 = [new CameraPositionPair(new CameraPosition(new Vec3(-20834.791, 47426.33, 2531.646), new Vec3(-25922.844, 23601.791, 886.872)), new CameraPosition(new Vec3(10194.038, -1464.044, 886.872), new Vec3(918.405, -14209.802, 886.872)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-4109.569, 11284.58, 2531.646), new Vec3(-26652.816, 1825.736, 886.872)), new CameraPosition(new Vec3(4167.435, 9801.106, 886.872), new Vec3(20338.879, -12121.901, 886.872)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-1316.869, -26605.557, 730.833), new Vec3(7972.117, -8640.933, 156.916)), new CameraPosition(new Vec3(5633.813, -2835.024, 590.909), new Vec3(7054.362, -11628.732, 156.916)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(1058.602, -6343.349, 7252.608), new Vec3(12343.629, -9785.771, 156.916)), new CameraPosition(new Vec3(10627.578, -5523.65, 952.352), new Vec3(7975.851, -12773.571, 156.916)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-15084.583, -6685.166, 1734.204), new Vec3(-7877.742, -11902.989, 156.916)), new CameraPosition(new Vec3(-5300.519, -8189.871, 2864.12), new Vec3(-14072.867, -12477.64, 156.916)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-12847.906, 6333.75, 388.651), new Vec3(-9402.603, 9611.532, 156.916)), new CameraPosition(new Vec3(-7762.645, 7800.965, 3749.253), new Vec3(-11462.321, 8195.902, 156.916)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-22389.021, 1075.924, 5119.1), new Vec3(-6829.5, 16726.61, 3154.788)), new CameraPosition(new Vec3(-23767.002, 14537.841, 5001.777), new Vec3(1434.719, 1224.992, 4490.559)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-35127.016, 27564.738, 886.872), new Vec3(-7923.539, 14634.557, 886.872)), new CameraPosition(new Vec3(-24081.432, -14828.664, 886.872), new Vec3(-7150.61, -5201.194, 886.872)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-26917.791, 18527.285, 3173.479), new Vec3(-19059.227, 11528.038, 886.872)), new CameraPosition(new Vec3(1437.67, 4945.704, 571.601), new Vec3(6268.789, -4323.603, 886.872)), 1.0)];
  }
  var Cameras_instance;
  function Cameras_getInstance() {
    if (Cameras_instance == null)
      new Cameras();
    return Cameras_instance;
  }
  function SceneColors(isDay, isLowSun, drawBirds, birds, clouds, stars, waterColorNear, waterColorFar, distantZFogColor) {
    this.wk_1 = isDay;
    this.xk_1 = isLowSun;
    this.yk_1 = drawBirds;
    this.zk_1 = birds;
    this.al_1 = clouds;
    this.bl_1 = stars;
    this.cl_1 = waterColorNear;
    this.dl_1 = waterColorFar;
    this.el_1 = distantZFogColor;
  }
  protoOf(SceneColors).toString = function () {
    return 'SceneColors(isDay=' + this.wk_1 + ', isLowSun=' + this.xk_1 + ', drawBirds=' + this.yk_1 + ', birds=' + this.zk_1 + ', clouds=' + this.al_1 + ', stars=' + this.bl_1 + ', waterColorNear=' + this.cl_1 + ', waterColorFar=' + this.dl_1 + ', distantZFogColor=' + this.el_1 + ')';
  };
  protoOf(SceneColors).hashCode = function () {
    var result = getBooleanHashCode(this.wk_1);
    result = imul(result, 31) + getBooleanHashCode(this.xk_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.yk_1) | 0;
    result = imul(result, 31) + this.zk_1.hashCode() | 0;
    result = imul(result, 31) + this.al_1.hashCode() | 0;
    result = imul(result, 31) + this.bl_1.hashCode() | 0;
    result = imul(result, 31) + this.cl_1.hashCode() | 0;
    result = imul(result, 31) + this.dl_1.hashCode() | 0;
    result = imul(result, 31) + this.el_1.hashCode() | 0;
    return result;
  };
  protoOf(SceneColors).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SceneColors))
      return false;
    var tmp0_other_with_cast = other instanceof SceneColors ? other : THROW_CCE();
    if (!(this.wk_1 === tmp0_other_with_cast.wk_1))
      return false;
    if (!(this.xk_1 === tmp0_other_with_cast.xk_1))
      return false;
    if (!(this.yk_1 === tmp0_other_with_cast.yk_1))
      return false;
    if (!this.zk_1.equals(tmp0_other_with_cast.zk_1))
      return false;
    if (!this.al_1.equals(tmp0_other_with_cast.al_1))
      return false;
    if (!this.bl_1.equals(tmp0_other_with_cast.bl_1))
      return false;
    if (!this.cl_1.equals(tmp0_other_with_cast.cl_1))
      return false;
    if (!this.dl_1.equals(tmp0_other_with_cast.dl_1))
      return false;
    if (!this.el_1.equals(tmp0_other_with_cast.el_1))
      return false;
    return true;
  };
  function Colors() {
    Colors_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.fl_1 = [new SceneColors(true, false, true, new Vec4(0.3137254901960784, 0.3137254901960784, 0.3137254901960784, 1.0), new Vec4(0.8666666666666667, 0.9725490196078431, 1.0, 0.3), new Vec4(0.8666666666666667, 0.9725490196078431, 1.0, 0.3), new Vec4(0.21568627450980393, 0.6313725490196078, 0.8274509803921568), new Vec4(0.5137254901960784, 0.8352941176470589, 0.8901960784313725), new Vec4(1.0, 1.0, 1.0, 0.75)), new SceneColors(false, false, false, new Vec4(1.0, 0.0, 0.0, 1.0), new Vec4(0.058823529411764705, 0.2627450980392157, 0.3843137254901961, 0.3), new Vec4(1.0, 1.0, 1.0, 1.0), new Vec4(0.03529411764705882, 0.17254901960784313, 0.3215686274509804), new Vec4(0.043137254901960784, 0.12156862745098039, 0.2196078431372549), new Vec4(0.2627450980392157, 0.4823529411764706, 0.611764705882353, 0.75)), new SceneColors(true, true, true, new Vec4(0.49411764705882355, 0.42745098039215684, 0.26666666666666666, 1.0), new Vec4(0.9294117647058824, 0.7490196078431373, 0.38823529411764707, 0.3), new Vec4(0.8666666666666667, 0.9725490196078431, 1.0, 0.3), new Vec4(0.592156862745098, 0.6313725490196078, 0.5098039215686274), new Vec4(0.8509803921568627, 0.7333333333333333, 0.5372549019607843), new Vec4(0.8980392156862745, 0.8745098039215686, 0.7137254901960784, 0.75)), new SceneColors(true, true, false, new Vec4(0.3686274509803922, 0.17647058823529413, 0.20784313725490197, 1.0), new Vec4(0.4549019607843137, 0.2784313725490196, 0.5019607843137255, 0.3), new Vec4(1.0, 1.0, 1.0, 1.0), new Vec4(0.0784313725490196, 0.20784313725490197, 0.4549019607843137), new Vec4(0.25882352941176473, 0.24313725490196078, 0.5098039215686274), new Vec4(0.8823529411764706, 0.6745098039215687, 0.8392156862745098, 0.75))];
  }
  var Colors_instance;
  function Colors_getInstance() {
    if (Colors_instance == null)
      new Colors();
    return Colors_instance;
  }
  function Meshes() {
    Meshes_instance = this;
    this.gl_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_U0_getInstance(), VertexFormat_HALF_getInstance(), 6)]), 8);
    this.hl_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_FLOAT3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 12)]), 16);
    this.il_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6)]), 12);
    this.jl_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0)), 8);
    this.kl_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_FLOAT3_getInstance(), 0)), 12);
    this.ll_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_FLOAT3_getInstance(), 0), new MeshAttribute(AttributeType_U0_getInstance(), VertexFormat_UBYTE_NORMALIZED_getInstance(), 12)]), 16);
    this.ml_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_FLOAT2_getInstance(), 0)), 4);
    this.nl_1 = MeshConstructor2('mountains1', this.gl_1);
    this.ol_1 = MeshConstructor2('mountains_distant1', this.gl_1);
    this.pl_1 = MeshConstructor2('sun', this.hl_1);
    this.ql_1 = MeshConstructor2('sun2', this.hl_1);
    this.rl_1 = MeshConstructor2('water_test', this.il_1);
    this.sl_1 = MeshConstructor2('sky', this.hl_1);
    this.tl_1 = MeshConstructor2('stars', this.kl_1);
    this.ul_1 = MeshConstructor2('clouds', this.ll_1);
    this.vl_1 = MeshConstructor2('bird1');
    this.wl_1 = MeshConstructor2('ship', this.gl_1);
    this.xl_1 = MeshConstructor2('penguin-idle', this.ml_1);
    this.yl_1 = MeshConstructor2('penguin-idle2', this.ml_1);
    this.zl_1 = MeshConstructor2('seal-idle', this.ml_1);
    this.am_1 = MeshConstructor2('animals_sleeping', this.hl_1);
    this.bm_1 = mutableListOf([this.pl_1, this.ql_1, this.nl_1, this.ol_1, this.rl_1, this.sl_1, this.tl_1, this.ul_1, this.vl_1, this.wl_1, this.xl_1, this.yl_1, this.zl_1, this.am_1]);
  }
  var Meshes_instance;
  function Meshes_getInstance() {
    if (Meshes_instance == null)
      new Meshes();
    return Meshes_instance;
  }
  function Penguins() {
    Penguins_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.apply' call
    var this_0 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE.<anonymous>' call
    this_0.lk_1 = new Vec3(-10793.156, 7192.894, 37.26);
    this_0.mk_1 = new Vec3(0.0, 0.0, -160.0);
    this_0.hk_1 = 0.88;
    this_0.ik_1 = 0.5;
    var tmp_0 = this_0;
    // Inline function 'kotlin.apply' call
    var this_1 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE.<anonymous>' call
    this_1.lk_1 = new Vec3(-10851.307, 7243.238, 37.26);
    this_1.mk_1 = new Vec3(0.0, 0.0, 70.0);
    this_1.hk_1 = 0.75;
    this_1.ik_1 = 0.25;
    var tmp_1 = this_1;
    // Inline function 'kotlin.apply' call
    var this_2 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE.<anonymous>' call
    this_2.lk_1 = new Vec3(-10762.938, 7258.693, 37.26);
    this_2.mk_1 = new Vec3(0.0, 0.0, 0.0);
    this_2.hk_1 = 0.65;
    this_2.ik_1 = 0.77;
    var tmp_2 = this_2;
    // Inline function 'kotlin.apply' call
    var this_3 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE.<anonymous>' call
    this_3.lk_1 = new Vec3(-10280.157, 8529.577, 69.556);
    this_3.mk_1 = new Vec3(0.0, 0.0, -20.0);
    this_3.hk_1 = 0.65;
    this_3.ik_1 = 0.2;
    var tmp_3 = this_3;
    // Inline function 'kotlin.apply' call
    var this_4 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE.<anonymous>' call
    this_4.lk_1 = new Vec3(-10359.45, 8782.093, 69.556);
    this_4.mk_1 = new Vec3(0.0, 0.0, 70.0);
    this_4.hk_1 = 0.77;
    this_4.ik_1 = 0.35;
    var tmp_4 = this_4;
    // Inline function 'kotlin.apply' call
    var this_5 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE.<anonymous>' call
    this_5.lk_1 = new Vec3(-10081.696, 8657.917, 69.556);
    this_5.mk_1 = new Vec3(0.0, 0.0, -160.0);
    this_5.hk_1 = 0.85;
    this_5.ik_1 = 0.75;
    var tmp_5 = this_5;
    // Inline function 'kotlin.apply' call
    var this_6 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE.<anonymous>' call
    this_6.lk_1 = new Vec3(-10150.821, 9009.801, 69.556);
    this_6.mk_1 = new Vec3(0.0, 0.0, 130.0);
    this_6.hk_1 = 0.7;
    this_6.ik_1 = 0.66;
    var tmp_6 = this_6;
    // Inline function 'kotlin.apply' call
    var this_7 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE.<anonymous>' call
    this_7.lk_1 = new Vec3(-10006.514, 8820.707, 69.556);
    this_7.mk_1 = new Vec3(0.0, 0.0, -90.0);
    this_7.hk_1 = 0.8;
    this_7.ik_1 = 0.8;
    var tmp_7 = this_7;
    // Inline function 'kotlin.apply' call
    var this_8 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE.<anonymous>' call
    this_8.lk_1 = new Vec3(-9890.24, 8932.688, 69.556);
    this_8.mk_1 = new Vec3(0.0, 0.0, 140.0);
    this_8.hk_1 = 0.85;
    this_8.ik_1 = 0.5;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.cm_1 = [tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, this_8];
    var tmp_8 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.apply' call
    var this_9 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE2.<anonymous>' call
    this_9.lk_1 = new Vec3(-12338.941, 6764.751, 33.536);
    this_9.mk_1 = new Vec3(0.0, 0.0, 180.0);
    this_9.hk_1 = 0.9;
    this_9.ik_1 = 0.2;
    var tmp_9 = this_9;
    // Inline function 'kotlin.apply' call
    var this_10 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE2.<anonymous>' call
    this_10.lk_1 = new Vec3(-12192.411, 6887.637, 33.536);
    this_10.mk_1 = new Vec3(0.0, 0.0, -135.0);
    this_10.hk_1 = 0.8;
    this_10.ik_1 = 0.33;
    var tmp_10 = this_10;
    // Inline function 'kotlin.apply' call
    var this_11 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE2.<anonymous>' call
    this_11.lk_1 = new Vec3(-12480.681, 6825.791, 33.536);
    this_11.mk_1 = new Vec3(0.0, 0.0, 160.0);
    this_11.hk_1 = 0.75;
    this_11.ik_1 = 0.5;
    var tmp_11 = this_11;
    // Inline function 'kotlin.apply' call
    var this_12 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE2.<anonymous>' call
    this_12.lk_1 = new Vec3(-10744.105, 7007.923, 33.536);
    this_12.mk_1 = new Vec3(0.0, 0.0, -160.0);
    this_12.hk_1 = 0.75;
    this_12.ik_1 = 0.5;
    var tmp_12 = this_12;
    // Inline function 'kotlin.apply' call
    var this_13 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE2.<anonymous>' call
    this_13.lk_1 = new Vec3(-11312.577, 8120.395, 33.536);
    this_13.mk_1 = new Vec3(0.0, 0.0, 50.0);
    this_13.hk_1 = 0.75;
    this_13.ik_1 = 0.75;
    var tmp_13 = this_13;
    // Inline function 'kotlin.apply' call
    var this_14 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Penguins.IDLE2.<anonymous>' call
    this_14.lk_1 = new Vec3(-10070.444, 7941.108, 65.833);
    this_14.mk_1 = new Vec3(0.0, 0.0, 155.0);
    this_14.hk_1 = 0.75;
    this_14.ik_1 = 0.8;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_8.dm_1 = [tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, this_14];
  }
  var Penguins_instance;
  function Penguins_getInstance() {
    if (Penguins_instance == null)
      new Penguins();
    return Penguins_instance;
  }
  function toggleDayNightObjects($this) {
    var isDay = Colors_getInstance().fl_1[$this.settings.timeOfDay.n4_1].wk_1;
    $this.commandStars.enabled = !isDay;
    $this.groupBirds.enabled = isDay;
    $this.groupAnimalsAnimated.enabled = isDay;
    $this.groupAnimalsSleeping.enabled = !isDay;
    $this.groupShips.enabled = isDay;
  }
  function updateColors($this) {
    var colors = Colors_getInstance().fl_1[$this.settings.timeOfDay.n4_1];
    setUniform($this.vm_1.t(2), colors.el_1.r, colors.el_1.g, colors.el_1.b, colors.el_1.a);
    setUniform_0($this.vm_1.t(3), 0.0, 1500.0);
    setUniform($this.xm_1.t(1), colors.bl_1.r, colors.bl_1.g, colors.bl_1.b, colors.bl_1.a);
    setUniform($this.ym_1.t(1), colors.al_1.r, colors.al_1.g, colors.al_1.b, colors.al_1.a);
    var tmp = $this.ym_1.t(2);
    // Inline function 'kotlin.math.sin' call
    var x = $this.timers.nj(Timers_CloudsAnimation_getInstance()) * $this.PIf * 2.0;
    var tmp$ret$0 = Math.sin(x);
    setUniform_1(tmp, tmp$ret$0);
    $this.commandClouds.transform.z9_1.z = $this.timers.nj(Timers_CloudsRotation_getInstance()) * 360.0;
  }
  function updateWater($this) {
    var colors = Colors_getInstance().fl_1[$this.settings.timeOfDay.n4_1];
    var k = 0.2;
    var timeFract = $this.timers.nj(Timers_Water_getInstance()) * 80.0 * k % 1.0;
    timeFract = timeFract / k;
    setUniform_1($this.wm_1.t(2), timeFract);
    setUniform_1($this.wm_1.t(3), $this.timers.nj(Timers_WaterLarge_getInstance()));
    setUniform_1($this.wm_1.t(4), 15.0);
    setUniform($this.wm_1.t(7), colors.cl_1.r, colors.cl_1.g, colors.cl_1.b, colors.cl_1.a);
    setUniform($this.wm_1.t(8), colors.dl_1.r, colors.dl_1.g, colors.dl_1.b, colors.dl_1.a);
    setUniform_0($this.wm_1.t(5), 10000.0, 15000.0);
    setUniform($this.wm_1.t(6), 5000.0, 2000.0, 1.0, $this.settings.blurred ? 100.0 : 20000.0);
  }
  function updateTimeOfDayTextures($this) {
    $this.uniformPaletteTexture.value = Textures_getInstance().pn_1[$this.settings.timeOfDay.n4_1];
    $this.uniformSkyTexture.value = Textures_getInstance().qn_1[$this.settings.timeOfDay.n4_1];
  }
  function updateSun($this) {
    var colors = Colors_getInstance().fl_1[$this.settings.timeOfDay.n4_1];
    $this.commandSun.enabled = !colors.xk_1;
    $this.commandSunLow.enabled = colors.xk_1;
  }
  function updateBirds($this) {
    var tmp = $this.groupBirds.commands;
    var commands = isInterface(tmp, List) ? tmp : THROW_CCE();
    var angle = $this.timers.nj(Timers_BirdsFly_getInstance()) * $this.PIf * 2.0;
    setBirdPosition($this, angle, 0.0, 0.0, commands.t(0).transform.y9_1);
    setBirdPosition($this, -angle - $this.PIf, 0.0, -4000.0, commands.t(1).transform.y9_1);
    setBirdPosition($this, -angle - $this.PIf, 0.0, 3000.0, commands.t(2).transform.y9_1);
    setBirdPosition($this, angle, 7000.0, 3000.0, commands.t(3).transform.y9_1);
    setBirdPosition($this, -angle - $this.PIf, 5000.0, 3000.0, commands.t(4).transform.y9_1);
    setBirdPosition($this, angle, -5000.0, 7000.0, commands.t(5).transform.y9_1);
    commands.t(0).transform.z9_1.z = (-angle + $this.PIf / 2.0) * 57.29578;
    commands.t(1).transform.z9_1.z = (angle + $this.PIf / 2.0) * 57.29578;
    commands.t(2).transform.z9_1.z = (angle + $this.PIf / 2.0) * 57.29578;
    commands.t(3).transform.z9_1.z = (-angle + $this.PIf / 2.0) * 57.29578;
    commands.t(4).transform.z9_1.z = (angle + $this.PIf / 2.0) * 57.29578;
    commands.t(5).transform.z9_1.z = (-angle + $this.PIf / 2.0) * 57.29578;
    var wingTimer1 = $this.timers.nj(Timers_BirdWings1_getInstance());
    var wingTimer2 = $this.timers.nj(Timers_BirdWings2_getInstance());
    setAnimationUniforms$default($this, wingTimer1, Animations_getInstance().qk_1, commands.t(0).uniforms);
    setAnimationUniforms$default($this, wingTimer2, Animations_getInstance().qk_1, commands.t(1).uniforms);
    setAnimationUniforms$default($this, wingTimer1 + 0.3, Animations_getInstance().qk_1, commands.t(2).uniforms);
    setAnimationUniforms$default($this, wingTimer2 + 0.5, Animations_getInstance().qk_1, commands.t(3).uniforms);
    setAnimationUniforms$default($this, wingTimer1 + 0.5, Animations_getInstance().qk_1, commands.t(4).uniforms);
    setAnimationUniforms$default($this, wingTimer2 + 0.6, Animations_getInstance().qk_1, commands.t(5).uniforms);
    var tmp0_iterator = commands.j();
    while (tmp0_iterator.k()) {
      var command = tmp0_iterator.l();
      setUniform(command.uniforms.t(1), 0.1640625, 0.1484375, 0.1171875, 1.0);
    }
  }
  function setBirdPosition($this, angle, centerX, centerY, translation) {
    // Inline function 'kotlin.math.sin' call
    translation.x = Math.sin(angle) * $this.BIRD_FLIGHT_RADIUS + centerX;
    // Inline function 'kotlin.math.cos' call
    translation.y = Math.cos(angle) * $this.BIRD_FLIGHT_RADIUS + centerY;
  }
  function setAnimationUniforms($this, timerAnim, animation, uniforms, startEndStart) {
    var timer = timerAnim % 1.0;
    setUniform_2(uniforms.t(2), animation.vb_1);
    setUniform_1(uniforms.t(3), 1.0 / animation.ac_1);
    setUniform(uniforms.t(5), animation.vb_1, animation.xb_1, startEndStart ? animation.cc(timer) : animation.dc(timer), animation.bc_1);
  }
  function setAnimationUniforms$default($this, timerAnim, animation, uniforms, startEndStart, $super) {
    startEndStart = startEndStart === VOID ? true : startEndStart;
    return setAnimationUniforms($this, timerAnim, animation, uniforms, startEndStart);
  }
  function updateShips($this) {
    var tmp = $this.groupShips.commands;
    var commandsShips = isInterface(tmp, List) ? tmp : THROW_CCE();
    var timerSpline = $this.timers.nj(Timers_Ships_getInstance());
    var inductionVariable = 0;
    var last = ShipsConfig_getInstance().rn_1.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ship = ShipsConfig_getInstance().rn_1[i];
        var command = commandsShips.t(i);
        var position = ship.sn_1.ce(timerSpline);
        var rotation = ship.sn_1.je(timerSpline).z + 180.0;
        command.transform.y9_1.x = position.x;
        command.transform.y9_1.y = position.y;
        command.transform.y9_1.z = position.z;
        command.transform.z9_1.z = rotation;
        command.transform.aa_1.x = ship.tn_1;
        command.transform.aa_1.y = ship.tn_1;
        command.transform.aa_1.z = ship.tn_1;
      }
       while (inductionVariable < last);
  }
  function updateAnimalsAnimated($this) {
    var timerPenguinIdle = $this.timers.nj(Timers_PenguinIdle_getInstance());
    var timerPenguinIdle2 = $this.timers.nj(Timers_PenguinIdle2_getInstance());
    var timerSealIdle = $this.timers.nj(Timers_SealIdleAnim_getInstance());
    var timerSealWalk = $this.timers.nj(Timers_SealWalkAnim_getInstance());
    var timerSealSpline = $this.timers.nj(Timers_SealWalkSpline_getInstance());
    var tmp = $this.groupPenguinsIdle.commands;
    var commandsPenguins1 = isInterface(tmp, List) ? tmp : THROW_CCE();
    var tmp_0 = $this.groupPenguinsIdle2.commands;
    var commandsPenguins2 = isInterface(tmp_0, List) ? tmp_0 : THROW_CCE();
    var tmp_1 = $this.groupSealIdle.commands;
    var commandsSealsIdle = isInterface(tmp_1, List) ? tmp_1 : THROW_CCE();
    var tmp_2 = $this.groupSealWalking.commands;
    var commandsSealsWalking = isInterface(tmp_2, List) ? tmp_2 : THROW_CCE();
    var inductionVariable = 0;
    var last = Penguins_getInstance().cm_1.length;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var command = commandsPenguins1.t(i);
        var config = Penguins_getInstance().cm_1[i];
        setAnimationUniforms$default($this, timerPenguinIdle + config.ik_1, Animations_getInstance().rk_1, command.uniforms);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = 0;
    var last_0 = Penguins_getInstance().dm_1.length;
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var command_0 = commandsPenguins2.t(i_0);
        var config_0 = Penguins_getInstance().dm_1[i_0];
        setAnimationUniforms$default($this, timerPenguinIdle2 + config_0.ik_1, Animations_getInstance().sk_1, command_0.uniforms);
      }
       while (inductionVariable_0 < last_0);
    var inductionVariable_1 = 0;
    var last_1 = Seals_getInstance().vn_1.length;
    if (inductionVariable_1 < last_1)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var command_1 = commandsSealsIdle.t(i_1);
        var config_1 = Seals_getInstance().vn_1[i_1];
        setAnimationUniforms($this, timerSealIdle + config_1.ik_1, Animations_getInstance().tk_1, command_1.uniforms, false);
      }
       while (inductionVariable_1 < last_1);
    var inductionVariable_2 = 0;
    var last_2 = Seals_getInstance().wn_1.length;
    if (inductionVariable_2 < last_2)
      $l$loop: do {
        var i_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        var command_2 = commandsSealsWalking.t(i_2);
        var config_2 = Seals_getInstance().wn_1[i_2];
        if (config_2.pk_1 == null) {
          continue $l$loop;
        }
        var position = ensureNotNull(config_2.pk_1).ce(timerSealSpline);
        var rotation = ensureNotNull(config_2.pk_1).je(timerSealSpline).z - 90.0;
        setAnimationUniforms($this, timerSealWalk + config_2.ik_1, Animations_getInstance().uk_1, command_2.uniforms, false);
        command_2.transform.y9_1.x = position.x;
        command_2.transform.y9_1.y = position.y;
        command_2.transform.y9_1.z = position.z;
        command_2.transform.z9_1.z = rotation;
        command_2.transform.aa_1.x = config_2.hk_1;
        command_2.transform.aa_1.y = config_2.hk_1;
        command_2.transform.aa_1.z = config_2.hk_1;
      }
       while (inductionVariable_2 < last_2);
  }
  function updateAnimalsSleeping($this) {
  }
  function ArcticScene() {
    Scene.call(this);
    this.timers = new TimersMap();
    this.jm_1 = 1000000.0;
    this.km_1 = 23000.0;
    this.lm_1 = 2000.0;
    this.FOV_TRANSITION = 20.0;
    this.tm_1 = mutableListOf([get_HINT_VRS_4X4()]);
    this.uniformPaletteTexture = new UniformTextureValue(Textures_getInstance().zm_1);
    this.uniformSkyTexture = new UniformTextureValue(Textures_getInstance().dn_1);
    this.BIRD_FLIGHT_RADIUS = 19000.0;
    this.PIf = 3.1415927;
    this.meshes = Meshes_getInstance().bm_1;
    this.textures = Textures_getInstance().on_1;
    this.shaders = Shaders_getInstance().ho_1;
    Companion_instance_2.io(this.timers);
    this.Z_NEAR = 20.0;
    this.Z_FAR = 115000.0;
    this.FOV_LANDSCAPE = 50.0;
    this.FOV_PORTRAIT = 75.0;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new ArcticSettings();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_0.cameraPeriod = 1.0;
    this_0.vignette = true;
    this_0.blurred = false;
    this_0.autoSwitchCameras = true;
    this_0.timeOfDay = TimeOfDay_Day_getInstance();
    tmp.settings = this_0;
    this.cameraAnimator = new CameraPathAnimator(this.jm_1, this.km_1, this.lm_1, true);
    this.cameraAnimator.setCameras(Cameras_getInstance().vk_1);
    this.cameraAnimator.minDurationCoefficient = this.settings.cameraPeriod;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new ClearColorCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_1.color = new Vec4(1.0, 0.0, 1.0, 1.0);
    this_1.name = 'clear color';
    this_1.enabled = true;
    tmp_0.qm_1 = this_1;
    var statePaletteFp16 = new DrawMeshState(Shaders_getInstance().xn_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_U0_getInstance(), 1, VertexFormat_HALF_getInstance(), 6)]), 8));
    var stateDiffuseFp16 = new DrawMeshState(Shaders_getInstance().yn_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_FLOAT3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_HALF2_getInstance(), 12)]), 16));
    var stateWater = new DrawMeshState(Shaders_getInstance().ao_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_HALF2_getInstance(), 6)]), 12));
    var stateDiffuseZFog = new DrawMeshState(Shaders_getInstance().zn_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_U0_getInstance(), 1, VertexFormat_HALF_getInstance(), 6)]), 8));
    var txOrigin = new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0));
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = DrawStaticMeshCommandConstructor(Meshes_getInstance().pl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture]), stateDiffuseFp16, txOrigin);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_2.hints = this.tm_1;
    tmp_1.commandSun = this_2;
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = DrawStaticMeshCommandConstructor(Meshes_getInstance().ql_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture]), stateDiffuseFp16, txOrigin);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_3.hints = this.tm_1;
    tmp_2.commandSunLow = this_3;
    // Inline function 'kotlin.apply' call
    var this_4 = new GroupCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_4.name = 'sun';
    this_4.enabled = true;
    this_4.commands = mutableListOf([this.commandSun, this.commandSunLow]);
    var groupSun = this_4;
    this.um_1 = listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture]);
    this.vm_1 = listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformFloatValueWithArray(new Float32Array(4)), UniformFloatValueWithArray(new Float32Array(2))]);
    // Inline function 'kotlin.apply' call
    var this_5 = new GroupCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_5.name = 'mountains';
    this_5.enabled = true;
    var tmp_3 = this_5;
    // Inline function 'kotlin.apply' call
    var this_6 = DrawStaticMeshCommandConstructor(Meshes_getInstance().nl_1, this.um_1, statePaletteFp16, txOrigin);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>.<anonymous>' call
    this_6.hints = this.tm_1;
    var tmp_4 = this_6;
    // Inline function 'kotlin.apply' call
    var this_7 = DrawStaticMeshCommandConstructor(Meshes_getInstance().ol_1, this.vm_1, stateDiffuseZFog, txOrigin);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>.<anonymous>' call
    this_7.hints = this.tm_1;
    tmp_3.commands = mutableListOf([tmp_4, this_7]);
    var groupMountains = this_5;
    this.wm_1 = listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance().in_1), UniformFloatValueWithArray(new Float32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), UniformFloatValueWithArray(new Float32Array(2)), UniformFloatValueWithArray(new Float32Array(4)), UniformFloatValueWithArray(new Float32Array(4)), UniformFloatValueWithArray(new Float32Array(4))]);
    var commandWater = DrawStaticMeshCommandConstructor(Meshes_getInstance().rl_1, this.wm_1, stateWater, txOrigin);
    var stateSky = new DrawMeshState(Shaders_getInstance().bo_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_FLOAT3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_HALF2_getInstance(), 12)]), 16));
    var commandSky = DrawStaticMeshCommandConstructor(Meshes_getInstance().sl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformSkyTexture, new UniformTextureValue(Textures_getInstance().hn_1)]), stateSky, txOrigin);
    var stateStars = new DrawMeshState(Shaders_getInstance().co_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf_0(new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_FLOAT3_getInstance(), 0)), 12));
    this.xm_1 = listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(4))]);
    var tmp_5 = this;
    // Inline function 'kotlin.apply' call
    var this_8 = DrawStaticMeshCommandConstructor(Meshes_getInstance().tl_1, this.xm_1, stateStars, txOrigin);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_8.hints = this.tm_1;
    tmp_5.commandStars = this_8;
    var stateClouds = new DrawMeshState(Shaders_getInstance().eo_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_FLOAT3_getInstance(), 0), new VertexAttribute(AttributeType_U0_getInstance(), 1, VertexFormat_UBYTE_NORMALIZED_getInstance(), 12)]), 16));
    this.ym_1 = listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(4)), UniformFloatValueWithArray(new Float32Array(1))]);
    var tmp_6 = this;
    // Inline function 'kotlin.apply' call
    var this_9 = new DrawTransformedMeshCommand(Meshes_getInstance().ul_1, this.ym_1, stateClouds, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_9.hints = this.tm_1;
    tmp_6.commandClouds = this_9;
    var stateBird = new DrawMeshState(Shaders_getInstance().fo_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), null);
    var tmp_7 = this;
    // Inline function 'kotlin.apply' call
    var this_10 = new DrawTransformedMeshCommand(Meshes_getInstance().vl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(4)), UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().jn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateBird, new AffineTranformation(new Vec3(0.0, 0.0, 10000.0), new Vec3(0.0, 0.0, 0.0), new Vec3(6.0, 3.0, 3.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_10.hints = this.tm_1;
    var tmp_8 = this_10;
    // Inline function 'kotlin.apply' call
    var this_11 = new DrawTransformedMeshCommand(Meshes_getInstance().vl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(4)), UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().jn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateBird, new AffineTranformation(new Vec3(0.0, 0.0, 11000.0), new Vec3(0.0, 0.0, 0.0), new Vec3(6.0, 3.0, 3.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_11.hints = this.tm_1;
    var tmp_9 = this_11;
    // Inline function 'kotlin.apply' call
    var this_12 = new DrawTransformedMeshCommand(Meshes_getInstance().vl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(4)), UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().jn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateBird, new AffineTranformation(new Vec3(0.0, 0.0, 12000.0), new Vec3(0.0, 0.0, 0.0), new Vec3(6.0, 3.0, 3.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_12.hints = this.tm_1;
    var tmp_10 = this_12;
    // Inline function 'kotlin.apply' call
    var this_13 = new DrawTransformedMeshCommand(Meshes_getInstance().vl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(4)), UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().jn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateBird, new AffineTranformation(new Vec3(0.0, 0.0, 13000.0), new Vec3(0.0, 0.0, 0.0), new Vec3(6.0, 3.0, 3.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_13.hints = this.tm_1;
    var tmp_11 = this_13;
    // Inline function 'kotlin.apply' call
    var this_14 = new DrawTransformedMeshCommand(Meshes_getInstance().vl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(4)), UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().jn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateBird, new AffineTranformation(new Vec3(0.0, 0.0, 14000.0), new Vec3(0.0, 0.0, 0.0), new Vec3(6.0, 3.0, 3.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_14.hints = this.tm_1;
    var tmp_12 = this_14;
    // Inline function 'kotlin.apply' call
    var this_15 = new DrawTransformedMeshCommand(Meshes_getInstance().vl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(4)), UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().jn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateBird, new AffineTranformation(new Vec3(0.0, 0.0, 15000.0), new Vec3(0.0, 0.0, 0.0), new Vec3(6.0, 3.0, 3.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_15.hints = this.tm_1;
    tmp_7.groupBirds = GroupCommandArr(true, [tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, this_15]);
    var tmp_13 = this;
    // Inline function 'kotlin.apply' call
    var this_16 = new DrawTransformedMeshCommand(Meshes_getInstance().wl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture]), statePaletteFp16, new AffineTranformation());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_16.hints = this.tm_1;
    var tmp_14 = this_16;
    // Inline function 'kotlin.apply' call
    var this_17 = new DrawTransformedMeshCommand(Meshes_getInstance().wl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture]), statePaletteFp16, new AffineTranformation());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_17.hints = this.tm_1;
    var tmp_15 = this_17;
    // Inline function 'kotlin.apply' call
    var this_18 = new DrawTransformedMeshCommand(Meshes_getInstance().wl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture]), statePaletteFp16, new AffineTranformation());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_18.hints = this.tm_1;
    tmp_13.groupShips = GroupCommandArr(true, [tmp_14, tmp_15, this_18]);
    var stateAnimatedTextured = new DrawMeshState(Shaders_getInstance().go_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf_0(new VertexAttribute(AttributeType_UV0_getInstance(), 0, VertexFormat_HALF2_getInstance(), 0)), 4));
    var tmp_16 = this;
    // Inline function 'kotlin.apply' call
    var this_19 = DrawStaticMeshCommandConstructor(Meshes_getInstance().xl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().kn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().cm_1[0].lk_1, Penguins_getInstance().cm_1[0].mk_1, new Vec3(Penguins_getInstance().cm_1[0].hk_1, Penguins_getInstance().cm_1[0].hk_1, Penguins_getInstance().cm_1[0].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_19.hints = this.tm_1;
    var tmp_17 = this_19;
    // Inline function 'kotlin.apply' call
    var this_20 = DrawStaticMeshCommandConstructor(Meshes_getInstance().xl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().kn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().cm_1[1].lk_1, Penguins_getInstance().cm_1[1].mk_1, new Vec3(Penguins_getInstance().cm_1[1].hk_1, Penguins_getInstance().cm_1[1].hk_1, Penguins_getInstance().cm_1[1].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_20.hints = this.tm_1;
    var tmp_18 = this_20;
    // Inline function 'kotlin.apply' call
    var this_21 = DrawStaticMeshCommandConstructor(Meshes_getInstance().xl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().kn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().cm_1[2].lk_1, Penguins_getInstance().cm_1[2].mk_1, new Vec3(Penguins_getInstance().cm_1[2].hk_1, Penguins_getInstance().cm_1[2].hk_1, Penguins_getInstance().cm_1[2].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_21.hints = this.tm_1;
    var tmp_19 = this_21;
    // Inline function 'kotlin.apply' call
    var this_22 = DrawStaticMeshCommandConstructor(Meshes_getInstance().xl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().kn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().cm_1[3].lk_1, Penguins_getInstance().cm_1[3].mk_1, new Vec3(Penguins_getInstance().cm_1[3].hk_1, Penguins_getInstance().cm_1[3].hk_1, Penguins_getInstance().cm_1[3].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_22.hints = this.tm_1;
    var tmp_20 = this_22;
    // Inline function 'kotlin.apply' call
    var this_23 = DrawStaticMeshCommandConstructor(Meshes_getInstance().xl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().kn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().cm_1[4].lk_1, Penguins_getInstance().cm_1[4].mk_1, new Vec3(Penguins_getInstance().cm_1[4].hk_1, Penguins_getInstance().cm_1[4].hk_1, Penguins_getInstance().cm_1[4].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_23.hints = this.tm_1;
    var tmp_21 = this_23;
    // Inline function 'kotlin.apply' call
    var this_24 = DrawStaticMeshCommandConstructor(Meshes_getInstance().xl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().kn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().cm_1[5].lk_1, Penguins_getInstance().cm_1[5].mk_1, new Vec3(Penguins_getInstance().cm_1[5].hk_1, Penguins_getInstance().cm_1[5].hk_1, Penguins_getInstance().cm_1[5].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_24.hints = this.tm_1;
    var tmp_22 = this_24;
    // Inline function 'kotlin.apply' call
    var this_25 = DrawStaticMeshCommandConstructor(Meshes_getInstance().xl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().kn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().cm_1[6].lk_1, Penguins_getInstance().cm_1[6].mk_1, new Vec3(Penguins_getInstance().cm_1[6].hk_1, Penguins_getInstance().cm_1[6].hk_1, Penguins_getInstance().cm_1[6].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_25.hints = this.tm_1;
    var tmp_23 = this_25;
    // Inline function 'kotlin.apply' call
    var this_26 = DrawStaticMeshCommandConstructor(Meshes_getInstance().xl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().kn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().cm_1[7].lk_1, Penguins_getInstance().cm_1[7].mk_1, new Vec3(Penguins_getInstance().cm_1[7].hk_1, Penguins_getInstance().cm_1[7].hk_1, Penguins_getInstance().cm_1[7].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_26.hints = this.tm_1;
    var tmp_24 = this_26;
    // Inline function 'kotlin.apply' call
    var this_27 = DrawStaticMeshCommandConstructor(Meshes_getInstance().xl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().kn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().cm_1[8].lk_1, Penguins_getInstance().cm_1[8].mk_1, new Vec3(Penguins_getInstance().cm_1[8].hk_1, Penguins_getInstance().cm_1[8].hk_1, Penguins_getInstance().cm_1[8].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_27.hints = this.tm_1;
    tmp_16.groupPenguinsIdle = GroupCommandArr(true, [tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, this_27]);
    var tmp_25 = this;
    // Inline function 'kotlin.apply' call
    var this_28 = DrawStaticMeshCommandConstructor(Meshes_getInstance().yl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().ln_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().dm_1[0].lk_1, Penguins_getInstance().dm_1[0].mk_1, new Vec3(Penguins_getInstance().dm_1[0].hk_1, Penguins_getInstance().dm_1[0].hk_1, Penguins_getInstance().dm_1[0].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_28.hints = this.tm_1;
    var tmp_26 = this_28;
    // Inline function 'kotlin.apply' call
    var this_29 = DrawStaticMeshCommandConstructor(Meshes_getInstance().yl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().ln_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().dm_1[1].lk_1, Penguins_getInstance().dm_1[1].mk_1, new Vec3(Penguins_getInstance().dm_1[1].hk_1, Penguins_getInstance().dm_1[1].hk_1, Penguins_getInstance().dm_1[1].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_29.hints = this.tm_1;
    var tmp_27 = this_29;
    // Inline function 'kotlin.apply' call
    var this_30 = DrawStaticMeshCommandConstructor(Meshes_getInstance().yl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().ln_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().dm_1[2].lk_1, Penguins_getInstance().dm_1[2].mk_1, new Vec3(Penguins_getInstance().dm_1[2].hk_1, Penguins_getInstance().dm_1[2].hk_1, Penguins_getInstance().dm_1[2].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_30.hints = this.tm_1;
    var tmp_28 = this_30;
    // Inline function 'kotlin.apply' call
    var this_31 = DrawStaticMeshCommandConstructor(Meshes_getInstance().yl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().ln_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().dm_1[3].lk_1, Penguins_getInstance().dm_1[3].mk_1, new Vec3(Penguins_getInstance().dm_1[3].hk_1, Penguins_getInstance().dm_1[3].hk_1, Penguins_getInstance().dm_1[3].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_31.hints = this.tm_1;
    var tmp_29 = this_31;
    // Inline function 'kotlin.apply' call
    var this_32 = DrawStaticMeshCommandConstructor(Meshes_getInstance().yl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().ln_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().dm_1[4].lk_1, Penguins_getInstance().dm_1[4].mk_1, new Vec3(Penguins_getInstance().dm_1[4].hk_1, Penguins_getInstance().dm_1[4].hk_1, Penguins_getInstance().dm_1[4].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_32.hints = this.tm_1;
    var tmp_30 = this_32;
    // Inline function 'kotlin.apply' call
    var this_33 = DrawStaticMeshCommandConstructor(Meshes_getInstance().yl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().ln_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Penguins_getInstance().dm_1[5].lk_1, Penguins_getInstance().dm_1[5].mk_1, new Vec3(Penguins_getInstance().dm_1[5].hk_1, Penguins_getInstance().dm_1[5].hk_1, Penguins_getInstance().dm_1[5].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_33.hints = this.tm_1;
    tmp_25.groupPenguinsIdle2 = GroupCommandArr(true, [tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, this_33]);
    var tmp_31 = this;
    // Inline function 'kotlin.apply' call
    var this_34 = DrawStaticMeshCommandConstructor(Meshes_getInstance().zl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().mn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Seals_getInstance().vn_1[0].lk_1, Seals_getInstance().vn_1[0].mk_1, new Vec3(Seals_getInstance().vn_1[0].hk_1, Seals_getInstance().vn_1[0].hk_1, Seals_getInstance().vn_1[0].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_34.hints = this.tm_1;
    var tmp_32 = this_34;
    // Inline function 'kotlin.apply' call
    var this_35 = DrawStaticMeshCommandConstructor(Meshes_getInstance().zl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().mn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Seals_getInstance().vn_1[1].lk_1, Seals_getInstance().vn_1[1].mk_1, new Vec3(Seals_getInstance().vn_1[1].hk_1, Seals_getInstance().vn_1[1].hk_1, Seals_getInstance().vn_1[1].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_35.hints = this.tm_1;
    var tmp_33 = this_35;
    // Inline function 'kotlin.apply' call
    var this_36 = DrawStaticMeshCommandConstructor(Meshes_getInstance().zl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().mn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Seals_getInstance().vn_1[2].lk_1, Seals_getInstance().vn_1[2].mk_1, new Vec3(Seals_getInstance().vn_1[2].hk_1, Seals_getInstance().vn_1[2].hk_1, Seals_getInstance().vn_1[2].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_36.hints = this.tm_1;
    var tmp_34 = this_36;
    // Inline function 'kotlin.apply' call
    var this_37 = DrawStaticMeshCommandConstructor(Meshes_getInstance().zl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().mn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Seals_getInstance().vn_1[3].lk_1, Seals_getInstance().vn_1[3].mk_1, new Vec3(Seals_getInstance().vn_1[3].hk_1, Seals_getInstance().vn_1[3].hk_1, Seals_getInstance().vn_1[3].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_37.hints = this.tm_1;
    var tmp_35 = this_37;
    // Inline function 'kotlin.apply' call
    var this_38 = DrawStaticMeshCommandConstructor(Meshes_getInstance().zl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().mn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Seals_getInstance().vn_1[4].lk_1, Seals_getInstance().vn_1[4].mk_1, new Vec3(Seals_getInstance().vn_1[4].hk_1, Seals_getInstance().vn_1[4].hk_1, Seals_getInstance().vn_1[4].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_38.hints = this.tm_1;
    var tmp_36 = this_38;
    // Inline function 'kotlin.apply' call
    var this_39 = DrawStaticMeshCommandConstructor(Meshes_getInstance().zl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().mn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Seals_getInstance().vn_1[5].lk_1, Seals_getInstance().vn_1[5].mk_1, new Vec3(Seals_getInstance().vn_1[5].hk_1, Seals_getInstance().vn_1[5].hk_1, Seals_getInstance().vn_1[5].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_39.hints = this.tm_1;
    var tmp_37 = this_39;
    // Inline function 'kotlin.apply' call
    var this_40 = DrawStaticMeshCommandConstructor(Meshes_getInstance().zl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().mn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Seals_getInstance().vn_1[6].lk_1, Seals_getInstance().vn_1[6].mk_1, new Vec3(Seals_getInstance().vn_1[6].hk_1, Seals_getInstance().vn_1[6].hk_1, Seals_getInstance().vn_1[6].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_40.hints = this.tm_1;
    var tmp_38 = this_40;
    // Inline function 'kotlin.apply' call
    var this_41 = DrawStaticMeshCommandConstructor(Meshes_getInstance().zl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().mn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation(Seals_getInstance().vn_1[7].lk_1, Seals_getInstance().vn_1[7].mk_1, new Vec3(Seals_getInstance().vn_1[7].hk_1, Seals_getInstance().vn_1[7].hk_1, Seals_getInstance().vn_1[7].hk_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_41.hints = this.tm_1;
    tmp_31.groupSealIdle = GroupCommandArr(true, [tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, this_41]);
    var tmp_39 = this;
    // Inline function 'kotlin.apply' call
    var this_42 = new DrawTransformedMeshCommand(Meshes_getInstance().zl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().nn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_42.hints = this.tm_1;
    var tmp_40 = this_42;
    // Inline function 'kotlin.apply' call
    var this_43 = new DrawTransformedMeshCommand(Meshes_getInstance().zl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().nn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_43.hints = this.tm_1;
    var tmp_41 = this_43;
    // Inline function 'kotlin.apply' call
    var this_44 = new DrawTransformedMeshCommand(Meshes_getInstance().zl_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance().nn_1), UniformFloatValueWithArray(new Float32Array(4))]), stateAnimatedTextured, new AffineTranformation());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_44.hints = this.tm_1;
    tmp_39.groupSealWalking = GroupCommandArr(true, [tmp_40, tmp_41, this_44]);
    this.groupAnimalsAnimated = GroupCommandArr(true, [this.groupPenguinsIdle, this.groupPenguinsIdle2, this.groupSealIdle, this.groupSealWalking]);
    var tmp_42 = this;
    // Inline function 'kotlin.apply' call
    var this_45 = DrawStaticMeshCommandConstructor(Meshes_getInstance().am_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), this.uniformPaletteTexture]), stateDiffuseFp16, txOrigin);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_45.hints = this.tm_1;
    tmp_42.groupAnimalsSleeping = GroupCommandArr(true, [this_45]);
    var tmp_43 = this;
    // Inline function 'kotlin.apply' call
    var this_46 = new ClearCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_46.clearType = ClearCommandClearType_COLOR_AND_DEPTH_getInstance();
    tmp_43.pm_1 = GroupCommandArr(true, [this.qm_1, this_46]);
    var tmp_44 = this;
    // Inline function 'kotlin.apply' call
    var this_47 = new VignetteCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_47.color0 = new Vec4(0.65, 0.65, 0.65, 1.0);
    this_47.color1 = new Vec4(1.0, 1.0, 1.0, 1.0);
    tmp_44.rm_1 = this_47;
    this.mm_1 = GroupCommandArr(true, [MainPassCommandArr(true, [this.pm_1, this.groupBirds, this.groupShips, this.groupAnimalsAnimated, this.groupAnimalsSleeping, groupSun, groupMountains, commandWater, this.commandStars, this.commandClouds, commandSky, this.rm_1])]);
    var tmp_45 = this;
    // Inline function 'kotlin.apply' call
    var this_48 = new BlurredPassCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_48.name = 'blurred-main';
    this_48.enabled = true;
    this_48.minSize = 220;
    this_48.brightness = 0.91;
    this_48.blurSize = BlurSize_KERNEL_4_getInstance();
    this_48.commands = mutableListOf([this.pm_1, this.groupShips, this.groupAnimalsAnimated, this.groupAnimalsSleeping, groupSun, groupMountains, commandWater, this.commandStars, this.commandClouds, commandSky, this.rm_1]);
    tmp_45.om_1 = this_48;
    var tmp_46 = this;
    // Inline function 'kotlin.apply' call
    var this_49 = new DrawBlurredCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.ArcticScene.<anonymous>' call
    this_49.name = 'draw blurred';
    this_49.blending = get_BLENDING_NONE();
    tmp_46.sm_1 = this_49;
    this.nm_1 = GroupCommandArr(false, [this.om_1, MainPassCommandArr(true, [this.pm_1, this.sm_1])]);
    this.commands = mutableListOf([this.mm_1, this.nm_1]);
  }
  protoOf(ArcticScene).jo = function () {
    return this.timers;
  };
  protoOf(ArcticScene).ko = function () {
    return this.cameraAnimator;
  };
  protoOf(ArcticScene).lo = function () {
    return this.FOV_TRANSITION;
  };
  protoOf(ArcticScene).mo = function () {
    return this.settings;
  };
  protoOf(ArcticScene).no = function () {
    return this.uniformPaletteTexture;
  };
  protoOf(ArcticScene).oo = function () {
    return this.uniformSkyTexture;
  };
  protoOf(ArcticScene).po = function () {
    return this.commandClouds;
  };
  protoOf(ArcticScene).qo = function () {
    return this.commandStars;
  };
  protoOf(ArcticScene).ro = function () {
    return this.groupBirds;
  };
  protoOf(ArcticScene).so = function () {
    return this.BIRD_FLIGHT_RADIUS;
  };
  protoOf(ArcticScene).to = function () {
    return this.groupShips;
  };
  protoOf(ArcticScene).uo = function () {
    return this.groupAnimalsAnimated;
  };
  protoOf(ArcticScene).vo = function () {
    return this.groupAnimalsSleeping;
  };
  protoOf(ArcticScene).wo = function () {
    return this.groupPenguinsIdle;
  };
  protoOf(ArcticScene).xo = function () {
    return this.groupPenguinsIdle2;
  };
  protoOf(ArcticScene).yo = function () {
    return this.groupSealIdle;
  };
  protoOf(ArcticScene).zo = function () {
    return this.groupSealWalking;
  };
  protoOf(ArcticScene).ap = function () {
    return this.commandSun;
  };
  protoOf(ArcticScene).bp = function () {
    return this.commandSunLow;
  };
  protoOf(ArcticScene).cp = function () {
    return this.PIf;
  };
  protoOf(ArcticScene).updateTimers = function (time) {
    this.timers.qj(time);
    this.cameraAnimator.animate(time);
    this.animate();
    protoOf(Scene).updateTimers.call(this, time);
  };
  protoOf(ArcticScene).updateViewportSize = function (width, height) {
    protoOf(Scene).updateViewportSize.call(this, width, height);
  };
  protoOf(ArcticScene).initialize = function () {
  };
  protoOf(ArcticScene).applySettings = function () {
    this.mm_1.enabled = !this.settings.blurred;
    this.nm_1.enabled = this.settings.blurred;
    this.rm_1.enabled = this.settings.vignette;
    if (!(this.cameraAnimator.minDurationCoefficient === this.settings.cameraPeriod)) {
      this.cameraAnimator.minDurationCoefficient = this.settings.cameraPeriod;
    }
    if ((this.cameraAnimator.timer > 0.99 ? this.settings.autoSwitchCameras : false) ? Default_getInstance().c6() < 0.5 : false) {
      this.randomCamera();
    }
  };
  protoOf(ArcticScene).animate = function () {
    this.applySettings();
    this.calculateProjection();
    var cameraPositionInterpolator = this.cameraAnimator.positionInterpolator;
    var eye = cameraPositionInterpolator.cameraPosition;
    var lookat = cameraPositionInterpolator.cameraRotation;
    if (!this.useExternalViewMatrix) {
      Matrix_getInstance().di(this.matView, 0, eye.x, eye.y, eye.z, lookat.x, lookat.y, lookat.z, 0.0, 0.0, 1.0);
    }
    toggleDayNightObjects(this);
    updateTimeOfDayTextures(this);
    updateSun(this);
    updateBirds(this);
    updateShips(this);
    updateAnimalsAnimated(this);
    updateAnimalsSleeping(this);
    updateWater(this);
    updateColors(this);
    this.updateMeshTransformations(this.commands);
  };
  protoOf(ArcticScene).nextCamera = function () {
    this.cameraAnimator.nextCamera();
  };
  protoOf(ArcticScene).randomCamera = function () {
    if (this.cameraAnimator.state.equals(CameraState_TRANSITIONING_getInstance())) {
      return Unit_instance;
    }
    this.cameraAnimator.positionInterpolator.reverse = Default_getInstance().c6() < 0.5;
    this.cameraAnimator.randomCamera();
  };
  function Seals() {
    Seals_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.apply' call
    var this_0 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Seals.IDLE.<anonymous>' call
    this_0.lk_1 = new Vec3(-10197.612, -11412.881, 163.703);
    this_0.mk_1 = new Vec3(0.0, 0.0, 305.0);
    this_0.hk_1 = 21.6;
    this_0.ik_1 = 0.1;
    var tmp_0 = this_0;
    // Inline function 'kotlin.apply' call
    var this_1 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Seals.IDLE.<anonymous>' call
    this_1.lk_1 = new Vec3(-11490.098, -10868.786, 163.703);
    this_1.mk_1 = new Vec3(0.0, 0.0, 180.0);
    this_1.hk_1 = 21.0;
    this_1.ik_1 = 0.2;
    var tmp_1 = this_1;
    // Inline function 'kotlin.apply' call
    var this_2 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Seals.IDLE.<anonymous>' call
    this_2.lk_1 = new Vec3(-12481.07, -9990.127, 163.703);
    this_2.mk_1 = new Vec3(0.0, 0.0, 40.0);
    this_2.hk_1 = 24.0;
    this_2.ik_1 = 0.0;
    var tmp_2 = this_2;
    // Inline function 'kotlin.apply' call
    var this_3 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Seals.IDLE.<anonymous>' call
    this_3.lk_1 = new Vec3(-8848.467, -10551.67, 163.703);
    this_3.mk_1 = new Vec3(0.0, 0.0, 270.0);
    this_3.hk_1 = 23.0;
    this_3.ik_1 = 0.66;
    var tmp_3 = this_3;
    // Inline function 'kotlin.apply' call
    var this_4 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Seals.IDLE.<anonymous>' call
    this_4.lk_1 = new Vec3(-11421.474, -8197.367, 163.703);
    this_4.mk_1 = new Vec3(0.0, 0.0, 155.0);
    this_4.hk_1 = 22.0;
    this_4.ik_1 = 0.3;
    var tmp_4 = this_4;
    // Inline function 'kotlin.apply' call
    var this_5 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Seals.IDLE.<anonymous>' call
    this_5.lk_1 = new Vec3(-9098.065, -9784.568, 163.703);
    this_5.mk_1 = new Vec3(0.0, 0.0, 180.0);
    this_5.hk_1 = 21.0;
    this_5.ik_1 = 0.7;
    var tmp_5 = this_5;
    // Inline function 'kotlin.apply' call
    var this_6 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Seals.IDLE.<anonymous>' call
    this_6.lk_1 = new Vec3(-8929.758, -9630.826, 163.703);
    this_6.mk_1 = new Vec3(0.0, 0.0, 260.0);
    this_6.hk_1 = 20.0;
    this_6.ik_1 = 0.2;
    var tmp_6 = this_6;
    // Inline function 'kotlin.apply' call
    var this_7 = new AnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Seals.IDLE.<anonymous>' call
    this_7.lk_1 = new Vec3(-9159.626, -9498.492, 163.703);
    this_7.mk_1 = new Vec3(0.0, 0.0, 25.0);
    this_7.hk_1 = 22.0;
    this_7.ik_1 = 0.4;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.vn_1 = [tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, this_7];
    var tmp_7 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.apply' call
    var this_8 = new SplineAnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Seals.WALKING.<anonymous>' call
    var tmp_8 = this_8;
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp_9 = new Float64Array([0.0, 0.0, -8594.068359375, -9185.310546875, -10173.7734375, -11037.0615234375, -11556.869140625, -11171.4091796875, -10388.73046875, -9319.6591796875, 0.0, 0.0]);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp_10 = new Float64Array([0.0, 0.0, -11242.3720703125, -10794.060546875, -10646.896484375, -10959.65625, -11507.3251953125, -12299.8046875, -12791.134765625, -12134.208984375, 0.0, 0.0]);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp$ret$13 = new Float64Array([0.0, 0.0, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 0.0, 0.0]);
    tmp_8.pk_1 = Spline3D_init_$Create$(true, tmp_9, tmp_10, tmp$ret$13);
    this_8.hk_1 = 25.0;
    this_8.ik_1 = 0.4;
    var tmp_11 = this_8;
    // Inline function 'kotlin.apply' call
    var this_9 = new SplineAnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Seals.WALKING.<anonymous>' call
    var tmp_12 = this_9;
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp_13 = new Float64Array([0.0, 0.0, -11045.8798828125, -11852.0166015625, -12877.1728515625, -13320.65625, -13395.7041015625, -12947.1123046875, -12279.501953125, -11478.47265625, 0.0, 0.0]);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp_14 = new Float64Array([0.0, 0.0, -9073.04296875, -8490.494140625, -8394.025390625, -9009.2021484375, -9902.9755859375, -10920.896484375, -11452.736328125, -10402.1875, 0.0, 0.0]);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp$ret$17 = new Float64Array([0.0, 0.0, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 0.0, 0.0]);
    tmp_12.pk_1 = Spline3D_init_$Create$(true, tmp_13, tmp_14, tmp$ret$17);
    this_9.hk_1 = 22.0;
    this_9.ik_1 = 0.6;
    var tmp_15 = this_9;
    // Inline function 'kotlin.apply' call
    var this_10 = new SplineAnimatedObjectInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Seals.WALKING.<anonymous>' call
    var tmp_16 = this_10;
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp_17 = new Float64Array([0.0, 0.0, -10500.1298828125, -10924.8193359375, -10816.751953125, -9659.0244140625, -8474.8583984375, -8261.033203125, -8579.9658203125, -9526.828125, 0.0, 0.0]);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp_18 = new Float64Array([0.0, 0.0, -9078.6171875, -9745.982421875, -10364.9296875, -10400.5146484375, -10125.8681640625, -9503.888671875, -8930.3291015625, -8849.357421875, 0.0, 0.0]);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp$ret$21 = new Float64Array([0.0, 0.0, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 204.815673828125, 0.0, 0.0]);
    tmp_16.pk_1 = Spline3D_init_$Create$(true, tmp_17, tmp_18, tmp$ret$21);
    this_10.hk_1 = 23.0;
    this_10.ik_1 = 0.88;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_7.wn_1 = [tmp_11, tmp_15, this_10];
  }
  var Seals_instance;
  function Seals_getInstance() {
    if (Seals_instance == null)
      new Seals();
    return Seals_instance;
  }
  var TimeOfDay_Day_instance;
  var TimeOfDay_Night_instance;
  var TimeOfDay_Sunrise_instance;
  var TimeOfDay_Sunset_instance;
  function values() {
    return [TimeOfDay_Day_getInstance(), TimeOfDay_Night_getInstance(), TimeOfDay_Sunrise_getInstance(), TimeOfDay_Sunset_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Day':
        return TimeOfDay_Day_getInstance();
      case 'Night':
        return TimeOfDay_Night_getInstance();
      case 'Sunrise':
        return TimeOfDay_Sunrise_getInstance();
      case 'Sunset':
        return TimeOfDay_Sunset_getInstance();
      default:
        TimeOfDay_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var TimeOfDay_entriesInitialized;
  function TimeOfDay_initEntries() {
    if (TimeOfDay_entriesInitialized)
      return Unit_instance;
    TimeOfDay_entriesInitialized = true;
    TimeOfDay_Day_instance = new TimeOfDay('Day', 0, 0);
    TimeOfDay_Night_instance = new TimeOfDay('Night', 1, 1);
    TimeOfDay_Sunrise_instance = new TimeOfDay('Sunrise', 2, 2);
    TimeOfDay_Sunset_instance = new TimeOfDay('Sunset', 3, 3);
  }
  function TimeOfDay(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  function ArcticSettings() {
    this.cameraPeriod = 1.0;
    this.vignette = true;
    this.blurred = false;
    this.autoSwitchCameras = true;
    this.timeOfDay = TimeOfDay_Day_getInstance();
    this.clock = false;
    this.lowQuality = false;
  }
  protoOf(ArcticSettings).fp = function (_set____db54di) {
    this.cameraPeriod = _set____db54di;
  };
  protoOf(ArcticSettings).gp = function () {
    return this.cameraPeriod;
  };
  protoOf(ArcticSettings).hp = function (_set____db54di) {
    this.vignette = _set____db54di;
  };
  protoOf(ArcticSettings).ip = function () {
    return this.vignette;
  };
  protoOf(ArcticSettings).jp = function (_set____db54di) {
    this.blurred = _set____db54di;
  };
  protoOf(ArcticSettings).kp = function () {
    return this.blurred;
  };
  protoOf(ArcticSettings).lp = function (_set____db54di) {
    this.autoSwitchCameras = _set____db54di;
  };
  protoOf(ArcticSettings).mp = function () {
    return this.autoSwitchCameras;
  };
  protoOf(ArcticSettings).np = function (_set____db54di) {
    this.timeOfDay = _set____db54di;
  };
  protoOf(ArcticSettings).op = function () {
    return this.timeOfDay;
  };
  protoOf(ArcticSettings).pp = function (_set____db54di) {
    this.clock = _set____db54di;
  };
  protoOf(ArcticSettings).qp = function () {
    return this.clock;
  };
  protoOf(ArcticSettings).rp = function (_set____db54di) {
    this.lowQuality = _set____db54di;
  };
  protoOf(ArcticSettings).sp = function () {
    return this.lowQuality;
  };
  function TimeOfDay_Day_getInstance() {
    TimeOfDay_initEntries();
    return TimeOfDay_Day_instance;
  }
  function TimeOfDay_Night_getInstance() {
    TimeOfDay_initEntries();
    return TimeOfDay_Night_instance;
  }
  function TimeOfDay_Sunrise_getInstance() {
    TimeOfDay_initEntries();
    return TimeOfDay_Sunrise_instance;
  }
  function TimeOfDay_Sunset_getInstance() {
    TimeOfDay_initEntries();
    return TimeOfDay_Sunset_instance;
  }
  function Shaders() {
    Shaders_instance = this;
    this.xn_1 = new Shader('Palette');
    this.yn_1 = new Shader('Diffuse');
    this.zn_1 = new Shader('DiffuseZFog');
    this.ao_1 = new Shader('CausticsWater');
    this.bo_1 = new Shader('SkyDither');
    this.co_1 = new Shader('Color');
    this.do_1 = new Shader('ColorAnimatedTextureChunked');
    this.eo_1 = new Shader('Cloud');
    this.fo_1 = new Shader('ColorAnimatedTextureChunked');
    this.go_1 = new Shader('DiffuseAnimatedTextureChunked');
    this.ho_1 = mutableListOf([this.yn_1, this.xn_1, this.zn_1, this.ao_1, this.bo_1, this.co_1, this.do_1, this.eo_1, this.fo_1, this.go_1]);
  }
  var Shaders_instance;
  function Shaders_getInstance() {
    if (Shaders_instance == null)
      new Shaders();
    return Shaders_instance;
  }
  function ShipConfig(spline, scale, animTimerOffset) {
    this.sn_1 = spline;
    this.tn_1 = scale;
    this.un_1 = animTimerOffset;
  }
  function ShipsConfig() {
    ShipsConfig_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp_0 = new Float64Array([0.0, 0.0, 24566.40234375, 26321.6640625, 26708.22265625, 25413.6328125, 21720.98828125, 16347.2109375, 11130.576171875, -1738.1689453125, -5963.7197265625, -10164.759765625, -14386.349609375, -19112.7109375, -23859.62109375, -27219.46875, -28770.119140625, -28933.70703125, -27569.021484375, -24096.890625, -19096.490234375, -14164.109375, -9853.759765625, -5611.431640625, -1371.3896484375, 2872.943359375, 7115.0, 11400.76953125, 16216.3984375, 21075.7578125, 0.0, 0.0]);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp_1 = new Float64Array([0.0, 0.0, -2645.7470703125, -2308.08984375, -1332.42919921875, -524.489013671875, -188.111328125, -19.454345703125, 87.28076171875, 141.75341796875, 128.7080078125, 141.283447265625, 426.818359375, 1443.571166992188, 2733.282470703125, 3168.5166015625, 1871.808227539063, -279.37744140625, -1780.083984375, -1864.28125, -1298.00048828125, -874.37158203125, -1001.830078125, -1271.9423828125, -1252.52978515625, -486.420654296875, 569.2119140625, 975.029541015625, -11.353515625, -1647.552734375, 0.0, 0.0]);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp$ret$2 = new Float64Array([0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]);
    var tmp_2 = new ShipConfig(Spline3D_init_$Create$(true, tmp_0, tmp_1, tmp$ret$2), 1.1, 0.4);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp_3 = new Float64Array([0.0, 0.0, 5714.380859375, 7315.091796875, 8650.72265625, 8823.93359375, 7143.5078125, 4300.67578125, 1471.7890625, -841.138671875, -3140.115234375, -5754.8447265625, -8983.2392578125, -12527.380859375, -15823.2197265625, -18887.14453125, -21702.765625, -23656.859375, -24672.4296875, -24826.474609375, -23736.755859375, -20925.265625, -16870.01171875, -12622.77734375, -8198.072265625, -3581.3828125, 219.033203125, 2683.359375, 4331.4140625, 0.0, 0.0]);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp_4 = new Float64Array([0.0, 0.0, 17442.65625, 17650.91015625, 18617.86328125, 20306.828125, 23014.0546875, 26443.2890625, 29669.087890625, 32581.82421875, 35291.12109375, 37200.40625, 37881.41015625, 37762.40625, 37531.61328125, 37789.6640625, 37935.92578125, 36856.74609375, 33521.96484375, 28961.73828125, 25152.900390625, 22777.57421875, 21153.63671875, 20211.54296875, 20346.490234375, 21163.28125, 21406.8046875, 20214.69921875, 18449.328125, 0.0, 0.0]);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp$ret$5 = new Float64Array([0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]);
    var tmp_5 = new ShipConfig(Spline3D_init_$Create$(true, tmp_3, tmp_4, tmp$ret$5), 1.7, 0.6);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp_6 = new Float64Array([0.0, 0.0, -16359.05859375, -14598.0546875, -13475.6875, -14188.6171875, -18206.640625, -24059.94921875, -28535.79296875, -30099.376953125, -30285.4921875, -30485.732421875, -30806.443359375, -31141.27734375, -32562.830078125, -35985.46875, -40494.81640625, -44420.37109375, -47366.64453125, -49729.125, -51023.7578125, -50949.22265625, -49806.84375, -48016.53125, -45479.21484375, -42293.97265625, -39177.921875, -36336.46875, -33564.20703125, -30962.0703125, -28666.095703125, -26540.240234375, -24277.328125, -21516.3984375, -18618.40234375, 0.0, 0.0]);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp_7 = new Float64Array([0.0, 0.0, -28069.041015625, -26702.79296875, -23600.751953125, -20893.908203125, -19807.138671875, -19115.580078125, -17275.615234375, -13230.767578125, -8037.52099609375, -3321.68798828125, 514.55712890625, 3873.38818359375, 6335.501953125, 7855.1728515625, 8478.1279296875, 7922.24853515625, 5656.2490234375, 2211.415771484375, -1100.50830078125, -4002.49853515625, -6771.58056640625, -8927.087890625, -9960.884765625, -10381.111328125, -11231.494140625, -13150.048828125, -15498.767578125, -17407.33984375, -18208.109375, -18568.73828125, -19621.876953125, -22554.5234375, -26179.6875, 0.0, 0.0]);
    // Inline function 'kotlin.doubleArrayOf' call
    var tmp$ret$8 = new Float64Array([0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0]);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.rn_1 = [tmp_2, tmp_5, new ShipConfig(Spline3D_init_$Create$(true, tmp_6, tmp_7, tmp$ret$8), 1.4, 0.88)];
  }
  var ShipsConfig_instance;
  function ShipsConfig_getInstance() {
    if (ShipsConfig_instance == null)
      new ShipsConfig();
    return ShipsConfig_instance;
  }
  function Textures() {
    Textures_instance = this;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texPaletteDay.<anonymous>' call
    this_0.name = 'palette-day';
    this_0.fileName = 'palette-day';
    this_0.format = TextureFormat_RGBA8_getInstance();
    this_0.minFilter = TextureFiltering_NEAREST_getInstance();
    this_0.magFilter = TextureFiltering_NEAREST_getInstance();
    this_0.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp.zm_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texPaletteNight.<anonymous>' call
    this_1.name = 'palette-night';
    this_1.fileName = 'palette-night';
    this_1.format = TextureFormat_RGBA8_getInstance();
    this_1.minFilter = TextureFiltering_NEAREST_getInstance();
    this_1.magFilter = TextureFiltering_NEAREST_getInstance();
    this_1.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp_0.an_1 = this_1;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texPaletteSunrise.<anonymous>' call
    this_2.name = 'palette-sunrise';
    this_2.fileName = 'palette-sunrise';
    this_2.format = TextureFormat_RGBA8_getInstance();
    this_2.minFilter = TextureFiltering_NEAREST_getInstance();
    this_2.magFilter = TextureFiltering_NEAREST_getInstance();
    this_2.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp_1.bn_1 = this_2;
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texPaletteSunset.<anonymous>' call
    this_3.name = 'palette-sunset';
    this_3.fileName = 'palette-sunset';
    this_3.format = TextureFormat_RGBA8_getInstance();
    this_3.minFilter = TextureFiltering_NEAREST_getInstance();
    this_3.magFilter = TextureFiltering_NEAREST_getInstance();
    this_3.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp_2.cn_1 = this_3;
    var tmp_3 = this;
    // Inline function 'kotlin.apply' call
    var this_4 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texSkyDay.<anonymous>' call
    this_4.name = 'sky-day';
    this_4.fileName = 'sky-day';
    this_4.format = TextureFormat_RGBA8_getInstance();
    this_4.minFilter = TextureFiltering_LINEAR_getInstance();
    this_4.magFilter = TextureFiltering_LINEAR_getInstance();
    this_4.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp_3.dn_1 = this_4;
    var tmp_4 = this;
    // Inline function 'kotlin.apply' call
    var this_5 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texSkyNight.<anonymous>' call
    this_5.name = 'sky-night';
    this_5.fileName = 'sky-night';
    this_5.format = TextureFormat_RGBA8_getInstance();
    this_5.minFilter = TextureFiltering_LINEAR_getInstance();
    this_5.magFilter = TextureFiltering_LINEAR_getInstance();
    this_5.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp_4.en_1 = this_5;
    var tmp_5 = this;
    // Inline function 'kotlin.apply' call
    var this_6 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texSkySunrise.<anonymous>' call
    this_6.name = 'sky-sunrise';
    this_6.fileName = 'sky-sunrise';
    this_6.format = TextureFormat_RGBA8_getInstance();
    this_6.minFilter = TextureFiltering_LINEAR_getInstance();
    this_6.magFilter = TextureFiltering_LINEAR_getInstance();
    this_6.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp_5.fn_1 = this_6;
    var tmp_6 = this;
    // Inline function 'kotlin.apply' call
    var this_7 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texSkySunset.<anonymous>' call
    this_7.name = 'sky-sunset';
    this_7.fileName = 'sky-sunset';
    this_7.format = TextureFormat_RGBA8_getInstance();
    this_7.minFilter = TextureFiltering_LINEAR_getInstance();
    this_7.magFilter = TextureFiltering_LINEAR_getInstance();
    this_7.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp_6.gn_1 = this_7;
    var tmp_7 = this;
    // Inline function 'kotlin.apply' call
    var this_8 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texNoise.<anonymous>' call
    this_8.name = 'blue-noise-16';
    this_8.fileName = 'blue-noise-16';
    this_8.format = TextureFormat_ASTC_getInstance();
    this_8.minFilter = TextureFiltering_NEAREST_getInstance();
    this_8.magFilter = TextureFiltering_NEAREST_getInstance();
    tmp_7.hn_1 = this_8;
    var tmp_8 = this;
    // Inline function 'kotlin.apply' call
    var this_9 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texWater.<anonymous>' call
    this_9.name = 'caustics1';
    this_9.fileName = 'caustics1';
    this_9.format = TextureFormat_ASTC_getInstance();
    this_9.minFilter = TextureFiltering_LINEAR_getInstance();
    this_9.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_9.mipmaps = 6;
    tmp_8.in_1 = this_9;
    var tmp_9 = this;
    // Inline function 'kotlin.apply' call
    var this_10 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texBird.<anonymous>' call
    this_10.name = 'bird';
    this_10.fileName = 'bird.rgba.fp16';
    this_10.format = TextureFormat_RGBA16F_getInstance();
    this_10.minFilter = TextureFiltering_NEAREST_getInstance();
    this_10.magFilter = TextureFiltering_NEAREST_getInstance();
    this_10.width = Animations_getInstance().qk_1.vb_1;
    this_10.height = Animations_getInstance().qk_1.ac_1;
    tmp_9.jn_1 = this_10;
    var tmp_10 = this;
    // Inline function 'kotlin.apply' call
    var this_11 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texPenguinIdle.<anonymous>' call
    this_11.name = 'penguin-idle';
    this_11.fileName = 'penguin/idle/animal.rgba.fp16';
    this_11.format = TextureFormat_RGBA16F_getInstance();
    this_11.minFilter = TextureFiltering_NEAREST_getInstance();
    this_11.magFilter = TextureFiltering_NEAREST_getInstance();
    this_11.width = Animations_getInstance().rk_1.vb_1;
    this_11.height = Animations_getInstance().rk_1.ac_1;
    tmp_10.kn_1 = this_11;
    var tmp_11 = this;
    // Inline function 'kotlin.apply' call
    var this_12 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texPenguinIdle2.<anonymous>' call
    this_12.name = 'penguin-idle';
    this_12.fileName = 'penguin/idle2/animal.rgba.fp16';
    this_12.format = TextureFormat_RGBA16F_getInstance();
    this_12.minFilter = TextureFiltering_NEAREST_getInstance();
    this_12.magFilter = TextureFiltering_NEAREST_getInstance();
    this_12.width = Animations_getInstance().sk_1.vb_1;
    this_12.height = Animations_getInstance().sk_1.ac_1;
    tmp_11.ln_1 = this_12;
    var tmp_12 = this;
    // Inline function 'kotlin.apply' call
    var this_13 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texSealIdle.<anonymous>' call
    this_13.name = 'seal-idle';
    this_13.fileName = 'seal/idle/animal.rgba.fp16';
    this_13.format = TextureFormat_RGBA16F_getInstance();
    this_13.minFilter = TextureFiltering_NEAREST_getInstance();
    this_13.magFilter = TextureFiltering_NEAREST_getInstance();
    this_13.width = Animations_getInstance().tk_1.vb_1;
    this_13.height = Animations_getInstance().tk_1.ac_1;
    tmp_12.mn_1 = this_13;
    var tmp_13 = this;
    // Inline function 'kotlin.apply' call
    var this_14 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.arctic.Textures.texSealWalk.<anonymous>' call
    this_14.name = 'seal-walk';
    this_14.fileName = 'seal/walk/animal.rgba.fp16';
    this_14.format = TextureFormat_RGBA16F_getInstance();
    this_14.minFilter = TextureFiltering_NEAREST_getInstance();
    this_14.magFilter = TextureFiltering_NEAREST_getInstance();
    this_14.width = Animations_getInstance().uk_1.vb_1;
    this_14.height = Animations_getInstance().uk_1.ac_1;
    tmp_13.nn_1 = this_14;
    this.on_1 = mutableListOf([this.zm_1, this.an_1, this.bn_1, this.cn_1, this.dn_1, this.en_1, this.fn_1, this.gn_1, this.hn_1, this.in_1, this.jn_1, this.kn_1, this.ln_1, this.mn_1, this.nn_1]);
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.pn_1 = [this.zm_1, this.an_1, this.bn_1, this.cn_1];
    var tmp_15 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_15.qn_1 = [this.dn_1, this.en_1, this.fn_1, this.gn_1];
  }
  var Textures_instance;
  function Textures_getInstance() {
    if (Textures_instance == null)
      new Textures();
    return Textures_instance;
  }
  var Timers_Camera_instance;
  var Timers_Water_instance;
  var Timers_WaterLarge_instance;
  var Timers_CloudsAnimation_instance;
  var Timers_CloudsRotation_instance;
  var Timers_BirdsFly_instance;
  var Timers_BirdWings1_instance;
  var Timers_BirdWings2_instance;
  var Timers_Ships_instance;
  var Timers_PenguinIdle_instance;
  var Timers_PenguinIdle2_instance;
  var Timers_SealIdleAnim_instance;
  var Timers_SealWalkAnim_instance;
  var Timers_SealWalkSpline_instance;
  function Companion() {
  }
  protoOf(Companion).io = function (timers) {
    timers.lj(Timers_Water_getInstance(), 720000.0);
    timers.lj(Timers_WaterLarge_getInstance(), 60000.0);
    timers.lj(Timers_CloudsRotation_getInstance(), 300000.0);
    timers.lj(Timers_CloudsAnimation_getInstance(), 15000.0);
    timers.lj(Timers_BirdWings1_getInstance(), 1000.0);
    timers.lj(Timers_BirdWings2_getInstance(), 900.0);
    timers.lj(Timers_BirdsFly_getInstance(), 75000.0);
    timers.lj(Timers_Ships_getInstance(), 200000.0);
    timers.lj(Timers_PenguinIdle_getInstance(), 5000.0);
    timers.lj(Timers_PenguinIdle2_getInstance(), 5000.0);
    timers.lj(Timers_SealIdleAnim_getInstance(), 4000.0);
    timers.lj(Timers_SealWalkAnim_getInstance(), 1900.0);
    timers.lj(Timers_SealWalkSpline_getInstance(), 114000.0);
  };
  var Companion_instance_2;
  function Companion_getInstance() {
    return Companion_instance_2;
  }
  var Timers_entriesInitialized;
  function Timers_initEntries() {
    if (Timers_entriesInitialized)
      return Unit_instance;
    Timers_entriesInitialized = true;
    Timers_Camera_instance = new Timers('Camera', 0);
    Timers_Water_instance = new Timers('Water', 1);
    Timers_WaterLarge_instance = new Timers('WaterLarge', 2);
    Timers_CloudsAnimation_instance = new Timers('CloudsAnimation', 3);
    Timers_CloudsRotation_instance = new Timers('CloudsRotation', 4);
    Timers_BirdsFly_instance = new Timers('BirdsFly', 5);
    Timers_BirdWings1_instance = new Timers('BirdWings1', 6);
    Timers_BirdWings2_instance = new Timers('BirdWings2', 7);
    Timers_Ships_instance = new Timers('Ships', 8);
    Timers_PenguinIdle_instance = new Timers('PenguinIdle', 9);
    Timers_PenguinIdle2_instance = new Timers('PenguinIdle2', 10);
    Timers_SealIdleAnim_instance = new Timers('SealIdleAnim', 11);
    Timers_SealWalkAnim_instance = new Timers('SealWalkAnim', 12);
    Timers_SealWalkSpline_instance = new Timers('SealWalkSpline', 13);
  }
  function Timers(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Timers_Water_getInstance() {
    Timers_initEntries();
    return Timers_Water_instance;
  }
  function Timers_WaterLarge_getInstance() {
    Timers_initEntries();
    return Timers_WaterLarge_instance;
  }
  function Timers_CloudsAnimation_getInstance() {
    Timers_initEntries();
    return Timers_CloudsAnimation_instance;
  }
  function Timers_CloudsRotation_getInstance() {
    Timers_initEntries();
    return Timers_CloudsRotation_instance;
  }
  function Timers_BirdsFly_getInstance() {
    Timers_initEntries();
    return Timers_BirdsFly_instance;
  }
  function Timers_BirdWings1_getInstance() {
    Timers_initEntries();
    return Timers_BirdWings1_instance;
  }
  function Timers_BirdWings2_getInstance() {
    Timers_initEntries();
    return Timers_BirdWings2_instance;
  }
  function Timers_Ships_getInstance() {
    Timers_initEntries();
    return Timers_Ships_instance;
  }
  function Timers_PenguinIdle_getInstance() {
    Timers_initEntries();
    return Timers_PenguinIdle_instance;
  }
  function Timers_PenguinIdle2_getInstance() {
    Timers_initEntries();
    return Timers_PenguinIdle2_instance;
  }
  function Timers_SealIdleAnim_getInstance() {
    Timers_initEntries();
    return Timers_SealIdleAnim_instance;
  }
  function Timers_SealWalkAnim_getInstance() {
    Timers_initEntries();
    return Timers_SealWalkAnim_instance;
  }
  function Timers_SealWalkSpline_getInstance() {
    Timers_initEntries();
    return Timers_SealWalkSpline_instance;
  }
  function Cameras_0() {
    Cameras_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [new CameraPositionPair(new CameraPosition(new Vec3(1595.2762, -1516.1268, 83.44518), new Vec3(-569.53894, -770.3358, 151.01573)), new CameraPosition(new Vec3(1957.1698, 1356.8844, 83.44518), new Vec3(-515.5615, -151.354, 151.01573)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-829.46936, -908.0382, 136.9292), new Vec3(-165.64581, 1195.0557, 251.3715)), new CameraPosition(new Vec3(1024.0853, -362.24524, 136.9292), new Vec3(1414.9342, 567.3635, 251.3715)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-243.95557, 1205.2717, 136.9292), new Vec3(362.46558, -880.0043, 251.3715)), new CameraPosition(new Vec3(-819.9841, -194.45178, 136.9292), new Vec3(991.0796, 1096.154, 251.3715)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(81.35687, -835.5989, 39.98031), new Vec3(334.3451, -294.1427, 394.6469)), new CameraPosition(new Vec3(895.4863, -925.46606, 39.98031), new Vec3(1337.5438, -802.4769, 725.81354)), 1.0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.tp_1 = [tmp_0, [new CameraPositionPair(new CameraPosition(new Vec3(-842.0926, -846.5076, 129.98555), new Vec3(-674.4083, 775.07825, 47.71223)), new CameraPosition(new Vec3(-828.56775, 790.18756, 129.86708), new Vec3(940.84375, 1304.5559, 46.237785)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-1442.4281, -137.39117, 400.79602), new Vec3(98.2589, -729.51196, 445.23422)), new CameraPosition(new Vec3(-165.14899, 2.8690004, 130.22337), new Vec3(1178.7565, 470.28696, 214.73752)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-451.56958, -252.30167, 587.1848), new Vec3(-898.23376, 597.8059, 38.427677)), new CameraPosition(new Vec3(1161.2458, -52.537415, 721.2996), new Vec3(1249.9236, 615.2596, 46.237785)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-1809.4268, 206.302, 822.04504), new Vec3(-704.4282, -1200.5166, 570.46594)), new CameraPosition(new Vec3(485.292, 0.00439453, 654.2626), new Vec3(740.58057, 152.70099, 570.47485)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-1201.3511, -321.01813, 1267.3562), new Vec3(-1091.3955, 484.66968, -120.63285)), new CameraPosition(new Vec3(348.40283, 333.19476, 531.56305), new Vec3(1243.907, 207.53552, 454.83487)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(1280.2383, 0.00817871, 765.05676), new Vec3(1020.4136, -0.0057373, 681.30115)), new CameraPosition(new Vec3(-542.4983, -0.00439453, 765.0978), new Vec3(-716.4851, 0.00195313, 656.9107)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(684.19763, -906.22656, 562.2279), new Vec3(293.5536, -235.00806, 457.9884)), new CameraPosition(new Vec3(-355.00952, 702.02734, 585.4181), new Vec3(582.56335, 400.67163, 433.59796)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(255.49573, -216.34082, 356.14874), new Vec3(621.0696, 213.13354, 377.2011)), new CameraPosition(new Vec3(-261.60974, 210.44629, 9.956253), new Vec3(444.66296, 48.16748, 614.7096)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(187.09607, -779.0669, 151.3941), new Vec3(-729.9801, -1107.8511, 366.46796)), new CameraPosition(new Vec3(181.64563, 716.58813, 151.3935), new Vec3(-921.05164, -237.90332, 366.46844)), 1.0)]];
  }
  var Cameras_instance_0;
  function Cameras_getInstance_0() {
    if (Cameras_instance_0 == null)
      new Cameras_0();
    return Cameras_instance_0;
  }
  function DrawClockCommand() {
    Command.call(this);
    this.up_1 = CommandType_CUSTOM_getInstance();
  }
  protoOf(DrawClockCommand).oa = function () {
    return this.up_1;
  };
  function BrutalismScene() {
    Scene.call(this);
    this.timers = new TimersMap();
    this.aq_1 = 1000000.0;
    this.bq_1 = 22000.0;
    this.cq_1 = 3500.0;
    this.FOV_TRANSITION = 20.0;
    this.uq_1 = mutableListOf([get_HINT_VRS_NONE()]);
    this.Z_NEAR = 20.0;
    this.Z_FAR = 10000.0;
    this.FOV_LANDSCAPE = 85.0;
    this.FOV_PORTRAIT = 100.0;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new BrutalismSettings();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_0.lowQuality = false;
    this_0.cameraPeriod = 1.0;
    this_0.vignette = true;
    this_0.clock = false;
    this_0.blurred = false;
    this_0.colorMode = ColorMode_Normal_getInstance();
    this_0.autoSwitchCameras = true;
    tmp.settings = this_0;
    this.cameraAnimator = new CameraPathAnimator(this.aq_1, this.bq_1, this.cq_1, true);
    this.cameraAnimator.setCameras(Cameras_getInstance_0().tp_1[1]);
    this.cameraAnimator.minDurationCoefficient = this.settings.cameraPeriod;
    this.sq_1 = new Vec4(1.0, 1.0, 1.0, 1.0);
    this.tq_1 = new Vec4(0.74, 0.55, 0.3, 1.0);
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new ClearColorCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_1.color = this.sq_1;
    this_1.name = 'clear color';
    this_1.enabled = true;
    tmp_0.rq_1 = this_1;
    var attribs = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6)]), 12);
    // Inline function 'kotlin.apply' call
    var this_2 = MeshConstructor1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_2.fileName = 'room1';
    this_2.attributes = attribs;
    var meshRoom1 = this_2;
    // Inline function 'kotlin.apply' call
    var this_3 = MeshConstructor1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_3.fileName = 'room2-optimized0';
    this_3.attributes = attribs;
    var meshRoom20 = this_3;
    // Inline function 'kotlin.apply' call
    var this_4 = MeshConstructor1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_4.fileName = 'room2-optimized1';
    this_4.attributes = attribs;
    var meshRoom21 = this_4;
    // Inline function 'kotlin.apply' call
    var this_5 = MeshConstructor1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_5.fileName = 'room2-optimized2';
    this_5.attributes = attribs;
    var meshRoom22 = this_5;
    this.meshes = mutableListOf([meshRoom1, meshRoom20, meshRoom21, meshRoom22]);
    // Inline function 'kotlin.apply' call
    var this_6 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_6.name = 'room1';
    this_6.fileName = 'room1';
    this_6.format = TextureFormat_ASTC_getInstance();
    this_6.mipmaps = 11;
    this_6.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_6.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_6.anisotropy = 3;
    var texRoom1 = this_6;
    // Inline function 'kotlin.apply' call
    var this_7 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_7.name = 'room20';
    this_7.fileName = 'room20';
    this_7.format = TextureFormat_ASTC_getInstance();
    this_7.mipmaps = 12;
    this_7.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_7.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_7.anisotropy = 3;
    this_7.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    var texRoom20 = this_7;
    // Inline function 'kotlin.apply' call
    var this_8 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_8.name = 'room21';
    this_8.fileName = 'room21';
    this_8.format = TextureFormat_ASTC_getInstance();
    var texRoom21 = this_8;
    // Inline function 'kotlin.apply' call
    var this_9 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_9.name = 'room22';
    this_9.fileName = 'room22';
    this_9.format = TextureFormat_ASTC_getInstance();
    var texRoom22 = this_9;
    this.textures = mutableListOf([texRoom1, texRoom20, texRoom21, texRoom22]);
    // Inline function 'kotlin.apply' call
    var this_10 = new Shader();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_10.name = 'Diffuse';
    var shaderDiffuse = this_10;
    this.shaders = mutableListOf([shaderDiffuse]);
    var stateDiffuseFp16 = new DrawMeshState(shaderDiffuse, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_HALF2_getInstance(), 6)]), 12));
    var txOrigin = new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0));
    var txOriginRoom2 = new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0));
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_11 = new GroupCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_11.name = 'room1';
    this_11.enabled = false;
    var tmp_2 = this_11;
    // Inline function 'kotlin.apply' call
    var this_12 = new DrawTransformedMeshCommand(meshRoom1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texRoom1)]), stateDiffuseFp16, txOrigin);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>.<anonymous>' call
    this_12.hints = this.uq_1;
    tmp_2.commands = mutableListOf([this_12]);
    tmp_1.dq_1 = this_11;
    var tmp_3 = this;
    // Inline function 'kotlin.apply' call
    var this_13 = new GroupCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_13.name = 'room1-blurred';
    var tmp_4 = this_13;
    // Inline function 'kotlin.apply' call
    var this_14 = new DrawTransformedMeshCommand(meshRoom1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texRoom21)]), stateDiffuseFp16, txOrigin);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>.<anonymous>' call
    this_14.hints = mutableListOf([get_HINT_VRS_4X4()]);
    tmp_4.commands = mutableListOf([this_14]);
    tmp_3.eq_1 = this_13;
    var tmp_5 = this;
    // Inline function 'kotlin.apply' call
    var this_15 = new GroupCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_15.name = 'room2';
    this_15.enabled = true;
    var tmp_6 = this_15;
    // Inline function 'kotlin.apply' call
    var this_16 = new DrawTransformedMeshCommand(meshRoom20, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texRoom20)]), stateDiffuseFp16, txOriginRoom2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>.<anonymous>' call
    this_16.hints = this.uq_1;
    var tmp_7 = this_16;
    // Inline function 'kotlin.apply' call
    var this_17 = new DrawTransformedMeshCommand(meshRoom21, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texRoom21)]), stateDiffuseFp16, txOriginRoom2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>.<anonymous>' call
    this_17.hints = mutableListOf([get_HINT_VRS_4X4()]);
    var tmp_8 = this_17;
    // Inline function 'kotlin.apply' call
    var this_18 = new DrawTransformedMeshCommand(meshRoom22, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texRoom22)]), stateDiffuseFp16, txOriginRoom2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>.<anonymous>' call
    this_18.hints = mutableListOf([get_HINT_VRS_4X4()]);
    tmp_6.commands = mutableListOf([tmp_7, tmp_8, this_18]);
    tmp_5.fq_1 = this_15;
    var tmp_9 = this;
    // Inline function 'kotlin.apply' call
    var this_19 = new GroupCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_19.name = 'room2-blurred';
    var tmp_10 = this_19;
    // Inline function 'kotlin.apply' call
    var this_20 = new DrawTransformedMeshCommand(meshRoom20, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texRoom21)]), stateDiffuseFp16, txOriginRoom2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>.<anonymous>' call
    this_20.hints = mutableListOf([get_HINT_VRS_4X4()]);
    var tmp_11 = this_20;
    // Inline function 'kotlin.apply' call
    var this_21 = new DrawTransformedMeshCommand(meshRoom21, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texRoom21)]), stateDiffuseFp16, txOriginRoom2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>.<anonymous>' call
    this_21.hints = mutableListOf([get_HINT_VRS_4X4()]);
    var tmp_12 = this_21;
    // Inline function 'kotlin.apply' call
    var this_22 = new DrawTransformedMeshCommand(meshRoom22, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texRoom22)]), stateDiffuseFp16, txOriginRoom2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>.<anonymous>' call
    this_22.hints = mutableListOf([get_HINT_VRS_4X4()]);
    tmp_10.commands = mutableListOf([tmp_11, tmp_12, this_22]);
    tmp_9.gq_1 = this_19;
    var tmp_13 = this;
    // Inline function 'kotlin.apply' call
    var this_23 = new GroupCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    var tmp_14 = this_23;
    // Inline function 'kotlin.apply' call
    var this_24 = new ClearCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>.<anonymous>' call
    this_24.clearType = ClearCommandClearType_COLOR_AND_DEPTH_getInstance();
    tmp_14.commands = mutableListOf([this.rq_1, this_24]);
    tmp_13.hq_1 = this_23;
    var tmp_15 = this;
    // Inline function 'kotlin.apply' call
    var this_25 = new BlurredPassCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_25.name = 'bloom1';
    this_25.enabled = false;
    this_25.minSize = 170;
    this_25.brightness = 1.0;
    this_25.blurSize = BlurSize_KERNEL_5_getInstance();
    this_25.commands = mutableListOf([this.hq_1, this.eq_1]);
    this_25.id = 0;
    tmp_15.iq_1 = this_25;
    var tmp_16 = this;
    // Inline function 'kotlin.apply' call
    var this_26 = new BlurredPassCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_26.name = 'bloom2';
    this_26.enabled = true;
    this_26.minSize = 170;
    this_26.brightness = 1.0;
    this_26.blurSize = BlurSize_KERNEL_5_getInstance();
    this_26.commands = mutableListOf([this.hq_1, this.gq_1]);
    this_26.id = 1;
    tmp_16.jq_1 = this_26;
    var tmp_17 = this;
    // Inline function 'kotlin.apply' call
    var this_27 = new DrawBlurredCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_27.name = 'draw bloom';
    var tmp_18 = this_27;
    // Inline function 'kotlin.apply' call
    var this_28 = new Blending();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>.<anonymous>' call
    this_28.enabled = true;
    this_28.equationColor = BlendingEquation_ADD_getInstance();
    this_28.sourceFactorColor = BlendingFactor_ONE_getInstance();
    this_28.destinationFactorColor = BlendingFactor_ONE_getInstance();
    tmp_18.blending = this_28;
    tmp_17.kq_1 = this_27;
    var tmp_19 = this;
    // Inline function 'kotlin.apply' call
    var this_29 = new DrawBlurredCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_29.name = 'draw blurred';
    this_29.blending = get_BLENDING_NONE();
    tmp_19.lq_1 = this_29;
    var tmp_20 = this;
    // Inline function 'kotlin.apply' call
    var this_30 = new VignetteCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_30.color0 = new Vec4(0.4, 0.4, 0.4, 1.0);
    this_30.color1 = new Vec4(1.0, 1.0, 1.0, 1.0);
    tmp_20.mq_1 = this_30;
    this.nq_1 = new DrawClockCommand();
    this.oq_1 = GroupCommandArr(true, [this.iq_1, this.jq_1, MainPassCommandArr(true, [this.hq_1, this.dq_1, this.fq_1, this.kq_1, this.mq_1, this.nq_1])]);
    var tmp_21 = this;
    // Inline function 'kotlin.apply' call
    var this_31 = new BlurredPassCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.brutalism.BrutalismScene.<anonymous>' call
    this_31.name = 'blurred-main';
    this_31.enabled = true;
    this_31.minSize = 200;
    this_31.brightness = 0.93;
    this_31.blurSize = BlurSize_KERNEL_3_getInstance();
    this_31.commands = mutableListOf([this.hq_1, this.dq_1, this.fq_1, this.mq_1]);
    this_31.id = 2;
    tmp_21.qq_1 = this_31;
    this.pq_1 = GroupCommandArr(true, [this.qq_1, MainPassCommandArr(true, [this.hq_1, this.lq_1])]);
    this.commands = mutableListOf([this.oq_1, this.pq_1]);
  }
  protoOf(BrutalismScene).jo = function () {
    return this.timers;
  };
  protoOf(BrutalismScene).ko = function () {
    return this.cameraAnimator;
  };
  protoOf(BrutalismScene).lo = function () {
    return this.FOV_TRANSITION;
  };
  protoOf(BrutalismScene).mo = function () {
    return this.settings;
  };
  protoOf(BrutalismScene).updateTimers = function (time) {
    this.timers.qj(time);
    this.cameraAnimator.animate(time);
    this.animate();
    protoOf(Scene).updateTimers.call(this, time);
  };
  protoOf(BrutalismScene).updateViewportSize = function (width, height) {
    protoOf(Scene).updateViewportSize.call(this, width, height);
  };
  protoOf(BrutalismScene).initialize = function () {
  };
  protoOf(BrutalismScene).applySettings = function () {
    this.oq_1.enabled = !this.settings.blurred;
    this.pq_1.enabled = this.settings.blurred;
    this.iq_1.blurSize = this.settings.lowQuality ? BlurSize_KERNEL_3_getInstance() : BlurSize_KERNEL_5_getInstance();
    this.jq_1.blurSize = this.settings.lowQuality ? BlurSize_KERNEL_3_getInstance() : BlurSize_KERNEL_5_getInstance();
    this.uq_1.w(0, this.settings.lowQuality ? get_HINT_VRS_2X2() : get_HINT_VRS_NONE());
    this.mq_1.enabled = this.settings.vignette;
    if (!(this.cameraAnimator.minDurationCoefficient === this.settings.cameraPeriod)) {
      this.cameraAnimator.minDurationCoefficient = this.settings.cameraPeriod;
    }
    this.nq_1.enabled = this.settings.clock;
    if ((this.cameraAnimator.timer > 0.98 ? this.settings.autoSwitchCameras : false) ? Default_getInstance().c6() < 0.5 : false) {
      this.randomCameraOrNextRoom();
    }
    this.rq_1.color = this.settings.colorMode.equals(ColorMode_Sepia_getInstance()) ? this.tq_1 : this.sq_1;
  };
  protoOf(BrutalismScene).animate = function () {
    this.applySettings();
    this.calculateProjection();
    var cameraPositionInterpolator = this.cameraAnimator.positionInterpolator;
    var eye = cameraPositionInterpolator.cameraPosition;
    var lookat = cameraPositionInterpolator.cameraRotation;
    if (!this.useExternalViewMatrix) {
      Matrix_getInstance().di(this.matView, 0, eye.x, eye.y, eye.z, lookat.x, lookat.y, lookat.z, 0.0, 0.0, 1.0);
    }
    this.updateMeshTransformations(this.commands);
  };
  protoOf(BrutalismScene).nextCamera = function () {
    this.cameraAnimator.nextCamera();
  };
  protoOf(BrutalismScene).nextRoom = function () {
    if (this.dq_1.enabled) {
      this.dq_1.enabled = false;
      this.fq_1.enabled = true;
      this.iq_1.enabled = false;
      this.jq_1.enabled = true;
      this.cameraAnimator.setCameras(Cameras_getInstance_0().tp_1[1], true);
    } else if (this.fq_1.enabled) {
      this.dq_1.enabled = true;
      this.fq_1.enabled = false;
      this.iq_1.enabled = true;
      this.jq_1.enabled = false;
      this.cameraAnimator.setCameras(Cameras_getInstance_0().tp_1[0], true);
    }
  };
  protoOf(BrutalismScene).nextCameraOrRoom = function () {
    if (this.cameraAnimator.state.equals(CameraState_TRANSITIONING_getInstance())) {
      return Unit_instance;
    }
    var switchRoomProbability = this.dq_1.enabled ? 0.75 : 0.25;
    if (Default_getInstance().c6() < switchRoomProbability) {
      this.nextRoom();
    } else {
      this.nextCamera();
    }
  };
  protoOf(BrutalismScene).randomCameraOrNextRoom = function () {
    if (this.cameraAnimator.state.equals(CameraState_TRANSITIONING_getInstance())) {
      return Unit_instance;
    }
    var switchRoomProbability = this.dq_1.enabled ? 0.75 : 0.25;
    if (Default_getInstance().c6() < switchRoomProbability) {
      this.nextRoom();
    } else {
      this.cameraAnimator.positionInterpolator.reverse = Default_getInstance().c6() < 0.5;
      this.cameraAnimator.randomCamera();
    }
  };
  function BrutalismSettings() {
    this.lowQuality = false;
    this.cameraPeriod = 1.0;
    this.vignette = true;
    this.clock = false;
    this.blurred = false;
    this.colorMode = ColorMode_Normal_getInstance();
    this.autoSwitchCameras = true;
  }
  protoOf(BrutalismSettings).rp = function (_set____db54di) {
    this.lowQuality = _set____db54di;
  };
  protoOf(BrutalismSettings).sp = function () {
    return this.lowQuality;
  };
  protoOf(BrutalismSettings).fp = function (_set____db54di) {
    this.cameraPeriod = _set____db54di;
  };
  protoOf(BrutalismSettings).gp = function () {
    return this.cameraPeriod;
  };
  protoOf(BrutalismSettings).hp = function (_set____db54di) {
    this.vignette = _set____db54di;
  };
  protoOf(BrutalismSettings).ip = function () {
    return this.vignette;
  };
  protoOf(BrutalismSettings).pp = function (_set____db54di) {
    this.clock = _set____db54di;
  };
  protoOf(BrutalismSettings).qp = function () {
    return this.clock;
  };
  protoOf(BrutalismSettings).jp = function (_set____db54di) {
    this.blurred = _set____db54di;
  };
  protoOf(BrutalismSettings).kp = function () {
    return this.blurred;
  };
  protoOf(BrutalismSettings).vq = function (_set____db54di) {
    this.colorMode = _set____db54di;
  };
  protoOf(BrutalismSettings).wq = function () {
    return this.colorMode;
  };
  protoOf(BrutalismSettings).lp = function (_set____db54di) {
    this.autoSwitchCameras = _set____db54di;
  };
  protoOf(BrutalismSettings).mp = function () {
    return this.autoSwitchCameras;
  };
  function Cameras_1() {
    Cameras_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.xq_1 = [new CameraPositionPair(new CameraPosition(new Vec3(4.70217, 28.08873, 270.66443), new Vec3(5.00588, -3.6056, 275.06628)), new CameraPosition(new Vec3(3.12283, 192.89926, 247.77449), new Vec3(5.00588, -3.6056, 275.06628)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-167.48071, -247.32603, 395.07346), new Vec3(0.846, 0.52085, 0.0)), new CameraPosition(new Vec3(152.95543, -114.2289, 420.22528), new Vec3(1.062, 5.25603, 0.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(158.38203, -171.77576, 113.49699), new Vec3(81.33907, -44.77591, 97.18001)), new CameraPosition(new Vec3(142.91772, 36.96619, 102.5881), new Vec3(81.33907, -44.77591, 97.18001)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-103.18249, -51.5279, 135.98773), new Vec3(-69.98534, 2.29645, 78.0)), new CameraPosition(new Vec3(-102.42075, 79.90053, 96.44623), new Vec3(-69.98534, 2.29645, 78.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-60.00303, -233.00087, 134.61186), new Vec3(-2.0, -171.0, 152.0)), new CameraPosition(new Vec3(59.45997, -200.96883, 192.98213), new Vec3(-2.0, -171.0, 152.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-37.85454, 253.6224, 86.5639), new Vec3(-11.55309, 91.53834, 40.85777)), new CameraPosition(new Vec3(78.33339, 78.01169, 391.95297), new Vec3(20.69628, -1.54488, 246.84042)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-285.20566, 143.63365, 294.8095), new Vec3(0.492, 1.944, 100.0)), new CameraPosition(new Vec3(-208.13516, -316.1127, 249.54102), new Vec3(0.474, 0.84, 150.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-0.54002, 275.47906, 29.0), new Vec3(-33.0, -7.0, 85.0)), new CameraPosition(new Vec3(-237.66232, 128.6006, 29.0), new Vec3(-33.0, -7.0, 85.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(385.65573, -254.91086, 34.32199), new Vec3(172.69778, -349.50497, 89.22903)), new CameraPosition(new Vec3(228.97934, 319.29816, 34.32199), new Vec3(6.75666, 258.66278, 89.22903)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-170.00986, -272.70618, 22.899), new Vec3(0.0, 0.0, 100.0)), new CameraPosition(new Vec3(223.77429, -293.52405, 22.77371), new Vec3(0.0, 0.0, 200.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(154.41058, -342.53302, 229.82729), new Vec3(0.0, 0.0, 0.0)), new CameraPosition(new Vec3(281.98663, 86.11906, 272.93246), new Vec3(63.22815, 10.94927, 260.0)), 1.0)];
  }
  var Cameras_instance_1;
  function Cameras_getInstance_1() {
    if (Cameras_instance_1 == null)
      new Cameras_1();
    return Cameras_instance_1;
  }
  function Meshes_0() {
    Meshes_instance_0 = this;
    this.yq_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6)]), 12);
    this.zq_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0)), 8);
    this.ar_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_FLOAT3_getInstance(), 0)), 12);
    this.br_1 = MeshConstructor2('grass', this.yq_1);
    this.cr_1 = MeshConstructor2('bouy1', this.yq_1);
    this.dr_1 = MeshConstructor2('boat', this.yq_1);
    this.er_1 = MeshConstructor2('bird1', this.yq_1);
    this.fr_1 = MeshConstructor2('bird2', this.yq_1);
    this.gr_1 = MeshConstructor2('grid30', this.zq_1);
    this.hr_1 = MeshConstructor2('stars', this.ar_1);
    this.ir_1 = MeshConstructor2('clouds', this.yq_1);
    this.jr_1 = MeshConstructor2('fishnet', this.yq_1);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.kr_1 = [MeshConstructor2('arrow', this.yq_1), MeshConstructor2('barrel', this.yq_1), MeshConstructor2('box', this.yq_1), MeshConstructor2('bricks', this.yq_1), MeshConstructor2('dock', this.yq_1), MeshConstructor2('fence', this.yq_1), MeshConstructor2('fence_topLighthouse', this.yq_1), MeshConstructor2('fish', this.yq_1), MeshConstructor2('fishingspot', this.yq_1), MeshConstructor2('fish_rope', this.yq_1), MeshConstructor2('hengel', this.yq_1), MeshConstructor2('house', this.yq_1), MeshConstructor2('lifebouy-rope', this.yq_1), MeshConstructor2('lifebouy', this.yq_1), MeshConstructor2('lighthouse', this.yq_1), MeshConstructor2('poles', this.yq_1), MeshConstructor2('rock', this.yq_1), MeshConstructor2('roof-tile', this.yq_1), MeshConstructor2('sign', this.yq_1), MeshConstructor2('smallPoles', this.yq_1), MeshConstructor2('SupportBeams', this.yq_1), MeshConstructor2('telescope', this.yq_1), MeshConstructor2('tree', this.yq_1)];
    this.lr_1 = mutableListOf(arrayConcat([this.kr_1, [this.br_1, this.cr_1, this.dr_1, this.er_1, this.fr_1, this.gr_1, this.hr_1, this.ir_1, this.jr_1]]));
  }
  var Meshes_instance_0;
  function Meshes_getInstance_0() {
    if (Meshes_instance_0 == null)
      new Meshes_0();
    return Meshes_instance_0;
  }
  function Preset(fogColor, waterColor, highlightColor, tintColor, cloudsColor) {
    fogColor = fogColor === VOID ? new Vec4() : fogColor;
    waterColor = waterColor === VOID ? new Vec4() : waterColor;
    highlightColor = highlightColor === VOID ? new Vec4() : highlightColor;
    tintColor = tintColor === VOID ? new Vec4() : tintColor;
    cloudsColor = cloudsColor === VOID ? new Vec4() : cloudsColor;
    this.mr_1 = fogColor;
    this.nr_1 = waterColor;
    this.or_1 = highlightColor;
    this.pr_1 = tintColor;
    this.qr_1 = cloudsColor;
  }
  protoOf(Preset).toString = function () {
    return 'Preset(fogColor=' + this.mr_1 + ', waterColor=' + this.nr_1 + ', highlightColor=' + this.or_1 + ', tintColor=' + this.pr_1 + ', cloudsColor=' + this.qr_1 + ')';
  };
  protoOf(Preset).hashCode = function () {
    var result = this.mr_1.hashCode();
    result = imul(result, 31) + this.nr_1.hashCode() | 0;
    result = imul(result, 31) + this.or_1.hashCode() | 0;
    result = imul(result, 31) + this.pr_1.hashCode() | 0;
    result = imul(result, 31) + this.qr_1.hashCode() | 0;
    return result;
  };
  protoOf(Preset).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Preset))
      return false;
    var tmp0_other_with_cast = other instanceof Preset ? other : THROW_CCE();
    if (!this.mr_1.equals(tmp0_other_with_cast.mr_1))
      return false;
    if (!this.nr_1.equals(tmp0_other_with_cast.nr_1))
      return false;
    if (!this.or_1.equals(tmp0_other_with_cast.or_1))
      return false;
    if (!this.pr_1.equals(tmp0_other_with_cast.pr_1))
      return false;
    if (!this.qr_1.equals(tmp0_other_with_cast.qr_1))
      return false;
    return true;
  };
  function Presets() {
    Presets_instance = this;
    this.rr_1 = new Vec4(0.56, 0.44, 0.26);
    this.sr_1 = new Vec4(0.6, 0.6, 0.6);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.tr_1 = [new Preset(new Vec4(0.7647058823529411, 0.9098039215686274, 0.9450980392156862, 1.0), new Vec4(0.387, 0.75, 0.795, 1.0), new Vec4(0.7843137254901961, 0.7843137254901961, 0.7843137254901961, 1.0), new Vec4(1.0, 1.0, 1.0, 1.0), new Vec4(1.0, 1.0, 1.0, 1.0)), new Preset(new Vec4(0.03137254901960784, 0.11372549019607843, 0.1843137254901961, 1.0), new Vec4(0.03529411764705882, 0.17254901960784313, 0.3176470588235294, 1.0), new Vec4(0.3137254901960784, 0.3137254901960784, 0.3137254901960784, 1.0), new Vec4(0.5215686274509804, 0.8705882352941177, 1.0, 1.0), new Vec4(0.0784313725490196, 0.3254901960784314, 0.47058823529411764, 1.0)), new Preset(new Vec4(1.0, 0.7686274509803922, 0.35294117647058826, 1.0), new Vec4(0.592156862745098, 0.6313725490196078, 0.5098039215686274, 1.0), new Vec4(0.5019607843137255, 0.43529411764705883, 0.23529411764705882, 1.0), new Vec4(1.0, 0.8705882352941177, 0.4745098039215686, 1.0), new Vec4(1.0, 0.8705882352941177, 0.47058823529411764, 1.0)), new Preset(new Vec4(0.21568627450980393, 0.2196078431372549, 0.47058823529411764, 1.0), new Vec4(0.0784313725490196, 0.20784313725490197, 0.4549019607843137, 1.0), new Vec4(0.5294117647058824, 0.3215686274509804, 0.48627450980392156, 1.0), new Vec4(0.9607843137254902, 0.7529411764705882, 0.9176470588235294, 1.0), new Vec4(0.9607843137254902, 0.7137254901960784, 0.8784313725490196, 1.0))];
  }
  var Presets_instance;
  function Presets_getInstance() {
    if (Presets_instance == null)
      new Presets();
    return Presets_instance;
  }
  function applySettings($this) {
    $this.vs_1.w(0, $this.settings.lowQuality ? get_HINT_VRS_2X2() : get_HINT_VRS_NONE());
    $this.as_1.enabled = !$this.settings.blurred;
    $this.bs_1.enabled = $this.settings.blurred;
    $this.fs_1.enabled = $this.settings.vignette;
    $this.cs_1.blurSize = $this.settings.lowQuality ? BlurSize_KERNEL_2_getInstance() : BlurSize_KERNEL_4_getInstance();
    $this.fs_1.enabled = !$this.settings.lowQuality;
    if (!($this.cameraAnimator.minDurationCoefficient === $this.settings.cameraPeriod)) {
      $this.cameraAnimator.minDurationCoefficient = $this.settings.cameraPeriod;
    }
    if (($this.cameraAnimator.timer > 0.99 ? $this.settings.autoSwitchCameras : false) ? Default_getInstance().c6() < 0.5 : false) {
      $this.randomCamera();
    }
    $this.ls_1.enabled = $this.settings.timeOfDay.equals(TimeOfDay_Night_getInstance_0());
  }
  function animate($this, time) {
    applySettings($this);
    positionCamera($this, time);
    $this.calculateProjection();
    animateBouys($this);
    animateBirds($this);
    animateWater($this);
    animateFishnet($this);
    animateWind($this);
    $this.updateMeshTransformations($this.commands);
  }
  function animateWind($this) {
    var timer1 = $this.zr_1.nj(Timers_WindMove1_getInstance());
    var timer2 = $this.zr_1.nj(Timers_WindMove2_getInstance());
    var timer3 = $this.zr_1.nj(Timers_WindMove3_getInstance());
    animateWindBatch($this, 0, timer1, 0.36, $this.ss_1);
    animateWindBatch($this, 3, timer2, 0.37, $this.ts_1);
    animateWindBatch($this, 6, timer3, 0.38, $this.us_1);
  }
  function animateWindBatch($this, offset, timerWindMove, timerPhase, randomWindCoeff) {
    var X_SPREAD = 22.0;
    var inductionVariable = 0;
    if (inductionVariable <= 2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = $this.os_1.commands.t(offset + i | 0);
        var uniforms = (tmp instanceof DrawTransformedMeshCommand ? tmp : THROW_CCE()).uniforms;
        var timer = (timerWindMove + i * timerPhase) % 1.0;
        // Inline function 'kotlin.math.pow' call
        // Inline function 'kotlin.math.sin' call
        var x = timer * $this.PIf;
        var this_0 = Math.sin(x);
        var a = Math.pow(this_0, 2.0);
        var color = $this.rs_1 * a;
        var offsetX = -X_SPREAD + i * X_SPREAD + X_SPREAD * randomWindCoeff;
        var offsetY = timer * 2.0 * $this.ps_1;
        setUniform(uniforms.t(1), color, color, color, 1.0);
        setUniform_3(uniforms.t(2), offsetX, offsetY * 10.0, 0.0);
      }
       while (inductionVariable <= 2);
  }
  function animateBouys($this) {
    var timerBob = $this.zr_1.nj(Timers_BouysBobbing_getInstance());
    var timerRot = $this.zr_1.nj(Timers_BouysRotation_getInstance());
    // Inline function 'kotlin.math.sin' call
    var x = timerBob * $this.PIf * 2.0;
    var bob1 = Math.sin(x) * 4.0;
    // Inline function 'kotlin.math.sin' call
    var x_0 = timerBob * $this.PIf * 2.0 + 1.0;
    var bob2 = Math.sin(x_0) * 4.0;
    // Inline function 'kotlin.math.sin' call
    var x_1 = timerBob * $this.PIf * 2.0 + 2.0;
    var bob3 = Math.sin(x_1) * 4.0;
    // Inline function 'kotlin.math.sin' call
    var x_2 = timerBob * $this.PIf * 2.0 + 3.0;
    var bob4 = Math.sin(x_2) * 4.0;
    var tmp = MathUtils_instance;
    // Inline function 'kotlin.math.sin' call
    var x_3 = timerRot * $this.PIf * 6.0;
    var tmp$ret$4 = Math.sin(x_3);
    var rot1y = tmp.wh(tmp$ret$4 * 0.3);
    var tmp_0 = MathUtils_instance;
    // Inline function 'kotlin.math.cos' call
    var x_4 = timerRot * $this.PIf * 4.0;
    var tmp$ret$5 = Math.cos(x_4);
    var rot1x = tmp_0.wh(tmp$ret$5 * 0.3);
    var tmp_1 = MathUtils_instance;
    // Inline function 'kotlin.math.sin' call
    var x_5 = timerRot * $this.PIf * 4.0 + 2.0;
    var tmp$ret$6 = Math.sin(x_5);
    var rot2y = tmp_1.wh(tmp$ret$6 * 0.3);
    var tmp_2 = MathUtils_instance;
    // Inline function 'kotlin.math.cos' call
    var x_6 = timerRot * $this.PIf * 6.0 + 2.0;
    var tmp$ret$7 = Math.cos(x_6);
    var rot2x = tmp_2.wh(tmp$ret$7 * 0.3);
    // Inline function 'kotlin.math.sin' call
    var x_7 = timerBob * $this.PIf * 2.0;
    var bobBoat = Math.sin(x_7) * 2.0;
    var tmp_3 = $this.is_1.commands.t(0);
    (tmp_3 instanceof DrawTransformedMeshCommand ? tmp_3 : THROW_CCE()).transform.y9_1.z = -5 + bob1;
    var tmp_4 = $this.is_1.commands.t(1);
    (tmp_4 instanceof DrawTransformedMeshCommand ? tmp_4 : THROW_CCE()).transform.y9_1.z = -5 + bob2;
    var tmp_5 = $this.is_1.commands.t(2);
    (tmp_5 instanceof DrawTransformedMeshCommand ? tmp_5 : THROW_CCE()).transform.y9_1.z = -5 + bob3;
    var tmp_6 = $this.is_1.commands.t(3);
    (tmp_6 instanceof DrawTransformedMeshCommand ? tmp_6 : THROW_CCE()).transform.y9_1.z = -5 + bob4;
    var tmp_7 = $this.is_1.commands.t(0);
    (tmp_7 instanceof DrawTransformedMeshCommand ? tmp_7 : THROW_CCE()).transform.z9_1.x = rot1x;
    var tmp_8 = $this.is_1.commands.t(0);
    (tmp_8 instanceof DrawTransformedMeshCommand ? tmp_8 : THROW_CCE()).transform.z9_1.y = rot1y;
    var tmp_9 = $this.is_1.commands.t(1);
    (tmp_9 instanceof DrawTransformedMeshCommand ? tmp_9 : THROW_CCE()).transform.z9_1.x = rot2x;
    var tmp_10 = $this.is_1.commands.t(1);
    (tmp_10 instanceof DrawTransformedMeshCommand ? tmp_10 : THROW_CCE()).transform.z9_1.y = rot2y;
    var tmp_11 = $this.is_1.commands.t(2);
    (tmp_11 instanceof DrawTransformedMeshCommand ? tmp_11 : THROW_CCE()).transform.z9_1.x = rot2x;
    var tmp_12 = $this.is_1.commands.t(2);
    (tmp_12 instanceof DrawTransformedMeshCommand ? tmp_12 : THROW_CCE()).transform.z9_1.y = rot2y;
    var tmp_13 = $this.is_1.commands.t(3);
    (tmp_13 instanceof DrawTransformedMeshCommand ? tmp_13 : THROW_CCE()).transform.z9_1.x = rot1x;
    var tmp_14 = $this.is_1.commands.t(3);
    (tmp_14 instanceof DrawTransformedMeshCommand ? tmp_14 : THROW_CCE()).transform.z9_1.y = rot1y;
    var tmp_15 = $this.is_1.commands.t(4);
    (tmp_15 instanceof DrawTransformedMeshCommand ? tmp_15 : THROW_CCE()).transform.y9_1.z = -1 + bobBoat;
  }
  function animateBirds($this) {
    var timerBob = $this.zr_1.nj(Timers_BirdBobbing_getInstance()) * 100.0;
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.sin' call
    var tmp = Math.sin(timerBob);
    // Inline function 'kotlin.math.cos' call
    var x = timerBob * 3.3;
    var b = tmp + Math.cos(x) * 0.5 - 0.8;
    var a = Math.max(0.0, b);
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.sin' call
    var tmp_0 = Math.sin(timerBob);
    // Inline function 'kotlin.math.sin' call
    var x_0 = timerBob * 3.2;
    var b_0 = tmp_0 + Math.sin(x_0) * 0.5 - 0.8;
    var b_1 = Math.max(0.0, b_0);
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.sin' call
    var tmp_1 = Math.sin(timerBob);
    // Inline function 'kotlin.math.sin' call
    var x_1 = timerBob * 3.1;
    var b_2 = tmp_1 + Math.sin(x_1) * 0.5 - 0.8;
    var c = Math.max(0.0, b_2);
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.sin' call
    var tmp_2 = Math.sin(timerBob);
    // Inline function 'kotlin.math.cos' call
    var x_2 = timerBob * 3.1;
    var b_3 = tmp_2 + Math.cos(x_2) * 0.5 - 0.8;
    var d = Math.max(0.0, b_3);
    var bob1 = a * 2.0;
    var bob2 = b_1 * 1.3;
    var bob3 = c * 2.0;
    var bob4 = d * 1.3;
    var tmp_3 = $this.js_1.commands.t(0);
    (tmp_3 instanceof DrawTransformedMeshCommand ? tmp_3 : THROW_CCE()).transform.y9_1.z = bob1;
    var tmp_4 = $this.js_1.commands.t(1);
    (tmp_4 instanceof DrawTransformedMeshCommand ? tmp_4 : THROW_CCE()).transform.y9_1.z = bob2;
    var tmp_5 = $this.js_1.commands.t(2);
    (tmp_5 instanceof DrawTransformedMeshCommand ? tmp_5 : THROW_CCE()).transform.y9_1.z = -192.1 + bob3;
    var tmp_6 = $this.js_1.commands.t(3);
    (tmp_6 instanceof DrawTransformedMeshCommand ? tmp_6 : THROW_CCE()).transform.y9_1.z = -75.1 + bob4;
  }
  function animateWater($this) {
    var preset = Presets_getInstance().tr_1[$this.settings.timeOfDay.n4_1];
    var time = $this.zr_1.nj(Timers_Water_getInstance_0());
    setUniform_1($this.ks_1.uniforms.t(1), time);
    setUniform_4($this.ks_1.uniforms.t(6), preset.nr_1);
    setUniform_4($this.ks_1.uniforms.t(7), preset.or_1);
    setUniform_4($this.ks_1.uniforms.t(8), preset.mr_1);
    setUniform_4($this.ms_1.uniforms.t(2), preset.qr_1);
    $this.es_1.color = preset.mr_1;
    if ($this.settings.colorMode.equals(ColorMode_Greyscale_getInstance())) {
      $this.es_1.color = Presets_getInstance().sr_1;
      setUniform_4($this.ks_1.uniforms.t(8), Presets_getInstance().sr_1);
    } else if ($this.settings.colorMode.equals(ColorMode_Sepia_getInstance_0())) {
      $this.es_1.color = Presets_getInstance().rr_1;
      setUniform_4($this.ks_1.uniforms.t(8), Presets_getInstance().rr_1);
    }
    $this.ws_1.value[0] = preset.pr_1.r;
    $this.ws_1.value[1] = preset.pr_1.g;
    $this.ws_1.value[2] = preset.pr_1.b;
  }
  function animateFishnet($this) {
    var preset = Presets_getInstance().tr_1[$this.settings.timeOfDay.n4_1];
    var time = $this.zr_1.nj(Timers_Fishnet_getInstance());
    setUniform_4($this.ns_1.uniforms.t(2), preset.or_1);
    setUniform_1($this.ns_1.uniforms.t(3), time);
  }
  function positionCamera($this, time) {
    if ($this.useExternalViewMatrix) {
      return Unit_instance;
    }
    if ($this.settings.cameraMode.equals(CameraMode_Random_getInstance())) {
      var cameraPositionInterpolator = $this.cameraAnimator.positionInterpolator;
      var eye = cameraPositionInterpolator.cameraPosition;
      var lookat = cameraPositionInterpolator.cameraRotation;
      Matrix_getInstance().di($this.matView, 0, eye.x, eye.y, eye.z, lookat.x, lookat.y, lookat.z, 0.0, 0.0, 1.0);
    } else if ($this.settings.cameraMode.equals(CameraMode_Orbiting_getInstance())) {
      var deltaTime = time - $this.lastFrameTime;
      var timerBobX = $this.zr_1.nj(Timers_OrbitingCameraX_getInstance());
      var timerBobZ = $this.zr_1.nj(Timers_OrbitingCameraZ_getInstance());
      $this.orbitingCamera.uj_1.fk_1 = $this.settings.cameraPeriod;
      $this.orbitingCamera.yj(deltaTime, timerBobX, timerBobZ);
      Matrix_getInstance().xh($this.orbitingCamera.xj_1, 0, $this.matView, 0, 16);
    }
  }
  function randomizeCamera($this) {
    if ($this.zr_1.nj(Timers_Camera_getInstance()) === 0.0) {
      $this.xs_1 = Default_getInstance().c6() * $this.PIf * 2.0;
      $this.ys_1 = (Default_getInstance().c6() - 0.3) * $this.PIf * 0.9;
      $this.zs_1 = Default_getInstance().c6() * $this.PIf * 2.0;
      $this.at_1 = (Default_getInstance().c6() - 0.3) * $this.PIf * 0.9;
    } else {
      $this.xs_1 = $this.zs_1;
      $this.ys_1 = $this.at_1;
      $this.zs_1 = Default_getInstance().c6() * $this.PIf * 2.0;
      $this.at_1 = (Default_getInstance().c6() - 0.3) * $this.PIf * 0.9;
    }
    $this.bt_1 = 3300.0;
    $this.bt_1 = 3300.0;
  }
  function CartoonLighthouseScene() {
    Scene.call(this);
    this.zr_1 = new TimersMap();
    this.ps_1 = 45;
    this.qs_1 = 0.1;
    this.rs_1 = 0.25;
    this.ss_1 = Default_getInstance().c6() - 0.5;
    this.ts_1 = Default_getInstance().c6() - 0.5;
    this.us_1 = Default_getInstance().c6() - 0.5;
    this.vs_1 = mutableListOf([get_HINT_VRS_NONE()]);
    this.PIf = 3.1415927;
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    tmp.ws_1 = UniformFloatValueWithArray(tmp$ret$0);
    this.xs_1 = 0.0;
    this.ys_1 = 0.0;
    this.zs_1 = 0.0;
    this.at_1 = 0.0;
    this.bt_1 = 3000.0;
    this.ct_1 = 1000000.0;
    this.dt_1 = 23000.0;
    this.et_1 = 2000.0;
    this.meshes = Meshes_getInstance_0().lr_1;
    this.textures = Textures_getInstance_0().ot_1;
    this.shaders = Shaders_getInstance_0().vt_1;
    Companion_instance_3.xt(this.zr_1);
    this.Z_NEAR = 20.0;
    this.Z_FAR = 5000.0;
    this.FOV_LANDSCAPE = 70.0;
    this.FOV_PORTRAIT = 100.0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new CartoonLighthouseSettings();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_0.cameraPeriod = 1.0;
    this_0.vignette = true;
    this_0.blurred = false;
    this_0.autoSwitchCameras = true;
    this_0.lowQuality = false;
    this_0.clock = false;
    this_0.timeOfDay = TimeOfDay_Day_getInstance_0();
    this_0.cameraMode = CameraMode_Orbiting_getInstance();
    tmp_0.settings = this_0;
    this.orbitingCamera = new OrbitingCamera(new OrbitingCameraConfig());
    this.cameraAnimator = new CameraPathAnimator(this.ct_1, this.dt_1, this.et_1, true);
    this.cameraAnimator.setCameras(Cameras_getInstance_1().xq_1);
    this.cameraAnimator.minDurationCoefficient = this.settings.cameraPeriod;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new ClearColorCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_1.color = new Vec4(0.0, 0.7843137254901961, 0.0, 1.0);
    this_1.name = 'clear color';
    this_1.enabled = true;
    tmp_1.es_1 = this_1;
    var txOrigin = new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 10.0, 10.0));
    var commonVertexAttributesDescriptor = new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_HALF2_getInstance(), 6)]), 12);
    var stateDiffuseColoredFp16 = new DrawMeshState(Shaders_getInstance_0().pt_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), commonVertexAttributesDescriptor);
    var stateDiffuseColoredAtFp16 = new DrawMeshState(Shaders_getInstance_0().qt_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_DISABLED_getInstance(), commonVertexAttributesDescriptor);
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_2 = Meshes_getInstance_0().kr_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList_init_$Create$(this_2.length);
    var index = 0;
    var inductionVariable = 0;
    var last = this_2.length;
    while (inductionVariable < last) {
      var item = this_2[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var tmp$ret$3 = DrawStaticMeshCommandConstructor(item, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_0().nt_1[tmp1]), this.ws_1]), stateDiffuseColoredFp16, txOrigin);
      destination.g(tmp$ret$3);
    }
    var drawStaticParts = copyToArray(destination);
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = DrawStaticMeshCommandConstructor(Meshes_getInstance_0().br_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_0().ft_1), this.ws_1]), stateDiffuseColoredAtFp16, txOrigin);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_3.hints = this.vs_1;
    tmp_2.hs_1 = GroupCommandArr(true, arrayConcat([drawStaticParts, [this_3]]));
    this.is_1 = GroupCommandArr(true, [new DrawTransformedMeshCommand(Meshes_getInstance_0().cr_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_0().gt_1), this.ws_1]), stateDiffuseColoredFp16, new AffineTranformation(new Vec3(-60.0, -215.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 10.0, 10.0))), new DrawTransformedMeshCommand(Meshes_getInstance_0().cr_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_0().gt_1), this.ws_1]), stateDiffuseColoredFp16, new AffineTranformation(new Vec3(-80.0, -145.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 10.0, 10.0))), new DrawTransformedMeshCommand(Meshes_getInstance_0().cr_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_0().gt_1), this.ws_1]), stateDiffuseColoredFp16, new AffineTranformation(new Vec3(80.0, -150.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 10.0, 10.0))), new DrawTransformedMeshCommand(Meshes_getInstance_0().cr_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_0().gt_1), this.ws_1]), stateDiffuseColoredFp16, new AffineTranformation(new Vec3(64.0, 160.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 10.0, 10.0))), new DrawTransformedMeshCommand(Meshes_getInstance_0().dr_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_0().ht_1), this.ws_1]), stateDiffuseColoredFp16, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 10.0, 10.0)))]);
    this.js_1 = GroupCommandArr(true, [new DrawTransformedMeshCommand(Meshes_getInstance_0().er_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_0().it_1), this.ws_1]), stateDiffuseColoredFp16, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 10.0, 10.0))), new DrawTransformedMeshCommand(Meshes_getInstance_0().fr_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_0().it_1), this.ws_1]), stateDiffuseColoredFp16, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 10.0, 10.0))), new DrawTransformedMeshCommand(Meshes_getInstance_0().er_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_0().it_1), this.ws_1]), stateDiffuseColoredFp16, new AffineTranformation(new Vec3(102.7, -18.7, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 10.0, 10.0))), new DrawTransformedMeshCommand(Meshes_getInstance_0().fr_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_0().it_1), this.ws_1]), stateDiffuseColoredFp16, new AffineTranformation(new Vec3(-57.7, 189.4, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 10.0, 10.0)))]);
    var stateWater = new DrawMeshState(Shaders_getInstance_0().rt_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf_0(new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0)), 8));
    var tmp_3 = this;
    // Inline function 'kotlin.apply' call
    var tmp_4 = Meshes_getInstance_0().gr_1;
    var tmp_5 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$8 = new Float32Array([0.0]);
    var tmp_6 = UniformFloatValueWithArray(tmp$ret$8);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$9 = new Float32Array([0.002, 0.007, 0.001953125]);
    var this_4 = DrawStaticMeshCommandConstructor(tmp_4, listOf([tmp_5, tmp_6, UniformFloatValueWithArray(tmp$ret$9), UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_0().jt_1), new UniformTextureValue(Textures_getInstance_0().kt_1), UniformFloatValueWithArray(new Float32Array(4)), UniformFloatValueWithArray(new Float32Array(4)), UniformFloatValueWithArray(new Float32Array(4))]), stateWater, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(2500.0, 2500.0, 1.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_4.indexUniformModel = 3;
    tmp_3.ks_1 = this_4;
    var stateStars = new DrawMeshState(Shaders_getInstance_0().st_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf_0(new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_FLOAT3_getInstance(), 0)), 12));
    var tmp_7 = this;
    // Inline function 'kotlin.apply' call
    var tmp_8 = Meshes_getInstance_0().hr_1;
    var tmp_9 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$11 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var this_5 = DrawStaticMeshCommandConstructor(tmp_8, listOf([tmp_9, UniformFloatValueWithArray(tmp$ret$11)]), stateStars, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(0.06, 0.06, 0.06)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_5.hints = this.vs_1;
    tmp_7.ls_1 = this_5;
    var tmp_10 = this;
    // Inline function 'kotlin.apply' call
    var tmp_11 = Meshes_getInstance_0().ir_1;
    var tmp_12 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_13 = new UniformTextureValue(Textures_getInstance_0().lt_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$13 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var this_6 = DrawStaticMeshCommandConstructor(tmp_11, listOf([tmp_12, tmp_13, UniformFloatValueWithArray(tmp$ret$13)]), stateDiffuseColoredAtFp16, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(80.0, 80.0, 80.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_6.hints = this.vs_1;
    tmp_10.ms_1 = this_6;
    var stateFishnet = new DrawMeshState(Shaders_getInstance_0().tt_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_DISABLED_getInstance(), commonVertexAttributesDescriptor);
    var tmp_14 = this;
    var tmp_15 = Meshes_getInstance_0().jr_1;
    var tmp_16 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_17 = new UniformTextureValue(Textures_getInstance_0().mt_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$15 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_18 = UniformFloatValueWithArray(tmp$ret$15);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$16 = new Float32Array([1.0]);
    tmp_14.ns_1 = DrawStaticMeshCommandConstructor(tmp_15, listOf([tmp_16, tmp_17, tmp_18, UniformFloatValueWithArray(tmp$ret$16)]), stateFishnet, txOrigin);
    var tmp_19 = Shaders_getInstance_0().ut_1;
    // Inline function 'kotlin.apply' call
    var this_7 = new Blending();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_7.enabled = true;
    this_7.equationColor = BlendingEquation_ADD_getInstance();
    this_7.sourceFactorColor = BlendingFactor_ONE_getInstance();
    this_7.destinationFactorColor = BlendingFactor_ONE_getInstance();
    var stateWind = new DrawMeshState(tmp_19, this_7, get_DEPTH_NO_WRITE(), CullFace_DISABLED_getInstance(), null);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$18 = new Float32Array([(this.ps_1 - 1 | 0) * 2.0, this.qs_1]);
    var tmp_20 = UniformFloatValueWithArray(tmp$ret$18);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$19 = new Float32Array([0.2, 0.25, 1.3]);
    var tmp_21 = UniformFloatValueWithArray(tmp$ret$19);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$20 = new Float32Array([0.032, 0.05, 0.02]);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var windStaticUniforms = [tmp_20, tmp_21, UniformFloatValueWithArray(tmp$ret$20)];
    var tmp_22 = this;
    // Inline function 'kotlin.apply' call
    var tmp_23 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$24 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_24 = UniformFloatValueWithArray(tmp$ret$24);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$25 = new Float32Array([0.0, 0.0, 0.0]);
    var this_8 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_23, tmp_24, UniformFloatValueWithArray(tmp$ret$25)], windStaticUniforms])), stateWind, new AffineTranformation(new Vec3(0.0, -500.0, 130.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 1.0, 10.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_8.primitiveCount = imul(6, this.ps_1);
    this_8.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_25 = this_8;
    // Inline function 'kotlin.apply' call
    var tmp_26 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$27 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_27 = UniformFloatValueWithArray(tmp$ret$27);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$28 = new Float32Array([0.0, 0.0, 0.0]);
    var this_9 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_26, tmp_27, UniformFloatValueWithArray(tmp$ret$28)], windStaticUniforms])), stateWind, new AffineTranformation(new Vec3(0.0, -500.0, 130.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 1.0, 10.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_9.primitiveCount = imul(6, this.ps_1);
    this_9.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_28 = this_9;
    // Inline function 'kotlin.apply' call
    var tmp_29 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$30 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_30 = UniformFloatValueWithArray(tmp$ret$30);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$31 = new Float32Array([0.0, 0.0, 0.0]);
    var this_10 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_29, tmp_30, UniformFloatValueWithArray(tmp$ret$31)], windStaticUniforms])), stateWind, new AffineTranformation(new Vec3(0.0, -500.0, 130.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 1.0, 10.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_10.primitiveCount = imul(6, this.ps_1);
    this_10.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_31 = this_10;
    // Inline function 'kotlin.apply' call
    var tmp_32 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$33 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_33 = UniformFloatValueWithArray(tmp$ret$33);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$34 = new Float32Array([0.0, 0.0, 0.0]);
    var this_11 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_32, tmp_33, UniformFloatValueWithArray(tmp$ret$34)], windStaticUniforms])), stateWind, new AffineTranformation(new Vec3(0.0, -500.0, 100.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 1.0, 10.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_11.primitiveCount = imul(6, this.ps_1);
    this_11.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_34 = this_11;
    // Inline function 'kotlin.apply' call
    var tmp_35 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$36 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_36 = UniformFloatValueWithArray(tmp$ret$36);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$37 = new Float32Array([0.0, 0.0, 0.0]);
    var this_12 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_35, tmp_36, UniformFloatValueWithArray(tmp$ret$37)], windStaticUniforms])), stateWind, new AffineTranformation(new Vec3(0.0, -500.0, 100.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 1.0, 10.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_12.primitiveCount = imul(6, this.ps_1);
    this_12.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_37 = this_12;
    // Inline function 'kotlin.apply' call
    var tmp_38 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$39 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_39 = UniformFloatValueWithArray(tmp$ret$39);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$40 = new Float32Array([0.0, 0.0, 0.0]);
    var this_13 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_38, tmp_39, UniformFloatValueWithArray(tmp$ret$40)], windStaticUniforms])), stateWind, new AffineTranformation(new Vec3(0.0, -500.0, 100.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 1.0, 10.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_13.primitiveCount = imul(6, this.ps_1);
    this_13.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_40 = this_13;
    // Inline function 'kotlin.apply' call
    var tmp_41 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$42 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_42 = UniformFloatValueWithArray(tmp$ret$42);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$43 = new Float32Array([0.0, 0.0, 0.0]);
    var this_14 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_41, tmp_42, UniformFloatValueWithArray(tmp$ret$43)], windStaticUniforms])), stateWind, new AffineTranformation(new Vec3(0.0, -500.0, 170.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 1.0, 10.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_14.primitiveCount = imul(6, this.ps_1);
    this_14.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_43 = this_14;
    // Inline function 'kotlin.apply' call
    var tmp_44 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$45 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_45 = UniformFloatValueWithArray(tmp$ret$45);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$46 = new Float32Array([0.0, 0.0, 0.0]);
    var this_15 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_44, tmp_45, UniformFloatValueWithArray(tmp$ret$46)], windStaticUniforms])), stateWind, new AffineTranformation(new Vec3(0.0, -500.0, 170.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 1.0, 10.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_15.primitiveCount = imul(6, this.ps_1);
    this_15.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_46 = this_15;
    // Inline function 'kotlin.apply' call
    var tmp_47 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$48 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_48 = UniformFloatValueWithArray(tmp$ret$48);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$49 = new Float32Array([0.0, 0.0, 0.0]);
    var this_16 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_47, tmp_48, UniformFloatValueWithArray(tmp$ret$49)], windStaticUniforms])), stateWind, new AffineTranformation(new Vec3(0.0, -500.0, 170.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 1.0, 10.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_16.primitiveCount = imul(6, this.ps_1);
    this_16.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    tmp_22.os_1 = GroupCommandArr(true, [tmp_25, tmp_28, tmp_31, tmp_34, tmp_37, tmp_40, tmp_43, tmp_46, this_16]);
    var tmp_49 = this;
    // Inline function 'kotlin.apply' call
    var this_17 = new ClearCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_17.clearType = ClearCommandClearType_COLOR_AND_DEPTH_getInstance();
    tmp_49.ds_1 = GroupCommandArr(true, [this.es_1, this_17]);
    var tmp_50 = this;
    // Inline function 'kotlin.apply' call
    var this_18 = new VignetteCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_18.color0 = new Vec4(0.7, 0.7, 0.7, 1.0);
    this_18.color1 = new Vec4(1.0, 1.0, 1.0, 1.0);
    tmp_50.fs_1 = this_18;
    this.as_1 = GroupCommandArr(true, [MainPassCommandArr(true, [this.ds_1, this.hs_1, this.is_1, this.js_1, this.ns_1, this.ks_1, this.ls_1, this.ms_1, this.os_1, this.fs_1])]);
    var tmp_51 = this;
    // Inline function 'kotlin.apply' call
    var this_19 = new BlurredPassCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_19.name = 'blurred-main';
    this_19.enabled = true;
    this_19.minSize = 180;
    this_19.brightness = 0.9;
    this_19.blurSize = BlurSize_KERNEL_4_getInstance();
    this_19.commands = mutableListOf([this.ds_1, this.hs_1, this.is_1, this.js_1, this.ns_1, this.ks_1, this.ms_1, this.fs_1]);
    tmp_51.cs_1 = this_19;
    var tmp_52 = this;
    // Inline function 'kotlin.apply' call
    var this_20 = new DrawBlurredCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.CartoonLighthouseScene.<anonymous>' call
    this_20.name = 'draw blurred';
    this_20.blending = get_BLENDING_NONE();
    tmp_52.gs_1 = this_20;
    this.bs_1 = GroupCommandArr(false, [this.cs_1, MainPassCommandArr(true, [this.ds_1, this.gs_1])]);
    this.commands = mutableListOf([this.as_1, this.bs_1]);
  }
  protoOf(CartoonLighthouseScene).mo = function () {
    return this.settings;
  };
  protoOf(CartoonLighthouseScene).cp = function () {
    return this.PIf;
  };
  protoOf(CartoonLighthouseScene).ko = function () {
    return this.cameraAnimator;
  };
  protoOf(CartoonLighthouseScene).yt = function () {
    return this.orbitingCamera;
  };
  protoOf(CartoonLighthouseScene).updateTimers = function (time) {
    this.zr_1.qj(time);
    this.cameraAnimator.animate(time);
    animate(this, time);
    protoOf(Scene).updateTimers.call(this, time);
  };
  protoOf(CartoonLighthouseScene).updateViewportSize = function (width, height) {
    protoOf(Scene).updateViewportSize.call(this, width, height);
  };
  protoOf(CartoonLighthouseScene).initialize = function () {
    randomizeCamera(this);
  };
  protoOf(CartoonLighthouseScene).nextCamera = function () {
    this.randomCamera();
  };
  protoOf(CartoonLighthouseScene).randomCamera = function () {
    if (this.cameraAnimator.state.equals(CameraState_TRANSITIONING_getInstance())) {
      return Unit_instance;
    }
    this.cameraAnimator.positionInterpolator.reverse = Default_getInstance().c6() < 0.5;
    this.cameraAnimator.randomCamera();
  };
  protoOf(CartoonLighthouseScene).cameraImpulse = function (impulse) {
    this.orbitingCamera.wj_1 = impulse * this.settings.cameraPeriod;
  };
  var TimeOfDay_Day_instance_0;
  var TimeOfDay_Night_instance_0;
  var TimeOfDay_Sunrise_instance_0;
  var TimeOfDay_Sunset_instance_0;
  function values_0() {
    return [TimeOfDay_Day_getInstance_0(), TimeOfDay_Night_getInstance_0(), TimeOfDay_Sunrise_getInstance_0(), TimeOfDay_Sunset_getInstance_0()];
  }
  function valueOf_0(value) {
    switch (value) {
      case 'Day':
        return TimeOfDay_Day_getInstance_0();
      case 'Night':
        return TimeOfDay_Night_getInstance_0();
      case 'Sunrise':
        return TimeOfDay_Sunrise_getInstance_0();
      case 'Sunset':
        return TimeOfDay_Sunset_getInstance_0();
      default:
        TimeOfDay_initEntries_0();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var TimeOfDay_entriesInitialized_0;
  function TimeOfDay_initEntries_0() {
    if (TimeOfDay_entriesInitialized_0)
      return Unit_instance;
    TimeOfDay_entriesInitialized_0 = true;
    TimeOfDay_Day_instance_0 = new TimeOfDay_0('Day', 0, 0);
    TimeOfDay_Night_instance_0 = new TimeOfDay_0('Night', 1, 1);
    TimeOfDay_Sunrise_instance_0 = new TimeOfDay_0('Sunrise', 2, 2);
    TimeOfDay_Sunset_instance_0 = new TimeOfDay_0('Sunset', 3, 3);
  }
  function TimeOfDay_0(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  var CameraMode_Random_instance;
  var CameraMode_Orbiting_instance;
  function values_1() {
    return [CameraMode_Random_getInstance(), CameraMode_Orbiting_getInstance()];
  }
  function valueOf_1(value) {
    switch (value) {
      case 'Random':
        return CameraMode_Random_getInstance();
      case 'Orbiting':
        return CameraMode_Orbiting_getInstance();
      default:
        CameraMode_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var CameraMode_entriesInitialized;
  function CameraMode_initEntries() {
    if (CameraMode_entriesInitialized)
      return Unit_instance;
    CameraMode_entriesInitialized = true;
    CameraMode_Random_instance = new CameraMode('Random', 0, 0);
    CameraMode_Orbiting_instance = new CameraMode('Orbiting', 1, 1);
  }
  function CameraMode(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  var ColorMode_None_instance;
  var ColorMode_Sepia_instance;
  var ColorMode_Greyscale_instance;
  function values_2() {
    return [ColorMode_None_getInstance(), ColorMode_Sepia_getInstance_0(), ColorMode_Greyscale_getInstance()];
  }
  function valueOf_2(value) {
    switch (value) {
      case 'None':
        return ColorMode_None_getInstance();
      case 'Sepia':
        return ColorMode_Sepia_getInstance_0();
      case 'Greyscale':
        return ColorMode_Greyscale_getInstance();
      default:
        ColorMode_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ColorMode_entriesInitialized;
  function ColorMode_initEntries() {
    if (ColorMode_entriesInitialized)
      return Unit_instance;
    ColorMode_entriesInitialized = true;
    ColorMode_None_instance = new ColorMode('None', 0, 0);
    ColorMode_Sepia_instance = new ColorMode('Sepia', 1, 1);
    ColorMode_Greyscale_instance = new ColorMode('Greyscale', 2, 2);
  }
  function ColorMode(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  function CartoonLighthouseSettings() {
    this.cameraPeriod = 1.0;
    this.vignette = true;
    this.blurred = false;
    this.autoSwitchCameras = true;
    this.lowQuality = false;
    this.clock = false;
    this.timeOfDay = TimeOfDay_Day_getInstance_0();
    this.cameraMode = CameraMode_Random_getInstance();
    this.debugDouble = 1.0;
    this.debugFloat = 1.0;
    this.debugString = '';
    this.colorMode = ColorMode_None_getInstance();
  }
  protoOf(CartoonLighthouseSettings).fp = function (_set____db54di) {
    this.cameraPeriod = _set____db54di;
  };
  protoOf(CartoonLighthouseSettings).gp = function () {
    return this.cameraPeriod;
  };
  protoOf(CartoonLighthouseSettings).hp = function (_set____db54di) {
    this.vignette = _set____db54di;
  };
  protoOf(CartoonLighthouseSettings).ip = function () {
    return this.vignette;
  };
  protoOf(CartoonLighthouseSettings).jp = function (_set____db54di) {
    this.blurred = _set____db54di;
  };
  protoOf(CartoonLighthouseSettings).kp = function () {
    return this.blurred;
  };
  protoOf(CartoonLighthouseSettings).lp = function (_set____db54di) {
    this.autoSwitchCameras = _set____db54di;
  };
  protoOf(CartoonLighthouseSettings).mp = function () {
    return this.autoSwitchCameras;
  };
  protoOf(CartoonLighthouseSettings).rp = function (_set____db54di) {
    this.lowQuality = _set____db54di;
  };
  protoOf(CartoonLighthouseSettings).sp = function () {
    return this.lowQuality;
  };
  protoOf(CartoonLighthouseSettings).pp = function (_set____db54di) {
    this.clock = _set____db54di;
  };
  protoOf(CartoonLighthouseSettings).qp = function () {
    return this.clock;
  };
  protoOf(CartoonLighthouseSettings).fu = function (_set____db54di) {
    this.timeOfDay = _set____db54di;
  };
  protoOf(CartoonLighthouseSettings).op = function () {
    return this.timeOfDay;
  };
  protoOf(CartoonLighthouseSettings).gu = function (_set____db54di) {
    this.cameraMode = _set____db54di;
  };
  protoOf(CartoonLighthouseSettings).hu = function () {
    return this.cameraMode;
  };
  protoOf(CartoonLighthouseSettings).iu = function (_set____db54di) {
    this.debugDouble = _set____db54di;
  };
  protoOf(CartoonLighthouseSettings).ju = function () {
    return this.debugDouble;
  };
  protoOf(CartoonLighthouseSettings).ku = function (_set____db54di) {
    this.debugFloat = _set____db54di;
  };
  protoOf(CartoonLighthouseSettings).lu = function () {
    return this.debugFloat;
  };
  protoOf(CartoonLighthouseSettings).mu = function (_set____db54di) {
    this.debugString = _set____db54di;
  };
  protoOf(CartoonLighthouseSettings).nu = function () {
    return this.debugString;
  };
  protoOf(CartoonLighthouseSettings).ou = function (_set____db54di) {
    this.colorMode = _set____db54di;
  };
  protoOf(CartoonLighthouseSettings).wq = function () {
    return this.colorMode;
  };
  function TimeOfDay_Day_getInstance_0() {
    TimeOfDay_initEntries_0();
    return TimeOfDay_Day_instance_0;
  }
  function TimeOfDay_Night_getInstance_0() {
    TimeOfDay_initEntries_0();
    return TimeOfDay_Night_instance_0;
  }
  function TimeOfDay_Sunrise_getInstance_0() {
    TimeOfDay_initEntries_0();
    return TimeOfDay_Sunrise_instance_0;
  }
  function TimeOfDay_Sunset_getInstance_0() {
    TimeOfDay_initEntries_0();
    return TimeOfDay_Sunset_instance_0;
  }
  function CameraMode_Random_getInstance() {
    CameraMode_initEntries();
    return CameraMode_Random_instance;
  }
  function CameraMode_Orbiting_getInstance() {
    CameraMode_initEntries();
    return CameraMode_Orbiting_instance;
  }
  function ColorMode_None_getInstance() {
    ColorMode_initEntries();
    return ColorMode_None_instance;
  }
  function ColorMode_Sepia_getInstance_0() {
    ColorMode_initEntries();
    return ColorMode_Sepia_instance;
  }
  function ColorMode_Greyscale_getInstance() {
    ColorMode_initEntries();
    return ColorMode_Greyscale_instance;
  }
  function Shaders_0() {
    Shaders_instance_0 = this;
    this.pt_1 = new Shader('DiffuseColored');
    this.qt_1 = new Shader('DiffuseColoredAt');
    this.rt_1 = new Shader('StylizedWater');
    this.st_1 = new Shader('Color');
    this.tt_1 = new Shader('Fishnet');
    this.ut_1 = new Shader('Wind');
    this.vt_1 = mutableListOf([this.pt_1, this.qt_1, this.rt_1, this.st_1, this.tt_1, this.ut_1]);
  }
  var Shaders_instance_0;
  function Shaders_getInstance_0() {
    if (Shaders_instance_0 == null)
      new Shaders_0();
    return Shaders_instance_0;
  }
  function SimpleTexture(name, mipmaps) {
    this.pu_1 = name;
    this.qu_1 = mipmaps;
  }
  protoOf(SimpleTexture).toString = function () {
    return 'SimpleTexture(name=' + this.pu_1 + ', mipmaps=' + this.qu_1 + ')';
  };
  protoOf(SimpleTexture).hashCode = function () {
    var result = getStringHashCode(this.pu_1);
    result = imul(result, 31) + this.qu_1 | 0;
    return result;
  };
  protoOf(SimpleTexture).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SimpleTexture))
      return false;
    var tmp0_other_with_cast = other instanceof SimpleTexture ? other : THROW_CCE();
    if (!(this.pu_1 === tmp0_other_with_cast.pu_1))
      return false;
    if (!(this.qu_1 === tmp0_other_with_cast.qu_1))
      return false;
    return true;
  };
  function Textures_0() {
    Textures_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.Textures.texGrass.<anonymous>' call
    this_0.name = 'grass';
    this_0.fileName = 'grass';
    this_0.format = TextureFormat_ASTC_getInstance();
    this_0.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_0.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_0.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_0.mipmaps = 8;
    tmp.ft_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.Textures.texBouy.<anonymous>' call
    this_1.name = 'bouy1';
    this_1.fileName = 'bouy1';
    this_1.format = TextureFormat_ASTC_getInstance();
    this_1.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_1.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_1.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_1.mipmaps = 4;
    tmp_0.gt_1 = this_1;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.Textures.texBoat.<anonymous>' call
    this_2.name = 'boat';
    this_2.fileName = 'boat';
    this_2.format = TextureFormat_ASTC_getInstance();
    this_2.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_2.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_2.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_2.mipmaps = 8;
    tmp_1.ht_1 = this_2;
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.Textures.texBird.<anonymous>' call
    this_3.name = 'bird';
    this_3.fileName = 'bird';
    this_3.format = TextureFormat_ASTC_getInstance();
    this_3.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_3.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_3.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_3.mipmaps = 7;
    tmp_2.it_1 = this_3;
    var tmp_3 = this;
    // Inline function 'kotlin.apply' call
    var this_4 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.Textures.texWaterNoise.<anonymous>' call
    this_4.name = 'water-noise';
    this_4.fileName = 'water-noise';
    this_4.format = TextureFormat_ASTC_getInstance();
    this_4.wrapping = TextureWrapping_REPEAT_getInstance();
    this_4.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_4.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_4.mipmaps = 7;
    tmp_3.jt_1 = this_4;
    var tmp_4 = this;
    // Inline function 'kotlin.apply' call
    var this_5 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.Textures.texWaterMask.<anonymous>' call
    this_5.name = 'water-mask';
    this_5.fileName = 'water-mask';
    this_5.format = TextureFormat_ASTC_getInstance();
    this_5.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_5.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_5.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_5.anisotropy = 4;
    this_5.mipmaps = 6;
    tmp_4.kt_1 = this_5;
    var tmp_5 = this;
    // Inline function 'kotlin.apply' call
    var this_6 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.Textures.texClouds.<anonymous>' call
    this_6.name = 'clouds';
    this_6.fileName = 'clouds';
    this_6.format = TextureFormat_ASTC_getInstance();
    this_6.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_6.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_6.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_6.mipmaps = 8;
    tmp_5.lt_1 = this_6;
    var tmp_6 = this;
    // Inline function 'kotlin.apply' call
    var this_7 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonlighthouse.Textures.texFishnet.<anonymous>' call
    this_7.name = 'fishnet';
    this_7.fileName = 'fishnet';
    this_7.format = TextureFormat_ASTC_getInstance();
    this_7.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_7.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_7.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_7.anisotropy = 3;
    this_7.mipmaps = 8;
    tmp_6.mt_1 = this_7;
    var tmp_7 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_8 = [new SimpleTexture('arrow', 7), new SimpleTexture('barrel', 8), new SimpleTexture('box', 8), new SimpleTexture('bricks', 8), new SimpleTexture('dock', 9), new SimpleTexture('fence', 9), new SimpleTexture('fence_topLighthouse', 8), new SimpleTexture('fish', 7), new SimpleTexture('fishingspot', 8), new SimpleTexture('fish_rope', 2), new SimpleTexture('hengel', 3), new SimpleTexture('house', 9), new SimpleTexture('lifebouy-rope', 7), new SimpleTexture('lifebouy', 7), new SimpleTexture('lighthouse', 10), new SimpleTexture('poles', 8), new SimpleTexture('rock', 8), new SimpleTexture('roof-tile', 7), new SimpleTexture('sign', 7), new SimpleTexture('smallPoles', 8), new SimpleTexture('SupportBeams', 8), new SimpleTexture('telescope', 9), new SimpleTexture('tree', 8)];
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(this_8.length);
    var inductionVariable = 0;
    var last = this_8.length;
    while (inductionVariable < last) {
      var item = this_8[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'org.androidworks.cartoonlighthouse.Textures.staticTextures.<anonymous>' call
      // Inline function 'kotlin.apply' call
      var this_9 = new Texture();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'org.androidworks.cartoonlighthouse.Textures.staticTextures.<anonymous>.<anonymous>' call
      this_9.name = item.pu_1;
      this_9.fileName = item.pu_1;
      this_9.format = TextureFormat_ASTC_getInstance();
      this_9.wrapping = TextureWrapping_REPEAT_getInstance();
      this_9.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
      this_9.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
      this_9.mipmaps = item.qu_1;
      destination.g(this_9);
    }
    tmp_7.nt_1 = copyToArray(destination);
    this.ot_1 = mutableListOf(arrayConcat([this.nt_1, [this.ft_1, this.gt_1, this.ht_1, this.it_1, this.kt_1, this.jt_1, this.lt_1, this.mt_1]]));
  }
  var Textures_instance_0;
  function Textures_getInstance_0() {
    if (Textures_instance_0 == null)
      new Textures_0();
    return Textures_instance_0;
  }
  var Timers_Camera_instance_0;
  var Timers_Water_instance_0;
  var Timers_BouysBobbing_instance;
  var Timers_BouysRotation_instance;
  var Timers_BirdBobbing_instance;
  var Timers_Fishnet_instance;
  var Timers_WindMove1_instance;
  var Timers_WindMove2_instance;
  var Timers_WindMove3_instance;
  var Timers_OrbitingCameraZ_instance;
  var Timers_OrbitingCameraX_instance;
  var Timers_ProjectionOffsetTransition_instance;
  function Companion_0() {
    this.wt_1 = 27800.0;
  }
  protoOf(Companion_0).xt = function (timers) {
    timers.mj(Timers_Camera_getInstance(), this.wt_1, true);
    timers.mj(Timers_Water_getInstance_0(), 25000.0, true);
    timers.mj(Timers_BouysBobbing_getInstance(), 2000.0, true);
    timers.mj(Timers_BouysRotation_getInstance(), 8000.0, true);
    timers.mj(Timers_BirdBobbing_getInstance(), 15000.0, true);
    timers.mj(Timers_Fishnet_getInstance(), 2000.0, true);
    timers.mj(Timers_WindMove1_getInstance(), 7000.0, true);
    timers.mj(Timers_WindMove2_getInstance(), 7500.0, true);
    timers.mj(Timers_WindMove3_getInstance(), 8000.0, true);
    timers.mj(Timers_OrbitingCameraZ_getInstance(), 42000.0, true);
    timers.mj(Timers_OrbitingCameraX_getInstance(), 32000.0, true);
    timers.mj(Timers_ProjectionOffsetTransition_getInstance(), 2000.0, false);
  };
  var Companion_instance_3;
  function Companion_getInstance_0() {
    return Companion_instance_3;
  }
  var Timers_entriesInitialized_0;
  function Timers_initEntries_0() {
    if (Timers_entriesInitialized_0)
      return Unit_instance;
    Timers_entriesInitialized_0 = true;
    Timers_Camera_instance_0 = new Timers_0('Camera', 0);
    Timers_Water_instance_0 = new Timers_0('Water', 1);
    Timers_BouysBobbing_instance = new Timers_0('BouysBobbing', 2);
    Timers_BouysRotation_instance = new Timers_0('BouysRotation', 3);
    Timers_BirdBobbing_instance = new Timers_0('BirdBobbing', 4);
    Timers_Fishnet_instance = new Timers_0('Fishnet', 5);
    Timers_WindMove1_instance = new Timers_0('WindMove1', 6);
    Timers_WindMove2_instance = new Timers_0('WindMove2', 7);
    Timers_WindMove3_instance = new Timers_0('WindMove3', 8);
    Timers_OrbitingCameraZ_instance = new Timers_0('OrbitingCameraZ', 9);
    Timers_OrbitingCameraX_instance = new Timers_0('OrbitingCameraX', 10);
    Timers_ProjectionOffsetTransition_instance = new Timers_0('ProjectionOffsetTransition', 11);
  }
  function Timers_0(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Timers_Camera_getInstance() {
    Timers_initEntries_0();
    return Timers_Camera_instance_0;
  }
  function Timers_Water_getInstance_0() {
    Timers_initEntries_0();
    return Timers_Water_instance_0;
  }
  function Timers_BouysBobbing_getInstance() {
    Timers_initEntries_0();
    return Timers_BouysBobbing_instance;
  }
  function Timers_BouysRotation_getInstance() {
    Timers_initEntries_0();
    return Timers_BouysRotation_instance;
  }
  function Timers_BirdBobbing_getInstance() {
    Timers_initEntries_0();
    return Timers_BirdBobbing_instance;
  }
  function Timers_Fishnet_getInstance() {
    Timers_initEntries_0();
    return Timers_Fishnet_instance;
  }
  function Timers_WindMove1_getInstance() {
    Timers_initEntries_0();
    return Timers_WindMove1_instance;
  }
  function Timers_WindMove2_getInstance() {
    Timers_initEntries_0();
    return Timers_WindMove2_instance;
  }
  function Timers_WindMove3_getInstance() {
    Timers_initEntries_0();
    return Timers_WindMove3_instance;
  }
  function Timers_OrbitingCameraZ_getInstance() {
    Timers_initEntries_0();
    return Timers_OrbitingCameraZ_instance;
  }
  function Timers_OrbitingCameraX_getInstance() {
    Timers_initEntries_0();
    return Timers_OrbitingCameraX_instance;
  }
  function Timers_ProjectionOffsetTransition_getInstance() {
    Timers_initEntries_0();
    return Timers_ProjectionOffsetTransition_instance;
  }
  function Meshes_1() {
    Meshes_instance_1 = this;
    this.ru_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6)]), 12);
    this.su_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6), new MeshAttribute(AttributeType_NORMAL_getInstance(), VertexFormat_HALF3_getInstance(), 10)]), 16);
    this.tu_1 = MeshConstructor2('sky', this.ru_1);
    this.uu_1 = MeshConstructor2('quad', this.ru_1);
    this.vu_1 = MeshConstructor2('plane0', this.su_1);
    this.wu_1 = MeshConstructor2('plane1', this.su_1);
    this.xu_1 = mutableListOf([this.tu_1, this.uu_1, this.vu_1, this.wu_1]);
  }
  var Meshes_instance_1;
  function Meshes_getInstance_1() {
    if (Meshes_instance_1 == null)
      new Meshes_1();
    return Meshes_instance_1;
  }
  function Props() {
    Props_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [new Vec3(-950.0, 0.0, 29.0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [new Vec3(-1113.0, 0.0, 343.0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_2 = [new Vec3(-1080.0, 0.0, 116.0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_3 = [new Vec3(-1113.0, 0.0, 105.0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_4 = [new Vec3(-1129.0, -986.0, 705.0), new Vec3(-1129.0, 986.0, 705.0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_5 = [new Vec3(-967.0, 0.0, -196.0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_6 = [new Vec3(-1422.0, -21.0, 64.0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_7 = [new Vec3(-1032.0, 0.0, 46.0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_8 = [new Vec3(220.0, 0.0, 116.0), new Vec3(-722.0, -368.0, 151.0), new Vec3(-722.0, 368.0, 151.0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_9 = [new Vec3(-1000.0, -570.0, -58.0), new Vec3(-1000.0, 570.0, -58.0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_10 = [new Vec3(-1000.0, 0.0, 168.0)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.yu_1 = [tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, [new Vec3(-224.0, -823.0, 515.0), new Vec3(-224.0, 823.0, 515.0)]];
    var tmp_11 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_11.zu_1 = new Float32Array([1.4, 1.1, 1.2, 1.5, 1.2, 1.8, 1.6, 1.1, 0.7, 1.1, 1.8, 1.2]);
  }
  var Props_instance;
  function Props_getInstance() {
    if (Props_instance == null)
      new Props();
    return Props_instance;
  }
  function applySettings_0($this) {
    $this.dw_1.w(0, $this.settings.lowQuality ? get_HINT_VRS_2X2() : get_HINT_VRS_NONE());
    $this.mv_1.enabled = !$this.settings.blurred;
    $this.nv_1.enabled = $this.settings.blurred;
    $this.rv_1.enabled = $this.settings.vignette;
    $this.ov_1.additionalBlur = !$this.settings.lowQuality;
    $this.rv_1.enabled = !$this.settings.lowQuality;
    var cameraPeriod = $this.settings.cameraPeriod * Companion_instance_4.ow_1;
    var params = $this.fv_1.pj(Timers_Camera_getInstance_0());
    if (!(params.hj_1 === cameraPeriod)) {
      $this.fv_1.mj(Timers_Camera_getInstance_0(), cameraPeriod, false);
      $this.fv_1.oj(Timers_Camera_getInstance_0(), 0.0);
    }
  }
  function animate_0($this) {
    applySettings_0($this);
    positionCamera_0($this);
    $this.calculateProjection();
    calculatePlanePosition($this, $this.hw_1, 0.0);
    updatePlaneTransforms($this, true);
    updatePlaneTransforms($this, false);
    updateSky($this);
    $this.updateMeshTransformations($this.commands);
  }
  function updateSky($this) {
    var timer = $this.fv_1.nj(Timers_SwapSky_getInstance());
    if (timer > 0.1 ? timer < 0.9 : false) {
      $this.uv_1.enabled = false;
      $this.tv_1.enabled = true;
      setUniform_1($this.tv_1.uniforms.t(4), timer);
      $this.tv_1.transform.y9_1 = $this.nw_1;
    } else {
      $this.uv_1.enabled = true;
      $this.tv_1.enabled = false;
      $this.uv_1.transform.y9_1 = $this.nw_1;
    }
    if (timer > 0.5) {
      $this.texSky.id = $this.texSky2.id;
      $this.texSky.fileName = $this.texSky2.fileName;
    }
    // Inline function 'kotlin.math.sin' call
    var x = timer * $this.PIf * 2.0 - $this.PIf * 0.5;
    var sineInOut = (Math.sin(x) + 1.0) * 0.5;
    var dimming = sineInOut * 0.5;
    $this.rv_1.color0.x = 0.7 - dimming;
    $this.rv_1.color0.y = 0.7 - dimming;
    $this.rv_1.color0.z = 0.7 - dimming;
  }
  function updatePlaneTransforms($this, current) {
    var txPlane = current ? $this.cw_1 : $this.bw_1;
    var groupProps = current ? $this.aw_1 : $this.zv_1;
    var props = Props_getInstance().yu_1[current ? $this.settings.nextPlane : $this.settings.currentPlane];
    var phase = current ? 0.0 : 0.0;
    var scaleProps = Props_getInstance().zu_1[current ? $this.settings.nextPlane : $this.settings.currentPlane] * $this.kv_1;
    var commandDiffuse = current ? $this.xv_1 : $this.vv_1;
    var commandOutline = current ? $this.yv_1 : $this.wv_1;
    var timer = $this.fv_1.nj(Timers_SwapPlanes_getInstance());
    var scale = current ? MathUtils_instance.od(0.0, 0.3, timer) : 1.0 - MathUtils_instance.od(0.0, 1.0, timer);
    var timerOffset = MathUtils_instance.vh(0.0, 1.0, timer);
    var offsetZ = current ? 18000.0 * (1.0 - timerOffset) : timerOffset * -12000.0;
    var offsetX = current ? offsetZ * 0.25 : offsetZ * 1.3;
    txPlane.y9_1.x = $this.fw_1.x + offsetX;
    txPlane.y9_1.y = $this.fw_1.y;
    txPlane.y9_1.z = $this.fw_1.z + offsetZ;
    txPlane.z9_1.x = MathUtils_instance.wh($this.gw_1);
    txPlane.aa_1.x = $this.jv_1 * scale;
    txPlane.aa_1.y = $this.jv_1 * scale;
    txPlane.aa_1.z = $this.jv_1 * scale;
    var tmp0_iterator = groupProps.commands.j();
    while (tmp0_iterator.k()) {
      var command = tmp0_iterator.l();
      command.enabled = false;
    }
    if (scale === 0.0) {
      commandDiffuse.enabled = false;
      commandOutline.enabled = false;
    } else {
      commandDiffuse.enabled = true;
      commandOutline.enabled = true;
    }
    if (scale > 0.33) {
      var inductionVariable = 0;
      var last = props.length;
      while (inductionVariable < last) {
        var propIndex = inductionVariable;
        var prop = props[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = prop.y;
        // Inline function 'kotlin.math.cos' call
        var x = $this.gw_1;
        var tmp_0 = tmp * Math.cos(x);
        var tmp_1 = prop.z;
        // Inline function 'kotlin.math.sin' call
        var x_0 = $this.gw_1;
        var propY = tmp_0 - tmp_1 * Math.sin(x_0);
        var tmp_2 = prop.z;
        // Inline function 'kotlin.math.cos' call
        var x_1 = $this.gw_1;
        var tmp_3 = tmp_2 * Math.cos(x_1);
        var tmp_4 = prop.y;
        // Inline function 'kotlin.math.sin' call
        var x_2 = $this.gw_1;
        var propZ = tmp_3 + tmp_4 * Math.sin(x_2);
        var rotation = MathUtils_instance.wh($this.fv_1.nj(Timers_PropRotate_getInstance()) * $this.PIf * 2.0 + propIndex + phase);
        // Inline function 'kotlin.math.sin' call
        var x_3 = $this.fv_1.nj(Timers_PropFlicker_getInstance()) * $this.PIf * 2.0 + propIndex + phase;
        var brightness = 2.0 + Math.sin(x_3);
        var tmp_5 = groupProps.commands.t(propIndex);
        var command_0 = tmp_5 instanceof DrawTransformedMeshCommand ? tmp_5 : THROW_CCE();
        command_0.enabled = true;
        setUniform_1(command_0.uniforms.t(2), brightness);
        command_0.transform.z9_1.x = MathUtils_instance.wh(rotation);
        command_0.transform.z9_1.y = 0.0;
        command_0.transform.z9_1.z = 0.0;
        command_0.transform.y9_1.x = ($this.fw_1.x + prop.x) * scale + offsetX;
        command_0.transform.y9_1.y = ($this.fw_1.y + propY) * scale;
        command_0.transform.y9_1.z = ($this.fw_1.z + propZ) * scale + offsetZ;
        command_0.transform.aa_1.x = scaleProps * scale;
        command_0.transform.aa_1.y = scaleProps * scale;
        command_0.transform.aa_1.z = scaleProps * scale;
      }
    }
  }
  function positionCamera_0($this) {
    if (!$this.useExternalViewMatrix) {
      var timer = $this.fv_1.nj(Timers_Camera_getInstance_0());
      timer = MathUtils_instance.od(0.0, 1.0, timer);
      var angleX = $this.iw_1 + timer * ($this.kw_1 - $this.iw_1);
      var angleY = $this.jw_1 + timer * ($this.lw_1 - $this.jw_1);
      var tmp = $this.nw_1;
      // Inline function 'kotlin.math.sin' call
      tmp.x = Math.sin(angleX) * $this.mw_1;
      var tmp_0 = $this.nw_1;
      // Inline function 'kotlin.math.cos' call
      tmp_0.y = Math.cos(angleX) * $this.mw_1;
      var tmp_1 = $this.nw_1;
      // Inline function 'kotlin.math.sin' call
      tmp_1.z = Math.sin(angleY) * $this.mw_1;
      Matrix_getInstance().di($this.matView, 0, $this.nw_1.x, $this.nw_1.y, $this.nw_1.z, 0.0, 0.0, 0.0, 0.0, 0.0, 1.0);
      if (timer === 1.0) {
        randomizeCamera_0($this);
        $this.fv_1.oj(Timers_Camera_getInstance_0(), 0.0);
      }
    }
  }
  function calculatePlanePosition($this, offset, timersOffset) {
    var time1 = ($this.fv_1.nj(Timers_PlaneWonder1_getInstance()) + timersOffset) % 1.0;
    var time2 = ($this.fv_1.nj(Timers_PlaneWonder2_getInstance()) + timersOffset) % 1.0;
    var tmp = offset.x;
    // Inline function 'kotlin.math.sin' call
    var x = time1 * 3.0 * $this.PIf * 2.0;
    var tmp$ret$0 = Math.sin(x);
    $this.fw_1.x = tmp + tmp$ret$0 * $this.hv_1 * 3.0;
    var tmp_0 = offset.y;
    // Inline function 'kotlin.math.cos' call
    var x_0 = time1 * 5.0 * $this.PIf * 2.0;
    var tmp$ret$1 = Math.cos(x_0);
    $this.fw_1.y = tmp_0 + tmp$ret$1 * $this.hv_1;
    var tmp_1 = offset.z;
    // Inline function 'kotlin.math.cos' call
    var x_1 = time2 * $this.PIf * 2.0;
    var tmp$ret$2 = Math.cos(x_1);
    $this.fw_1.z = tmp_1 + tmp$ret$2 * $this.iv_1;
    var tmp_2 = $this;
    // Inline function 'kotlin.math.sin' call
    var x_2 = $this.fv_1.nj(Timers_PlaneBanking_getInstance()) * $this.PIf * 2.0;
    tmp_2.gw_1 = Math.sin(x_2) * $this.gv_1 * 1.0;
  }
  function randomizeCamera_0($this) {
    if ($this.fv_1.nj(Timers_Camera_getInstance_0()) === 0.0) {
      $this.iw_1 = Default_getInstance().c6() * $this.PIf * 2.0;
      $this.jw_1 = (Default_getInstance().c6() - 0.3) * $this.PIf * 0.9;
      $this.kw_1 = Default_getInstance().c6() * $this.PIf * 2.0;
      $this.lw_1 = (Default_getInstance().c6() - 0.3) * $this.PIf * 0.9;
    } else {
      $this.iw_1 = $this.kw_1;
      $this.jw_1 = $this.lw_1;
      $this.kw_1 = Default_getInstance().c6() * $this.PIf * 2.0;
      $this.lw_1 = (Default_getInstance().c6() - 0.3) * $this.PIf * 0.9;
    }
    $this.mw_1 = 3300.0;
  }
  function CartoonPlanesScene() {
    Scene.call(this);
    this.fv_1 = new TimersMap();
    this.gv_1 = 0.25;
    this.hv_1 = 80.0;
    this.iv_1 = 100.0;
    this.jv_1 = 10.0;
    this.kv_1 = 500.0;
    this.lv_1 = 1.7;
    this.bw_1 = new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.jv_1, this.jv_1, this.jv_1));
    this.cw_1 = new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.jv_1, this.jv_1, this.jv_1));
    this.dw_1 = mutableListOf([get_HINT_VRS_NONE()]);
    this.PIf = 3.1415927;
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.ew_1 = new Float32Array([0.5]);
    this.fw_1 = new Vec3();
    this.gw_1 = 0.0;
    this.hw_1 = new Vec3(0.0, 0.0, 0.0);
    this.iw_1 = 0.0;
    this.jw_1 = 0.0;
    this.kw_1 = 0.0;
    this.lw_1 = 0.0;
    this.mw_1 = 3000.0;
    this.nw_1 = new Vec3();
    this.texSky = Textures_getInstance_1().sw_1;
    this.texSky1 = Textures_getInstance_1().qw_1;
    this.texSky2 = Textures_getInstance_1().rw_1;
    this.meshPlane1 = Meshes_getInstance_1().vu_1;
    this.meshPlane2 = Meshes_getInstance_1().wu_1;
    this.texPlane1 = Textures_getInstance_1().tw_1;
    this.texPlane2 = Textures_getInstance_1().uw_1;
    this.meshes = Meshes_getInstance_1().xu_1;
    this.textures = Textures_getInstance_1().ww_1;
    this.shaders = Shaders_getInstance_1().bx_1;
    Companion_instance_4.cx(this.fv_1);
    this.Z_NEAR = 30.0;
    this.Z_FAR = 30000.0;
    this.FOV_LANDSCAPE = 75.0;
    this.FOV_PORTRAIT = 120.0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new CartoonPlanesSettings();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.CartoonPlanesScene.<anonymous>' call
    this_0.cameraPeriod = 1.0;
    this_0.vignette = true;
    this_0.blurred = false;
    this_0.autoSwitchCameras = true;
    this_0.lowQuality = false;
    this_0.clock = false;
    tmp_0.settings = this_0;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new ClearColorCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.CartoonPlanesScene.<anonymous>' call
    this_1.color = new Vec4(0.0, 0.7843137254901961, 0.0, 1.0);
    this_1.name = 'clear color';
    this_1.enabled = true;
    tmp_1.qv_1 = this_1;
    var txSceneObjects = new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0));
    var stateSky = new DrawMeshState(Shaders_getInstance_1().yw_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_HALF2_getInstance(), 6)]), 12));
    this.tv_1 = new DrawTransformedMeshCommand(Meshes_getInstance_1().tu_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_1().qw_1), new UniformTextureValue(Textures_getInstance_1().rw_1), new UniformTextureValue(Textures_getInstance_1().pw_1), UniformFloatValueWithArray(this.ew_1)]), stateSky, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(350.0, 350.0, 350.0)));
    var stateSkyStatic = new DrawMeshState(Shaders_getInstance_1().xw_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_HALF2_getInstance(), 6)]), 12));
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new DrawTransformedMeshCommand(Meshes_getInstance_1().tu_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(this.texSky)]), stateSkyStatic, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(350.0, 350.0, 350.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.CartoonPlanesScene.<anonymous>' call
    this_2.hints = this.dw_1;
    tmp_2.uv_1 = this_2;
    var statePlaneDiffuse = new DrawMeshState(Shaders_getInstance_1().xw_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_HALF2_getInstance(), 6)]), 16));
    var tmp_3 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = new DrawTransformedMeshCommand(Meshes_getInstance_1().vu_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_1().tw_1)]), statePlaneDiffuse, this.bw_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.CartoonPlanesScene.<anonymous>' call
    this_3.hints = this.dw_1;
    tmp_3.vv_1 = this_3;
    var tmp_4 = this;
    // Inline function 'kotlin.apply' call
    var this_4 = new DrawTransformedMeshCommand(Meshes_getInstance_1().wu_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_1().uw_1)]), statePlaneDiffuse, this.cw_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.CartoonPlanesScene.<anonymous>' call
    this_4.hints = this.dw_1;
    tmp_4.xv_1 = this_4;
    var statePlaneOutline = new DrawMeshState(Shaders_getInstance_1().zw_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_FRONT_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_NORMAL_getInstance(), 1, VertexFormat_HALF3_getInstance(), 10)]), 16));
    var tmp_5 = this;
    var tmp_6 = Meshes_getInstance_1().vu_1;
    var tmp_7 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$6 = new Float32Array([this.lv_1]);
    var tmp_8 = UniformFloatValueWithArray(tmp$ret$6);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$7 = new Float32Array([0.0, 0.0, 0.0, 1.0]);
    tmp_5.wv_1 = new DrawTransformedMeshCommand(tmp_6, listOf([tmp_7, tmp_8, UniformFloatValueWithArray(tmp$ret$7)]), statePlaneOutline, this.bw_1);
    var tmp_9 = this;
    var tmp_10 = Meshes_getInstance_1().wu_1;
    var tmp_11 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$8 = new Float32Array([this.lv_1]);
    var tmp_12 = UniformFloatValueWithArray(tmp$ret$8);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$9 = new Float32Array([0.0, 0.0, 0.0, 1.0]);
    tmp_9.yv_1 = new DrawTransformedMeshCommand(tmp_10, listOf([tmp_11, tmp_12, UniformFloatValueWithArray(tmp$ret$9)]), statePlaneOutline, this.cw_1);
    var tmp_13 = Shaders_getInstance_1().ax_1;
    // Inline function 'kotlin.apply' call
    var this_5 = new Blending();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.CartoonPlanesScene.<anonymous>' call
    this_5.enabled = true;
    this_5.equationColor = BlendingEquation_ADD_getInstance();
    this_5.sourceFactorColor = BlendingFactor_SRC_ALPHA_getInstance();
    this_5.destinationFactorColor = BlendingFactor_ONE_getInstance();
    var stateProp = new DrawMeshState(tmp_13, this_5, get_DEPTH_NO_WRITE(), CullFace_DISABLED_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_HALF2_getInstance(), 6)]), 12));
    var tmp_14 = this;
    var tmp_15 = Meshes_getInstance_1().uu_1;
    var tmp_16 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_17 = new UniformTextureValue(Textures_getInstance_1().vw_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$11 = new Float32Array([1.5]);
    var tmp_18 = new DrawTransformedMeshCommand(tmp_15, listOf([tmp_16, tmp_17, UniformFloatValueWithArray(tmp$ret$11)]), stateProp, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.kv_1 * 3.0, this.kv_1 * 3.0, this.kv_1 * 3.0)));
    var tmp_19 = Meshes_getInstance_1().uu_1;
    var tmp_20 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_21 = new UniformTextureValue(Textures_getInstance_1().vw_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$12 = new Float32Array([1.5]);
    var tmp_22 = new DrawTransformedMeshCommand(tmp_19, listOf([tmp_20, tmp_21, UniformFloatValueWithArray(tmp$ret$12)]), stateProp, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.kv_1 * 3.0, this.kv_1 * 3.0, this.kv_1 * 3.0)));
    var tmp_23 = Meshes_getInstance_1().uu_1;
    var tmp_24 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_25 = new UniformTextureValue(Textures_getInstance_1().vw_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$13 = new Float32Array([1.5]);
    tmp_14.zv_1 = GroupCommandArr(true, [tmp_18, tmp_22, new DrawTransformedMeshCommand(tmp_23, listOf([tmp_24, tmp_25, UniformFloatValueWithArray(tmp$ret$13)]), stateProp, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.kv_1 * 3.0, this.kv_1 * 3.0, this.kv_1 * 3.0)))]);
    var tmp_26 = this;
    var tmp_27 = Meshes_getInstance_1().uu_1;
    var tmp_28 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_29 = new UniformTextureValue(Textures_getInstance_1().vw_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$14 = new Float32Array([1.5]);
    var tmp_30 = new DrawTransformedMeshCommand(tmp_27, listOf([tmp_28, tmp_29, UniformFloatValueWithArray(tmp$ret$14)]), stateProp, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.kv_1 * 3.0, this.kv_1 * 3.0, this.kv_1 * 3.0)));
    var tmp_31 = Meshes_getInstance_1().uu_1;
    var tmp_32 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_33 = new UniformTextureValue(Textures_getInstance_1().vw_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$15 = new Float32Array([1.5]);
    var tmp_34 = new DrawTransformedMeshCommand(tmp_31, listOf([tmp_32, tmp_33, UniformFloatValueWithArray(tmp$ret$15)]), stateProp, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.kv_1 * 3.0, this.kv_1 * 3.0, this.kv_1 * 3.0)));
    var tmp_35 = Meshes_getInstance_1().uu_1;
    var tmp_36 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_37 = new UniformTextureValue(Textures_getInstance_1().vw_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$16 = new Float32Array([1.5]);
    tmp_26.aw_1 = GroupCommandArr(true, [tmp_30, tmp_34, new DrawTransformedMeshCommand(tmp_35, listOf([tmp_36, tmp_37, UniformFloatValueWithArray(tmp$ret$16)]), stateProp, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.kv_1 * 3.0, this.kv_1 * 3.0, this.kv_1 * 3.0)))]);
    var tmp_38 = this;
    // Inline function 'kotlin.apply' call
    var this_6 = new ClearCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.CartoonPlanesScene.<anonymous>' call
    this_6.clearType = ClearCommandClearType_COLOR_AND_DEPTH_getInstance();
    tmp_38.pv_1 = GroupCommandArr(true, [this.qv_1, this_6]);
    var tmp_39 = this;
    // Inline function 'kotlin.apply' call
    var this_7 = new VignetteCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.CartoonPlanesScene.<anonymous>' call
    this_7.color0 = new Vec4(0.7, 0.7, 0.7, 1.0);
    this_7.color1 = new Vec4(1.0, 1.0, 1.0, 1.0);
    tmp_39.rv_1 = this_7;
    this.mv_1 = GroupCommandArr(true, [MainPassCommandArr(true, [this.pv_1, this.vv_1, this.wv_1, this.xv_1, this.yv_1, this.uv_1, this.tv_1, this.zv_1, this.aw_1, this.rv_1])]);
    var tmp_40 = this;
    // Inline function 'kotlin.apply' call
    var this_8 = new BlurredPassCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.CartoonPlanesScene.<anonymous>' call
    this_8.name = 'blurred-main';
    this_8.enabled = true;
    this_8.minSize = 180;
    this_8.brightness = 0.95;
    this_8.blurSize = BlurSize_KERNEL_4_getInstance();
    this_8.commands = mutableListOf([this.pv_1, this.vv_1, this.wv_1, this.xv_1, this.yv_1, this.uv_1, this.tv_1, this.zv_1, this.aw_1, this.rv_1]);
    tmp_40.ov_1 = this_8;
    var tmp_41 = this;
    // Inline function 'kotlin.apply' call
    var this_9 = new DrawBlurredCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.CartoonPlanesScene.<anonymous>' call
    this_9.name = 'draw blurred';
    this_9.blending = get_BLENDING_NONE();
    tmp_41.sv_1 = this_9;
    this.nv_1 = GroupCommandArr(false, [this.ov_1, MainPassCommandArr(true, [this.pv_1, this.sv_1])]);
    this.commands = mutableListOf([this.mv_1, this.nv_1]);
  }
  protoOf(CartoonPlanesScene).mo = function () {
    return this.settings;
  };
  protoOf(CartoonPlanesScene).cp = function () {
    return this.PIf;
  };
  protoOf(CartoonPlanesScene).dx = function (_set____db54di) {
    this.texSky = _set____db54di;
  };
  protoOf(CartoonPlanesScene).ex = function () {
    return this.texSky;
  };
  protoOf(CartoonPlanesScene).fx = function (_set____db54di) {
    this.texSky1 = _set____db54di;
  };
  protoOf(CartoonPlanesScene).gx = function () {
    return this.texSky1;
  };
  protoOf(CartoonPlanesScene).hx = function (_set____db54di) {
    this.texSky2 = _set____db54di;
  };
  protoOf(CartoonPlanesScene).ix = function () {
    return this.texSky2;
  };
  protoOf(CartoonPlanesScene).jx = function (_set____db54di) {
    this.meshPlane1 = _set____db54di;
  };
  protoOf(CartoonPlanesScene).kx = function () {
    return this.meshPlane1;
  };
  protoOf(CartoonPlanesScene).lx = function (_set____db54di) {
    this.meshPlane2 = _set____db54di;
  };
  protoOf(CartoonPlanesScene).mx = function () {
    return this.meshPlane2;
  };
  protoOf(CartoonPlanesScene).nx = function (_set____db54di) {
    this.texPlane1 = _set____db54di;
  };
  protoOf(CartoonPlanesScene).ox = function () {
    return this.texPlane1;
  };
  protoOf(CartoonPlanesScene).px = function (_set____db54di) {
    this.texPlane2 = _set____db54di;
  };
  protoOf(CartoonPlanesScene).qx = function () {
    return this.texPlane2;
  };
  protoOf(CartoonPlanesScene).updateTimers = function (time) {
    this.fv_1.qj(time);
    animate_0(this);
    protoOf(Scene).updateTimers.call(this, time);
  };
  protoOf(CartoonPlanesScene).updateViewportSize = function (width, height) {
    protoOf(Scene).updateViewportSize.call(this, width, height);
  };
  protoOf(CartoonPlanesScene).initialize = function () {
    randomizeCamera_0(this);
  };
  protoOf(CartoonPlanesScene).changeSky = function () {
    this.fv_1.oj(Timers_SwapSky_getInstance(), 0.0);
  };
  protoOf(CartoonPlanesScene).preventChangeSky = function () {
    this.fv_1.oj(Timers_SwapSky_getInstance(), 1.0);
  };
  protoOf(CartoonPlanesScene).randomizePropTexture = function () {
    var id = Default_getInstance().b6(2, 6);
    Textures_getInstance_1().vw_1.fileName = 'prop/' + id;
  };
  protoOf(CartoonPlanesScene).setPropTexture = function (id) {
    Textures_getInstance_1().vw_1.fileName = 'prop/' + id;
  };
  protoOf(CartoonPlanesScene).canChangePlanes = function () {
    return this.fv_1.nj(Timers_SwapPlanes_getInstance()) === 1.0;
  };
  protoOf(CartoonPlanesScene).canChangeSky = function () {
    return this.fv_1.nj(Timers_SwapSky_getInstance()) === 1.0;
  };
  protoOf(CartoonPlanesScene).changePlanes = function (plane1, plane2) {
    this.settings.currentPlane = plane1;
    this.settings.nextPlane = plane2;
    Meshes_getInstance_1().vu_1.fileName = 'plane' + plane1;
    Meshes_getInstance_1().wu_1.fileName = 'plane' + plane2;
    Textures_getInstance_1().tw_1.fileName = 'plane' + plane1;
    Textures_getInstance_1().uw_1.fileName = 'plane' + plane2;
    if (!(plane1 === plane2)) {
      this.fv_1.oj(Timers_SwapPlanes_getInstance(), 0.0);
    } else {
      if (Default_getInstance().c6() > 0.75) {
        this.fv_1.oj(Timers_SwapPlanes_getInstance(), 0.0);
      } else {
        this.fv_1.oj(Timers_SwapPlanes_getInstance(), 1.0);
      }
    }
    animate_0(this);
  };
  var TimeOfDay_Day_instance_1;
  var TimeOfDay_Night_instance_1;
  var TimeOfDay_Sunrise_instance_1;
  function values_3() {
    return [TimeOfDay_Day_getInstance_1(), TimeOfDay_Night_getInstance_1(), TimeOfDay_Sunrise_getInstance_1()];
  }
  function valueOf_3(value) {
    switch (value) {
      case 'Day':
        return TimeOfDay_Day_getInstance_1();
      case 'Night':
        return TimeOfDay_Night_getInstance_1();
      case 'Sunrise':
        return TimeOfDay_Sunrise_getInstance_1();
      default:
        TimeOfDay_initEntries_1();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var TimeOfDay_entriesInitialized_1;
  function TimeOfDay_initEntries_1() {
    if (TimeOfDay_entriesInitialized_1)
      return Unit_instance;
    TimeOfDay_entriesInitialized_1 = true;
    TimeOfDay_Day_instance_1 = new TimeOfDay_1('Day', 0, 0);
    TimeOfDay_Night_instance_1 = new TimeOfDay_1('Night', 1, 1);
    TimeOfDay_Sunrise_instance_1 = new TimeOfDay_1('Sunrise', 2, 2);
  }
  function TimeOfDay_1(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  function CartoonPlanesSettings() {
    this.cameraPeriod = 1.0;
    this.vignette = true;
    this.blurred = false;
    this.autoSwitchCameras = true;
    this.lowQuality = false;
    this.clock = false;
    this.currentPlane = 0;
    this.nextPlane = 1;
    this.timeOfDay = TimeOfDay_Day_getInstance_1();
  }
  protoOf(CartoonPlanesSettings).fp = function (_set____db54di) {
    this.cameraPeriod = _set____db54di;
  };
  protoOf(CartoonPlanesSettings).gp = function () {
    return this.cameraPeriod;
  };
  protoOf(CartoonPlanesSettings).hp = function (_set____db54di) {
    this.vignette = _set____db54di;
  };
  protoOf(CartoonPlanesSettings).ip = function () {
    return this.vignette;
  };
  protoOf(CartoonPlanesSettings).jp = function (_set____db54di) {
    this.blurred = _set____db54di;
  };
  protoOf(CartoonPlanesSettings).kp = function () {
    return this.blurred;
  };
  protoOf(CartoonPlanesSettings).lp = function (_set____db54di) {
    this.autoSwitchCameras = _set____db54di;
  };
  protoOf(CartoonPlanesSettings).mp = function () {
    return this.autoSwitchCameras;
  };
  protoOf(CartoonPlanesSettings).rp = function (_set____db54di) {
    this.lowQuality = _set____db54di;
  };
  protoOf(CartoonPlanesSettings).sp = function () {
    return this.lowQuality;
  };
  protoOf(CartoonPlanesSettings).pp = function (_set____db54di) {
    this.clock = _set____db54di;
  };
  protoOf(CartoonPlanesSettings).qp = function () {
    return this.clock;
  };
  protoOf(CartoonPlanesSettings).tx = function (_set____db54di) {
    this.currentPlane = _set____db54di;
  };
  protoOf(CartoonPlanesSettings).ux = function () {
    return this.currentPlane;
  };
  protoOf(CartoonPlanesSettings).vx = function (_set____db54di) {
    this.nextPlane = _set____db54di;
  };
  protoOf(CartoonPlanesSettings).wx = function () {
    return this.nextPlane;
  };
  protoOf(CartoonPlanesSettings).xx = function (_set____db54di) {
    this.timeOfDay = _set____db54di;
  };
  protoOf(CartoonPlanesSettings).op = function () {
    return this.timeOfDay;
  };
  function TimeOfDay_Day_getInstance_1() {
    TimeOfDay_initEntries_1();
    return TimeOfDay_Day_instance_1;
  }
  function TimeOfDay_Night_getInstance_1() {
    TimeOfDay_initEntries_1();
    return TimeOfDay_Night_instance_1;
  }
  function TimeOfDay_Sunrise_getInstance_1() {
    TimeOfDay_initEntries_1();
    return TimeOfDay_Sunrise_instance_1;
  }
  function Shaders_1() {
    Shaders_instance_1 = this;
    this.xw_1 = new Shader('Diffuse');
    this.yw_1 = new Shader('SkyTransition');
    this.zw_1 = new Shader('Outline');
    this.ax_1 = new Shader('Prop');
    this.bx_1 = mutableListOf([this.xw_1, this.yw_1, this.zw_1, this.ax_1]);
  }
  var Shaders_instance_1;
  function Shaders_getInstance_1() {
    if (Shaders_instance_1 == null)
      new Shaders_1();
    return Shaders_instance_1;
  }
  function Textures_1() {
    Textures_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.Textures.texNoise.<anonymous>' call
    this_0.name = 'noise';
    this_0.fileName = 'noise';
    this_0.format = TextureFormat_ASTC_getInstance();
    this_0.minFilter = TextureFiltering_LINEAR_getInstance();
    this_0.magFilter = TextureFiltering_LINEAR_getInstance();
    this_0.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp.pw_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.Textures.texSky1.<anonymous>' call
    this_1.name = 'sky-1';
    this_1.fileName = 'sky/day/1';
    this_1.format = TextureFormat_ASTC_getInstance();
    this_1.minFilter = TextureFiltering_LINEAR_getInstance();
    this_1.magFilter = TextureFiltering_LINEAR_getInstance();
    this_1.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp_0.qw_1 = this_1;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.Textures.texSky2.<anonymous>' call
    this_2.name = 'sky-2';
    this_2.fileName = 'sky/night/1';
    this_2.format = TextureFormat_ASTC_getInstance();
    this_2.minFilter = TextureFiltering_LINEAR_getInstance();
    this_2.magFilter = TextureFiltering_LINEAR_getInstance();
    this_2.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp_1.rw_1 = this_2;
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.Textures.texSky.<anonymous>' call
    this_3.name = 'sky';
    this_3.fileName = 'sky/night/1';
    this_3.format = TextureFormat_ASTC_getInstance();
    this_3.minFilter = TextureFiltering_LINEAR_getInstance();
    this_3.magFilter = TextureFiltering_LINEAR_getInstance();
    this_3.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp_2.sw_1 = this_3;
    var tmp_3 = this;
    // Inline function 'kotlin.apply' call
    var this_4 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.Textures.texPlane1.<anonymous>' call
    this_4.name = 'plane-1';
    this_4.fileName = 'plane0';
    this_4.format = TextureFormat_ASTC_getInstance();
    this_4.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_4.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_4.wrapping = TextureWrapping_REPEAT_getInstance();
    this_4.mipmaps = 10;
    tmp_3.tw_1 = this_4;
    var tmp_4 = this;
    // Inline function 'kotlin.apply' call
    var this_5 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.Textures.texPlane2.<anonymous>' call
    this_5.name = 'plane-2';
    this_5.fileName = 'plane1';
    this_5.format = TextureFormat_ASTC_getInstance();
    this_5.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_5.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_5.wrapping = TextureWrapping_REPEAT_getInstance();
    this_5.mipmaps = 10;
    tmp_4.uw_1 = this_5;
    var tmp_5 = this;
    // Inline function 'kotlin.apply' call
    var this_6 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cartoonplanes.Textures.texProp.<anonymous>' call
    this_6.name = 'prop';
    this_6.fileName = 'prop/2';
    this_6.format = TextureFormat_ASTC_getInstance();
    this_6.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_6.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_6.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_6.mipmaps = 8;
    tmp_5.vw_1 = this_6;
    this.ww_1 = mutableListOf([this.pw_1, this.sw_1, this.qw_1, this.rw_1, this.tw_1, this.uw_1, this.vw_1]);
  }
  var Textures_instance_1;
  function Textures_getInstance_1() {
    if (Textures_instance_1 == null)
      new Textures_1();
    return Textures_instance_1;
  }
  var Timers_PropRotate_instance;
  var Timers_PropFlicker_instance;
  var Timers_PlaneWonder1_instance;
  var Timers_PlaneWonder2_instance;
  var Timers_PlaneBanking_instance;
  var Timers_Camera_instance_1;
  var Timers_SwapPlanes_instance;
  var Timers_SwapSky_instance;
  function Companion_1() {
    this.ow_1 = 27800.0;
  }
  protoOf(Companion_1).cx = function (timers) {
    timers.lj(Timers_PropRotate_getInstance(), 741000.0);
    timers.lj(Timers_PropFlicker_getInstance(), 10.0);
    timers.lj(Timers_PlaneWonder1_getInstance(), 25000.0);
    timers.lj(Timers_PlaneWonder2_getInstance(), 6000.0);
    timers.lj(Timers_PlaneBanking_getInstance(), 22800.0);
    timers.mj(Timers_Camera_getInstance_0(), this.ow_1, false);
    timers.mj(Timers_SwapPlanes_getInstance(), 4000.0, false);
    timers.mj(Timers_SwapSky_getInstance(), 3000.0, false);
  };
  var Companion_instance_4;
  function Companion_getInstance_1() {
    return Companion_instance_4;
  }
  var Timers_entriesInitialized_1;
  function Timers_initEntries_1() {
    if (Timers_entriesInitialized_1)
      return Unit_instance;
    Timers_entriesInitialized_1 = true;
    Timers_PropRotate_instance = new Timers_1('PropRotate', 0);
    Timers_PropFlicker_instance = new Timers_1('PropFlicker', 1);
    Timers_PlaneWonder1_instance = new Timers_1('PlaneWonder1', 2);
    Timers_PlaneWonder2_instance = new Timers_1('PlaneWonder2', 3);
    Timers_PlaneBanking_instance = new Timers_1('PlaneBanking', 4);
    Timers_Camera_instance_1 = new Timers_1('Camera', 5);
    Timers_SwapPlanes_instance = new Timers_1('SwapPlanes', 6);
    Timers_SwapSky_instance = new Timers_1('SwapSky', 7);
  }
  function Timers_1(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Timers_PropRotate_getInstance() {
    Timers_initEntries_1();
    return Timers_PropRotate_instance;
  }
  function Timers_PropFlicker_getInstance() {
    Timers_initEntries_1();
    return Timers_PropFlicker_instance;
  }
  function Timers_PlaneWonder1_getInstance() {
    Timers_initEntries_1();
    return Timers_PlaneWonder1_instance;
  }
  function Timers_PlaneWonder2_getInstance() {
    Timers_initEntries_1();
    return Timers_PlaneWonder2_instance;
  }
  function Timers_PlaneBanking_getInstance() {
    Timers_initEntries_1();
    return Timers_PlaneBanking_instance;
  }
  function Timers_Camera_getInstance_0() {
    Timers_initEntries_1();
    return Timers_Camera_instance_1;
  }
  function Timers_SwapPlanes_getInstance() {
    Timers_initEntries_1();
    return Timers_SwapPlanes_instance;
  }
  function Timers_SwapSky_getInstance() {
    Timers_initEntries_1();
    return Timers_SwapSky_instance;
  }
  function Animations_0() {
    Animations_instance_0 = this;
    this.yx_1 = new TextureAnimationChunked(75, 75, 3);
  }
  var Animations_instance_0;
  function Animations_getInstance_0() {
    if (Animations_instance_0 == null)
      new Animations_0();
    return Animations_instance_0;
  }
  function Cameras_2() {
    Cameras_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.zx_1 = [new CameraPositionPair(new CameraPosition(new Vec3(38.70992, 5.15985, 5.91246), new Vec3(10.16353, -1.09901, 0.0518)), new CameraPosition(new Vec3(24.18353, 1.64399, 1.8614), new Vec3(6.5007, 2.24976, 1.69956)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-6.82741, 43.0728, 15.12059), new Vec3(2.9745, -9.71872, 2.66179)), new CameraPosition(new Vec3(-0.14104, 7.06108, 6.62179), new Vec3(2.9745, -9.71872, 2.66179)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-8.88309, 15.58949, 1.076), new Vec3(2.71626, 4.88696, 2.42399)), new CameraPosition(new Vec3(-8.88309, 15.58949, 1.076), new Vec3(2.01102, 4.12261, 2.42399)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(9.28378, 8.52561, 1.45335), new Vec3(0.1673, -7.79788, 1.23904)), new CameraPosition(new Vec3(9.28378, 8.52561, 1.45335), new Vec3(-0.92421, -7.12931, 1.23904)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(23.89814, 1.84801, 0.42454), new Vec3(13.745, 8.35707, 1.0304)), new CameraPosition(new Vec3(23.89814, 1.84801, 0.42454), new Vec3(12.9949, 7.15828, 1.0076)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-7.61864, 5.66412, 1.1225), new Vec3(6.11309, -6.64757, 0.54667)), new CameraPosition(new Vec3(-7.61864, 5.66412, 1.1225), new Vec3(4.47143, -3.8803, 1.23546)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-0.3545, -1.09883, 3.13904), new Vec3(-7.08796, -2.19082, 1.11842)), new CameraPosition(new Vec3(11.72716, 0.70572, 12.43634), new Vec3(-7.08796, -2.19082, 1.11842)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(2.50435, -5.30191, 4.57216), new Vec3(0.74438, 1.3856, 2.6324)), new CameraPosition(new Vec3(5.71569, 4.02841, 3.81446), new Vec3(0.74438, 1.3856, 2.6324)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(11.67545, -1.01319, 4.16589), new Vec3(16.63255, 5.23404, 3.42004)), new CameraPosition(new Vec3(22.93408, 5.5423, 4.6691), new Vec3(16.63255, 5.23404, 3.42004)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(5.95616, -3.69933, 0.57542), new Vec3(2.43907, -10.90985, 2.699)), new CameraPosition(new Vec3(5.95616, -3.69933, 0.57542), new Vec3(2.23556, 3.19109, 1.07307)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(1.03509, -17.76093, 0.61357), new Vec3(6.94162, 9.72911, 1.74293)), new CameraPosition(new Vec3(2.90728, -8.73623, 0.6173), new Vec3(6.94162, 9.72911, 1.74293)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(27.71519, -10.70263, 2.42775), new Vec3(14.72766, -7.33379, 0.15963)), new CameraPosition(new Vec3(27.14785, -6.90781, 2.40519), new Vec3(14.72766, -7.33379, 0.15963)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(5.28697, -14.83829, 2.66817), new Vec3(10.4528, -1.8823, 1.02553)), new CameraPosition(new Vec3(10.11546, -15.15036, 2.62786), new Vec3(10.4528, -1.8823, 1.02553)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(3.34795, -6.26302, 1.8104), new Vec3(-0.91791, -6.39719, 1.12574)), new CameraPosition(new Vec3(7.13582, -0.96275, 8.4854), new Vec3(-0.12868, -5.88976, 1.53747)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(4.52857, 2.51818, 3.22811), new Vec3(9.62498, 5.62938, 1.71498)), new CameraPosition(new Vec3(14.22244, 2.33154, 7.43974), new Vec3(12.04065, 4.80087, 2.0615)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(2.45082, -10.52241, 6.11413), new Vec3(7.9111, -4.35091, 0.71477)), new CameraPosition(new Vec3(13.36669, -11.10688, 6.11413), new Vec3(9.67914, -6.7669, 1.29186)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(20.98959, -1.69565, 8.14323), new Vec3(12.02538, -11.04883, 2.94463)), new CameraPosition(new Vec3(20.98959, -1.69565, 8.14323), new Vec3(15.88589, 7.95272, 1.755)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-1.15391, -3.71734, 8.98853), new Vec3(-5.85964, 2.59812, 1.85741)), new CameraPosition(new Vec3(-1.15391, -3.71734, 8.98853), new Vec3(10.94908, -5.03643, 3.17853)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(2.18649, -9.92329, 7.27979), new Vec3(-10.18294, -5.2422, 3.81831)), new CameraPosition(new Vec3(15.34668, -1.80578, 8.70861), new Vec3(19.77751, 7.57039, 2.41142)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(10.1439, -15.64655, 4.13888), new Vec3(-6.40787, -9.5562, 3.12396)), new CameraPosition(new Vec3(9.79544, 6.12718, 7.422), new Vec3(-5.44877, 0.32482, 2.01216)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-8.84024, 0.27637, 6.27443), new Vec3(-4.90632, 12.88201, 1.9203)), new CameraPosition(new Vec3(12.02008, 0.2488, 6.74946), new Vec3(22.7403, 10.25339, 1.24117)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(20.5219, -13.06709, 5.46594), new Vec3(19.30067, 0.57551, 1.50315)), new CameraPosition(new Vec3(3.12073, -12.23503, 6.06164), new Vec3(5.71142, -5.60674, 2.27801)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-8.15922, 13.82588, 2.09516), new Vec3(-0.03049, 7.9972, 0.89048)), new CameraPosition(new Vec3(-15.84635, 12.90287, 10.49672), new Vec3(-5.5892, 11.65156, 2.72385)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-0.36919, 4.22139, 4.84757), new Vec3(-4.90552, 11.10387, 2.30008)), new CameraPosition(new Vec3(-13.00475, 10.10982, 6.17595), new Vec3(-1.74259, 15.56522, 1.32554)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(25.60301, 6.31494, 3.91502), new Vec3(17.36128, 5.45937, 1.01392)), new CameraPosition(new Vec3(16.82751, 0.67953, 3.14737), new Vec3(17.36128, 5.45937, 1.01392)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-9.70366, -10.41646, 3.64063), new Vec3(-5.52848, -6.20358, 1.11495)), new CameraPosition(new Vec3(-0.50177, -8.92422, 3.56217), new Vec3(-5.52848, -6.20358, 1.11495)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-3.59182, 6.94843, 2.34605), new Vec3(-6.05712, 3.23195, 0.94271)), new CameraPosition(new Vec3(-1.52778, -0.68069, 3.38069), new Vec3(-6.05712, 3.23195, 0.94271)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(22.82161, -10.59952, 3.30366), new Vec3(18.49043, -2.69692, 1.71761)), new CameraPosition(new Vec3(10.8253, -11.05882, 1.29563), new Vec3(16.42235, -2.49028, 1.19195)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(25.30372, -13.31767, 4.51761), new Vec3(12.26076, 4.34953, 3.34535)), new CameraPosition(new Vec3(25.47256, 7.29274, 4.82758), new Vec3(17.58136, -2.74657, 3.81204)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-13.03896, 16.18357, 5.57775), new Vec3(17.46652, 2.3497, 3.34768)), new CameraPosition(new Vec3(-15.96301, -12.92775, 4.70224), new Vec3(17.46652, 2.3497, 3.34768)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-10.26255, -20.13821, 2.92488), new Vec3(4.41334, 0.87215, 2.83055)), new CameraPosition(new Vec3(25.03896, -17.07435, 7.22314), new Vec3(4.41334, 0.87215, 2.83055)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-12.90432, 25.76418, 5.99604), new Vec3(10.71068, -12.79007, 3.20119)), new CameraPosition(new Vec3(3.74226, -1.4133, 3.11995), new Vec3(10.71068, -12.79007, 3.20119)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-7.28207, -5.64235, 5.48364), new Vec3(4.48909, 0.70829, 3.30727)), new CameraPosition(new Vec3(9.17722, 2.97599, 3.09496), new Vec3(27.06189, 12.95163, 2.84923)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(28.24284, -1.87409, 3.28226), new Vec3(-3.56355, -1.57982, 2.39246)), new CameraPosition(new Vec3(6.04908, -1.45837, 1.93234), new Vec3(-3.56355, -1.57982, 2.39246)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(1.97821, -19.04979, 3.44), new Vec3(2.08283, 6.51826, 2.1118)), new CameraPosition(new Vec3(2.07565, -2.81006, 2.4), new Vec3(2.08283, 6.51826, 2.1118)), 1.0)];
  }
  var Cameras_instance_2;
  function Cameras_getInstance_2() {
    if (Cameras_instance_2 == null)
      new Cameras_2();
    return Cameras_instance_2;
  }
  function CommonAssetForgeTextures() {
    CommonAssetForgeTextures_instance = this;
    this.ay_1 = Textures_getInstance_2().ey_1;
    this.by_1 = Textures_getInstance_2().gy_1;
  }
  var CommonAssetForgeTextures_instance;
  function CommonAssetForgeTextures_getInstance() {
    if (CommonAssetForgeTextures_instance == null)
      new CommonAssetForgeTextures();
    return CommonAssetForgeTextures_instance;
  }
  function Flames() {
    Flames_instance = this;
    this.iy_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0)), 8);
    this.jy_1 = MeshConstructor2('flame', this.iy_1);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.ky_1 = ArrayList_init_$Create$_0();
    var tmp_0 = this;
    // Inline function 'kotlin.also' call
    var this_0 = GroupCommandArr(true, []);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.Flames.group.<anonymous>' call
    this_0.commands = Flames_getInstance().ky_1;
    tmp_0.ly_1 = this_0;
    var color = CommonAssetForgeShaders_getInstance().fz_1.value;
    color[0] = 1.0;
    color[1] = 0.82;
    color[2] = 0.71;
    color[3] = 1.0;
    this.hz(new Vec3(20.2993, -6.295, 1.1178), 0.1);
    this.hz(new Vec3(17.9, 5.6, 0.78), 0.1);
    this.hz(new Vec3(20.0042, -5.995, 0.9654), 0.1);
    this.hz(new Vec3(13.9938, -6.0102, 0.9754), 0.1);
    this.hz(new Vec3(14.2089, -5.9502, 1.1154), 0.1);
    this.hz(new Vec3(-4.9426, 11.436, 1.638), 0.1);
    this.hz(new Vec3(-5.0226, 11.2887, 1.7354), 0.1);
    this.hz(new Vec3(-6.2926, 3.438, 0.9829), 0.1);
    this.hz(new Vec3(-5.8626, 3.1505, 0.8929), 0.1);
    this.hz(new Vec3(-5.8526, -5.8602, 0.9154), 0.1);
    this.hz(new Vec3(-6.1326, -6.2902, 0.9629), 0.1);
    this.hz(new Vec3(-5.7826, -6.8102, 0.8054), 0.1);
  }
  protoOf(Flames).hz = function (position, scale) {
    this.ky_1.g(DrawStaticMeshCommandConstructor(this.jy_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), CommonAssetForgeShaders_getInstance().fz_1, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().ty_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(this.jy_1, CommonAssetForgeShaders_getInstance().ty_1)), new AffineTranformation(new Vec3(position.x, position.y, position.z), new Vec3(0.0, 0.0, 0.0), new Vec3(scale * 0.6, scale * 0.6, scale))));
  };
  var Flames_instance;
  function Flames_getInstance() {
    if (Flames_instance == null)
      new Flames();
    return Flames_instance;
  }
  function Ghosts() {
    Ghosts_instance = this;
    this.iz_1 = MeshConstructor2('ghost', Meshes_getInstance_2().nz_1);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.jz_1 = ArrayList_init_$Create$_0();
    var tmp_0 = this;
    // Inline function 'kotlin.also' call
    var this_0 = GroupCommandArr(true, []);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.Ghosts.group.<anonymous>' call
    this_0.commands = Ghosts_getInstance().jz_1;
    tmp_0.kz_1 = this_0;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$2 = new Float32Array([0.96, 0.86, 1.0, 1.0]);
    var uniformGhostColor0 = UniformFloatValueWithArray(tmp$ret$2);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$3 = new Float32Array([0.86, 0.85, 1.0, 1.0]);
    var uniformGhostColor1 = UniformFloatValueWithArray(tmp$ret$3);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$4 = new Float32Array([0.86, 1.0, 0.88, 1.0]);
    var uniformGhostColor2 = UniformFloatValueWithArray(tmp$ret$4);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$5 = new Float32Array([0.98, 1.0, 0.86, 1.0]);
    var uniformGhostColor3 = UniformFloatValueWithArray(tmp$ret$5);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$6 = new Float32Array([0.82, 0.82, 1.0, 1.0]);
    var uniformGhostColor4 = UniformFloatValueWithArray(tmp$ret$6);
    var GHOST_SCALE = 0.5;
    // Inline function 'kotlin.apply' call
    var this_1 = new Blending();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.Ghosts.<anonymous>' call
    this_1.enabled = true;
    this_1.equationColor = BlendingEquation_ADD_getInstance();
    this_1.sourceFactorColor = BlendingFactor_SRC_ALPHA_getInstance();
    this_1.destinationFactorColor = BlendingFactor_ONE_MINUS_SRC_ALPHA_getInstance();
    var blending = this_1;
    this.jz_1.g(DrawStaticMeshCommandConstructor(this.iz_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(CommonAssetForgeTextures_getInstance().by_1), CommonAssetForgeShaders_getInstance().gz_1, uniformGhostColor0, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().uy_1, blending, get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(this.iz_1, CommonAssetForgeShaders_getInstance().uy_1)), new AffineTranformation(new Vec3(0.0, 0.0, 0.3), new Vec3(0.0, 0.0, 0.0), new Vec3(GHOST_SCALE, GHOST_SCALE, GHOST_SCALE))));
    this.jz_1.g(DrawStaticMeshCommandConstructor(this.iz_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(CommonAssetForgeTextures_getInstance().by_1), CommonAssetForgeShaders_getInstance().gz_1, uniformGhostColor1, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().uy_1, blending, get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(this.iz_1, CommonAssetForgeShaders_getInstance().uy_1)), new AffineTranformation(new Vec3(1.0, 0.0, 0.3), new Vec3(0.0, 0.0, 0.0), new Vec3(GHOST_SCALE * 0.8, GHOST_SCALE * 0.8, GHOST_SCALE))));
    this.jz_1.g(DrawStaticMeshCommandConstructor(this.iz_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(CommonAssetForgeTextures_getInstance().by_1), CommonAssetForgeShaders_getInstance().gz_1, uniformGhostColor2, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().uy_1, blending, get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(this.iz_1, CommonAssetForgeShaders_getInstance().uy_1)), new AffineTranformation(new Vec3(2.0, 0.0, 0.3), new Vec3(0.0, 0.0, 0.0), new Vec3(GHOST_SCALE, GHOST_SCALE, GHOST_SCALE * 1.2))));
    this.jz_1.g(DrawStaticMeshCommandConstructor(this.iz_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(CommonAssetForgeTextures_getInstance().by_1), CommonAssetForgeShaders_getInstance().gz_1, uniformGhostColor3, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().uy_1, blending, get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(this.iz_1, CommonAssetForgeShaders_getInstance().uy_1)), new AffineTranformation(new Vec3(3.0, 0.0, 0.3), new Vec3(0.0, 0.0, 0.0), new Vec3(GHOST_SCALE * 0.8, GHOST_SCALE * 0.8, GHOST_SCALE))));
    this.jz_1.g(DrawStaticMeshCommandConstructor(this.iz_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(CommonAssetForgeTextures_getInstance().by_1), CommonAssetForgeShaders_getInstance().gz_1, uniformGhostColor4, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().uy_1, blending, get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(this.iz_1, CommonAssetForgeShaders_getInstance().uy_1)), new AffineTranformation(new Vec3(4.0, 0.0, 0.3), new Vec3(0.0, 0.0, 0.0), new Vec3(GHOST_SCALE * 1.3, GHOST_SCALE * 1.3, GHOST_SCALE * 0.9))));
  }
  var Ghosts_instance;
  function Ghosts_getInstance() {
    if (Ghosts_instance == null)
      new Ghosts();
    return Ghosts_instance;
  }
  function ImportedAssetForgeCommands() {
    ImportedAssetForgeCommands_instance = this;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.g10_1 = ArrayList_init_$Create$_0();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.h10_1 = ArrayList_init_$Create$_0();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_1.i10_1 = ArrayList_init_$Create$_0();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_2.j10_1 = ArrayList_init_$Create$_0();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_3.k10_1 = ArrayList_init_$Create$_0();
    var tmp_4 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_4.l10_1 = ArrayList_init_$Create$_0();
    var tmp_5 = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeCommands.texSSAO.<anonymous>' call
    this_0.type = TextureType_SSAO_getInstance();
    tmp_5.m10_1 = this_0;
    this.j12(ImportedAssetForgeMeshes_getInstance().r10_1, ImportedAssetForgeTextures_getInstance().g12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(29.938583, -11.785566, -0.071564), new Vec3(36.345463, -1.671677, 1.471558)));
    this.j12(ImportedAssetForgeMeshes_getInstance().s10_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-36.0, -44.0, -0.603714), new Vec3(2.472875, -16.0, 7.240505)));
    this.j12(ImportedAssetForgeMeshes_getInstance().t10_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(14.565916, -44.412815, -0.665716), new Vec3(52.0, -14.009504, 12.66412)));
    this.j12(ImportedAssetForgeMeshes_getInstance().u10_1, ImportedAssetForgeTextures_getInstance().g12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(17.427229, -12.654359, -0.047736), new Vec3(23.531727, -3.287938, 0.88749)));
    this.j12(ImportedAssetForgeMeshes_getInstance().v10_1, ImportedAssetForgeTextures_getInstance().g12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(22.34564, 4.468273, -0.047783), new Vec3(23.712063, 7.712062, 1.074488)));
    this.j12(ImportedAssetForgeMeshes_getInstance().w10_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.0, -44.0, -0.065464), new Vec3(20.0, -20.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance().x10_1, ImportedAssetForgeTextures_getInstance().g12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-7.308465, -32.008465, -0.071617), new Vec3(21.345463, -15.940843, 1.78013)));
    this.j12(ImportedAssetForgeMeshes_getInstance().y10_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.436442, 10.706612, -0.400237), new Vec3(1.379266, 27.034237, 7.222706)));
    this.j12(ImportedAssetForgeMeshes_getInstance().z10_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.25, 0.0, -0.296535), new Vec3(-0.062865, 9.027068, 3.0)));
    this.j12(ImportedAssetForgeMeshes_getInstance().a11_1, ImportedAssetForgeTextures_getInstance().g12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-3.783728, -4.579492, -0.047736), new Vec3(-0.782496, 2.363871, 0.88749)));
    this.j12(ImportedAssetForgeMeshes_getInstance().b11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.25, -8.0, 0.0), new Vec3(-3.625, 0.25, 2.200001)));
    this.j12(ImportedAssetForgeMeshes_getInstance().c11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.5, -12.5, -0.110926), new Vec3(0.0, -7.75, 4.4)));
    this.j12(ImportedAssetForgeMeshes_getInstance().d11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.0, -20.0, -0.065464), new Vec3(4.0, -12.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance().e11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(0.046961, -19.881874, 0.0), new Vec3(3.953039, -12.074254, 0.100002)));
    this.j12(ImportedAssetForgeMeshes_getInstance().f11_1, ImportedAssetForgeTextures_getInstance().g12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-2.819215, -17.418945, -0.047783), new Vec3(6.808515, -12.593954, 1.168037)));
    this.j12(ImportedAssetForgeMeshes_getInstance().g11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.25, 7.5, -0.106424), new Vec3(-1.934515, 15.234923, 2.2)));
    this.j12(ImportedAssetForgeMeshes_getInstance().h11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-36.0, -16.0, -0.59394), new Vec3(-8.0, 8.076118, 10.517678)));
    this.j12(ImportedAssetForgeMeshes_getInstance().i11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(4.0, -20.0, -0.065464), new Vec3(16.0, -8.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance().j11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(24.8881, -7.759596, -0.665716), new Vec3(39.39676, 32.545006, 12.663438)));
    this.j12(ImportedAssetForgeMeshes_getInstance().k11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(28.0, -16.0, -0.065464), new Vec3(52.0, 16.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance().l11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(16.0, 16.0, -0.065464), new Vec3(52.0, 40.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance().m11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.0, 16.0, -0.065464), new Vec3(16.0, 40.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance().n11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-36.0, 8.0, -0.603714), new Vec3(-7.487249, 40.0, 9.787996)));
    this.j12(ImportedAssetForgeMeshes_getInstance().o11_1, ImportedAssetForgeTextures_getInstance().g12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-20.933353, -3.952754, -1.979322), new Vec3(-6.981812, 27.380268, 3.886004)));
    this.j12(ImportedAssetForgeMeshes_getInstance().p11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(4.0, 0.0, -0.065464), new Vec3(28.0, 16.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance().q11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.0, -12.0, -0.065464), new Vec3(4.0, 4.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance().r11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-2.266702, -14.402639, -0.328623), new Vec3(4.109221, 7.953039, 4.413949)));
    this.j12(ImportedAssetForgeMeshes_getInstance().s11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.0, 4.0, -0.065464), new Vec3(4.0, 16.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance().t11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-1.0, 7.964671, 0.0), new Vec3(5.0, 16.0, 8.0)));
    this.j12(ImportedAssetForgeMeshes_getInstance().u11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(4.0, -8.0, -1.5), new Vec3(16.0, 0.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance().v11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(4.0, -12.323488, -1.54635), new Vec3(16.0, -3.160703, 2.600205)));
    this.j12(ImportedAssetForgeMeshes_getInstance().w11_1, ImportedAssetForgeTextures_getInstance().g12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(4.243107, -11.654359, -0.047736), new Vec3(12.712062, -3.287938, 0.88749)));
    this.j12(ImportedAssetForgeMeshes_getInstance().x11_1, ImportedAssetForgeTextures_getInstance().g12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(8.713272, 3.391726, -0.047736), new Vec3(17.01526, 8.713467, 0.88749)));
    this.j12(ImportedAssetForgeMeshes_getInstance().y11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(13.25472, 3.54914, -0.321442), new Vec3(24.25, 16.0, 3.831946)));
    this.j12(ImportedAssetForgeMeshes_getInstance().z11_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(16.066969, -4.0, -0.226658), new Vec3(24.918962, 4.0, 2.215322)));
    this.j12(ImportedAssetForgeMeshes_getInstance().a12_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(16.0, -16.0, -0.065464), new Vec3(28.0, 0.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance().b12_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(14.033948, -12.5, -0.368515), new Vec3(24.571564, -3.42622, 4.738093)));
    this.j12(ImportedAssetForgeMeshes_getInstance().c12_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(3.082648, 7.75047, -1.054764), new Vec3(25.613907, 26.76259, 12.88447)));
    this.j12(ImportedAssetForgeMeshes_getInstance().d12_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(4.033948, -2.945264, -0.28921), new Vec3(15.937135, 9.849547, 4.793867)));
    this.j12(ImportedAssetForgeMeshes_getInstance().e12_1, ImportedAssetForgeTextures_getInstance().h12_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(0.17999, -8.72001, 0.4), new Vec3(7.810161, 5.210161, 3.1)));
    this.j12(ImportedAssetForgeMeshes_getInstance().q10_1, ImportedAssetForgeTextures_getInstance().g12_1, new AffineTranformation(new Vec3(-1.6, 10.0, 0.0095), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.2)), new Aabb(new Vec3(-2.172771, 9.345641, -0.047783), new Vec3(-1.068273, 10.712062, 1.074488)));
    this.n10_1 = new Vec3(-0.8, 5.0, 0.00475);
    this.o10_1 = 5.063598;
  }
  protoOf(ImportedAssetForgeCommands).j12 = function (mesh, texture, transform, bounds) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.l10_1.g(bounds);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.g10_1;
    var element = DrawStaticMeshCommandConstructor(mesh, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texture), CommonAssetForgeShaders_getInstance().wy_1, CommonAssetForgeShaders_getInstance().xy_1, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1, new UniformTextureValue(this.m10_1)]), Companion_instance_0.forSolidGeometry(mesh, CommonAssetForgeShaders_getInstance().my_1), transform, 0, 1);
    this_0.g(element);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this.h10_1;
    var element_0 = DrawStaticMeshCommandConstructor(mesh, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texture), CommonAssetForgeShaders_getInstance().wy_1, CommonAssetForgeShaders_getInstance().xy_1, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1, new UniformTextureValue(this.m10_1), new UniformTextureValue(CommonAssetForgeTextures_getInstance().ay_1), CommonAssetForgeShaders_getInstance().bz_1, CommonAssetForgeShaders_getInstance().cz_1, CommonAssetForgeShaders_getInstance().dz_1, CommonAssetForgeShaders_getInstance().ez_1]), Companion_instance_0.forSolidGeometry(mesh, CommonAssetForgeShaders_getInstance().ny_1), transform, 0, 1);
    this_1.g(element_0);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_2 = this.i10_1;
    var element_1 = Companion_instance_1.forSolidGeometry(mesh, CommonAssetForgeShaders_getInstance().py_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texture)]), transform);
    this_2.g(element_1);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_3 = this.j10_1;
    var element_2 = Companion_instance_1.forSolidGeometry(mesh, CommonAssetForgeShaders_getInstance().qy_1, listOf_0(UniformFloatValueWithArray(new Float32Array(16))), transform);
    this_3.g(element_2);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_4 = this.k10_1;
    var element_3 = DrawStaticMeshCommandConstructor(mesh, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(16))]), Companion_instance_0.forSolidGeometry(mesh, CommonAssetForgeShaders_getInstance().ry_1), transform, 0, 1);
    this_4.g(element_3);
  };
  var ImportedAssetForgeCommands_instance;
  function ImportedAssetForgeCommands_getInstance() {
    if (ImportedAssetForgeCommands_instance == null)
      new ImportedAssetForgeCommands();
    return ImportedAssetForgeCommands_instance;
  }
  function ImportedAssetForgeMeshes() {
    ImportedAssetForgeMeshes_instance = this;
    this.p10_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_UBYTE2_NORMALIZED_getInstance(), 6), new MeshAttribute(AttributeType_NORMAL_getInstance(), VertexFormat_BYTE3_NORMALIZED_getInstance(), 8)]), 12);
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = MeshConstructor2('kay-forest-free_Grass_2_D_Color1', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshKayForestFreeGrass2DColor1.<anonymous>' call
    this_0.fileName = 'imported/kay-forest-free_Grass_2_D_Color1';
    tmp.q10_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = MeshConstructor2('cemetery_Group_227', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup227.<anonymous>' call
    this_1.fileName = 'imported/cemetery_Group_227';
    tmp_0.r10_1 = this_1;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = MeshConstructor2('cemetery_Group_268', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup268.<anonymous>' call
    this_2.fileName = 'imported/cemetery_Group_268';
    tmp_1.s10_1 = this_2;
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = MeshConstructor2('cemetery_Group_271', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup271.<anonymous>' call
    this_3.fileName = 'imported/cemetery_Group_271';
    tmp_2.t10_1 = this_3;
    var tmp_3 = this;
    // Inline function 'kotlin.apply' call
    var this_4 = MeshConstructor2('cemetery_Group_272', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup272.<anonymous>' call
    this_4.fileName = 'imported/cemetery_Group_272';
    tmp_3.u10_1 = this_4;
    var tmp_4 = this;
    // Inline function 'kotlin.apply' call
    var this_5 = MeshConstructor2('cemetery_Group_138', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup138.<anonymous>' call
    this_5.fileName = 'imported/cemetery_Group_138';
    tmp_4.v10_1 = this_5;
    var tmp_5 = this;
    // Inline function 'kotlin.apply' call
    var this_6 = MeshConstructor2('cemetery_Group_207', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup207.<anonymous>' call
    this_6.fileName = 'imported/cemetery_Group_207';
    tmp_5.w10_1 = this_6;
    var tmp_6 = this;
    // Inline function 'kotlin.apply' call
    var this_7 = MeshConstructor2('cemetery_Group_276', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup276.<anonymous>' call
    this_7.fileName = 'imported/cemetery_Group_276';
    tmp_6.x10_1 = this_7;
    var tmp_7 = this;
    // Inline function 'kotlin.apply' call
    var this_8 = MeshConstructor2('cemetery_Group_200', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup200.<anonymous>' call
    this_8.fileName = 'imported/cemetery_Group_200';
    tmp_7.y10_1 = this_8;
    var tmp_8 = this;
    // Inline function 'kotlin.apply' call
    var this_9 = MeshConstructor2('cemetery_Group_236', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup236.<anonymous>' call
    this_9.fileName = 'imported/cemetery_Group_236';
    tmp_8.z10_1 = this_9;
    var tmp_9 = this;
    // Inline function 'kotlin.apply' call
    var this_10 = MeshConstructor2('cemetery_Group_231', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup231.<anonymous>' call
    this_10.fileName = 'imported/cemetery_Group_231';
    tmp_9.a11_1 = this_10;
    var tmp_10 = this;
    // Inline function 'kotlin.apply' call
    var this_11 = MeshConstructor2('cemetery_Group_235', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup235.<anonymous>' call
    this_11.fileName = 'imported/cemetery_Group_235';
    tmp_10.b11_1 = this_11;
    var tmp_11 = this;
    // Inline function 'kotlin.apply' call
    var this_12 = MeshConstructor2('cemetery_Group_234', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup234.<anonymous>' call
    this_12.fileName = 'imported/cemetery_Group_234';
    tmp_11.c11_1 = this_12;
    var tmp_12 = this;
    // Inline function 'kotlin.apply' call
    var this_13 = MeshConstructor2('cemetery_Group_224', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup224.<anonymous>' call
    this_13.fileName = 'imported/cemetery_Group_224';
    tmp_12.d11_1 = this_13;
    var tmp_13 = this;
    // Inline function 'kotlin.apply' call
    var this_14 = MeshConstructor2('cemetery_Group_208', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup208.<anonymous>' call
    this_14.fileName = 'imported/cemetery_Group_208';
    tmp_13.e11_1 = this_14;
    var tmp_14 = this;
    // Inline function 'kotlin.apply' call
    var this_15 = MeshConstructor2('cemetery_Group_228', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup228.<anonymous>' call
    this_15.fileName = 'imported/cemetery_Group_228';
    tmp_14.f11_1 = this_15;
    var tmp_15 = this;
    // Inline function 'kotlin.apply' call
    var this_16 = MeshConstructor2('cemetery_Group_215', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup215.<anonymous>' call
    this_16.fileName = 'imported/cemetery_Group_215';
    tmp_15.g11_1 = this_16;
    var tmp_16 = this;
    // Inline function 'kotlin.apply' call
    var this_17 = MeshConstructor2('cemetery_Group_279', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup279.<anonymous>' call
    this_17.fileName = 'imported/cemetery_Group_279';
    tmp_16.h11_1 = this_17;
    var tmp_17 = this;
    // Inline function 'kotlin.apply' call
    var this_18 = MeshConstructor2('cemetery_Group_7', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup7.<anonymous>' call
    this_18.fileName = 'imported/cemetery_Group_7';
    tmp_17.i11_1 = this_18;
    var tmp_18 = this;
    // Inline function 'kotlin.apply' call
    var this_19 = MeshConstructor2('cemetery_Group_204', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup204.<anonymous>' call
    this_19.fileName = 'imported/cemetery_Group_204';
    tmp_18.j11_1 = this_19;
    var tmp_19 = this;
    // Inline function 'kotlin.apply' call
    var this_20 = MeshConstructor2('cemetery_Group_226', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup226.<anonymous>' call
    this_20.fileName = 'imported/cemetery_Group_226';
    tmp_19.k11_1 = this_20;
    var tmp_20 = this;
    // Inline function 'kotlin.apply' call
    var this_21 = MeshConstructor2('cemetery_Group_202', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup202.<anonymous>' call
    this_21.fileName = 'imported/cemetery_Group_202';
    tmp_20.l11_1 = this_21;
    var tmp_21 = this;
    // Inline function 'kotlin.apply' call
    var this_22 = MeshConstructor2('cemetery_Group_201', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup201.<anonymous>' call
    this_22.fileName = 'imported/cemetery_Group_201';
    tmp_21.m11_1 = this_22;
    var tmp_22 = this;
    // Inline function 'kotlin.apply' call
    var this_23 = MeshConstructor2('cemetery_Group_270', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup270.<anonymous>' call
    this_23.fileName = 'imported/cemetery_Group_270';
    tmp_22.n11_1 = this_23;
    var tmp_23 = this;
    // Inline function 'kotlin.apply' call
    var this_24 = MeshConstructor2('cemetery_Group_280', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup280.<anonymous>' call
    this_24.fileName = 'imported/cemetery_Group_280';
    tmp_23.o11_1 = this_24;
    var tmp_24 = this;
    // Inline function 'kotlin.apply' call
    var this_25 = MeshConstructor2('cemetery_Group_205', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup205.<anonymous>' call
    this_25.fileName = 'imported/cemetery_Group_205';
    tmp_24.p11_1 = this_25;
    var tmp_25 = this;
    // Inline function 'kotlin.apply' call
    var this_26 = MeshConstructor2('cemetery_Group_223', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup223.<anonymous>' call
    this_26.fileName = 'imported/cemetery_Group_223';
    tmp_25.q11_1 = this_26;
    var tmp_26 = this;
    // Inline function 'kotlin.apply' call
    var this_27 = MeshConstructor2('cemetery_Group_277', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup277.<anonymous>' call
    this_27.fileName = 'imported/cemetery_Group_277';
    tmp_26.r11_1 = this_27;
    var tmp_27 = this;
    // Inline function 'kotlin.apply' call
    var this_28 = MeshConstructor2('cemetery_Group_3', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup3.<anonymous>' call
    this_28.fileName = 'imported/cemetery_Group_3';
    tmp_27.s11_1 = this_28;
    var tmp_28 = this;
    // Inline function 'kotlin.apply' call
    var this_29 = MeshConstructor2('cemetery_Group_237', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup237.<anonymous>' call
    this_29.fileName = 'imported/cemetery_Group_237';
    tmp_28.t11_1 = this_29;
    var tmp_29 = this;
    // Inline function 'kotlin.apply' call
    var this_30 = MeshConstructor2('cemetery_Group_211', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup211.<anonymous>' call
    this_30.fileName = 'imported/cemetery_Group_211';
    tmp_29.u11_1 = this_30;
    var tmp_30 = this;
    // Inline function 'kotlin.apply' call
    var this_31 = MeshConstructor2('cemetery_Group_243', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup243.<anonymous>' call
    this_31.fileName = 'imported/cemetery_Group_243';
    tmp_30.v11_1 = this_31;
    var tmp_31 = this;
    // Inline function 'kotlin.apply' call
    var this_32 = MeshConstructor2('cemetery_Group_273', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup273.<anonymous>' call
    this_32.fileName = 'imported/cemetery_Group_273';
    tmp_31.w11_1 = this_32;
    var tmp_32 = this;
    // Inline function 'kotlin.apply' call
    var this_33 = MeshConstructor2('cemetery_Group_274', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup274.<anonymous>' call
    this_33.fileName = 'imported/cemetery_Group_274';
    tmp_32.x11_1 = this_33;
    var tmp_33 = this;
    // Inline function 'kotlin.apply' call
    var this_34 = MeshConstructor2('cemetery_Group_238', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup238.<anonymous>' call
    this_34.fileName = 'imported/cemetery_Group_238';
    tmp_33.y11_1 = this_34;
    var tmp_34 = this;
    // Inline function 'kotlin.apply' call
    var this_35 = MeshConstructor2('cemetery_Group_241', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup241.<anonymous>' call
    this_35.fileName = 'imported/cemetery_Group_241';
    tmp_34.z11_1 = this_35;
    var tmp_35 = this;
    // Inline function 'kotlin.apply' call
    var this_36 = MeshConstructor2('cemetery_Group_210', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup210.<anonymous>' call
    this_36.fileName = 'imported/cemetery_Group_210';
    tmp_35.a12_1 = this_36;
    var tmp_36 = this;
    // Inline function 'kotlin.apply' call
    var this_37 = MeshConstructor2('cemetery_Group_242', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup242.<anonymous>' call
    this_37.fileName = 'imported/cemetery_Group_242';
    tmp_36.b12_1 = this_37;
    var tmp_37 = this;
    // Inline function 'kotlin.apply' call
    var this_38 = MeshConstructor2('cemetery_Group_206', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup206.<anonymous>' call
    this_38.fileName = 'imported/cemetery_Group_206';
    tmp_37.c12_1 = this_38;
    var tmp_38 = this;
    // Inline function 'kotlin.apply' call
    var this_39 = MeshConstructor2('cemetery_Group_282', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup282.<anonymous>' call
    this_39.fileName = 'imported/cemetery_Group_282';
    tmp_38.d12_1 = this_39;
    var tmp_39 = this;
    // Inline function 'kotlin.apply' call
    var this_40 = MeshConstructor2('cemetery_Group_281', this.p10_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeMeshes.meshCemeteryGroup281.<anonymous>' call
    this_40.fileName = 'imported/cemetery_Group_281';
    tmp_39.e12_1 = this_40;
    this.f12_1 = mutableListOf([this.q10_1, this.r10_1, this.s10_1, this.t10_1, this.u10_1, this.v10_1, this.w10_1, this.x10_1, this.y10_1, this.z10_1, this.a11_1, this.b11_1, this.c11_1, this.d11_1, this.e11_1, this.f11_1, this.g11_1, this.h11_1, this.i11_1, this.j11_1, this.k11_1, this.l11_1, this.m11_1, this.n11_1, this.o11_1, this.p11_1, this.q11_1, this.r11_1, this.s11_1, this.t11_1, this.u11_1, this.v11_1, this.w11_1, this.x11_1, this.y11_1, this.z11_1, this.a12_1, this.b12_1, this.c12_1, this.d12_1, this.e12_1]);
  }
  var ImportedAssetForgeMeshes_instance;
  function ImportedAssetForgeMeshes_getInstance() {
    if (ImportedAssetForgeMeshes_instance == null)
      new ImportedAssetForgeMeshes();
    return ImportedAssetForgeMeshes_instance;
  }
  function ImportedAssetForgeTextures() {
    ImportedAssetForgeTextures_instance = this;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeTextures.texKayForestFreeForestTexture.<anonymous>' call
    this_0.name = 'imported/kay-forest-free_forest_texture';
    this_0.fileName = 'imported/kay-forest-free_forest_texture';
    this_0.format = TextureFormat_ASTC_getInstance();
    this_0.wrapping = TextureWrapping_REPEAT_getInstance();
    this_0.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_0.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_0.mipmaps = 8;
    tmp.g12_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.ImportedAssetForgeTextures.texKayHalloweenHalloweenbitsTexture.<anonymous>' call
    this_1.name = 'imported/kay-halloween_halloweenbits_texture';
    this_1.fileName = 'imported/kay-halloween_halloweenbits_texture';
    this_1.format = TextureFormat_ASTC_getInstance();
    this_1.wrapping = TextureWrapping_REPEAT_getInstance();
    this_1.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_1.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_1.mipmaps = 8;
    tmp_0.h12_1 = this_1;
    this.i12_1 = mutableListOf([this.g12_1, this.h12_1]);
  }
  var ImportedAssetForgeTextures_instance;
  function ImportedAssetForgeTextures_getInstance() {
    if (ImportedAssetForgeTextures_instance == null)
      new ImportedAssetForgeTextures();
    return ImportedAssetForgeTextures_instance;
  }
  function LeavesParticleSystemConfig(particleCount, minX, maxX, minY, maxY, height, size, speed, amplitude, frequency, rotationSpeed, baseRotation, positionJitter) {
    particleCount = particleCount === VOID ? 18 : particleCount;
    minX = minX === VOID ? -30.0 : minX;
    maxX = maxX === VOID ? 30.0 : maxX;
    minY = minY === VOID ? -22.0 : minY;
    maxY = maxY === VOID ? 28.0 : maxY;
    height = height === VOID ? 3.5 : height;
    size = size === VOID ? 0.75 : size;
    speed = speed === VOID ? 1.5 : speed;
    amplitude = amplitude === VOID ? new Vec3(4.0, 4.0, 2.0) : amplitude;
    frequency = frequency === VOID ? new Vec3(0.3, 0.3, 0.1) : frequency;
    rotationSpeed = rotationSpeed === VOID ? new Vec3(85.0, 73.0, 81.0) : rotationSpeed;
    baseRotation = baseRotation === VOID ? new Vec3(0.0, 90.0, 0.0) : baseRotation;
    positionJitter = positionJitter === VOID ? 0.6 : positionJitter;
    this.k12_1 = particleCount;
    this.l12_1 = minX;
    this.m12_1 = maxX;
    this.n12_1 = minY;
    this.o12_1 = maxY;
    this.p12_1 = height;
    this.q12_1 = size;
    this.r12_1 = speed;
    this.s12_1 = amplitude;
    this.t12_1 = frequency;
    this.u12_1 = rotationSpeed;
    this.v12_1 = baseRotation;
    this.w12_1 = positionJitter;
    this.x12_1 = 3;
  }
  protoOf(LeavesParticleSystemConfig).toString = function () {
    return 'LeavesParticleSystemConfig(particleCount=' + this.k12_1 + ', minX=' + this.l12_1 + ', maxX=' + this.m12_1 + ', minY=' + this.n12_1 + ', maxY=' + this.o12_1 + ', height=' + this.p12_1 + ', size=' + this.q12_1 + ', speed=' + this.r12_1 + ', amplitude=' + this.s12_1 + ', frequency=' + this.t12_1 + ', rotationSpeed=' + this.u12_1 + ', baseRotation=' + this.v12_1 + ', positionJitter=' + this.w12_1 + ')';
  };
  protoOf(LeavesParticleSystemConfig).hashCode = function () {
    var result = this.k12_1;
    result = imul(result, 31) + getNumberHashCode(this.l12_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m12_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n12_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o12_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p12_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q12_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r12_1) | 0;
    result = imul(result, 31) + this.s12_1.hashCode() | 0;
    result = imul(result, 31) + this.t12_1.hashCode() | 0;
    result = imul(result, 31) + this.u12_1.hashCode() | 0;
    result = imul(result, 31) + this.v12_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.w12_1) | 0;
    return result;
  };
  protoOf(LeavesParticleSystemConfig).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LeavesParticleSystemConfig))
      return false;
    var tmp0_other_with_cast = other instanceof LeavesParticleSystemConfig ? other : THROW_CCE();
    if (!(this.k12_1 === tmp0_other_with_cast.k12_1))
      return false;
    if (!equals(this.l12_1, tmp0_other_with_cast.l12_1))
      return false;
    if (!equals(this.m12_1, tmp0_other_with_cast.m12_1))
      return false;
    if (!equals(this.n12_1, tmp0_other_with_cast.n12_1))
      return false;
    if (!equals(this.o12_1, tmp0_other_with_cast.o12_1))
      return false;
    if (!equals(this.p12_1, tmp0_other_with_cast.p12_1))
      return false;
    if (!equals(this.q12_1, tmp0_other_with_cast.q12_1))
      return false;
    if (!equals(this.r12_1, tmp0_other_with_cast.r12_1))
      return false;
    if (!this.s12_1.equals(tmp0_other_with_cast.s12_1))
      return false;
    if (!this.t12_1.equals(tmp0_other_with_cast.t12_1))
      return false;
    if (!this.u12_1.equals(tmp0_other_with_cast.u12_1))
      return false;
    if (!this.v12_1.equals(tmp0_other_with_cast.v12_1))
      return false;
    if (!equals(this.w12_1, tmp0_other_with_cast.w12_1))
      return false;
    return true;
  };
  function Particle(command, progress, seed, rotationSeed, laneY, heightOffset) {
    this.y12_1 = command;
    this.z12_1 = progress;
    this.a13_1 = seed;
    this.b13_1 = rotationSeed;
    this.c13_1 = laneY;
    this.d13_1 = heightOffset;
  }
  function advance($this) {
    var trackLength = $this.e13_1.m12_1 - $this.e13_1.l12_1;
    var twoPi = 2 * get_PI();
    var tmp0_iterator = $this.g13_1.j();
    while (tmp0_iterator.k()) {
      var particle = tmp0_iterator.l();
      var progress = particle.z12_1 + $this.h13_1 * $this.e13_1.r12_1 / trackLength;
      var tmp = progress;
      // Inline function 'kotlin.math.floor' call
      var x = progress;
      progress = tmp - Math.floor(x);
      var transform = particle.y12_1.transform;
      var tmp_0 = transform.y9_1;
      var tmp_1 = $this.e13_1.l12_1 + progress * trackLength;
      // Inline function 'kotlin.math.sin' call
      var x_0 = ($this.h13_1 + particle.a13_1) * twoPi * $this.e13_1.t12_1.x;
      tmp_0.x = tmp_1 + Math.sin(x_0) * $this.e13_1.s12_1.x;
      var tmp_2 = transform.y9_1;
      // Inline function 'kotlin.math.sin' call
      var x_1 = ($this.h13_1 + particle.a13_1 * 1.7) * twoPi * $this.e13_1.t12_1.y;
      var tmp$ret$2 = Math.sin(x_1);
      tmp_2.y = particle.c13_1 + tmp$ret$2 * $this.e13_1.s12_1.y;
      var tmp_3 = transform.y9_1;
      var tmp_4 = $this.e13_1.p12_1 + particle.d13_1;
      // Inline function 'kotlin.math.sin' call
      var x_2 = ($this.h13_1 + particle.a13_1 * 2.3) * twoPi * $this.e13_1.t12_1.z;
      tmp_3.z = tmp_4 + Math.sin(x_2) * $this.e13_1.s12_1.z;
      transform.z9_1.x = angle($this, $this.e13_1.v12_1.x + ($this.h13_1 + particle.b13_1.x) * $this.e13_1.u12_1.x);
      transform.z9_1.y = angle($this, $this.e13_1.v12_1.y + ($this.h13_1 + particle.b13_1.y) * $this.e13_1.u12_1.y);
      transform.z9_1.z = angle($this, $this.e13_1.v12_1.z + ($this.h13_1 + particle.b13_1.z) * $this.e13_1.u12_1.z);
    }
  }
  function angle($this, degrees) {
    var wrapped = degrees % 360.0;
    return wrapped < 0.0 ? wrapped + 360.0 : wrapped;
  }
  function Companion_2() {
    this.i13_1 = 0.1;
  }
  var Companion_instance_5;
  function Companion_getInstance_2() {
    return Companion_instance_5;
  }
  function LeavesParticleSystem(mesh, texture, config) {
    config = config === VOID ? new LeavesParticleSystemConfig() : config;
    this.e13_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.f13_1 = ArrayList_init_$Create$_0();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.g13_1 = ArrayList_init_$Create$_0();
    this.h13_1 = 0.0;
    var random = Default_getInstance();
    var trackLength = this.e13_1.m12_1 - this.e13_1.l12_1;
    var laneSpacing = (this.e13_1.o12_1 - this.e13_1.n12_1) / this.e13_1.k12_1;
    var atlas = this.e13_1.x12_1;
    var halfSize = this.e13_1.q12_1 / 2.0;
    var inductionVariable = 0;
    var last = this.e13_1.k12_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var jitter = (random.c6() - 0.5) * this.e13_1.w12_1;
        // Inline function 'kotlin.apply' call
        var this_0 = UniformFloatValueWithArray(new Float32Array(2));
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'org.androidworks.cemetery.LeavesParticleSystem.<anonymous>' call
        this_0.value[0] = (i % atlas | 0) / atlas;
        this_0.value[1] = ((i / atlas | 0) % atlas | 0) / atlas;
        var textureOffset = this_0;
        var command = DrawStaticMeshCommandConstructor(mesh, listOf([UniformFloatValueWithArray(new Float32Array(16)), textureOffset, new UniformTextureValue(texture), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().sy_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_DISABLED_getInstance(), Companion_instance.fromMeshAndShader(mesh, CommonAssetForgeShaders_getInstance().sy_1)), new AffineTranformation(new Vec3(this.e13_1.l12_1, 0.0, this.e13_1.p12_1), new Vec3(this.e13_1.v12_1.x, this.e13_1.v12_1.y, this.e13_1.v12_1.z), new Vec3(halfSize, halfSize, halfSize)));
        this.g13_1.g(new Particle(command, random.c6(), random.c6() * 100.0, new Vec3(random.c6() * 360.0, random.c6() * 360.0, random.c6() * 360.0), this.e13_1.n12_1 + (i + 0.5) * laneSpacing + jitter * laneSpacing, (random.c6() - 0.5) * this.e13_1.p12_1 * 0.1));
        this.f13_1.g(command);
      }
       while (inductionVariable < last);
    advance(this);
  }
  protoOf(LeavesParticleSystem).j13 = function (deltaTime) {
    this.h13_1 = this.h13_1 + coerceIn(deltaTime, 0.0, 0.1);
    advance(this);
  };
  function Meshes_2() {
    Meshes_instance_2 = this;
    this.lz_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6)]), 12);
    this.mz_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6), new MeshAttribute(AttributeType_UV1_getInstance(), VertexFormat_HALF2_getInstance(), 10)]), 16);
    this.nz_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_UBYTE2_NORMALIZED_getInstance(), 6)]), 8);
    this.oz_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_UBYTE2_NORMALIZED_getInstance(), 6), new MeshAttribute(AttributeType_NORMAL_getInstance(), VertexFormat_BYTE3_NORMALIZED_getInstance(), 8)]), 12);
    this.pz_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_FLOAT3_getInstance(), 0)), 12);
    this.qz_1 = MeshConstructor2('quad', this.lz_1);
    this.rz_1 = MeshConstructor2('boat', this.lz_1);
    this.sz_1 = MeshConstructor2('water', this.nz_1);
    this.tz_1 = MeshConstructor2('clouds', this.lz_1);
    this.uz_1 = MeshConstructor2('stars', this.pz_1);
    this.vz_1 = MeshConstructor2('flag-triangle', this.nz_1);
    this.wz_1 = MeshConstructor2('rocks', this.oz_1);
    this.xz_1 = MeshConstructor2('ship', this.mz_1);
    this.yz_1 = MeshConstructor2('lantern', this.mz_1);
    this.zz_1 = MeshConstructor2('box', this.mz_1);
    this.a10_1 = MeshConstructor2('ground', this.mz_1);
    this.b10_1 = MeshConstructor2('grass', this.mz_1);
    this.c10_1 = MeshConstructor2('tree_leaves', this.lz_1);
    this.d10_1 = MeshConstructor2('tree_trunks', this.nz_1);
    this.e10_1 = MeshConstructor2('bat1');
    this.f10_1 = mutableListOf([this.rz_1, this.sz_1, this.tz_1, this.uz_1, this.e10_1, this.vz_1, this.wz_1, this.xz_1, this.yz_1, this.zz_1, this.a10_1, this.b10_1, this.c10_1, this.d10_1, this.qz_1]);
  }
  var Meshes_instance_2;
  function Meshes_getInstance_2() {
    if (Meshes_instance_2 == null)
      new Meshes_2();
    return Meshes_instance_2;
  }
  function Preset_0(fogColor, waterColor, highlightColor, tintColor, cloudsColor, lightsColor, lampsColor, drawLights, drawBirds, birdsColor) {
    this.k13_1 = fogColor;
    this.l13_1 = waterColor;
    this.m13_1 = highlightColor;
    this.n13_1 = tintColor;
    this.o13_1 = cloudsColor;
    this.p13_1 = lightsColor;
    this.q13_1 = lampsColor;
    this.r13_1 = drawLights;
    this.s13_1 = drawBirds;
    this.t13_1 = birdsColor;
  }
  protoOf(Preset_0).toString = function () {
    return 'Preset(fogColor=' + this.k13_1 + ', waterColor=' + this.l13_1 + ', highlightColor=' + this.m13_1 + ', tintColor=' + this.n13_1 + ', cloudsColor=' + this.o13_1 + ', lightsColor=' + this.p13_1 + ', lampsColor=' + this.q13_1 + ', drawLights=' + this.r13_1 + ', drawBirds=' + this.s13_1 + ', birdsColor=' + this.t13_1 + ')';
  };
  protoOf(Preset_0).hashCode = function () {
    var result = this.k13_1.hashCode();
    result = imul(result, 31) + this.l13_1.hashCode() | 0;
    result = imul(result, 31) + this.m13_1.hashCode() | 0;
    result = imul(result, 31) + this.n13_1.hashCode() | 0;
    result = imul(result, 31) + this.o13_1.hashCode() | 0;
    result = imul(result, 31) + this.p13_1.hashCode() | 0;
    result = imul(result, 31) + this.q13_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r13_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.s13_1) | 0;
    result = imul(result, 31) + this.t13_1.hashCode() | 0;
    return result;
  };
  protoOf(Preset_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Preset_0))
      return false;
    var tmp0_other_with_cast = other instanceof Preset_0 ? other : THROW_CCE();
    if (!this.k13_1.equals(tmp0_other_with_cast.k13_1))
      return false;
    if (!this.l13_1.equals(tmp0_other_with_cast.l13_1))
      return false;
    if (!this.m13_1.equals(tmp0_other_with_cast.m13_1))
      return false;
    if (!this.n13_1.equals(tmp0_other_with_cast.n13_1))
      return false;
    if (!this.o13_1.equals(tmp0_other_with_cast.o13_1))
      return false;
    if (!this.p13_1.equals(tmp0_other_with_cast.p13_1))
      return false;
    if (!this.q13_1.equals(tmp0_other_with_cast.q13_1))
      return false;
    if (!(this.r13_1 === tmp0_other_with_cast.r13_1))
      return false;
    if (!(this.s13_1 === tmp0_other_with_cast.s13_1))
      return false;
    if (!this.t13_1.equals(tmp0_other_with_cast.t13_1))
      return false;
    return true;
  };
  function Presets_0() {
    Presets_instance_0 = this;
    this.u13_1 = new Vec4(0.56, 0.44, 0.26);
    this.v13_1 = new Vec4(0.6, 0.6, 0.6);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w13_1 = [new Preset_0(new Vec4(0.7647058823529411, 0.9098039215686274, 0.9450980392156862, 1.0), new Vec4(0.387, 0.75, 0.795, 1.0), new Vec4(0.7843137254901961, 0.7843137254901961, 0.7843137254901961, 1.0), new Vec4(1.0, 1.0, 1.0, 1.0), new Vec4(1.0, 1.0, 1.0, 1.0), new Vec4(0.0, 0.0, 0.0, 1.0), new Vec4(0.0, 0.0, 0.0, 1.0), false, true, new Vec4(0.3137254901960784, 0.3137254901960784, 0.3137254901960784, 1.0)), new Preset_0(new Vec4(0.03137254901960784, 0.11372549019607843, 0.1843137254901961, 1.0), new Vec4(0.03529411764705882, 0.17254901960784313, 0.3176470588235294, 1.0), new Vec4(0.3137254901960784, 0.3137254901960784, 0.3137254901960784, 1.0), new Vec4(0.5215686274509804, 0.8705882352941177, 1.0, 1.0), new Vec4(0.0784313725490196, 0.3254901960784314, 0.47058823529411764, 1.0), new Vec4(3.0, 1.2000000000000002, 0.0, 1.0), new Vec4(4.0, 2.4, 0.0, 1.0), true, false, new Vec4(0.3137254901960784, 0.3137254901960784, 0.3137254901960784, 1.0)), new Preset_0(new Vec4(1.0, 0.7686274509803922, 0.35294117647058826, 1.0), new Vec4(0.592156862745098, 0.6313725490196078, 0.5098039215686274, 1.0), new Vec4(0.5019607843137255, 0.43529411764705883, 0.23529411764705882, 1.0), new Vec4(1.0, 0.8705882352941177, 0.4745098039215686, 1.0), new Vec4(1.0, 0.8705882352941177, 0.47058823529411764, 1.0), new Vec4(0.0, 0.0, 0.0, 1.0), new Vec4(0.0, 0.0, 0.0, 1.0), false, true, new Vec4(0.4921875, 0.42578125, 0.265625, 1.0)), new Preset_0(new Vec4(0.21568627450980393, 0.2196078431372549, 0.47058823529411764, 1.0), new Vec4(0.0784313725490196, 0.20784313725490197, 0.4549019607843137, 1.0), new Vec4(0.5294117647058824, 0.3215686274509804, 0.48627450980392156, 1.0), new Vec4(0.9607843137254902, 0.7529411764705882, 0.9176470588235294, 1.0), new Vec4(0.9607843137254902, 0.7137254901960784, 0.8784313725490196, 1.0), new Vec4(3.0, 1.2000000000000002, 0.0, 1.0), new Vec4(1.6, 1.2800000000000002, 0.0, 1.0), true, false, new Vec4(0.3671875, 0.17578125, 0.20703125, 1.0))];
  }
  var Presets_instance_0;
  function Presets_getInstance_0() {
    if (Presets_instance_0 == null)
      new Presets_0();
    return Presets_instance_0;
  }
  function applySettings_1($this) {
    if (!($this.cameraAnimator.minDurationCoefficient === $this.settings.cameraPeriod)) {
      $this.cameraAnimator.minDurationCoefficient = $this.settings.cameraPeriod;
    }
    $this.f14_1.enabled = $this.settings.renderMode.equals(RenderMode_Complete_getInstance()) ? true : $this.settings.renderMode.equals(RenderMode_SsaoOnly_getInstance());
    $this.g14_1.enabled = $this.settings.renderMode.equals(RenderMode_CompleteWithLm_getInstance());
    $this.h14_1.enabled = $this.settings.renderMode.equals(RenderMode_DiffuseOnly_getInstance());
    $this.i14_1.enabled = $this.settings.renderMode.equals(RenderMode_ModelNormals_getInstance());
    $this.j14_1.enabled = $this.settings.renderMode.equals(RenderMode_Lambert_getInstance());
    $this.m14_1.enabled = $this.settings.renderMode.equals(RenderMode_SsaoOnly_getInstance());
    updateShaderParams($this);
    if (($this.cameraAnimator.timer > 0.99 ? $this.settings.autoSwitchCameras : false) ? Default_getInstance().c6() < 0.5 : false) {
      $this.randomCamera();
    }
    $this.Z_FAR = $this.settings.fogStartDistance + $this.settings.fogDistance;
    if ($this.settings.lowQuality) {
      $this.l14_1.radius = 19.0;
      $this.l14_1.intensity = 1.3;
    } else {
      $this.l14_1.radius = 25.0;
      $this.l14_1.intensity = 1.5;
    }
    if ($this.settings.colorMode.equals(ColorMode_Greyscale_getInstance_0()) ? true : $this.settings.colorMode.equals(ColorMode_Sepia_getInstance_1())) {
      $this.p14_1.color0 = $this.o14_1;
    } else {
      $this.p14_1.color0 = $this.n14_1;
    }
  }
  function updateShaderParams($this) {
    var light = $this.settings.lightDirection;
    setUniform(CommonAssetForgeShaders_getInstance().wy_1, light.x, light.y, light.z, $this.settings.lightExponent);
    var ambient = $this.settings.ambientColor;
    setUniform_3(CommonAssetForgeShaders_getInstance().xy_1, ambient.r, ambient.g, ambient.b);
    var modeFogColor;
    switch ($this.settings.colorMode.n4_1) {
      case 2:
        modeFogColor = Presets_getInstance_0().v13_1;
        break;
      case 1:
        modeFogColor = Presets_getInstance_0().u13_1;
        break;
      default:
        modeFogColor = null;
        break;
    }
    var tmp1_safe_receiver = modeFogColor;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r;
    var fogR = tmp2_elvis_lhs == null ? $this.settings.fogColor.r : tmp2_elvis_lhs;
    var tmp3_safe_receiver = modeFogColor;
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.g;
    var fogG = tmp4_elvis_lhs == null ? $this.settings.fogColor.g : tmp4_elvis_lhs;
    var tmp5_safe_receiver = modeFogColor;
    var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.b;
    var fogB = tmp6_elvis_lhs == null ? $this.settings.fogColor.b : tmp6_elvis_lhs;
    setUniform(CommonAssetForgeShaders_getInstance().yy_1, fogR, fogG, fogB, 1.0);
    setUniform_1(CommonAssetForgeShaders_getInstance().zy_1, $this.settings.fogStartDistance);
    setUniform_1(CommonAssetForgeShaders_getInstance().az_1, $this.settings.fogDistance);
    setUniform_0(CommonAssetForgeShaders_getInstance().bz_1, $this.settings.lmScaleX, -$this.settings.lmScaleY);
    var lmColor = $this.settings.lmColor;
    setUniform_3(CommonAssetForgeShaders_getInstance().cz_1, lmColor.r, lmColor.g, lmColor.b);
    setUniform_0(CommonAssetForgeShaders_getInstance().dz_1, $this.settings.lmHeightMax, $this.settings.lmHeightStartFade);
    setUniform_1(CommonAssetForgeShaders_getInstance().ez_1, $this.settings.lmBrightness);
    setUniform_0(CommonAssetForgeShaders_getInstance().gz_1, $this.c14_1.nj(Timers_GhostAnim1_getInstance()), $this.c14_1.nj(Timers_GhostAnim2_getInstance()));
    $this.k14_1.color.r = fogR;
    $this.k14_1.color.g = fogG;
    $this.k14_1.color.b = fogB;
    $this.k14_1.color.a = 1.0;
  }
  function animate_1($this, time) {
    applySettings_1($this);
    positionCamera_1($this, time);
    $this.calculateProjection();
    cullImportedModels($this);
    $this.q14_1.j13((time - $this.lastFrameTime) / 1000.0);
    updateGhosts($this);
    updateBirds_0($this);
    var flicker = $this.c14_1.nj(Timers_FlameFlicker_getInstance()) * (2.0 * get_PI()) * 2.0;
    var flames = Flames_getInstance().ly_1.commands;
    var inductionVariable = 0;
    var last = flames.m() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = flames.t(index);
        var command = tmp instanceof DrawTransformedMeshCommand ? tmp : THROW_CCE();
        var t = flicker + index;
        // Inline function 'kotlin.math.sin' call
        var tmp_0 = 2.0 + Math.sin(t);
        // Inline function 'kotlin.math.cos' call
        var x = t * 3.31;
        var scaleZ = (tmp_0 + Math.cos(x)) / 4.0;
        command.transform.aa_1.z = 0.09 + 0.06 * scaleZ;
      }
       while (inductionVariable <= last);
    $this.updateMeshTransformations($this.commands);
  }
  function cullImportedModels($this) {
    Matrix_getInstance().x9($this.s14_1, 0, $this.matProjection, 0, $this.matView, 0);
    var commands = activeImportedCommands($this);
    $this.u14_1 = cullDrawCalls(commands, ImportedAssetForgeCommands_getInstance().l10_1, $this.s14_1);
    $this.t14_1 = commands.m();
  }
  function activeImportedCommands($this) {
    var tmp;
    switch ($this.settings.renderMode.n4_1) {
      case 0:
      case 5:
        tmp = ImportedAssetForgeCommands_getInstance().g10_1;
        break;
      case 4:
        tmp = ImportedAssetForgeCommands_getInstance().h10_1;
        break;
      case 1:
        tmp = ImportedAssetForgeCommands_getInstance().i10_1;
        break;
      case 2:
        tmp = ImportedAssetForgeCommands_getInstance().j10_1;
        break;
      case 3:
        tmp = ImportedAssetForgeCommands_getInstance().k10_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function positionCamera_1($this, time) {
    if ($this.useExternalViewMatrix) {
      return Unit_instance;
    }
    if ($this.settings.cameraMode.equals(CameraMode_Random_getInstance_0())) {
      var cameraPositionInterpolator = $this.cameraAnimator.positionInterpolator;
      var eye = cameraPositionInterpolator.cameraPosition;
      var lookat = cameraPositionInterpolator.cameraRotation;
      Matrix_getInstance().di($this.matView, 0, eye.x, eye.y, eye.z, lookat.x, lookat.y, lookat.z, 0.0, 0.0, 1.0);
    } else if ($this.settings.cameraMode.equals(CameraMode_Orbiting_getInstance_0())) {
      var deltaTime = time - $this.lastFrameTime;
      var timerBobX = $this.c14_1.nj(Timers_OrbitingCameraX_getInstance_0());
      var timerBobZ = $this.c14_1.nj(Timers_OrbitingCameraZ_getInstance_0());
      $this.orbitingCamera.uj_1.fk_1 = $this.settings.cameraPeriod;
      $this.orbitingCamera.yj(deltaTime, timerBobX, timerBobZ);
      Matrix_getInstance().xh($this.orbitingCamera.xj_1, 0, $this.matView, 0, 16);
    }
  }
  function setBirdPosition_0($this, angle, centerX, centerY, radius, translation) {
    // Inline function 'kotlin.math.sin' call
    translation.x = Math.sin(angle) * radius + centerX;
    // Inline function 'kotlin.math.cos' call
    translation.y = Math.cos(angle) * radius + centerY;
  }
  function updateGhosts($this) {
    var tmp = Ghosts_getInstance().kz_1.commands;
    var commands = isInterface(tmp, List) ? tmp : THROW_CCE();
    var angle = $this.c14_1.nj(Timers_GhostMove_getInstance()) * get_PIf() * 2.0;
    // Inline function 'kotlin.math.sin' call
    var x = $this.c14_1.nj(Timers_GhostBob_getInstance()) * get_PIf() * 2.0;
    var bob0 = Math.sin(x) * 0.3;
    // Inline function 'kotlin.math.cos' call
    var x_0 = $this.c14_1.nj(Timers_GhostBob_getInstance()) * get_PIf() * 2.0;
    var bob1 = Math.cos(x_0) * 0.3;
    setBirdPosition_0($this, angle, -2.0, 8.0, $this.y14_1, commands.t(0).transform.y9_1);
    setBirdPosition_0($this, -angle - get_PIf(), 3.0, -6.0, $this.y14_1, commands.t(1).transform.y9_1);
    setBirdPosition_0($this, -angle - get_PIf(), 3.0, 5.0, $this.y14_1, commands.t(2).transform.y9_1);
    setBirdPosition_0($this, angle, 7.0, 3.0, $this.y14_1, commands.t(3).transform.y9_1);
    setBirdPosition_0($this, -angle - get_PIf(), 19.0, -2.0, $this.y14_1 * 1.2, commands.t(4).transform.y9_1);
    commands.t(0).transform.z9_1.z = (-angle - get_PIf() / 2.0) * 57.29578;
    commands.t(1).transform.z9_1.z = (angle - get_PIf() / 2.0) * 57.29578;
    commands.t(2).transform.z9_1.z = (angle - get_PIf() / 2.0) * 57.29578;
    commands.t(3).transform.z9_1.z = (-angle - get_PIf() / 2.0) * 57.29578;
    commands.t(4).transform.z9_1.z = (angle - get_PIf() / 2.0) * 57.29578;
    commands.t(0).transform.y9_1.z = 0.6 + bob0;
    commands.t(1).transform.y9_1.z = 0.6 + bob1;
    commands.t(2).transform.y9_1.z = 0.6 + bob0;
    commands.t(3).transform.y9_1.z = 0.6 + bob1;
    commands.t(4).transform.y9_1.z = 0.6 + bob0;
  }
  function updateBirds_0($this) {
    var tmp = $this.groupBirds.commands;
    var commands = isInterface(tmp, List) ? tmp : THROW_CCE();
    var angle = $this.c14_1.nj(Timers_BirdsFly_getInstance_0()) * get_PIf() * 2.0;
    // Inline function 'kotlin.math.sin' call
    var x = $this.c14_1.nj(Timers_BirdsBob_getInstance()) * get_PIf() * 2.0;
    var bob0 = (Math.sin(x) + 1.0) * 0.6;
    // Inline function 'kotlin.math.cos' call
    var x_0 = $this.c14_1.nj(Timers_BirdsBob_getInstance()) * get_PIf() * 2.0;
    var bob1 = (Math.cos(x_0) + 1.0) * 0.6;
    setBirdPosition_0($this, angle, -10.0, 0.0, $this.BIRD_FLIGHT_RADIUS, commands.t(0).transform.y9_1);
    setBirdPosition_0($this, -angle - get_PIf(), -12.0, 0.0, $this.BIRD_FLIGHT_RADIUS, commands.t(1).transform.y9_1);
    setBirdPosition_0($this, -angle - get_PIf(), 20.0, 8.0, $this.BIRD_FLIGHT_RADIUS, commands.t(2).transform.y9_1);
    setBirdPosition_0($this, angle, 20.0, -8.0, $this.BIRD_FLIGHT_RADIUS, commands.t(3).transform.y9_1);
    setBirdPosition_0($this, -angle - get_PIf(), 0.0, 0.0, $this.BIRD_FLIGHT_RADIUS * 1.55, commands.t(4).transform.y9_1);
    setBirdPosition_0($this, angle, 5.0, 7.0, $this.BIRD_FLIGHT_RADIUS, commands.t(5).transform.y9_1);
    commands.t(0).transform.z9_1.z = (-angle - get_PIf() / 2.0) * 57.29578;
    commands.t(1).transform.z9_1.z = (angle - get_PIf() / 2.0) * 57.29578;
    commands.t(2).transform.z9_1.z = (angle - get_PIf() / 2.0) * 57.29578;
    commands.t(3).transform.z9_1.z = (-angle - get_PIf() / 2.0) * 57.29578;
    commands.t(4).transform.z9_1.z = (angle - get_PIf() / 2.0) * 57.29578;
    commands.t(5).transform.z9_1.z = (-angle - get_PIf() / 2.0) * 57.29578;
    commands.t(0).transform.y9_1.z = bob0 + 3.4;
    commands.t(1).transform.y9_1.z = bob1 + 3.7;
    commands.t(2).transform.y9_1.z = bob0 + 5.0;
    commands.t(3).transform.y9_1.z = bob1 + 4.0;
    commands.t(4).transform.y9_1.z = bob0 + 3.8;
    commands.t(5).transform.y9_1.z = bob1 + 4.4;
    var wingTimer1 = $this.c14_1.nj(Timers_BirdWings1_getInstance_0());
    var wingTimer2 = $this.c14_1.nj(Timers_BirdWings2_getInstance_0());
    Animations_getInstance_0().yx_1.fc(wingTimer1, commands.t(0).uniforms.t(2), commands.t(0).uniforms.t(3), commands.t(0).uniforms.t(5));
    Animations_getInstance_0().yx_1.fc(wingTimer2, commands.t(1).uniforms.t(2), commands.t(1).uniforms.t(3), commands.t(1).uniforms.t(5));
    Animations_getInstance_0().yx_1.fc(wingTimer1 + 0.3, commands.t(2).uniforms.t(2), commands.t(2).uniforms.t(3), commands.t(2).uniforms.t(5));
    Animations_getInstance_0().yx_1.fc(wingTimer2 + 0.5, commands.t(3).uniforms.t(2), commands.t(3).uniforms.t(3), commands.t(3).uniforms.t(5));
    Animations_getInstance_0().yx_1.fc(wingTimer1 + 0.5, commands.t(4).uniforms.t(2), commands.t(4).uniforms.t(3), commands.t(4).uniforms.t(5));
    Animations_getInstance_0().yx_1.fc(wingTimer2 + 0.6, commands.t(5).uniforms.t(2), commands.t(5).uniforms.t(3), commands.t(5).uniforms.t(5));
  }
  function CemeteryScene() {
    Scene.call(this);
    this.c14_1 = new TimersMap();
    this.n14_1 = new Vec4(0.45, 0.45, 0.45, 1.0);
    this.o14_1 = new Vec4(0.35, 0.35, 0.35, 1.0);
    this.BIRD_FLIGHT_RADIUS = 11.0;
    this.s14_1 = new Float32Array(16);
    this.t14_1 = 0;
    this.u14_1 = 0;
    this.drawCallBounds = ImportedAssetForgeCommands_getInstance_0().e15_1;
    this.v14_1 = 1000000.0;
    this.w14_1 = 19000.0;
    this.x14_1 = 2000.0;
    this.y14_1 = 11.0;
    this.meshes.h(ImportedAssetForgeMeshes_getInstance().f12_1);
    this.meshes.g(Meshes_getInstance_2().qz_1);
    this.meshes.g(Flames_getInstance().jy_1);
    this.meshes.g(Ghosts_getInstance().iz_1);
    this.meshes.g(Meshes_getInstance_2().e10_1);
    this.textures.h(ImportedAssetForgeTextures_getInstance().i12_1);
    this.textures.g(Textures_getInstance_2().cy_1);
    this.textures.g(Textures_getInstance_2().ey_1);
    this.textures.g(Textures_getInstance_2().fy_1);
    this.textures.g(CommonAssetForgeTextures_getInstance().by_1);
    this.shaders.h(CommonAssetForgeShaders_getInstance().vy_1);
    this.shaders.g(Shaders_getInstance_2().h15_1);
    Companion_instance_6.k15(this.c14_1);
    this.Z_NEAR = 0.5;
    this.Z_FAR = 38.0;
    this.FOV_LANDSCAPE = 50.0;
    this.FOV_PORTRAIT = 65.0;
    this.settings = new CemeterySettings();
    var sceneCenter = new Vec3(0.0, 0.0, 0.5);
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new OrbitingCameraConfig();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.CemeteryScene.<anonymous>' call
    this_0.ck_1 = 15.0;
    this_0.bk_1 = 10.5;
    this_0.gk_1 = sceneCenter;
    tmp.orbitingCamera = new OrbitingCamera(this_0);
    this.cameraAnimator = new CameraPathAnimator(this.v14_1, this.w14_1, this.x14_1, true);
    this.cameraAnimator.setCameras(Cameras_getInstance_2().zx_1);
    this.cameraAnimator.minDurationCoefficient = this.settings.cameraPeriod;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new ClearColorCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.CemeteryScene.<anonymous>' call
    this_1.color = new Vec4(this.settings.fogColor.x, this.settings.fogColor.y, this.settings.fogColor.z, 1.0);
    this_1.name = 'clear color';
    this_1.enabled = true;
    tmp_0.k14_1 = this_1;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new ClearCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.CemeteryScene.<anonymous>' call
    this_2.clearType = ClearCommandClearType_COLOR_AND_DEPTH_getInstance();
    tmp_1.e14_1 = GroupCommandArr(true, [this.k14_1, this_2]);
    var tmp0_iterator = ImportedAssetForgeCommands_getInstance().h10_1.j();
    while (tmp0_iterator.k()) {
      var command = tmp0_iterator.l();
      var tmp_2;
      if (command instanceof DrawMeshCommand) {
        tmp_2 = command.mesh === ImportedAssetForgeMeshes_getInstance().e12_1;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        command.state.shader = CommonAssetForgeShaders_getInstance().oy_1;
      }
    }
    var tmp_3 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_3 = ImportedAssetForgeCommands_getInstance().g10_1;
    var tmp$ret$3 = copyToArray(this_3);
    tmp_3.f14_1 = GroupCommandArr(true, tmp$ret$3.slice());
    var tmp_4 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_4 = ImportedAssetForgeCommands_getInstance().h10_1;
    var tmp$ret$4 = copyToArray(this_4);
    tmp_4.g14_1 = GroupCommandArr(false, tmp$ret$4.slice());
    var tmp_5 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_5 = ImportedAssetForgeCommands_getInstance().i10_1;
    var tmp$ret$5 = copyToArray(this_5);
    tmp_5.h14_1 = GroupCommandArr(false, tmp$ret$5.slice());
    var tmp_6 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_6 = ImportedAssetForgeCommands_getInstance().j10_1;
    var tmp$ret$6 = copyToArray(this_6);
    tmp_6.i14_1 = GroupCommandArr(false, tmp$ret$6.slice());
    var tmp_7 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_7 = ImportedAssetForgeCommands_getInstance().k10_1;
    var tmp$ret$7 = copyToArray(this_7);
    tmp_7.j14_1 = GroupCommandArr(false, tmp$ret$7.slice());
    var stateBird = new DrawMeshState(Shaders_getInstance_2().h15_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_DISABLED_getInstance(), null);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$8 = new Float32Array([0.1640625, 0.1484375, 0.1171875, 1.0]);
    var uniformBatColor = UniformFloatValueWithArray(tmp$ret$8);
    this.groupBirds = GroupCommandArr(true, [new DrawTransformedMeshCommand(Meshes_getInstance_2().e10_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), uniformBatColor, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_2().cy_1), UniformFloatValueWithArray(new Float32Array(4)), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), stateBird, new AffineTranformation(new Vec3(0.0, 0.0, 3.4), new Vec3(0.0, 0.0, 0.0), new Vec3(0.04, 0.04, 0.06))), new DrawTransformedMeshCommand(Meshes_getInstance_2().e10_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), uniformBatColor, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_2().cy_1), UniformFloatValueWithArray(new Float32Array(4)), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), stateBird, new AffineTranformation(new Vec3(2.0, 0.0, 3.7), new Vec3(0.0, 0.0, 0.0), new Vec3(0.04, 0.04, 0.06))), new DrawTransformedMeshCommand(Meshes_getInstance_2().e10_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), uniformBatColor, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_2().cy_1), UniformFloatValueWithArray(new Float32Array(4)), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), stateBird, new AffineTranformation(new Vec3(4.0, 0.0, 5.0), new Vec3(0.0, 0.0, 0.0), new Vec3(0.04, 0.04, 0.06))), new DrawTransformedMeshCommand(Meshes_getInstance_2().e10_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), uniformBatColor, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_2().cy_1), UniformFloatValueWithArray(new Float32Array(4)), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), stateBird, new AffineTranformation(new Vec3(6.0, 0.0, 4.0), new Vec3(0.0, 0.0, 0.0), new Vec3(0.04, 0.04, 0.06))), new DrawTransformedMeshCommand(Meshes_getInstance_2().e10_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), uniformBatColor, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_2().cy_1), UniformFloatValueWithArray(new Float32Array(4)), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), stateBird, new AffineTranformation(new Vec3(8.0, 0.0, 3.8), new Vec3(0.0, 0.0, 0.0), new Vec3(0.04, 0.04, 0.06))), new DrawTransformedMeshCommand(Meshes_getInstance_2().e10_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), uniformBatColor, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_2().cy_1), UniformFloatValueWithArray(new Float32Array(4)), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), stateBird, new AffineTranformation(new Vec3(10.0, 0.0, 4.4), new Vec3(0.0, 0.0, 0.0), new Vec3(0.04, 0.04, 0.06)))]);
    var tmp_8 = this;
    var tmp_9 = Meshes_getInstance_2().qz_1;
    var tmp_10 = Textures_getInstance_2().fy_1;
    var tmp1_minX = sceneCenter.x - 36;
    var tmp2_maxX = sceneCenter.x + 36;
    var tmp3_minY = sceneCenter.y - 30;
    var tmp4_maxY = sceneCenter.y + 30;
    tmp_8.q14_1 = new LeavesParticleSystem(tmp_9, tmp_10, new LeavesParticleSystemConfig(VOID, tmp1_minX, tmp2_maxX, tmp3_minY, tmp4_maxY, 4.0, 0.85, 5.0));
    var tmp_11 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_8 = this.q14_1.f13_1;
    var tmp$ret$9 = copyToArray(this_8);
    tmp_11.r14_1 = GroupCommandArr(true, tmp$ret$9.slice());
    var tmp_12 = this;
    // Inline function 'kotlin.apply' call
    var this_9 = new SsaoPassCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.CemeteryScene.<anonymous>' call
    this_9.name = 'ssao';
    this_9.enabled = true;
    this_9.resolutionScale = 0.8;
    this_9.blurSize = BlurSize_KERNEL_2_getInstance();
    this_9.radius = 25.0;
    this_9.depthRange = 0.9;
    this_9.bias = 0.05;
    this_9.intensity = 1.5;
    this_9.commands = mutableListOf([this.f14_1, this.g14_1, this.h14_1, this.i14_1, this.j14_1]);
    this_9.id = 2;
    tmp_12.l14_1 = this_9;
    var tmp_13 = this;
    // Inline function 'kotlin.apply' call
    var this_10 = new DrawSsaoCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.CemeteryScene.<anonymous>' call
    this_10.name = 'draw ssao';
    this_10.enabled = false;
    this_10.id = 2;
    tmp_13.m14_1 = this_10;
    var tmp_14 = this;
    // Inline function 'kotlin.apply' call
    var this_11 = new VignetteCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.CemeteryScene.<anonymous>' call
    this_11.color0 = this.n14_1;
    this_11.color1 = new Vec4(1.0, 1.0, 1.0, 1.0);
    tmp_14.p14_1 = this_11;
    this.d14_1 = GroupCommandArr(true, [this.l14_1, MainPassCommandArr(true, [this.e14_1, this.f14_1, this.g14_1, this.h14_1, this.i14_1, this.j14_1, this.r14_1, Flames_getInstance().ly_1, Ghosts_getInstance().kz_1, this.groupBirds, this.p14_1]), this.m14_1]);
    this.commands = mutableListOf([this.d14_1]);
    updateShaderParams(this);
  }
  protoOf(CemeteryScene).ro = function () {
    return this.groupBirds;
  };
  protoOf(CemeteryScene).so = function () {
    return this.BIRD_FLIGHT_RADIUS;
  };
  protoOf(CemeteryScene).mo = function () {
    return this.settings;
  };
  protoOf(CemeteryScene).l15 = function () {
    return this.drawCallBounds;
  };
  protoOf(CemeteryScene).m15 = function () {
    return this.t14_1;
  };
  protoOf(CemeteryScene).n15 = function () {
    return this.u14_1;
  };
  protoOf(CemeteryScene).ko = function () {
    return this.cameraAnimator;
  };
  protoOf(CemeteryScene).yt = function () {
    return this.orbitingCamera;
  };
  protoOf(CemeteryScene).updateTimers = function (time) {
    this.c14_1.qj(time);
    this.cameraAnimator.animate(time);
    animate_1(this, time);
    protoOf(Scene).updateTimers.call(this, time);
  };
  protoOf(CemeteryScene).updateViewportSize = function (width, height) {
    protoOf(Scene).updateViewportSize.call(this, width, height);
  };
  protoOf(CemeteryScene).initialize = function () {
    this.randomCamera();
  };
  protoOf(CemeteryScene).nextCamera = function () {
    this.randomCamera();
  };
  protoOf(CemeteryScene).randomCamera = function () {
    if (this.cameraAnimator.state.equals(CameraState_TRANSITIONING_getInstance())) {
      return Unit_instance;
    }
    this.cameraAnimator.positionInterpolator.reverse = Default_getInstance().c6() < 0.5;
    this.cameraAnimator.randomCamera();
  };
  protoOf(CemeteryScene).cameraImpulse = function (impulse) {
    this.orbitingCamera.wj_1 = impulse * this.settings.cameraPeriod;
  };
  var TimeOfDay_Day_instance_2;
  var TimeOfDay_Night_instance_2;
  var TimeOfDay_Sunrise_instance_2;
  var TimeOfDay_Sunset_instance_1;
  function values_4() {
    return [TimeOfDay_Day_getInstance_2(), TimeOfDay_Night_getInstance_2(), TimeOfDay_Sunrise_getInstance_2(), TimeOfDay_Sunset_getInstance_1()];
  }
  function valueOf_4(value) {
    switch (value) {
      case 'Day':
        return TimeOfDay_Day_getInstance_2();
      case 'Night':
        return TimeOfDay_Night_getInstance_2();
      case 'Sunrise':
        return TimeOfDay_Sunrise_getInstance_2();
      case 'Sunset':
        return TimeOfDay_Sunset_getInstance_1();
      default:
        TimeOfDay_initEntries_2();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var TimeOfDay_entriesInitialized_2;
  function TimeOfDay_initEntries_2() {
    if (TimeOfDay_entriesInitialized_2)
      return Unit_instance;
    TimeOfDay_entriesInitialized_2 = true;
    TimeOfDay_Day_instance_2 = new TimeOfDay_2('Day', 0, 0);
    TimeOfDay_Night_instance_2 = new TimeOfDay_2('Night', 1, 1);
    TimeOfDay_Sunrise_instance_2 = new TimeOfDay_2('Sunrise', 2, 2);
    TimeOfDay_Sunset_instance_1 = new TimeOfDay_2('Sunset', 3, 3);
  }
  function TimeOfDay_2(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  var CameraMode_Random_instance_0;
  var CameraMode_Orbiting_instance_0;
  function values_5() {
    return [CameraMode_Random_getInstance_0(), CameraMode_Orbiting_getInstance_0()];
  }
  function valueOf_5(value) {
    switch (value) {
      case 'Random':
        return CameraMode_Random_getInstance_0();
      case 'Orbiting':
        return CameraMode_Orbiting_getInstance_0();
      default:
        CameraMode_initEntries_0();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var CameraMode_entriesInitialized_0;
  function CameraMode_initEntries_0() {
    if (CameraMode_entriesInitialized_0)
      return Unit_instance;
    CameraMode_entriesInitialized_0 = true;
    CameraMode_Random_instance_0 = new CameraMode_0('Random', 0, 0);
    CameraMode_Orbiting_instance_0 = new CameraMode_0('Orbiting', 1, 1);
  }
  function CameraMode_0(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  var ColorMode_None_instance_0;
  var ColorMode_Sepia_instance_0;
  var ColorMode_Greyscale_instance_0;
  var ColorMode_HighContrast_instance;
  var ColorMode_LowContrast_instance;
  var ColorMode_LimitedColors_instance;
  function values_6() {
    return [ColorMode_None_getInstance_0(), ColorMode_Sepia_getInstance_1(), ColorMode_Greyscale_getInstance_0(), ColorMode_HighContrast_getInstance(), ColorMode_LowContrast_getInstance(), ColorMode_LimitedColors_getInstance()];
  }
  function valueOf_6(value) {
    switch (value) {
      case 'None':
        return ColorMode_None_getInstance_0();
      case 'Sepia':
        return ColorMode_Sepia_getInstance_1();
      case 'Greyscale':
        return ColorMode_Greyscale_getInstance_0();
      case 'HighContrast':
        return ColorMode_HighContrast_getInstance();
      case 'LowContrast':
        return ColorMode_LowContrast_getInstance();
      case 'LimitedColors':
        return ColorMode_LimitedColors_getInstance();
      default:
        ColorMode_initEntries_0();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ColorMode_entriesInitialized_0;
  function ColorMode_initEntries_0() {
    if (ColorMode_entriesInitialized_0)
      return Unit_instance;
    ColorMode_entriesInitialized_0 = true;
    ColorMode_None_instance_0 = new ColorMode_0('None', 0, 0);
    ColorMode_Sepia_instance_0 = new ColorMode_0('Sepia', 1, 1);
    ColorMode_Greyscale_instance_0 = new ColorMode_0('Greyscale', 2, 2);
    ColorMode_HighContrast_instance = new ColorMode_0('HighContrast', 3, 3);
    ColorMode_LowContrast_instance = new ColorMode_0('LowContrast', 4, 4);
    ColorMode_LimitedColors_instance = new ColorMode_0('LimitedColors', 5, 5);
  }
  function ColorMode_0(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  var RenderMode_Complete_instance;
  var RenderMode_DiffuseOnly_instance;
  var RenderMode_ModelNormals_instance;
  var RenderMode_Lambert_instance;
  var RenderMode_CompleteWithLm_instance;
  var RenderMode_SsaoOnly_instance;
  function values_7() {
    return [RenderMode_Complete_getInstance(), RenderMode_DiffuseOnly_getInstance(), RenderMode_ModelNormals_getInstance(), RenderMode_Lambert_getInstance(), RenderMode_CompleteWithLm_getInstance(), RenderMode_SsaoOnly_getInstance()];
  }
  function valueOf_7(value) {
    switch (value) {
      case 'Complete':
        return RenderMode_Complete_getInstance();
      case 'DiffuseOnly':
        return RenderMode_DiffuseOnly_getInstance();
      case 'ModelNormals':
        return RenderMode_ModelNormals_getInstance();
      case 'Lambert':
        return RenderMode_Lambert_getInstance();
      case 'CompleteWithLm':
        return RenderMode_CompleteWithLm_getInstance();
      case 'SsaoOnly':
        return RenderMode_SsaoOnly_getInstance();
      default:
        RenderMode_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RenderMode_entriesInitialized;
  function RenderMode_initEntries() {
    if (RenderMode_entriesInitialized)
      return Unit_instance;
    RenderMode_entriesInitialized = true;
    RenderMode_Complete_instance = new RenderMode('Complete', 0, 0);
    RenderMode_DiffuseOnly_instance = new RenderMode('DiffuseOnly', 1, 1);
    RenderMode_ModelNormals_instance = new RenderMode('ModelNormals', 2, 2);
    RenderMode_Lambert_instance = new RenderMode('Lambert', 3, 3);
    RenderMode_CompleteWithLm_instance = new RenderMode('CompleteWithLm', 4, 5);
    RenderMode_SsaoOnly_instance = new RenderMode('SsaoOnly', 5, 4);
  }
  function RenderMode(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  function CemeterySettings() {
    this.cameraPeriod = 1.0;
    this.vignette = true;
    this.blurred = false;
    this.autoSwitchCameras = true;
    this.lowQuality = false;
    this.clock = false;
    this.renderMode = RenderMode_CompleteWithLm_getInstance();
    this.timeOfDay = TimeOfDay_Day_getInstance_2();
    this.lightDirection = new Vec3(0.0, 0.0, 1.0);
    this.lightExponent = 0.85;
    this.ambientColor = new Vec3(0.62, 0.82, 1.0);
    this.fogColor = new Vec3(0.62, 0.68, 0.78);
    this.fogStartDistance = 17.0;
    this.fogDistance = 20.0;
    this.lmScaleX = 0.01;
    this.lmScaleY = 0.01;
    this.lmColor = new Vec3(1.0, 0.94, 0.48);
    this.lmHeightMax = 2.7;
    this.lmHeightStartFade = 0.8;
    this.lmBrightness = 1.9;
    this.cameraMode = CameraMode_Random_getInstance_0();
    this.debugDouble = 1.0;
    this.debugFloat = 1.0;
    this.debugString = '';
    this.colorMode = ColorMode_None_getInstance_0();
    this.testX = 0.0;
    this.testY = 0.0;
    this.testZ = 0.0;
  }
  protoOf(CemeterySettings).fp = function (_set____db54di) {
    this.cameraPeriod = _set____db54di;
  };
  protoOf(CemeterySettings).gp = function () {
    return this.cameraPeriod;
  };
  protoOf(CemeterySettings).hp = function (_set____db54di) {
    this.vignette = _set____db54di;
  };
  protoOf(CemeterySettings).ip = function () {
    return this.vignette;
  };
  protoOf(CemeterySettings).jp = function (_set____db54di) {
    this.blurred = _set____db54di;
  };
  protoOf(CemeterySettings).kp = function () {
    return this.blurred;
  };
  protoOf(CemeterySettings).lp = function (_set____db54di) {
    this.autoSwitchCameras = _set____db54di;
  };
  protoOf(CemeterySettings).mp = function () {
    return this.autoSwitchCameras;
  };
  protoOf(CemeterySettings).rp = function (_set____db54di) {
    this.lowQuality = _set____db54di;
  };
  protoOf(CemeterySettings).sp = function () {
    return this.lowQuality;
  };
  protoOf(CemeterySettings).pp = function (_set____db54di) {
    this.clock = _set____db54di;
  };
  protoOf(CemeterySettings).qp = function () {
    return this.clock;
  };
  protoOf(CemeterySettings).w15 = function (_set____db54di) {
    this.renderMode = _set____db54di;
  };
  protoOf(CemeterySettings).x15 = function () {
    return this.renderMode;
  };
  protoOf(CemeterySettings).y15 = function (_set____db54di) {
    this.timeOfDay = _set____db54di;
  };
  protoOf(CemeterySettings).op = function () {
    return this.timeOfDay;
  };
  protoOf(CemeterySettings).z15 = function (_set____db54di) {
    this.lightDirection = _set____db54di;
  };
  protoOf(CemeterySettings).a16 = function () {
    return this.lightDirection;
  };
  protoOf(CemeterySettings).b16 = function (_set____db54di) {
    this.lightExponent = _set____db54di;
  };
  protoOf(CemeterySettings).c16 = function () {
    return this.lightExponent;
  };
  protoOf(CemeterySettings).d16 = function (_set____db54di) {
    this.ambientColor = _set____db54di;
  };
  protoOf(CemeterySettings).e16 = function () {
    return this.ambientColor;
  };
  protoOf(CemeterySettings).f16 = function (_set____db54di) {
    this.fogColor = _set____db54di;
  };
  protoOf(CemeterySettings).g16 = function () {
    return this.fogColor;
  };
  protoOf(CemeterySettings).h16 = function (_set____db54di) {
    this.fogStartDistance = _set____db54di;
  };
  protoOf(CemeterySettings).i16 = function () {
    return this.fogStartDistance;
  };
  protoOf(CemeterySettings).j16 = function (_set____db54di) {
    this.fogDistance = _set____db54di;
  };
  protoOf(CemeterySettings).k16 = function () {
    return this.fogDistance;
  };
  protoOf(CemeterySettings).l16 = function (_set____db54di) {
    this.lmScaleX = _set____db54di;
  };
  protoOf(CemeterySettings).m16 = function () {
    return this.lmScaleX;
  };
  protoOf(CemeterySettings).n16 = function (_set____db54di) {
    this.lmScaleY = _set____db54di;
  };
  protoOf(CemeterySettings).o16 = function () {
    return this.lmScaleY;
  };
  protoOf(CemeterySettings).p16 = function (_set____db54di) {
    this.lmColor = _set____db54di;
  };
  protoOf(CemeterySettings).q16 = function () {
    return this.lmColor;
  };
  protoOf(CemeterySettings).r16 = function (_set____db54di) {
    this.lmHeightMax = _set____db54di;
  };
  protoOf(CemeterySettings).s16 = function () {
    return this.lmHeightMax;
  };
  protoOf(CemeterySettings).t16 = function (_set____db54di) {
    this.lmHeightStartFade = _set____db54di;
  };
  protoOf(CemeterySettings).u16 = function () {
    return this.lmHeightStartFade;
  };
  protoOf(CemeterySettings).v16 = function (_set____db54di) {
    this.lmBrightness = _set____db54di;
  };
  protoOf(CemeterySettings).w16 = function () {
    return this.lmBrightness;
  };
  protoOf(CemeterySettings).x16 = function (_set____db54di) {
    this.cameraMode = _set____db54di;
  };
  protoOf(CemeterySettings).hu = function () {
    return this.cameraMode;
  };
  protoOf(CemeterySettings).iu = function (_set____db54di) {
    this.debugDouble = _set____db54di;
  };
  protoOf(CemeterySettings).ju = function () {
    return this.debugDouble;
  };
  protoOf(CemeterySettings).ku = function (_set____db54di) {
    this.debugFloat = _set____db54di;
  };
  protoOf(CemeterySettings).lu = function () {
    return this.debugFloat;
  };
  protoOf(CemeterySettings).mu = function (_set____db54di) {
    this.debugString = _set____db54di;
  };
  protoOf(CemeterySettings).nu = function () {
    return this.debugString;
  };
  protoOf(CemeterySettings).y16 = function (_set____db54di) {
    this.colorMode = _set____db54di;
  };
  protoOf(CemeterySettings).wq = function () {
    return this.colorMode;
  };
  protoOf(CemeterySettings).z16 = function (_set____db54di) {
    this.testX = _set____db54di;
  };
  protoOf(CemeterySettings).a17 = function () {
    return this.testX;
  };
  protoOf(CemeterySettings).b17 = function (_set____db54di) {
    this.testY = _set____db54di;
  };
  protoOf(CemeterySettings).c17 = function () {
    return this.testY;
  };
  protoOf(CemeterySettings).d17 = function (_set____db54di) {
    this.testZ = _set____db54di;
  };
  protoOf(CemeterySettings).e17 = function () {
    return this.testZ;
  };
  function TimeOfDay_Day_getInstance_2() {
    TimeOfDay_initEntries_2();
    return TimeOfDay_Day_instance_2;
  }
  function TimeOfDay_Night_getInstance_2() {
    TimeOfDay_initEntries_2();
    return TimeOfDay_Night_instance_2;
  }
  function TimeOfDay_Sunrise_getInstance_2() {
    TimeOfDay_initEntries_2();
    return TimeOfDay_Sunrise_instance_2;
  }
  function TimeOfDay_Sunset_getInstance_1() {
    TimeOfDay_initEntries_2();
    return TimeOfDay_Sunset_instance_1;
  }
  function CameraMode_Random_getInstance_0() {
    CameraMode_initEntries_0();
    return CameraMode_Random_instance_0;
  }
  function CameraMode_Orbiting_getInstance_0() {
    CameraMode_initEntries_0();
    return CameraMode_Orbiting_instance_0;
  }
  function ColorMode_None_getInstance_0() {
    ColorMode_initEntries_0();
    return ColorMode_None_instance_0;
  }
  function ColorMode_Sepia_getInstance_1() {
    ColorMode_initEntries_0();
    return ColorMode_Sepia_instance_0;
  }
  function ColorMode_Greyscale_getInstance_0() {
    ColorMode_initEntries_0();
    return ColorMode_Greyscale_instance_0;
  }
  function ColorMode_HighContrast_getInstance() {
    ColorMode_initEntries_0();
    return ColorMode_HighContrast_instance;
  }
  function ColorMode_LowContrast_getInstance() {
    ColorMode_initEntries_0();
    return ColorMode_LowContrast_instance;
  }
  function ColorMode_LimitedColors_getInstance() {
    ColorMode_initEntries_0();
    return ColorMode_LimitedColors_instance;
  }
  function RenderMode_Complete_getInstance() {
    RenderMode_initEntries();
    return RenderMode_Complete_instance;
  }
  function RenderMode_DiffuseOnly_getInstance() {
    RenderMode_initEntries();
    return RenderMode_DiffuseOnly_instance;
  }
  function RenderMode_ModelNormals_getInstance() {
    RenderMode_initEntries();
    return RenderMode_ModelNormals_instance;
  }
  function RenderMode_Lambert_getInstance() {
    RenderMode_initEntries();
    return RenderMode_Lambert_instance;
  }
  function RenderMode_CompleteWithLm_getInstance() {
    RenderMode_initEntries();
    return RenderMode_CompleteWithLm_instance;
  }
  function RenderMode_SsaoOnly_getInstance() {
    RenderMode_initEntries();
    return RenderMode_SsaoOnly_instance;
  }
  function Shaders_2() {
    Shaders_instance_2 = this;
    this.h15_1 = new Shader('ColorAnimatedTextureChunkedFog');
    this.i15_1 = mutableListOf([this.h15_1]);
  }
  var Shaders_instance_2;
  function Shaders_getInstance_2() {
    if (Shaders_instance_2 == null)
      new Shaders_2();
    return Shaders_instance_2;
  }
  function Textures_2() {
    Textures_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.Textures.texBat.<anonymous>' call
    this_0.name = 'bat';
    this_0.fileName = 'bat.rgba.fp16';
    this_0.format = TextureFormat_RGBA16F_getInstance();
    this_0.minFilter = TextureFiltering_NEAREST_getInstance();
    this_0.magFilter = TextureFiltering_NEAREST_getInstance();
    this_0.width = Animations_getInstance_0().yx_1.vb_1;
    this_0.height = Animations_getInstance_0().yx_1.ac_1;
    tmp.cy_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.Textures.texWhite.<anonymous>' call
    this_1.name = 'white';
    this_1.fileName = 'white';
    this_1.format = TextureFormat_ASTC_getInstance();
    this_1.wrapping = TextureWrapping_REPEAT_getInstance();
    this_1.minFilter = TextureFiltering_NEAREST_getInstance();
    this_1.magFilter = TextureFiltering_NEAREST_getInstance();
    tmp_0.dy_1 = this_1;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.Textures.texLM.<anonymous>' call
    this_2.name = 'Lightmap';
    this_2.fileName = 'lm';
    this_2.format = TextureFormat_ASTC_getInstance();
    this_2.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_2.minFilter = TextureFiltering_LINEAR_getInstance();
    this_2.magFilter = TextureFiltering_LINEAR_getInstance();
    this_2.mipmaps = 8;
    tmp_1.ey_1 = this_2;
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.Textures.texLeaves.<anonymous>' call
    this_3.name = 'Leaves';
    this_3.fileName = 'leaves';
    this_3.format = TextureFormat_ASTC_getInstance();
    this_3.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_3.minFilter = TextureFiltering_LINEAR_getInstance();
    this_3.magFilter = TextureFiltering_LINEAR_getInstance();
    this_3.mipmaps = 7;
    tmp_2.fy_1 = this_3;
    var tmp_3 = this;
    // Inline function 'kotlin.apply' call
    var this_4 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.cemetery.Textures.texGhost.<anonymous>' call
    this_4.name = 'ghost';
    this_4.fileName = 'ghost_eyes';
    this_4.format = TextureFormat_ASTC_getInstance();
    this_4.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_4.minFilter = TextureFiltering_LINEAR_getInstance();
    this_4.magFilter = TextureFiltering_LINEAR_getInstance();
    this_4.mipmaps = 7;
    tmp_3.gy_1 = this_4;
    this.hy_1 = mutableListOf([this.dy_1, this.cy_1, this.ey_1, this.fy_1, this.gy_1]);
  }
  var Textures_instance_2;
  function Textures_getInstance_2() {
    if (Textures_instance_2 == null)
      new Textures_2();
    return Textures_instance_2;
  }
  var Timers_OrbitingCameraZ_instance_0;
  var Timers_OrbitingCameraX_instance_0;
  var Timers_BirdWings1_instance_0;
  var Timers_BirdWings2_instance_0;
  var Timers_BirdsFly_instance_0;
  var Timers_ProjectionOffsetTransition_instance_0;
  var Timers_FlameFlicker_instance;
  var Timers_GhostAnim1_instance;
  var Timers_GhostAnim2_instance;
  var Timers_GhostMove_instance;
  var Timers_GhostBob_instance;
  var Timers_BirdsBob_instance;
  function Companion_3() {
    this.j15_1 = 27800.0;
  }
  protoOf(Companion_3).k15 = function (timers) {
    timers.mj(Timers_OrbitingCameraZ_getInstance_0(), 42000.0, true);
    timers.mj(Timers_OrbitingCameraX_getInstance_0(), 32000.0, true);
    timers.mj(Timers_ProjectionOffsetTransition_getInstance_0(), 2000.0, false);
    timers.mj(Timers_BirdWings1_getInstance_0(), 900.0, true);
    timers.mj(Timers_BirdWings2_getInstance_0(), 800.0, true);
    timers.mj(Timers_BirdsFly_getInstance_0(), 19000.0, true);
    timers.mj(Timers_BirdsBob_getInstance(), 2800.0, true);
    timers.mj(Timers_FlameFlicker_getInstance(), 900.0, true);
    timers.mj(Timers_GhostAnim1_getInstance(), 4000.0, true);
    timers.mj(Timers_GhostAnim2_getInstance(), 5000.0, true);
    timers.mj(Timers_GhostMove_getInstance(), 58000.0, true);
    timers.mj(Timers_GhostBob_getInstance(), 4000.0, true);
  };
  var Companion_instance_6;
  function Companion_getInstance_3() {
    return Companion_instance_6;
  }
  var Timers_entriesInitialized_2;
  function Timers_initEntries_2() {
    if (Timers_entriesInitialized_2)
      return Unit_instance;
    Timers_entriesInitialized_2 = true;
    Timers_OrbitingCameraZ_instance_0 = new Timers_2('OrbitingCameraZ', 0);
    Timers_OrbitingCameraX_instance_0 = new Timers_2('OrbitingCameraX', 1);
    Timers_BirdWings1_instance_0 = new Timers_2('BirdWings1', 2);
    Timers_BirdWings2_instance_0 = new Timers_2('BirdWings2', 3);
    Timers_BirdsFly_instance_0 = new Timers_2('BirdsFly', 4);
    Timers_ProjectionOffsetTransition_instance_0 = new Timers_2('ProjectionOffsetTransition', 5);
    Timers_FlameFlicker_instance = new Timers_2('FlameFlicker', 6);
    Timers_GhostAnim1_instance = new Timers_2('GhostAnim1', 7);
    Timers_GhostAnim2_instance = new Timers_2('GhostAnim2', 8);
    Timers_GhostMove_instance = new Timers_2('GhostMove', 9);
    Timers_GhostBob_instance = new Timers_2('GhostBob', 10);
    Timers_BirdsBob_instance = new Timers_2('BirdsBob', 11);
  }
  function Timers_2(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Timers_OrbitingCameraZ_getInstance_0() {
    Timers_initEntries_2();
    return Timers_OrbitingCameraZ_instance_0;
  }
  function Timers_OrbitingCameraX_getInstance_0() {
    Timers_initEntries_2();
    return Timers_OrbitingCameraX_instance_0;
  }
  function Timers_BirdWings1_getInstance_0() {
    Timers_initEntries_2();
    return Timers_BirdWings1_instance_0;
  }
  function Timers_BirdWings2_getInstance_0() {
    Timers_initEntries_2();
    return Timers_BirdWings2_instance_0;
  }
  function Timers_BirdsFly_getInstance_0() {
    Timers_initEntries_2();
    return Timers_BirdsFly_instance_0;
  }
  function Timers_ProjectionOffsetTransition_getInstance_0() {
    Timers_initEntries_2();
    return Timers_ProjectionOffsetTransition_instance_0;
  }
  function Timers_FlameFlicker_getInstance() {
    Timers_initEntries_2();
    return Timers_FlameFlicker_instance;
  }
  function Timers_GhostAnim1_getInstance() {
    Timers_initEntries_2();
    return Timers_GhostAnim1_instance;
  }
  function Timers_GhostAnim2_getInstance() {
    Timers_initEntries_2();
    return Timers_GhostAnim2_instance;
  }
  function Timers_GhostMove_getInstance() {
    Timers_initEntries_2();
    return Timers_GhostMove_instance;
  }
  function Timers_GhostBob_getInstance() {
    Timers_initEntries_2();
    return Timers_GhostBob_instance;
  }
  function Timers_BirdsBob_getInstance() {
    Timers_initEntries_2();
    return Timers_BirdsBob_instance;
  }
  function Animations_1() {
    Animations_instance_1 = this;
    this.f17_1 = new TextureAnimationChunked(75, 75, 3);
  }
  var Animations_instance_1;
  function Animations_getInstance_1() {
    if (Animations_instance_1 == null)
      new Animations_1();
    return Animations_instance_1;
  }
  function Cameras_3() {
    Cameras_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g17_1 = [new CameraPositionPair(new CameraPosition(new Vec3(38.70992, 5.15985, 5.91246), new Vec3(10.16353, -1.09901, 0.0518)), new CameraPosition(new Vec3(24.18353, 1.64399, 1.8614), new Vec3(6.5007, 2.24976, 1.69956)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-6.82741, 43.0728, 15.12059), new Vec3(2.9745, -9.71872, 2.66179)), new CameraPosition(new Vec3(-0.14104, 7.06108, 6.62179), new Vec3(2.9745, -9.71872, 2.66179)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-8.88309, 15.58949, 1.076), new Vec3(2.71626, 4.88696, 2.42399)), new CameraPosition(new Vec3(-8.88309, 15.58949, 1.076), new Vec3(2.01102, 4.12261, 2.42399)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(9.28378, 8.52561, 1.45335), new Vec3(0.1673, -7.79788, 1.23904)), new CameraPosition(new Vec3(9.28378, 8.52561, 1.45335), new Vec3(-0.92421, -7.12931, 1.23904)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(23.89814, 1.84801, 0.42454), new Vec3(13.745, 8.35707, 1.0304)), new CameraPosition(new Vec3(23.89814, 1.84801, 0.42454), new Vec3(12.9949, 7.15828, 1.0076)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-7.61864, 5.66412, 1.1225), new Vec3(6.11309, -6.64757, 0.54667)), new CameraPosition(new Vec3(-7.61864, 5.66412, 1.1225), new Vec3(4.47143, -3.8803, 1.23546)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-0.3545, -1.09883, 3.13904), new Vec3(-7.08796, -2.19082, 1.11842)), new CameraPosition(new Vec3(11.72716, 0.70572, 12.43634), new Vec3(-7.08796, -2.19082, 1.11842)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(2.50435, -5.30191, 4.57216), new Vec3(0.74438, 1.3856, 2.6324)), new CameraPosition(new Vec3(5.71569, 4.02841, 3.81446), new Vec3(0.74438, 1.3856, 2.6324)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(11.67545, -1.01319, 4.16589), new Vec3(16.63255, 5.23404, 3.42004)), new CameraPosition(new Vec3(22.93408, 5.5423, 4.6691), new Vec3(16.63255, 5.23404, 3.42004)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(5.95616, -3.69933, 0.57542), new Vec3(2.43907, -10.90985, 2.699)), new CameraPosition(new Vec3(5.95616, -3.69933, 0.57542), new Vec3(2.23556, 3.19109, 1.07307)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(1.03509, -17.76093, 0.61357), new Vec3(6.94162, 9.72911, 1.74293)), new CameraPosition(new Vec3(2.90728, -8.73623, 0.6173), new Vec3(6.94162, 9.72911, 1.74293)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(27.71519, -10.70263, 2.42775), new Vec3(14.72766, -7.33379, 0.15963)), new CameraPosition(new Vec3(27.14785, -6.90781, 2.40519), new Vec3(14.72766, -7.33379, 0.15963)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(5.28697, -14.83829, 2.66817), new Vec3(10.4528, -1.8823, 1.02553)), new CameraPosition(new Vec3(10.11546, -15.15036, 2.62786), new Vec3(10.4528, -1.8823, 1.02553)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(3.34795, -6.26302, 1.8104), new Vec3(-0.91791, -6.39719, 1.12574)), new CameraPosition(new Vec3(7.13582, -0.96275, 8.4854), new Vec3(-0.12868, -5.88976, 1.53747)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(4.52857, 2.51818, 3.22811), new Vec3(9.62498, 5.62938, 1.71498)), new CameraPosition(new Vec3(14.22244, 2.33154, 7.43974), new Vec3(12.04065, 4.80087, 2.0615)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(2.45082, -10.52241, 6.11413), new Vec3(7.9111, -4.35091, 0.71477)), new CameraPosition(new Vec3(13.36669, -11.10688, 6.11413), new Vec3(9.67914, -6.7669, 1.29186)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(20.98959, -1.69565, 8.14323), new Vec3(12.02538, -11.04883, 2.94463)), new CameraPosition(new Vec3(20.98959, -1.69565, 8.14323), new Vec3(15.88589, 7.95272, 1.755)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-1.15391, -3.71734, 8.98853), new Vec3(-5.85964, 2.59812, 1.85741)), new CameraPosition(new Vec3(-1.15391, -3.71734, 8.98853), new Vec3(10.94908, -5.03643, 3.17853)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(2.18649, -9.92329, 7.27979), new Vec3(-10.18294, -5.2422, 3.81831)), new CameraPosition(new Vec3(15.34668, -1.80578, 8.70861), new Vec3(19.77751, 7.57039, 2.41142)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(10.1439, -15.64655, 4.13888), new Vec3(-6.40787, -9.5562, 3.12396)), new CameraPosition(new Vec3(9.79544, 6.12718, 7.422), new Vec3(-5.44877, 0.32482, 2.01216)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-8.84024, 0.27637, 6.27443), new Vec3(-4.90632, 12.88201, 1.9203)), new CameraPosition(new Vec3(12.02008, 0.2488, 6.74946), new Vec3(22.7403, 10.25339, 1.24117)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(20.5219, -13.06709, 5.46594), new Vec3(19.30067, 0.57551, 1.50315)), new CameraPosition(new Vec3(3.12073, -12.23503, 6.06164), new Vec3(5.71142, -5.60674, 2.27801)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-8.15922, 13.82588, 2.09516), new Vec3(-0.03049, 7.9972, 0.89048)), new CameraPosition(new Vec3(-15.84635, 12.90287, 10.49672), new Vec3(-5.5892, 11.65156, 2.72385)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-0.36919, 4.22139, 4.84757), new Vec3(-4.90552, 11.10387, 2.30008)), new CameraPosition(new Vec3(-13.00475, 10.10982, 6.17595), new Vec3(-1.74259, 15.56522, 1.32554)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(25.60301, 6.31494, 3.91502), new Vec3(17.36128, 5.45937, 1.01392)), new CameraPosition(new Vec3(16.82751, 0.67953, 3.14737), new Vec3(17.36128, 5.45937, 1.01392)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-9.70366, -10.41646, 3.64063), new Vec3(-5.52848, -6.20358, 1.11495)), new CameraPosition(new Vec3(-0.50177, -8.92422, 3.56217), new Vec3(-5.52848, -6.20358, 1.11495)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-3.59182, 6.94843, 2.34605), new Vec3(-6.05712, 3.23195, 0.94271)), new CameraPosition(new Vec3(-1.52778, -0.68069, 3.38069), new Vec3(-6.05712, 3.23195, 0.94271)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(22.82161, -10.59952, 3.30366), new Vec3(18.49043, -2.69692, 1.71761)), new CameraPosition(new Vec3(10.8253, -11.05882, 1.29563), new Vec3(16.42235, -2.49028, 1.19195)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(25.30372, -13.31767, 4.51761), new Vec3(12.26076, 4.34953, 3.34535)), new CameraPosition(new Vec3(25.47256, 7.29274, 4.82758), new Vec3(17.58136, -2.74657, 3.81204)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-13.03896, 16.18357, 5.57775), new Vec3(17.46652, 2.3497, 3.34768)), new CameraPosition(new Vec3(-15.96301, -12.92775, 4.70224), new Vec3(17.46652, 2.3497, 3.34768)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-10.26255, -20.13821, 2.92488), new Vec3(4.41334, 0.87215, 2.83055)), new CameraPosition(new Vec3(25.03896, -17.07435, 7.22314), new Vec3(4.41334, 0.87215, 2.83055)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-12.90432, 25.76418, 5.99604), new Vec3(10.71068, -12.79007, 3.20119)), new CameraPosition(new Vec3(3.74226, -1.4133, 3.11995), new Vec3(10.71068, -12.79007, 3.20119)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-7.28207, -5.64235, 5.48364), new Vec3(4.48909, 0.70829, 3.30727)), new CameraPosition(new Vec3(9.17722, 2.97599, 3.09496), new Vec3(27.06189, 12.95163, 2.84923)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(28.24284, -1.87409, 3.28226), new Vec3(-3.56355, -1.57982, 2.39246)), new CameraPosition(new Vec3(6.04908, -1.45837, 1.93234), new Vec3(-3.56355, -1.57982, 2.39246)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(1.97821, -19.04979, 3.44), new Vec3(2.08283, 6.51826, 2.1118)), new CameraPosition(new Vec3(2.07565, -2.81006, 2.4), new Vec3(2.08283, 6.51826, 2.1118)), 1.0)];
  }
  var Cameras_instance_3;
  function Cameras_getInstance_3() {
    if (Cameras_instance_3 == null)
      new Cameras_3();
    return Cameras_instance_3;
  }
  function CommonAssetForgeTextures_0() {
    CommonAssetForgeTextures_instance_0 = this;
    this.h17_1 = Textures_getInstance_3().v17_1;
    this.i17_1 = Textures_getInstance_3().x17_1;
  }
  var CommonAssetForgeTextures_instance_0;
  function CommonAssetForgeTextures_getInstance_0() {
    if (CommonAssetForgeTextures_instance_0 == null)
      new CommonAssetForgeTextures_0();
    return CommonAssetForgeTextures_instance_0;
  }
  function Flames_0() {
    Flames_instance_0 = this;
    this.z17_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0)), 8);
    this.a18_1 = MeshConstructor2('flame', this.z17_1);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.b18_1 = ArrayList_init_$Create$_0();
    var tmp_0 = this;
    // Inline function 'kotlin.also' call
    var this_0 = GroupCommandArr(true, []);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Flames.group.<anonymous>' call
    this_0.commands = Flames_getInstance_0().b18_1;
    tmp_0.c18_1 = this_0;
    var color = CommonAssetForgeShaders_getInstance().fz_1.value;
    color[0] = 1.0;
    color[1] = 0.82;
    color[2] = 0.71;
    color[3] = 1.0;
    this.hz(new Vec3(20.2993, -6.295, 1.1178), 0.1);
    this.hz(new Vec3(17.9, 5.6, 0.78), 0.1);
    this.hz(new Vec3(20.0042, -5.995, 0.9654), 0.1);
    this.hz(new Vec3(13.9938, -6.0102, 0.9754), 0.1);
    this.hz(new Vec3(14.2089, -5.9502, 1.1154), 0.1);
    this.hz(new Vec3(-4.9426, 11.436, 1.638), 0.1);
    this.hz(new Vec3(-5.0226, 11.2887, 1.7354), 0.1);
    this.hz(new Vec3(-6.2926, 3.438, 0.9829), 0.1);
    this.hz(new Vec3(-5.8626, 3.1505, 0.8929), 0.1);
    this.hz(new Vec3(-5.8526, -5.8602, 0.9154), 0.1);
    this.hz(new Vec3(-6.1326, -6.2902, 0.9629), 0.1);
    this.hz(new Vec3(-5.7826, -6.8102, 0.8054), 0.1);
  }
  protoOf(Flames_0).hz = function (position, scale) {
    this.b18_1.g(DrawStaticMeshCommandConstructor(this.a18_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), CommonAssetForgeShaders_getInstance().fz_1, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().ty_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(this.a18_1, CommonAssetForgeShaders_getInstance().ty_1)), new AffineTranformation(new Vec3(position.x, position.y, position.z), new Vec3(0.0, 0.0, 0.0), new Vec3(scale * 0.6, scale * 0.6, scale))));
  };
  var Flames_instance_0;
  function Flames_getInstance_0() {
    if (Flames_instance_0 == null)
      new Flames_0();
    return Flames_instance_0;
  }
  function Ghosts_0() {
    Ghosts_instance_0 = this;
    this.d18_1 = MeshConstructor2('ghost', Meshes_getInstance_3().i18_1);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.e18_1 = ArrayList_init_$Create$_0();
    var tmp_0 = this;
    // Inline function 'kotlin.also' call
    var this_0 = GroupCommandArr(true, []);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Ghosts.group.<anonymous>' call
    this_0.commands = Ghosts_getInstance_0().e18_1;
    tmp_0.f18_1 = this_0;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$2 = new Float32Array([0.96, 0.86, 1.0, 1.0]);
    var uniformGhostColor0 = UniformFloatValueWithArray(tmp$ret$2);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$3 = new Float32Array([0.86, 0.85, 1.0, 1.0]);
    var uniformGhostColor1 = UniformFloatValueWithArray(tmp$ret$3);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$4 = new Float32Array([0.86, 1.0, 0.88, 1.0]);
    var uniformGhostColor2 = UniformFloatValueWithArray(tmp$ret$4);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$5 = new Float32Array([0.98, 1.0, 0.86, 1.0]);
    var uniformGhostColor3 = UniformFloatValueWithArray(tmp$ret$5);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$6 = new Float32Array([0.82, 0.82, 1.0, 1.0]);
    var uniformGhostColor4 = UniformFloatValueWithArray(tmp$ret$6);
    var GHOST_SCALE = 0.5;
    // Inline function 'kotlin.apply' call
    var this_1 = new Blending();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Ghosts.<anonymous>' call
    this_1.enabled = true;
    this_1.equationColor = BlendingEquation_ADD_getInstance();
    this_1.sourceFactorColor = BlendingFactor_SRC_ALPHA_getInstance();
    this_1.destinationFactorColor = BlendingFactor_ONE_MINUS_SRC_ALPHA_getInstance();
    var blending = this_1;
    this.e18_1.g(DrawStaticMeshCommandConstructor(this.d18_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(CommonAssetForgeTextures_getInstance_0().i17_1), CommonAssetForgeShaders_getInstance().gz_1, uniformGhostColor0, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().uy_1, blending, get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(this.d18_1, CommonAssetForgeShaders_getInstance().uy_1)), new AffineTranformation(new Vec3(0.0, 0.0, 0.3), new Vec3(0.0, 0.0, 0.0), new Vec3(GHOST_SCALE, GHOST_SCALE, GHOST_SCALE))));
    this.e18_1.g(DrawStaticMeshCommandConstructor(this.d18_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(CommonAssetForgeTextures_getInstance_0().i17_1), CommonAssetForgeShaders_getInstance().gz_1, uniformGhostColor1, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().uy_1, blending, get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(this.d18_1, CommonAssetForgeShaders_getInstance().uy_1)), new AffineTranformation(new Vec3(1.0, 0.0, 0.3), new Vec3(0.0, 0.0, 0.0), new Vec3(GHOST_SCALE * 0.8, GHOST_SCALE * 0.8, GHOST_SCALE))));
    this.e18_1.g(DrawStaticMeshCommandConstructor(this.d18_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(CommonAssetForgeTextures_getInstance_0().i17_1), CommonAssetForgeShaders_getInstance().gz_1, uniformGhostColor2, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().uy_1, blending, get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(this.d18_1, CommonAssetForgeShaders_getInstance().uy_1)), new AffineTranformation(new Vec3(2.0, 0.0, 0.3), new Vec3(0.0, 0.0, 0.0), new Vec3(GHOST_SCALE, GHOST_SCALE, GHOST_SCALE * 1.2))));
    this.e18_1.g(DrawStaticMeshCommandConstructor(this.d18_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(CommonAssetForgeTextures_getInstance_0().i17_1), CommonAssetForgeShaders_getInstance().gz_1, uniformGhostColor3, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().uy_1, blending, get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(this.d18_1, CommonAssetForgeShaders_getInstance().uy_1)), new AffineTranformation(new Vec3(3.0, 0.0, 0.3), new Vec3(0.0, 0.0, 0.0), new Vec3(GHOST_SCALE * 0.8, GHOST_SCALE * 0.8, GHOST_SCALE))));
    this.e18_1.g(DrawStaticMeshCommandConstructor(this.d18_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(CommonAssetForgeTextures_getInstance_0().i17_1), CommonAssetForgeShaders_getInstance().gz_1, uniformGhostColor4, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().uy_1, blending, get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(this.d18_1, CommonAssetForgeShaders_getInstance().uy_1)), new AffineTranformation(new Vec3(4.0, 0.0, 0.3), new Vec3(0.0, 0.0, 0.0), new Vec3(GHOST_SCALE * 1.3, GHOST_SCALE * 1.3, GHOST_SCALE * 0.9))));
  }
  var Ghosts_instance_0;
  function Ghosts_getInstance_0() {
    if (Ghosts_instance_0 == null)
      new Ghosts_0();
    return Ghosts_instance_0;
  }
  function ImportedAssetForgeCommands_0() {
    ImportedAssetForgeCommands_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.z14_1 = ArrayList_init_$Create$_0();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.a15_1 = ArrayList_init_$Create$_0();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_1.b15_1 = ArrayList_init_$Create$_0();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_2.c15_1 = ArrayList_init_$Create$_0();
    var tmp_3 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_3.d15_1 = ArrayList_init_$Create$_0();
    var tmp_4 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_4.e15_1 = ArrayList_init_$Create$_0();
    this.j12(ImportedAssetForgeMeshes_getInstance_0().d19_1, ImportedAssetForgeTextures_getInstance_0().s1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(29.938583, -11.785566, -0.071564), new Vec3(36.345463, -1.671677, 1.471558)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().e19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-36.0, -44.0, -0.603714), new Vec3(2.472875, -16.0, 7.240505)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().f19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(14.565916, -44.412815, -0.665716), new Vec3(52.0, -14.009504, 12.66412)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().g19_1, ImportedAssetForgeTextures_getInstance_0().s1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(17.427229, -12.654359, -0.047736), new Vec3(23.531727, -3.287938, 0.88749)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().h19_1, ImportedAssetForgeTextures_getInstance_0().s1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(22.34564, 4.468273, -0.047783), new Vec3(23.712063, 7.712062, 1.074488)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().i19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.0, -44.0, -0.065464), new Vec3(20.0, -20.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().j19_1, ImportedAssetForgeTextures_getInstance_0().s1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-7.308465, -32.008465, -0.071617), new Vec3(21.345463, -15.940843, 1.78013)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().k19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.436442, 10.706612, -0.400237), new Vec3(1.379266, 27.034237, 7.222706)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().l19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.25, 0.0, -0.296535), new Vec3(-0.062865, 9.027068, 3.0)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().m19_1, ImportedAssetForgeTextures_getInstance_0().s1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-3.783728, -4.579492, -0.047736), new Vec3(-0.782496, 2.363871, 0.88749)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().n19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.25, -8.0, 0.0), new Vec3(-3.625, 0.25, 2.200001)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().o19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.5, -12.5, -0.110926), new Vec3(0.0, -7.75, 4.4)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().p19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.0, -20.0, -0.065464), new Vec3(4.0, -12.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().q19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(0.046961, -19.881874, 0.0), new Vec3(3.953039, -12.074254, 0.100002)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().r19_1, ImportedAssetForgeTextures_getInstance_0().s1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-2.819215, -17.418945, -0.047783), new Vec3(6.808515, -12.593954, 1.168037)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().s19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.25, 7.5, -0.106424), new Vec3(-1.934515, 15.234923, 2.2)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().t19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-36.0, -16.0, -0.59394), new Vec3(-8.0, 8.076118, 10.517678)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().u19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(4.0, -20.0, -0.065464), new Vec3(16.0, -8.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().v19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(24.8881, -7.759596, -0.665716), new Vec3(39.39676, 32.545006, 12.663438)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().w19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(28.0, -16.0, -0.065464), new Vec3(52.0, 16.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().x19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(16.0, 16.0, -0.065464), new Vec3(52.0, 40.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().y19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.0, 16.0, -0.065464), new Vec3(16.0, 40.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().z19_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-36.0, 8.0, -0.603714), new Vec3(-7.487249, 40.0, 9.787996)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().a1a_1, ImportedAssetForgeTextures_getInstance_0().s1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-20.933353, -3.952754, -1.979322), new Vec3(-6.981812, 27.380268, 3.886004)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().b1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(4.0, 0.0, -0.065464), new Vec3(28.0, 16.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().c1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.0, -12.0, -0.065464), new Vec3(4.0, 4.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().d1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-2.266702, -14.402639, -0.328623), new Vec3(4.109221, 7.953039, 4.413949)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().e1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-8.0, 4.0, -0.065464), new Vec3(4.0, 16.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().f1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(-1.0, 7.964671, 0.0), new Vec3(5.0, 16.0, 8.0)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().g1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(4.0, -8.0, -1.5), new Vec3(16.0, 0.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().h1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(4.0, -12.323488, -1.54635), new Vec3(16.0, -3.160703, 2.600205)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().i1a_1, ImportedAssetForgeTextures_getInstance_0().s1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(4.243107, -11.654359, -0.047736), new Vec3(12.712062, -3.287938, 0.88749)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().j1a_1, ImportedAssetForgeTextures_getInstance_0().s1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(8.713272, 3.391726, -0.047736), new Vec3(17.01526, 8.713467, 0.88749)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().k1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(13.25472, 3.54914, -0.321442), new Vec3(24.25, 16.0, 3.831946)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().l1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(16.066969, -4.0, -0.226658), new Vec3(24.918962, 4.0, 2.215322)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().m1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(16.0, -16.0, -0.065464), new Vec3(28.0, 0.0, 0.03)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().n1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(14.033948, -12.5, -0.368515), new Vec3(24.571564, -3.42622, 4.738093)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().o1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(3.082648, 7.75047, -1.054764), new Vec3(25.613907, 26.76259, 12.88447)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().p1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(4.033948, -2.945264, -0.28921), new Vec3(15.937135, 9.849547, 4.793867)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().q1a_1, ImportedAssetForgeTextures_getInstance_0().t1a_1, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.0)), new Aabb(new Vec3(0.17999, -8.72001, 0.4), new Vec3(7.810161, 5.210161, 3.1)));
    this.j12(ImportedAssetForgeMeshes_getInstance_0().c19_1, ImportedAssetForgeTextures_getInstance_0().s1a_1, new AffineTranformation(new Vec3(-1.6, 10.0, 0.0095), new Vec3(0.0, 0.0, 0.0), new Vec3(1.0, 1.0, 1.2)), new Aabb(new Vec3(-2.172771, 9.345641, -0.047783), new Vec3(-1.068273, 10.712062, 1.074488)));
    this.f15_1 = new Vec3(-0.8, 5.0, 0.00475);
    this.g15_1 = 5.063598;
  }
  protoOf(ImportedAssetForgeCommands_0).j12 = function (mesh, texture, transform, bounds) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.e15_1.g(bounds);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.z14_1;
    var element = DrawStaticMeshCommandConstructor(mesh, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texture), CommonAssetForgeShaders_getInstance().wy_1, CommonAssetForgeShaders_getInstance().xy_1, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), Companion_instance_0.forSolidGeometry(mesh, CommonAssetForgeShaders_getInstance().my_1), transform, 0, 1);
    this_0.g(element);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this.a15_1;
    var element_0 = DrawStaticMeshCommandConstructor(mesh, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texture), CommonAssetForgeShaders_getInstance().wy_1, CommonAssetForgeShaders_getInstance().xy_1, CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1, new UniformTextureValue(texture), new UniformTextureValue(CommonAssetForgeTextures_getInstance_0().h17_1), CommonAssetForgeShaders_getInstance().bz_1, CommonAssetForgeShaders_getInstance().cz_1, CommonAssetForgeShaders_getInstance().dz_1, CommonAssetForgeShaders_getInstance().ez_1]), Companion_instance_0.forSolidGeometry(mesh, CommonAssetForgeShaders_getInstance().ny_1), transform, 0, 1);
    this_1.g(element_0);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_2 = this.b15_1;
    var element_1 = Companion_instance_1.forSolidGeometry(mesh, CommonAssetForgeShaders_getInstance().py_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(texture)]), transform);
    this_2.g(element_1);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_3 = this.c15_1;
    var element_2 = Companion_instance_1.forSolidGeometry(mesh, CommonAssetForgeShaders_getInstance().qy_1, listOf_0(UniformFloatValueWithArray(new Float32Array(16))), transform);
    this_3.g(element_2);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_4 = this.d15_1;
    var element_3 = DrawStaticMeshCommandConstructor(mesh, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(16))]), Companion_instance_0.forSolidGeometry(mesh, CommonAssetForgeShaders_getInstance().ry_1), transform, 0, 1);
    this_4.g(element_3);
  };
  var ImportedAssetForgeCommands_instance_0;
  function ImportedAssetForgeCommands_getInstance_0() {
    if (ImportedAssetForgeCommands_instance_0 == null)
      new ImportedAssetForgeCommands_0();
    return ImportedAssetForgeCommands_instance_0;
  }
  function ImportedAssetForgeMeshes_0() {
    ImportedAssetForgeMeshes_instance_0 = this;
    this.b19_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_UBYTE2_NORMALIZED_getInstance(), 6), new MeshAttribute(AttributeType_NORMAL_getInstance(), VertexFormat_BYTE3_NORMALIZED_getInstance(), 8)]), 12);
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = MeshConstructor2('kay-forest-free_Grass_2_D_Color1', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshKayForestFreeGrass2DColor1.<anonymous>' call
    this_0.fileName = 'imported/kay-forest-free_Grass_2_D_Color1';
    tmp.c19_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = MeshConstructor2('cemetery_Group_227', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup227.<anonymous>' call
    this_1.fileName = 'imported/cemetery_Group_227';
    tmp_0.d19_1 = this_1;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = MeshConstructor2('cemetery_Group_268', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup268.<anonymous>' call
    this_2.fileName = 'imported/cemetery_Group_268';
    tmp_1.e19_1 = this_2;
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = MeshConstructor2('cemetery_Group_271', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup271.<anonymous>' call
    this_3.fileName = 'imported/cemetery_Group_271';
    tmp_2.f19_1 = this_3;
    var tmp_3 = this;
    // Inline function 'kotlin.apply' call
    var this_4 = MeshConstructor2('cemetery_Group_272', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup272.<anonymous>' call
    this_4.fileName = 'imported/cemetery_Group_272';
    tmp_3.g19_1 = this_4;
    var tmp_4 = this;
    // Inline function 'kotlin.apply' call
    var this_5 = MeshConstructor2('cemetery_Group_138', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup138.<anonymous>' call
    this_5.fileName = 'imported/cemetery_Group_138';
    tmp_4.h19_1 = this_5;
    var tmp_5 = this;
    // Inline function 'kotlin.apply' call
    var this_6 = MeshConstructor2('cemetery_Group_207', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup207.<anonymous>' call
    this_6.fileName = 'imported/cemetery_Group_207';
    tmp_5.i19_1 = this_6;
    var tmp_6 = this;
    // Inline function 'kotlin.apply' call
    var this_7 = MeshConstructor2('cemetery_Group_276', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup276.<anonymous>' call
    this_7.fileName = 'imported/cemetery_Group_276';
    tmp_6.j19_1 = this_7;
    var tmp_7 = this;
    // Inline function 'kotlin.apply' call
    var this_8 = MeshConstructor2('cemetery_Group_200', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup200.<anonymous>' call
    this_8.fileName = 'imported/cemetery_Group_200';
    tmp_7.k19_1 = this_8;
    var tmp_8 = this;
    // Inline function 'kotlin.apply' call
    var this_9 = MeshConstructor2('cemetery_Group_236', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup236.<anonymous>' call
    this_9.fileName = 'imported/cemetery_Group_236';
    tmp_8.l19_1 = this_9;
    var tmp_9 = this;
    // Inline function 'kotlin.apply' call
    var this_10 = MeshConstructor2('cemetery_Group_231', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup231.<anonymous>' call
    this_10.fileName = 'imported/cemetery_Group_231';
    tmp_9.m19_1 = this_10;
    var tmp_10 = this;
    // Inline function 'kotlin.apply' call
    var this_11 = MeshConstructor2('cemetery_Group_235', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup235.<anonymous>' call
    this_11.fileName = 'imported/cemetery_Group_235';
    tmp_10.n19_1 = this_11;
    var tmp_11 = this;
    // Inline function 'kotlin.apply' call
    var this_12 = MeshConstructor2('cemetery_Group_234', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup234.<anonymous>' call
    this_12.fileName = 'imported/cemetery_Group_234';
    tmp_11.o19_1 = this_12;
    var tmp_12 = this;
    // Inline function 'kotlin.apply' call
    var this_13 = MeshConstructor2('cemetery_Group_224', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup224.<anonymous>' call
    this_13.fileName = 'imported/cemetery_Group_224';
    tmp_12.p19_1 = this_13;
    var tmp_13 = this;
    // Inline function 'kotlin.apply' call
    var this_14 = MeshConstructor2('cemetery_Group_208', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup208.<anonymous>' call
    this_14.fileName = 'imported/cemetery_Group_208';
    tmp_13.q19_1 = this_14;
    var tmp_14 = this;
    // Inline function 'kotlin.apply' call
    var this_15 = MeshConstructor2('cemetery_Group_228', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup228.<anonymous>' call
    this_15.fileName = 'imported/cemetery_Group_228';
    tmp_14.r19_1 = this_15;
    var tmp_15 = this;
    // Inline function 'kotlin.apply' call
    var this_16 = MeshConstructor2('cemetery_Group_215', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup215.<anonymous>' call
    this_16.fileName = 'imported/cemetery_Group_215';
    tmp_15.s19_1 = this_16;
    var tmp_16 = this;
    // Inline function 'kotlin.apply' call
    var this_17 = MeshConstructor2('cemetery_Group_279', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup279.<anonymous>' call
    this_17.fileName = 'imported/cemetery_Group_279';
    tmp_16.t19_1 = this_17;
    var tmp_17 = this;
    // Inline function 'kotlin.apply' call
    var this_18 = MeshConstructor2('cemetery_Group_7', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup7.<anonymous>' call
    this_18.fileName = 'imported/cemetery_Group_7';
    tmp_17.u19_1 = this_18;
    var tmp_18 = this;
    // Inline function 'kotlin.apply' call
    var this_19 = MeshConstructor2('cemetery_Group_204', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup204.<anonymous>' call
    this_19.fileName = 'imported/cemetery_Group_204';
    tmp_18.v19_1 = this_19;
    var tmp_19 = this;
    // Inline function 'kotlin.apply' call
    var this_20 = MeshConstructor2('cemetery_Group_226', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup226.<anonymous>' call
    this_20.fileName = 'imported/cemetery_Group_226';
    tmp_19.w19_1 = this_20;
    var tmp_20 = this;
    // Inline function 'kotlin.apply' call
    var this_21 = MeshConstructor2('cemetery_Group_202', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup202.<anonymous>' call
    this_21.fileName = 'imported/cemetery_Group_202';
    tmp_20.x19_1 = this_21;
    var tmp_21 = this;
    // Inline function 'kotlin.apply' call
    var this_22 = MeshConstructor2('cemetery_Group_201', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup201.<anonymous>' call
    this_22.fileName = 'imported/cemetery_Group_201';
    tmp_21.y19_1 = this_22;
    var tmp_22 = this;
    // Inline function 'kotlin.apply' call
    var this_23 = MeshConstructor2('cemetery_Group_270', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup270.<anonymous>' call
    this_23.fileName = 'imported/cemetery_Group_270';
    tmp_22.z19_1 = this_23;
    var tmp_23 = this;
    // Inline function 'kotlin.apply' call
    var this_24 = MeshConstructor2('cemetery_Group_280', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup280.<anonymous>' call
    this_24.fileName = 'imported/cemetery_Group_280';
    tmp_23.a1a_1 = this_24;
    var tmp_24 = this;
    // Inline function 'kotlin.apply' call
    var this_25 = MeshConstructor2('cemetery_Group_205', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup205.<anonymous>' call
    this_25.fileName = 'imported/cemetery_Group_205';
    tmp_24.b1a_1 = this_25;
    var tmp_25 = this;
    // Inline function 'kotlin.apply' call
    var this_26 = MeshConstructor2('cemetery_Group_223', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup223.<anonymous>' call
    this_26.fileName = 'imported/cemetery_Group_223';
    tmp_25.c1a_1 = this_26;
    var tmp_26 = this;
    // Inline function 'kotlin.apply' call
    var this_27 = MeshConstructor2('cemetery_Group_277', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup277.<anonymous>' call
    this_27.fileName = 'imported/cemetery_Group_277';
    tmp_26.d1a_1 = this_27;
    var tmp_27 = this;
    // Inline function 'kotlin.apply' call
    var this_28 = MeshConstructor2('cemetery_Group_3', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup3.<anonymous>' call
    this_28.fileName = 'imported/cemetery_Group_3';
    tmp_27.e1a_1 = this_28;
    var tmp_28 = this;
    // Inline function 'kotlin.apply' call
    var this_29 = MeshConstructor2('cemetery_Group_237', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup237.<anonymous>' call
    this_29.fileName = 'imported/cemetery_Group_237';
    tmp_28.f1a_1 = this_29;
    var tmp_29 = this;
    // Inline function 'kotlin.apply' call
    var this_30 = MeshConstructor2('cemetery_Group_211', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup211.<anonymous>' call
    this_30.fileName = 'imported/cemetery_Group_211';
    tmp_29.g1a_1 = this_30;
    var tmp_30 = this;
    // Inline function 'kotlin.apply' call
    var this_31 = MeshConstructor2('cemetery_Group_243', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup243.<anonymous>' call
    this_31.fileName = 'imported/cemetery_Group_243';
    tmp_30.h1a_1 = this_31;
    var tmp_31 = this;
    // Inline function 'kotlin.apply' call
    var this_32 = MeshConstructor2('cemetery_Group_273', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup273.<anonymous>' call
    this_32.fileName = 'imported/cemetery_Group_273';
    tmp_31.i1a_1 = this_32;
    var tmp_32 = this;
    // Inline function 'kotlin.apply' call
    var this_33 = MeshConstructor2('cemetery_Group_274', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup274.<anonymous>' call
    this_33.fileName = 'imported/cemetery_Group_274';
    tmp_32.j1a_1 = this_33;
    var tmp_33 = this;
    // Inline function 'kotlin.apply' call
    var this_34 = MeshConstructor2('cemetery_Group_238', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup238.<anonymous>' call
    this_34.fileName = 'imported/cemetery_Group_238';
    tmp_33.k1a_1 = this_34;
    var tmp_34 = this;
    // Inline function 'kotlin.apply' call
    var this_35 = MeshConstructor2('cemetery_Group_241', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup241.<anonymous>' call
    this_35.fileName = 'imported/cemetery_Group_241';
    tmp_34.l1a_1 = this_35;
    var tmp_35 = this;
    // Inline function 'kotlin.apply' call
    var this_36 = MeshConstructor2('cemetery_Group_210', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup210.<anonymous>' call
    this_36.fileName = 'imported/cemetery_Group_210';
    tmp_35.m1a_1 = this_36;
    var tmp_36 = this;
    // Inline function 'kotlin.apply' call
    var this_37 = MeshConstructor2('cemetery_Group_242', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup242.<anonymous>' call
    this_37.fileName = 'imported/cemetery_Group_242';
    tmp_36.n1a_1 = this_37;
    var tmp_37 = this;
    // Inline function 'kotlin.apply' call
    var this_38 = MeshConstructor2('cemetery_Group_206', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup206.<anonymous>' call
    this_38.fileName = 'imported/cemetery_Group_206';
    tmp_37.o1a_1 = this_38;
    var tmp_38 = this;
    // Inline function 'kotlin.apply' call
    var this_39 = MeshConstructor2('cemetery_Group_282', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup282.<anonymous>' call
    this_39.fileName = 'imported/cemetery_Group_282';
    tmp_38.p1a_1 = this_39;
    var tmp_39 = this;
    // Inline function 'kotlin.apply' call
    var this_40 = MeshConstructor2('cemetery_Group_281', this.b19_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeMeshes.meshCemeteryGroup281.<anonymous>' call
    this_40.fileName = 'imported/cemetery_Group_281';
    tmp_39.q1a_1 = this_40;
    this.r1a_1 = mutableListOf([this.c19_1, this.d19_1, this.e19_1, this.f19_1, this.g19_1, this.h19_1, this.i19_1, this.j19_1, this.k19_1, this.l19_1, this.m19_1, this.n19_1, this.o19_1, this.p19_1, this.q19_1, this.r19_1, this.s19_1, this.t19_1, this.u19_1, this.v19_1, this.w19_1, this.x19_1, this.y19_1, this.z19_1, this.a1a_1, this.b1a_1, this.c1a_1, this.d1a_1, this.e1a_1, this.f1a_1, this.g1a_1, this.h1a_1, this.i1a_1, this.j1a_1, this.k1a_1, this.l1a_1, this.m1a_1, this.n1a_1, this.o1a_1, this.p1a_1, this.q1a_1]);
  }
  var ImportedAssetForgeMeshes_instance_0;
  function ImportedAssetForgeMeshes_getInstance_0() {
    if (ImportedAssetForgeMeshes_instance_0 == null)
      new ImportedAssetForgeMeshes_0();
    return ImportedAssetForgeMeshes_instance_0;
  }
  function ImportedAssetForgeTextures_0() {
    ImportedAssetForgeTextures_instance_0 = this;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeTextures.texKayForestFreeForestTexture.<anonymous>' call
    this_0.name = 'imported/kay-forest-free_forest_texture';
    this_0.fileName = 'imported/kay-forest-free_forest_texture';
    this_0.format = TextureFormat_ASTC_getInstance();
    this_0.wrapping = TextureWrapping_REPEAT_getInstance();
    this_0.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_0.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_0.mipmaps = 8;
    tmp.s1a_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ImportedAssetForgeTextures.texKayHalloweenHalloweenbitsTexture.<anonymous>' call
    this_1.name = 'imported/kay-halloween_halloweenbits_texture';
    this_1.fileName = 'imported/kay-halloween_halloweenbits_texture';
    this_1.format = TextureFormat_ASTC_getInstance();
    this_1.wrapping = TextureWrapping_REPEAT_getInstance();
    this_1.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_1.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_1.mipmaps = 8;
    tmp_0.t1a_1 = this_1;
    this.u1a_1 = mutableListOf([this.s1a_1, this.t1a_1]);
  }
  var ImportedAssetForgeTextures_instance_0;
  function ImportedAssetForgeTextures_getInstance_0() {
    if (ImportedAssetForgeTextures_instance_0 == null)
      new ImportedAssetForgeTextures_0();
    return ImportedAssetForgeTextures_instance_0;
  }
  function LeavesParticleSystemConfig_0(particleCount, minX, maxX, minY, maxY, height, size, speed, amplitude, frequency, rotationSpeed, baseRotation, positionJitter) {
    particleCount = particleCount === VOID ? 18 : particleCount;
    minX = minX === VOID ? -30.0 : minX;
    maxX = maxX === VOID ? 30.0 : maxX;
    minY = minY === VOID ? -22.0 : minY;
    maxY = maxY === VOID ? 28.0 : maxY;
    height = height === VOID ? 3.5 : height;
    size = size === VOID ? 0.75 : size;
    speed = speed === VOID ? 1.5 : speed;
    amplitude = amplitude === VOID ? new Vec3(4.0, 4.0, 2.0) : amplitude;
    frequency = frequency === VOID ? new Vec3(0.3, 0.3, 0.1) : frequency;
    rotationSpeed = rotationSpeed === VOID ? new Vec3(85.0, 73.0, 81.0) : rotationSpeed;
    baseRotation = baseRotation === VOID ? new Vec3(0.0, 90.0, 0.0) : baseRotation;
    positionJitter = positionJitter === VOID ? 0.6 : positionJitter;
    this.v1a_1 = particleCount;
    this.w1a_1 = minX;
    this.x1a_1 = maxX;
    this.y1a_1 = minY;
    this.z1a_1 = maxY;
    this.a1b_1 = height;
    this.b1b_1 = size;
    this.c1b_1 = speed;
    this.d1b_1 = amplitude;
    this.e1b_1 = frequency;
    this.f1b_1 = rotationSpeed;
    this.g1b_1 = baseRotation;
    this.h1b_1 = positionJitter;
    this.i1b_1 = 3;
  }
  protoOf(LeavesParticleSystemConfig_0).toString = function () {
    return 'LeavesParticleSystemConfig(particleCount=' + this.v1a_1 + ', minX=' + this.w1a_1 + ', maxX=' + this.x1a_1 + ', minY=' + this.y1a_1 + ', maxY=' + this.z1a_1 + ', height=' + this.a1b_1 + ', size=' + this.b1b_1 + ', speed=' + this.c1b_1 + ', amplitude=' + this.d1b_1 + ', frequency=' + this.e1b_1 + ', rotationSpeed=' + this.f1b_1 + ', baseRotation=' + this.g1b_1 + ', positionJitter=' + this.h1b_1 + ')';
  };
  protoOf(LeavesParticleSystemConfig_0).hashCode = function () {
    var result = this.v1a_1;
    result = imul(result, 31) + getNumberHashCode(this.w1a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x1a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y1a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z1a_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.a1b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b1b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c1b_1) | 0;
    result = imul(result, 31) + this.d1b_1.hashCode() | 0;
    result = imul(result, 31) + this.e1b_1.hashCode() | 0;
    result = imul(result, 31) + this.f1b_1.hashCode() | 0;
    result = imul(result, 31) + this.g1b_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.h1b_1) | 0;
    return result;
  };
  protoOf(LeavesParticleSystemConfig_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LeavesParticleSystemConfig_0))
      return false;
    var tmp0_other_with_cast = other instanceof LeavesParticleSystemConfig_0 ? other : THROW_CCE();
    if (!(this.v1a_1 === tmp0_other_with_cast.v1a_1))
      return false;
    if (!equals(this.w1a_1, tmp0_other_with_cast.w1a_1))
      return false;
    if (!equals(this.x1a_1, tmp0_other_with_cast.x1a_1))
      return false;
    if (!equals(this.y1a_1, tmp0_other_with_cast.y1a_1))
      return false;
    if (!equals(this.z1a_1, tmp0_other_with_cast.z1a_1))
      return false;
    if (!equals(this.a1b_1, tmp0_other_with_cast.a1b_1))
      return false;
    if (!equals(this.b1b_1, tmp0_other_with_cast.b1b_1))
      return false;
    if (!equals(this.c1b_1, tmp0_other_with_cast.c1b_1))
      return false;
    if (!this.d1b_1.equals(tmp0_other_with_cast.d1b_1))
      return false;
    if (!this.e1b_1.equals(tmp0_other_with_cast.e1b_1))
      return false;
    if (!this.f1b_1.equals(tmp0_other_with_cast.f1b_1))
      return false;
    if (!this.g1b_1.equals(tmp0_other_with_cast.g1b_1))
      return false;
    if (!equals(this.h1b_1, tmp0_other_with_cast.h1b_1))
      return false;
    return true;
  };
  function Particle_0(command, progress, seed, rotationSeed, laneY, heightOffset) {
    this.j1b_1 = command;
    this.k1b_1 = progress;
    this.l1b_1 = seed;
    this.m1b_1 = rotationSeed;
    this.n1b_1 = laneY;
    this.o1b_1 = heightOffset;
  }
  function advance_0($this) {
    var trackLength = $this.p1b_1.x1a_1 - $this.p1b_1.w1a_1;
    var twoPi = 2 * get_PI();
    var tmp0_iterator = $this.r1b_1.j();
    while (tmp0_iterator.k()) {
      var particle = tmp0_iterator.l();
      var progress = particle.k1b_1 + $this.s1b_1 * $this.p1b_1.c1b_1 / trackLength;
      var tmp = progress;
      // Inline function 'kotlin.math.floor' call
      var x = progress;
      progress = tmp - Math.floor(x);
      var transform = particle.j1b_1.transform;
      var tmp_0 = transform.y9_1;
      var tmp_1 = $this.p1b_1.w1a_1 + progress * trackLength;
      // Inline function 'kotlin.math.sin' call
      var x_0 = ($this.s1b_1 + particle.l1b_1) * twoPi * $this.p1b_1.e1b_1.x;
      tmp_0.x = tmp_1 + Math.sin(x_0) * $this.p1b_1.d1b_1.x;
      var tmp_2 = transform.y9_1;
      // Inline function 'kotlin.math.sin' call
      var x_1 = ($this.s1b_1 + particle.l1b_1 * 1.7) * twoPi * $this.p1b_1.e1b_1.y;
      var tmp$ret$2 = Math.sin(x_1);
      tmp_2.y = particle.n1b_1 + tmp$ret$2 * $this.p1b_1.d1b_1.y;
      var tmp_3 = transform.y9_1;
      var tmp_4 = $this.p1b_1.a1b_1 + particle.o1b_1;
      // Inline function 'kotlin.math.sin' call
      var x_2 = ($this.s1b_1 + particle.l1b_1 * 2.3) * twoPi * $this.p1b_1.e1b_1.z;
      tmp_3.z = tmp_4 + Math.sin(x_2) * $this.p1b_1.d1b_1.z;
      transform.z9_1.x = angle_0($this, $this.p1b_1.g1b_1.x + ($this.s1b_1 + particle.m1b_1.x) * $this.p1b_1.f1b_1.x);
      transform.z9_1.y = angle_0($this, $this.p1b_1.g1b_1.y + ($this.s1b_1 + particle.m1b_1.y) * $this.p1b_1.f1b_1.y);
      transform.z9_1.z = angle_0($this, $this.p1b_1.g1b_1.z + ($this.s1b_1 + particle.m1b_1.z) * $this.p1b_1.f1b_1.z);
    }
  }
  function angle_0($this, degrees) {
    var wrapped = degrees % 360.0;
    return wrapped < 0.0 ? wrapped + 360.0 : wrapped;
  }
  function Companion_4() {
    this.t1b_1 = 0.1;
  }
  var Companion_instance_7;
  function Companion_getInstance_4() {
    return Companion_instance_7;
  }
  function LeavesParticleSystem_0(mesh, texture, config) {
    config = config === VOID ? new LeavesParticleSystemConfig_0() : config;
    this.p1b_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.q1b_1 = ArrayList_init_$Create$_0();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.r1b_1 = ArrayList_init_$Create$_0();
    this.s1b_1 = 0.0;
    var random = Default_getInstance();
    var trackLength = this.p1b_1.x1a_1 - this.p1b_1.w1a_1;
    var laneSpacing = (this.p1b_1.z1a_1 - this.p1b_1.y1a_1) / this.p1b_1.v1a_1;
    var atlas = this.p1b_1.i1b_1;
    var halfSize = this.p1b_1.b1b_1 / 2.0;
    var inductionVariable = 0;
    var last = this.p1b_1.v1a_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var jitter = (random.c6() - 0.5) * this.p1b_1.h1b_1;
        // Inline function 'kotlin.apply' call
        var this_0 = UniformFloatValueWithArray(new Float32Array(2));
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'org.androidworks.example.LeavesParticleSystem.<anonymous>' call
        this_0.value[0] = (i % atlas | 0) / atlas;
        this_0.value[1] = ((i / atlas | 0) % atlas | 0) / atlas;
        var textureOffset = this_0;
        var command = DrawStaticMeshCommandConstructor(mesh, listOf([UniformFloatValueWithArray(new Float32Array(16)), textureOffset, new UniformTextureValue(texture), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), new DrawMeshState(CommonAssetForgeShaders_getInstance().sy_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_DISABLED_getInstance(), Companion_instance.fromMeshAndShader(mesh, CommonAssetForgeShaders_getInstance().sy_1)), new AffineTranformation(new Vec3(this.p1b_1.w1a_1, 0.0, this.p1b_1.a1b_1), new Vec3(this.p1b_1.g1b_1.x, this.p1b_1.g1b_1.y, this.p1b_1.g1b_1.z), new Vec3(halfSize, halfSize, halfSize)));
        this.r1b_1.g(new Particle_0(command, random.c6(), random.c6() * 100.0, new Vec3(random.c6() * 360.0, random.c6() * 360.0, random.c6() * 360.0), this.p1b_1.y1a_1 + (i + 0.5) * laneSpacing + jitter * laneSpacing, (random.c6() - 0.5) * this.p1b_1.a1b_1 * 0.1));
        this.q1b_1.g(command);
      }
       while (inductionVariable < last);
    advance_0(this);
  }
  protoOf(LeavesParticleSystem_0).j13 = function (deltaTime) {
    this.s1b_1 = this.s1b_1 + coerceIn(deltaTime, 0.0, 0.1);
    advance_0(this);
  };
  function Meshes_3() {
    Meshes_instance_3 = this;
    this.g18_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6)]), 12);
    this.h18_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6), new MeshAttribute(AttributeType_UV1_getInstance(), VertexFormat_HALF2_getInstance(), 10)]), 16);
    this.i18_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_UBYTE2_NORMALIZED_getInstance(), 6)]), 8);
    this.j18_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_UBYTE2_NORMALIZED_getInstance(), 6), new MeshAttribute(AttributeType_NORMAL_getInstance(), VertexFormat_BYTE3_NORMALIZED_getInstance(), 8)]), 12);
    this.k18_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_FLOAT3_getInstance(), 0)), 12);
    this.l18_1 = MeshConstructor2('quad', this.g18_1);
    this.m18_1 = MeshConstructor2('boat', this.g18_1);
    this.n18_1 = MeshConstructor2('water', this.i18_1);
    this.o18_1 = MeshConstructor2('clouds', this.g18_1);
    this.p18_1 = MeshConstructor2('stars', this.k18_1);
    this.q18_1 = MeshConstructor2('flag-triangle', this.i18_1);
    this.r18_1 = MeshConstructor2('rocks', this.j18_1);
    this.s18_1 = MeshConstructor2('ship', this.h18_1);
    this.t18_1 = MeshConstructor2('lantern', this.h18_1);
    this.u18_1 = MeshConstructor2('box', this.h18_1);
    this.v18_1 = MeshConstructor2('ground', this.h18_1);
    this.w18_1 = MeshConstructor2('grass', this.h18_1);
    this.x18_1 = MeshConstructor2('tree_leaves', this.g18_1);
    this.y18_1 = MeshConstructor2('tree_trunks', this.i18_1);
    this.z18_1 = MeshConstructor2('bat1');
    this.a19_1 = mutableListOf([this.m18_1, this.n18_1, this.o18_1, this.p18_1, this.z18_1, this.q18_1, this.r18_1, this.s18_1, this.t18_1, this.u18_1, this.v18_1, this.w18_1, this.x18_1, this.y18_1, this.l18_1]);
  }
  var Meshes_instance_3;
  function Meshes_getInstance_3() {
    if (Meshes_instance_3 == null)
      new Meshes_3();
    return Meshes_instance_3;
  }
  function applySettings_2($this) {
    if (!($this.cameraAnimator.minDurationCoefficient === $this.settings.cameraPeriod)) {
      $this.cameraAnimator.minDurationCoefficient = $this.settings.cameraPeriod;
    }
    $this.c1c_1.enabled = $this.settings.renderMode.equals(RenderMode_Complete_getInstance_0()) ? true : $this.settings.renderMode.equals(RenderMode_SsaoOnly_getInstance_0());
    $this.d1c_1.enabled = $this.settings.renderMode.equals(RenderMode_CompleteWithLm_getInstance_0());
    $this.e1c_1.enabled = $this.settings.renderMode.equals(RenderMode_DiffuseOnly_getInstance_0());
    $this.f1c_1.enabled = $this.settings.renderMode.equals(RenderMode_ModelNormals_getInstance_0());
    $this.g1c_1.enabled = $this.settings.renderMode.equals(RenderMode_Lambert_getInstance_0());
    $this.j1c_1.enabled = $this.settings.renderMode.equals(RenderMode_SsaoOnly_getInstance_0());
    updateShaderParams_0($this);
    if (($this.cameraAnimator.timer > 0.99 ? $this.settings.autoSwitchCameras : false) ? Default_getInstance().c6() < 0.5 : false) {
      $this.randomCamera();
    }
    $this.Z_FAR = $this.settings.fogStartDistance + $this.settings.fogDistance;
  }
  function updateShaderParams_0($this) {
    var light = $this.settings.lightDirection;
    setUniform(CommonAssetForgeShaders_getInstance().wy_1, light.x, light.y, light.z, $this.settings.lightExponent);
    var ambient = $this.settings.ambientColor;
    setUniform_3(CommonAssetForgeShaders_getInstance().xy_1, ambient.r, ambient.g, ambient.b);
    var fogColor = $this.settings.fogColor;
    setUniform(CommonAssetForgeShaders_getInstance().yy_1, fogColor.r, fogColor.g, fogColor.b, 1.0);
    setUniform_1(CommonAssetForgeShaders_getInstance().zy_1, $this.settings.fogStartDistance);
    setUniform_1(CommonAssetForgeShaders_getInstance().az_1, $this.settings.fogDistance);
    setUniform_0(CommonAssetForgeShaders_getInstance().bz_1, $this.settings.lmScaleX, -$this.settings.lmScaleY);
    var lmColor = $this.settings.lmColor;
    setUniform_3(CommonAssetForgeShaders_getInstance().cz_1, lmColor.r, lmColor.g, lmColor.b);
    setUniform_0(CommonAssetForgeShaders_getInstance().dz_1, $this.settings.lmHeightMax, $this.settings.lmHeightStartFade);
    setUniform_1(CommonAssetForgeShaders_getInstance().ez_1, $this.settings.lmBrightness);
    setUniform_0(CommonAssetForgeShaders_getInstance().gz_1, $this.z1b_1.nj(Timers_GhostAnim1_getInstance_0()), $this.z1b_1.nj(Timers_GhostAnim2_getInstance_0()));
    $this.h1c_1.color.r = fogColor.r;
    $this.h1c_1.color.g = fogColor.g;
    $this.h1c_1.color.b = fogColor.b;
    $this.h1c_1.color.a = 1.0;
  }
  function animate_2($this, time) {
    applySettings_2($this);
    positionCamera_2($this, time);
    $this.calculateProjection();
    cullImportedModels_0($this);
    $this.k1c_1.j13((time - $this.lastFrameTime) / 1000.0);
    updateGhosts_0($this);
    updateBirds_1($this);
    var flicker = $this.z1b_1.nj(Timers_FlameFlicker_getInstance_0()) * (2.0 * get_PI()) * 2.0;
    var flames = Flames_getInstance_0().c18_1.commands;
    var inductionVariable = 0;
    var last = flames.m() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = flames.t(index);
        var command = tmp instanceof DrawTransformedMeshCommand ? tmp : THROW_CCE();
        var t = flicker + index;
        // Inline function 'kotlin.math.sin' call
        var tmp_0 = 2.0 + Math.sin(t);
        // Inline function 'kotlin.math.cos' call
        var x = t * 3.31;
        var scaleZ = (tmp_0 + Math.cos(x)) / 4.0;
        command.transform.aa_1.z = 0.09 + 0.06 * scaleZ;
      }
       while (inductionVariable <= last);
    $this.updateMeshTransformations($this.commands);
  }
  function cullImportedModels_0($this) {
    Matrix_getInstance().x9($this.m1c_1, 0, $this.matProjection, 0, $this.matView, 0);
    var commands = activeImportedCommands_0($this);
    $this.o1c_1 = cullDrawCalls(commands, ImportedAssetForgeCommands_getInstance_0().e15_1, $this.m1c_1);
    $this.n1c_1 = commands.m();
  }
  function activeImportedCommands_0($this) {
    var tmp;
    switch ($this.settings.renderMode.n4_1) {
      case 0:
      case 5:
        tmp = ImportedAssetForgeCommands_getInstance_0().z14_1;
        break;
      case 4:
        tmp = ImportedAssetForgeCommands_getInstance_0().a15_1;
        break;
      case 1:
        tmp = ImportedAssetForgeCommands_getInstance_0().b15_1;
        break;
      case 2:
        tmp = ImportedAssetForgeCommands_getInstance_0().c15_1;
        break;
      case 3:
        tmp = ImportedAssetForgeCommands_getInstance_0().d15_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function positionCamera_2($this, time) {
    if ($this.useExternalViewMatrix) {
      return Unit_instance;
    }
    if ($this.settings.cameraMode.equals(CameraMode_Random_getInstance_1())) {
      var cameraPositionInterpolator = $this.cameraAnimator.positionInterpolator;
      var eye = cameraPositionInterpolator.cameraPosition;
      var lookat = cameraPositionInterpolator.cameraRotation;
      Matrix_getInstance().di($this.matView, 0, eye.x, eye.y, eye.z, lookat.x, lookat.y, lookat.z, 0.0, 0.0, 1.0);
    } else if ($this.settings.cameraMode.equals(CameraMode_Orbiting_getInstance_1())) {
      var deltaTime = time - $this.lastFrameTime;
      var timerBobX = $this.z1b_1.nj(Timers_OrbitingCameraX_getInstance_1());
      var timerBobZ = $this.z1b_1.nj(Timers_OrbitingCameraZ_getInstance_1());
      $this.orbitingCamera.uj_1.fk_1 = $this.settings.cameraPeriod;
      $this.orbitingCamera.yj(deltaTime, timerBobX, timerBobZ);
      Matrix_getInstance().xh($this.orbitingCamera.xj_1, 0, $this.matView, 0, 16);
    }
  }
  function setBirdPosition_1($this, angle, centerX, centerY, radius, translation) {
    // Inline function 'kotlin.math.sin' call
    translation.x = Math.sin(angle) * radius + centerX;
    // Inline function 'kotlin.math.cos' call
    translation.y = Math.cos(angle) * radius + centerY;
  }
  function updateGhosts_0($this) {
    var tmp = Ghosts_getInstance_0().f18_1.commands;
    var commands = isInterface(tmp, List) ? tmp : THROW_CCE();
    var angle = $this.z1b_1.nj(Timers_GhostMove_getInstance_0()) * get_PIf() * 2.0;
    // Inline function 'kotlin.math.sin' call
    var x = $this.z1b_1.nj(Timers_GhostBob_getInstance_0()) * get_PIf() * 2.0;
    var bob0 = Math.sin(x) * 0.3;
    // Inline function 'kotlin.math.cos' call
    var x_0 = $this.z1b_1.nj(Timers_GhostBob_getInstance_0()) * get_PIf() * 2.0;
    var bob1 = Math.cos(x_0) * 0.3;
    setBirdPosition_1($this, angle, -2.0, 8.0, $this.s1c_1, commands.t(0).transform.y9_1);
    setBirdPosition_1($this, -angle - get_PIf(), 3.0, -6.0, $this.s1c_1, commands.t(1).transform.y9_1);
    setBirdPosition_1($this, -angle - get_PIf(), 3.0, 5.0, $this.s1c_1, commands.t(2).transform.y9_1);
    setBirdPosition_1($this, angle, 7.0, 3.0, $this.s1c_1, commands.t(3).transform.y9_1);
    setBirdPosition_1($this, -angle - get_PIf(), 19.0, -2.0, $this.s1c_1 * 1.2, commands.t(4).transform.y9_1);
    commands.t(0).transform.z9_1.z = (-angle - get_PIf() / 2.0) * 57.29578;
    commands.t(1).transform.z9_1.z = (angle - get_PIf() / 2.0) * 57.29578;
    commands.t(2).transform.z9_1.z = (angle - get_PIf() / 2.0) * 57.29578;
    commands.t(3).transform.z9_1.z = (-angle - get_PIf() / 2.0) * 57.29578;
    commands.t(4).transform.z9_1.z = (angle - get_PIf() / 2.0) * 57.29578;
    commands.t(0).transform.y9_1.z = 0.6 + bob0;
    commands.t(1).transform.y9_1.z = 0.6 + bob1;
    commands.t(2).transform.y9_1.z = 0.6 + bob0;
    commands.t(3).transform.y9_1.z = 0.6 + bob1;
    commands.t(4).transform.y9_1.z = 0.6 + bob0;
  }
  function updateBirds_1($this) {
    var tmp = $this.groupBirds.commands;
    var commands = isInterface(tmp, List) ? tmp : THROW_CCE();
    var angle = $this.z1b_1.nj(Timers_BirdsFly_getInstance_1()) * get_PIf() * 2.0;
    // Inline function 'kotlin.math.sin' call
    var x = $this.z1b_1.nj(Timers_BirdsBob_getInstance_0()) * get_PIf() * 2.0;
    var bob0 = (Math.sin(x) + 1.0) * 0.6;
    // Inline function 'kotlin.math.cos' call
    var x_0 = $this.z1b_1.nj(Timers_BirdsBob_getInstance_0()) * get_PIf() * 2.0;
    var bob1 = (Math.cos(x_0) + 1.0) * 0.6;
    setBirdPosition_1($this, angle, -10.0, 0.0, $this.BIRD_FLIGHT_RADIUS, commands.t(0).transform.y9_1);
    setBirdPosition_1($this, -angle - get_PIf(), -12.0, 0.0, $this.BIRD_FLIGHT_RADIUS, commands.t(1).transform.y9_1);
    setBirdPosition_1($this, -angle - get_PIf(), 20.0, 8.0, $this.BIRD_FLIGHT_RADIUS, commands.t(2).transform.y9_1);
    setBirdPosition_1($this, angle, 20.0, -8.0, $this.BIRD_FLIGHT_RADIUS, commands.t(3).transform.y9_1);
    setBirdPosition_1($this, -angle - get_PIf(), 0.0, 0.0, $this.BIRD_FLIGHT_RADIUS * 1.55, commands.t(4).transform.y9_1);
    setBirdPosition_1($this, angle, 5.0, 7.0, $this.BIRD_FLIGHT_RADIUS, commands.t(5).transform.y9_1);
    commands.t(0).transform.z9_1.z = (-angle - get_PIf() / 2.0) * 57.29578;
    commands.t(1).transform.z9_1.z = (angle - get_PIf() / 2.0) * 57.29578;
    commands.t(2).transform.z9_1.z = (angle - get_PIf() / 2.0) * 57.29578;
    commands.t(3).transform.z9_1.z = (-angle - get_PIf() / 2.0) * 57.29578;
    commands.t(4).transform.z9_1.z = (angle - get_PIf() / 2.0) * 57.29578;
    commands.t(5).transform.z9_1.z = (-angle - get_PIf() / 2.0) * 57.29578;
    commands.t(0).transform.y9_1.z = bob0 + 3.4;
    commands.t(1).transform.y9_1.z = bob1 + 3.7;
    commands.t(2).transform.y9_1.z = bob0 + 5.0;
    commands.t(3).transform.y9_1.z = bob1 + 4.0;
    commands.t(4).transform.y9_1.z = bob0 + 3.8;
    commands.t(5).transform.y9_1.z = bob1 + 4.4;
    var wingTimer1 = $this.z1b_1.nj(Timers_BirdWings1_getInstance_1());
    var wingTimer2 = $this.z1b_1.nj(Timers_BirdWings2_getInstance_1());
    Animations_getInstance_1().f17_1.fc(wingTimer1, commands.t(0).uniforms.t(2), commands.t(0).uniforms.t(3), commands.t(0).uniforms.t(5));
    Animations_getInstance_1().f17_1.fc(wingTimer2, commands.t(1).uniforms.t(2), commands.t(1).uniforms.t(3), commands.t(1).uniforms.t(5));
    Animations_getInstance_1().f17_1.fc(wingTimer1 + 0.3, commands.t(2).uniforms.t(2), commands.t(2).uniforms.t(3), commands.t(2).uniforms.t(5));
    Animations_getInstance_1().f17_1.fc(wingTimer2 + 0.5, commands.t(3).uniforms.t(2), commands.t(3).uniforms.t(3), commands.t(3).uniforms.t(5));
    Animations_getInstance_1().f17_1.fc(wingTimer1 + 0.5, commands.t(4).uniforms.t(2), commands.t(4).uniforms.t(3), commands.t(4).uniforms.t(5));
    Animations_getInstance_1().f17_1.fc(wingTimer2 + 0.6, commands.t(5).uniforms.t(2), commands.t(5).uniforms.t(3), commands.t(5).uniforms.t(5));
  }
  function ExampleScene() {
    Scene.call(this);
    this.z1b_1 = new TimersMap();
    this.BIRD_FLIGHT_RADIUS = 11.0;
    this.drawCallBounds = ImportedAssetForgeCommands_getInstance_0().e15_1;
    this.m1c_1 = new Float32Array(16);
    this.n1c_1 = 0;
    this.o1c_1 = 0;
    this.p1c_1 = 1000000.0;
    this.q1c_1 = 23000.0;
    this.r1c_1 = 2000.0;
    this.s1c_1 = 11.0;
    this.meshes.h(ImportedAssetForgeMeshes_getInstance_0().r1a_1);
    this.meshes.g(Meshes_getInstance_3().l18_1);
    this.meshes.g(Flames_getInstance_0().a18_1);
    this.meshes.g(Ghosts_getInstance_0().d18_1);
    this.meshes.g(Meshes_getInstance_3().z18_1);
    this.textures.h(ImportedAssetForgeTextures_getInstance_0().u1a_1);
    this.textures.g(Textures_getInstance_3().s17_1);
    this.textures.g(Textures_getInstance_3().v17_1);
    this.textures.g(Textures_getInstance_3().w17_1);
    this.textures.g(CommonAssetForgeTextures_getInstance_0().i17_1);
    this.shaders.h(CommonAssetForgeShaders_getInstance().vy_1);
    this.shaders.g(Shaders_getInstance_3().c1d_1);
    Companion_instance_8.f1d(this.z1b_1);
    this.Z_NEAR = 0.5;
    this.Z_FAR = 38.0;
    this.FOV_LANDSCAPE = 50.0;
    this.FOV_PORTRAIT = 65.0;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new ShipwreckSettings();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ExampleScene.<anonymous>' call
    this_0.cameraPeriod = 1.0;
    this_0.vignette = true;
    this_0.blurred = false;
    this_0.autoSwitchCameras = true;
    this_0.lowQuality = false;
    this_0.clock = false;
    this_0.timeOfDay = TimeOfDay_Day_getInstance_3();
    this_0.cameraMode = CameraMode_Random_getInstance_1();
    tmp.settings = this_0;
    var sceneCenter = new Vec3(0.0, 0.0, 0.5);
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new OrbitingCameraConfig();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ExampleScene.<anonymous>' call
    this_1.ck_1 = 15.0;
    this_1.bk_1 = 10.5;
    this_1.gk_1 = sceneCenter;
    tmp_0.orbitingCamera = new OrbitingCamera(this_1);
    this.cameraAnimator = new CameraPathAnimator(this.p1c_1 * 3.0, this.q1c_1 / 2.0, this.r1c_1, true);
    this.cameraAnimator.setCameras(Cameras_getInstance_3().g17_1);
    this.cameraAnimator.minDurationCoefficient = this.settings.cameraPeriod;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new ClearColorCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ExampleScene.<anonymous>' call
    this_2.color = new Vec4(this.settings.fogColor.x, this.settings.fogColor.y, this.settings.fogColor.z, 1.0);
    this_2.name = 'clear color';
    this_2.enabled = true;
    tmp_1.h1c_1 = this_2;
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = new ClearCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ExampleScene.<anonymous>' call
    this_3.clearType = ClearCommandClearType_COLOR_AND_DEPTH_getInstance();
    tmp_2.b1c_1 = GroupCommandArr(true, [this.h1c_1, this_3]);
    var tmp0_iterator = ImportedAssetForgeCommands_getInstance_0().a15_1.j();
    while (tmp0_iterator.k()) {
      var command = tmp0_iterator.l();
      var tmp_3;
      if (command instanceof DrawMeshCommand) {
        tmp_3 = command.mesh === ImportedAssetForgeMeshes_getInstance_0().q1a_1;
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        command.state.shader = CommonAssetForgeShaders_getInstance().oy_1;
      }
    }
    var tmp_4 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_4 = ImportedAssetForgeCommands_getInstance_0().z14_1;
    var tmp$ret$4 = copyToArray(this_4);
    tmp_4.c1c_1 = GroupCommandArr(true, tmp$ret$4.slice());
    var tmp_5 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_5 = ImportedAssetForgeCommands_getInstance_0().a15_1;
    var tmp$ret$5 = copyToArray(this_5);
    tmp_5.d1c_1 = GroupCommandArr(false, tmp$ret$5.slice());
    var tmp_6 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_6 = ImportedAssetForgeCommands_getInstance_0().b15_1;
    var tmp$ret$6 = copyToArray(this_6);
    tmp_6.e1c_1 = GroupCommandArr(false, tmp$ret$6.slice());
    var tmp_7 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_7 = ImportedAssetForgeCommands_getInstance_0().c15_1;
    var tmp$ret$7 = copyToArray(this_7);
    tmp_7.f1c_1 = GroupCommandArr(false, tmp$ret$7.slice());
    var tmp_8 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_8 = ImportedAssetForgeCommands_getInstance_0().d15_1;
    var tmp$ret$8 = copyToArray(this_8);
    tmp_8.g1c_1 = GroupCommandArr(false, tmp$ret$8.slice());
    var stateBird = new DrawMeshState(Shaders_getInstance_3().c1d_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_DISABLED_getInstance(), null);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$9 = new Float32Array([0.1640625, 0.1484375, 0.1171875, 1.0]);
    var uniformBatColor = UniformFloatValueWithArray(tmp$ret$9);
    this.groupBirds = GroupCommandArr(true, [new DrawTransformedMeshCommand(Meshes_getInstance_3().z18_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), uniformBatColor, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_3().s17_1), UniformFloatValueWithArray(new Float32Array(4)), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), stateBird, new AffineTranformation(new Vec3(0.0, 0.0, 3.4), new Vec3(0.0, 0.0, 0.0), new Vec3(0.04, 0.04, 0.06))), new DrawTransformedMeshCommand(Meshes_getInstance_3().z18_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), uniformBatColor, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_3().s17_1), UniformFloatValueWithArray(new Float32Array(4)), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), stateBird, new AffineTranformation(new Vec3(2.0, 0.0, 3.7), new Vec3(0.0, 0.0, 0.0), new Vec3(0.04, 0.04, 0.06))), new DrawTransformedMeshCommand(Meshes_getInstance_3().z18_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), uniformBatColor, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_3().s17_1), UniformFloatValueWithArray(new Float32Array(4)), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), stateBird, new AffineTranformation(new Vec3(4.0, 0.0, 5.0), new Vec3(0.0, 0.0, 0.0), new Vec3(0.04, 0.04, 0.06))), new DrawTransformedMeshCommand(Meshes_getInstance_3().z18_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), uniformBatColor, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_3().s17_1), UniformFloatValueWithArray(new Float32Array(4)), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), stateBird, new AffineTranformation(new Vec3(6.0, 0.0, 4.0), new Vec3(0.0, 0.0, 0.0), new Vec3(0.04, 0.04, 0.06))), new DrawTransformedMeshCommand(Meshes_getInstance_3().z18_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), uniformBatColor, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_3().s17_1), UniformFloatValueWithArray(new Float32Array(4)), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), stateBird, new AffineTranformation(new Vec3(8.0, 0.0, 3.8), new Vec3(0.0, 0.0, 0.0), new Vec3(0.04, 0.04, 0.06))), new DrawTransformedMeshCommand(Meshes_getInstance_3().z18_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), uniformBatColor, UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_3().s17_1), UniformFloatValueWithArray(new Float32Array(4)), CommonAssetForgeShaders_getInstance().yy_1, CommonAssetForgeShaders_getInstance().zy_1, CommonAssetForgeShaders_getInstance().az_1]), stateBird, new AffineTranformation(new Vec3(10.0, 0.0, 4.4), new Vec3(0.0, 0.0, 0.0), new Vec3(0.04, 0.04, 0.06)))]);
    var tmp_9 = this;
    var tmp_10 = Meshes_getInstance_3().l18_1;
    var tmp_11 = Textures_getInstance_3().w17_1;
    var tmp1_minX = sceneCenter.x - 36;
    var tmp2_maxX = sceneCenter.x + 36;
    var tmp3_minY = sceneCenter.y - 30;
    var tmp4_maxY = sceneCenter.y + 30;
    tmp_9.k1c_1 = new LeavesParticleSystem_0(tmp_10, tmp_11, new LeavesParticleSystemConfig_0(VOID, tmp1_minX, tmp2_maxX, tmp3_minY, tmp4_maxY, 4.0, 0.85, 5.0));
    var tmp_12 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_9 = this.k1c_1.q1b_1;
    var tmp$ret$10 = copyToArray(this_9);
    tmp_12.l1c_1 = GroupCommandArr(true, tmp$ret$10.slice());
    var tmp_13 = this;
    // Inline function 'kotlin.apply' call
    var this_10 = new SsaoPassCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ExampleScene.<anonymous>' call
    this_10.name = 'ssao';
    this_10.enabled = true;
    this_10.resolutionScale = 0.8;
    this_10.blurSize = BlurSize_KERNEL_2_getInstance();
    this_10.radius = 32.0;
    this_10.depthRange = 0.9;
    this_10.bias = 0.05;
    this_10.intensity = 1.5;
    this_10.commands = mutableListOf([this.c1c_1, this.d1c_1, this.e1c_1, this.f1c_1, this.g1c_1]);
    this_10.id = 2;
    tmp_13.i1c_1 = this_10;
    var tmp_14 = this;
    // Inline function 'kotlin.apply' call
    var this_11 = new DrawSsaoCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ExampleScene.<anonymous>' call
    this_11.name = 'draw ssao';
    this_11.enabled = false;
    this_11.id = 2;
    tmp_14.j1c_1 = this_11;
    // Inline function 'kotlin.apply' call
    var this_12 = new VignetteCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.ExampleScene.<anonymous>' call
    this_12.color0 = new Vec4(0.45, 0.45, 0.45, 1.0);
    this_12.color1 = new Vec4(1.0, 1.0, 1.0, 1.0);
    var vignetteCommand = this_12;
    this.a1c_1 = GroupCommandArr(true, [this.i1c_1, MainPassCommandArr(true, [this.b1c_1, this.c1c_1, this.d1c_1, this.e1c_1, this.f1c_1, this.g1c_1, this.l1c_1, Flames_getInstance_0().c18_1, Ghosts_getInstance_0().f18_1, this.groupBirds, vignetteCommand]), this.j1c_1]);
    this.commands = mutableListOf([this.a1c_1]);
    updateShaderParams_0(this);
  }
  protoOf(ExampleScene).ro = function () {
    return this.groupBirds;
  };
  protoOf(ExampleScene).so = function () {
    return this.BIRD_FLIGHT_RADIUS;
  };
  protoOf(ExampleScene).mo = function () {
    return this.settings;
  };
  protoOf(ExampleScene).l15 = function () {
    return this.drawCallBounds;
  };
  protoOf(ExampleScene).m15 = function () {
    return this.n1c_1;
  };
  protoOf(ExampleScene).n15 = function () {
    return this.o1c_1;
  };
  protoOf(ExampleScene).ko = function () {
    return this.cameraAnimator;
  };
  protoOf(ExampleScene).yt = function () {
    return this.orbitingCamera;
  };
  protoOf(ExampleScene).updateTimers = function (time) {
    this.z1b_1.qj(time);
    this.cameraAnimator.animate(time);
    animate_2(this, time);
    protoOf(Scene).updateTimers.call(this, time);
  };
  protoOf(ExampleScene).updateViewportSize = function (width, height) {
    protoOf(Scene).updateViewportSize.call(this, width, height);
  };
  protoOf(ExampleScene).initialize = function () {
    this.randomCamera();
  };
  protoOf(ExampleScene).nextCamera = function () {
    this.randomCamera();
  };
  protoOf(ExampleScene).randomCamera = function () {
    if (this.cameraAnimator.state.equals(CameraState_TRANSITIONING_getInstance())) {
      return Unit_instance;
    }
    this.cameraAnimator.positionInterpolator.reverse = Default_getInstance().c6() < 0.5;
  };
  protoOf(ExampleScene).cameraImpulse = function (impulse) {
    this.orbitingCamera.wj_1 = impulse * this.settings.cameraPeriod;
  };
  var TimeOfDay_Day_instance_3;
  var TimeOfDay_Night_instance_3;
  var TimeOfDay_Sunrise_instance_3;
  var TimeOfDay_Sunset_instance_2;
  function values_8() {
    return [TimeOfDay_Day_getInstance_3(), TimeOfDay_Night_getInstance_3(), TimeOfDay_Sunrise_getInstance_3(), TimeOfDay_Sunset_getInstance_2()];
  }
  function valueOf_8(value) {
    switch (value) {
      case 'Day':
        return TimeOfDay_Day_getInstance_3();
      case 'Night':
        return TimeOfDay_Night_getInstance_3();
      case 'Sunrise':
        return TimeOfDay_Sunrise_getInstance_3();
      case 'Sunset':
        return TimeOfDay_Sunset_getInstance_2();
      default:
        TimeOfDay_initEntries_3();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var TimeOfDay_entriesInitialized_3;
  function TimeOfDay_initEntries_3() {
    if (TimeOfDay_entriesInitialized_3)
      return Unit_instance;
    TimeOfDay_entriesInitialized_3 = true;
    TimeOfDay_Day_instance_3 = new TimeOfDay_3('Day', 0, 0);
    TimeOfDay_Night_instance_3 = new TimeOfDay_3('Night', 1, 1);
    TimeOfDay_Sunrise_instance_3 = new TimeOfDay_3('Sunrise', 2, 2);
    TimeOfDay_Sunset_instance_2 = new TimeOfDay_3('Sunset', 3, 3);
  }
  function TimeOfDay_3(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  var CameraMode_Random_instance_1;
  var CameraMode_Orbiting_instance_1;
  function values_9() {
    return [CameraMode_Random_getInstance_1(), CameraMode_Orbiting_getInstance_1()];
  }
  function valueOf_9(value) {
    switch (value) {
      case 'Random':
        return CameraMode_Random_getInstance_1();
      case 'Orbiting':
        return CameraMode_Orbiting_getInstance_1();
      default:
        CameraMode_initEntries_1();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var CameraMode_entriesInitialized_1;
  function CameraMode_initEntries_1() {
    if (CameraMode_entriesInitialized_1)
      return Unit_instance;
    CameraMode_entriesInitialized_1 = true;
    CameraMode_Random_instance_1 = new CameraMode_1('Random', 0, 0);
    CameraMode_Orbiting_instance_1 = new CameraMode_1('Orbiting', 1, 1);
  }
  function CameraMode_1(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  var ColorMode_None_instance_1;
  var ColorMode_Sepia_instance_1;
  var ColorMode_Greyscale_instance_1;
  function values_10() {
    return [ColorMode_None_getInstance_1(), ColorMode_Sepia_getInstance_2(), ColorMode_Greyscale_getInstance_1()];
  }
  function valueOf_10(value) {
    switch (value) {
      case 'None':
        return ColorMode_None_getInstance_1();
      case 'Sepia':
        return ColorMode_Sepia_getInstance_2();
      case 'Greyscale':
        return ColorMode_Greyscale_getInstance_1();
      default:
        ColorMode_initEntries_1();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ColorMode_entriesInitialized_1;
  function ColorMode_initEntries_1() {
    if (ColorMode_entriesInitialized_1)
      return Unit_instance;
    ColorMode_entriesInitialized_1 = true;
    ColorMode_None_instance_1 = new ColorMode_1('None', 0, 0);
    ColorMode_Sepia_instance_1 = new ColorMode_1('Sepia', 1, 1);
    ColorMode_Greyscale_instance_1 = new ColorMode_1('Greyscale', 2, 2);
  }
  function ColorMode_1(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  var RenderMode_Complete_instance_0;
  var RenderMode_DiffuseOnly_instance_0;
  var RenderMode_ModelNormals_instance_0;
  var RenderMode_Lambert_instance_0;
  var RenderMode_CompleteWithLm_instance_0;
  var RenderMode_SsaoOnly_instance_0;
  function values_11() {
    return [RenderMode_Complete_getInstance_0(), RenderMode_DiffuseOnly_getInstance_0(), RenderMode_ModelNormals_getInstance_0(), RenderMode_Lambert_getInstance_0(), RenderMode_CompleteWithLm_getInstance_0(), RenderMode_SsaoOnly_getInstance_0()];
  }
  function valueOf_11(value) {
    switch (value) {
      case 'Complete':
        return RenderMode_Complete_getInstance_0();
      case 'DiffuseOnly':
        return RenderMode_DiffuseOnly_getInstance_0();
      case 'ModelNormals':
        return RenderMode_ModelNormals_getInstance_0();
      case 'Lambert':
        return RenderMode_Lambert_getInstance_0();
      case 'CompleteWithLm':
        return RenderMode_CompleteWithLm_getInstance_0();
      case 'SsaoOnly':
        return RenderMode_SsaoOnly_getInstance_0();
      default:
        RenderMode_initEntries_0();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RenderMode_entriesInitialized_0;
  function RenderMode_initEntries_0() {
    if (RenderMode_entriesInitialized_0)
      return Unit_instance;
    RenderMode_entriesInitialized_0 = true;
    RenderMode_Complete_instance_0 = new RenderMode_0('Complete', 0, 0);
    RenderMode_DiffuseOnly_instance_0 = new RenderMode_0('DiffuseOnly', 1, 1);
    RenderMode_ModelNormals_instance_0 = new RenderMode_0('ModelNormals', 2, 2);
    RenderMode_Lambert_instance_0 = new RenderMode_0('Lambert', 3, 3);
    RenderMode_CompleteWithLm_instance_0 = new RenderMode_0('CompleteWithLm', 4, 5);
    RenderMode_SsaoOnly_instance_0 = new RenderMode_0('SsaoOnly', 5, 4);
  }
  function RenderMode_0(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  function ShipwreckSettings() {
    this.cameraPeriod = 1.0;
    this.vignette = true;
    this.blurred = false;
    this.autoSwitchCameras = true;
    this.lowQuality = false;
    this.clock = false;
    this.renderMode = RenderMode_CompleteWithLm_getInstance_0();
    this.timeOfDay = TimeOfDay_Day_getInstance_3();
    this.lightDirection = new Vec3(0.0, 0.0, 1.0);
    this.lightExponent = 0.85;
    this.ambientColor = new Vec3(0.62, 0.82, 1.0);
    this.fogColor = new Vec3(0.62, 0.68, 0.78);
    this.fogStartDistance = 17.0;
    this.fogDistance = 20.0;
    this.lmScaleX = 0.01;
    this.lmScaleY = 0.01;
    this.lmColor = new Vec3(1.0, 0.94, 0.48);
    this.lmHeightMax = 2.7;
    this.lmHeightStartFade = 0.8;
    this.lmBrightness = 1.9;
    this.cameraMode = CameraMode_Random_getInstance_1();
    this.debugDouble = 1.0;
    this.debugFloat = 1.0;
    this.debugString = '';
    this.colorMode = ColorMode_None_getInstance_1();
    this.testX = 0.0;
    this.testY = 0.0;
    this.testZ = 0.0;
  }
  protoOf(ShipwreckSettings).fp = function (_set____db54di) {
    this.cameraPeriod = _set____db54di;
  };
  protoOf(ShipwreckSettings).gp = function () {
    return this.cameraPeriod;
  };
  protoOf(ShipwreckSettings).hp = function (_set____db54di) {
    this.vignette = _set____db54di;
  };
  protoOf(ShipwreckSettings).ip = function () {
    return this.vignette;
  };
  protoOf(ShipwreckSettings).jp = function (_set____db54di) {
    this.blurred = _set____db54di;
  };
  protoOf(ShipwreckSettings).kp = function () {
    return this.blurred;
  };
  protoOf(ShipwreckSettings).lp = function (_set____db54di) {
    this.autoSwitchCameras = _set____db54di;
  };
  protoOf(ShipwreckSettings).mp = function () {
    return this.autoSwitchCameras;
  };
  protoOf(ShipwreckSettings).rp = function (_set____db54di) {
    this.lowQuality = _set____db54di;
  };
  protoOf(ShipwreckSettings).sp = function () {
    return this.lowQuality;
  };
  protoOf(ShipwreckSettings).pp = function (_set____db54di) {
    this.clock = _set____db54di;
  };
  protoOf(ShipwreckSettings).qp = function () {
    return this.clock;
  };
  protoOf(ShipwreckSettings).o1d = function (_set____db54di) {
    this.renderMode = _set____db54di;
  };
  protoOf(ShipwreckSettings).x15 = function () {
    return this.renderMode;
  };
  protoOf(ShipwreckSettings).p1d = function (_set____db54di) {
    this.timeOfDay = _set____db54di;
  };
  protoOf(ShipwreckSettings).op = function () {
    return this.timeOfDay;
  };
  protoOf(ShipwreckSettings).z15 = function (_set____db54di) {
    this.lightDirection = _set____db54di;
  };
  protoOf(ShipwreckSettings).a16 = function () {
    return this.lightDirection;
  };
  protoOf(ShipwreckSettings).b16 = function (_set____db54di) {
    this.lightExponent = _set____db54di;
  };
  protoOf(ShipwreckSettings).c16 = function () {
    return this.lightExponent;
  };
  protoOf(ShipwreckSettings).d16 = function (_set____db54di) {
    this.ambientColor = _set____db54di;
  };
  protoOf(ShipwreckSettings).e16 = function () {
    return this.ambientColor;
  };
  protoOf(ShipwreckSettings).f16 = function (_set____db54di) {
    this.fogColor = _set____db54di;
  };
  protoOf(ShipwreckSettings).g16 = function () {
    return this.fogColor;
  };
  protoOf(ShipwreckSettings).h16 = function (_set____db54di) {
    this.fogStartDistance = _set____db54di;
  };
  protoOf(ShipwreckSettings).i16 = function () {
    return this.fogStartDistance;
  };
  protoOf(ShipwreckSettings).j16 = function (_set____db54di) {
    this.fogDistance = _set____db54di;
  };
  protoOf(ShipwreckSettings).k16 = function () {
    return this.fogDistance;
  };
  protoOf(ShipwreckSettings).l16 = function (_set____db54di) {
    this.lmScaleX = _set____db54di;
  };
  protoOf(ShipwreckSettings).m16 = function () {
    return this.lmScaleX;
  };
  protoOf(ShipwreckSettings).n16 = function (_set____db54di) {
    this.lmScaleY = _set____db54di;
  };
  protoOf(ShipwreckSettings).o16 = function () {
    return this.lmScaleY;
  };
  protoOf(ShipwreckSettings).p16 = function (_set____db54di) {
    this.lmColor = _set____db54di;
  };
  protoOf(ShipwreckSettings).q16 = function () {
    return this.lmColor;
  };
  protoOf(ShipwreckSettings).r16 = function (_set____db54di) {
    this.lmHeightMax = _set____db54di;
  };
  protoOf(ShipwreckSettings).s16 = function () {
    return this.lmHeightMax;
  };
  protoOf(ShipwreckSettings).t16 = function (_set____db54di) {
    this.lmHeightStartFade = _set____db54di;
  };
  protoOf(ShipwreckSettings).u16 = function () {
    return this.lmHeightStartFade;
  };
  protoOf(ShipwreckSettings).v16 = function (_set____db54di) {
    this.lmBrightness = _set____db54di;
  };
  protoOf(ShipwreckSettings).w16 = function () {
    return this.lmBrightness;
  };
  protoOf(ShipwreckSettings).q1d = function (_set____db54di) {
    this.cameraMode = _set____db54di;
  };
  protoOf(ShipwreckSettings).hu = function () {
    return this.cameraMode;
  };
  protoOf(ShipwreckSettings).iu = function (_set____db54di) {
    this.debugDouble = _set____db54di;
  };
  protoOf(ShipwreckSettings).ju = function () {
    return this.debugDouble;
  };
  protoOf(ShipwreckSettings).ku = function (_set____db54di) {
    this.debugFloat = _set____db54di;
  };
  protoOf(ShipwreckSettings).lu = function () {
    return this.debugFloat;
  };
  protoOf(ShipwreckSettings).mu = function (_set____db54di) {
    this.debugString = _set____db54di;
  };
  protoOf(ShipwreckSettings).nu = function () {
    return this.debugString;
  };
  protoOf(ShipwreckSettings).r1d = function (_set____db54di) {
    this.colorMode = _set____db54di;
  };
  protoOf(ShipwreckSettings).wq = function () {
    return this.colorMode;
  };
  protoOf(ShipwreckSettings).z16 = function (_set____db54di) {
    this.testX = _set____db54di;
  };
  protoOf(ShipwreckSettings).a17 = function () {
    return this.testX;
  };
  protoOf(ShipwreckSettings).b17 = function (_set____db54di) {
    this.testY = _set____db54di;
  };
  protoOf(ShipwreckSettings).c17 = function () {
    return this.testY;
  };
  protoOf(ShipwreckSettings).d17 = function (_set____db54di) {
    this.testZ = _set____db54di;
  };
  protoOf(ShipwreckSettings).e17 = function () {
    return this.testZ;
  };
  function TimeOfDay_Day_getInstance_3() {
    TimeOfDay_initEntries_3();
    return TimeOfDay_Day_instance_3;
  }
  function TimeOfDay_Night_getInstance_3() {
    TimeOfDay_initEntries_3();
    return TimeOfDay_Night_instance_3;
  }
  function TimeOfDay_Sunrise_getInstance_3() {
    TimeOfDay_initEntries_3();
    return TimeOfDay_Sunrise_instance_3;
  }
  function TimeOfDay_Sunset_getInstance_2() {
    TimeOfDay_initEntries_3();
    return TimeOfDay_Sunset_instance_2;
  }
  function CameraMode_Random_getInstance_1() {
    CameraMode_initEntries_1();
    return CameraMode_Random_instance_1;
  }
  function CameraMode_Orbiting_getInstance_1() {
    CameraMode_initEntries_1();
    return CameraMode_Orbiting_instance_1;
  }
  function ColorMode_None_getInstance_1() {
    ColorMode_initEntries_1();
    return ColorMode_None_instance_1;
  }
  function ColorMode_Sepia_getInstance_2() {
    ColorMode_initEntries_1();
    return ColorMode_Sepia_instance_1;
  }
  function ColorMode_Greyscale_getInstance_1() {
    ColorMode_initEntries_1();
    return ColorMode_Greyscale_instance_1;
  }
  function RenderMode_Complete_getInstance_0() {
    RenderMode_initEntries_0();
    return RenderMode_Complete_instance_0;
  }
  function RenderMode_DiffuseOnly_getInstance_0() {
    RenderMode_initEntries_0();
    return RenderMode_DiffuseOnly_instance_0;
  }
  function RenderMode_ModelNormals_getInstance_0() {
    RenderMode_initEntries_0();
    return RenderMode_ModelNormals_instance_0;
  }
  function RenderMode_Lambert_getInstance_0() {
    RenderMode_initEntries_0();
    return RenderMode_Lambert_instance_0;
  }
  function RenderMode_CompleteWithLm_getInstance_0() {
    RenderMode_initEntries_0();
    return RenderMode_CompleteWithLm_instance_0;
  }
  function RenderMode_SsaoOnly_getInstance_0() {
    RenderMode_initEntries_0();
    return RenderMode_SsaoOnly_instance_0;
  }
  function Shaders_3() {
    Shaders_instance_3 = this;
    this.t1c_1 = ShaderConstructor2('DiffuseColoredLm', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1), to(AttributeType_UV1_getInstance(), 2)]));
    this.u1c_1 = ShaderConstructor2('DiffuseDoubleColoredLm', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1), to(AttributeType_UV1_getInstance(), 2)]));
    this.v1c_1 = ShaderConstructor2('DiffuseColored', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1)]));
    this.w1c_1 = ShaderConstructor2('DiffuseColoredAt', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1)]));
    this.x1c_1 = ShaderConstructor2('Flag', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1)]));
    this.y1c_1 = ShaderConstructor2('StylizedWater', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1)]));
    this.z1c_1 = ShaderConstructor2('Rocks', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1), to(AttributeType_NORMAL_getInstance(), 2)]));
    this.a1d_1 = ShaderConstructor2('Color', mapOf_0(to(AttributeType_VERTEX_getInstance(), 0)));
    this.b1d_1 = new Shader('Wind');
    this.c1d_1 = new Shader('ColorAnimatedTextureChunkedFog');
    this.d1d_1 = mutableListOf([this.t1c_1, this.u1c_1, this.v1c_1, this.w1c_1, this.x1c_1, this.y1c_1, this.z1c_1, this.a1d_1, this.b1d_1, this.c1d_1]);
  }
  var Shaders_instance_3;
  function Shaders_getInstance_3() {
    if (Shaders_instance_3 == null)
      new Shaders_3();
    return Shaders_instance_3;
  }
  function Textures_3() {
    Textures_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texWaterNoise.<anonymous>' call
    this_0.name = 'water-noise';
    this_0.fileName = 'water-noise';
    this_0.format = TextureFormat_ASTC_getInstance();
    this_0.wrapping = TextureWrapping_REPEAT_getInstance();
    this_0.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_0.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_0.mipmaps = 7;
    tmp.j17_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texWaterAO.<anonymous>' call
    this_1.name = 'water-ao';
    this_1.fileName = 'water-ao';
    this_1.format = TextureFormat_ASTC_getInstance();
    this_1.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_1.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_1.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_1.anisotropy = 3;
    this_1.mipmaps = 8;
    tmp_0.k17_1 = this_1;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texClouds.<anonymous>' call
    this_2.name = 'clouds';
    this_2.fileName = 'clouds';
    this_2.format = TextureFormat_ASTC_getInstance();
    this_2.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_2.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_2.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_2.mipmaps = 8;
    tmp_1.l17_1 = this_2;
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texTreeTrunks.<anonymous>' call
    this_3.name = 'tree_trunk';
    this_3.fileName = 'tree_trunk';
    this_3.format = TextureFormat_ASTC_getInstance();
    this_3.wrapping = TextureWrapping_REPEAT_getInstance();
    this_3.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_3.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_3.mipmaps = 3;
    tmp_2.m17_1 = this_3;
    var tmp_3 = this;
    // Inline function 'kotlin.apply' call
    var this_4 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texTreeLeaves.<anonymous>' call
    this_4.name = 'tree_leaves';
    this_4.fileName = 'tree_leaves';
    this_4.format = TextureFormat_ASTC_getInstance();
    this_4.wrapping = TextureWrapping_REPEAT_getInstance();
    this_4.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_4.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_4.mipmaps = 7;
    tmp_3.n17_1 = this_4;
    var tmp_4 = this;
    // Inline function 'kotlin.apply' call
    var this_5 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texRocks.<anonymous>' call
    this_5.name = 'rocks';
    this_5.fileName = 'rocks';
    this_5.format = TextureFormat_ASTC_getInstance();
    this_5.wrapping = TextureWrapping_REPEAT_getInstance();
    this_5.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_5.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_5.mipmaps = 9;
    tmp_4.o17_1 = this_5;
    var tmp_5 = this;
    // Inline function 'kotlin.apply' call
    var this_6 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texGround.<anonymous>' call
    this_6.name = 'ground';
    this_6.fileName = 'ground';
    this_6.format = TextureFormat_ASTC_getInstance();
    this_6.wrapping = TextureWrapping_REPEAT_getInstance();
    this_6.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_6.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_6.mipmaps = 8;
    tmp_5.p17_1 = this_6;
    var tmp_6 = this;
    // Inline function 'kotlin.apply' call
    var this_7 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texShip.<anonymous>' call
    this_7.name = 'ship';
    this_7.fileName = 'ship';
    this_7.format = TextureFormat_ASTC_getInstance();
    this_7.wrapping = TextureWrapping_REPEAT_getInstance();
    this_7.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_7.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_7.mipmaps = 9;
    tmp_6.q17_1 = this_7;
    var tmp_7 = this;
    // Inline function 'kotlin.apply' call
    var this_8 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texFlag.<anonymous>' call
    this_8.name = 'flag';
    this_8.fileName = 'flag';
    this_8.format = TextureFormat_ASTC_getInstance();
    this_8.wrapping = TextureWrapping_REPEAT_getInstance();
    this_8.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_8.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_8.mipmaps = 3;
    tmp_7.r17_1 = this_8;
    var tmp_8 = this;
    // Inline function 'kotlin.apply' call
    var this_9 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texBat.<anonymous>' call
    this_9.name = 'bat';
    this_9.fileName = 'bat.rgba.fp16';
    this_9.format = TextureFormat_RGBA16F_getInstance();
    this_9.minFilter = TextureFiltering_NEAREST_getInstance();
    this_9.magFilter = TextureFiltering_NEAREST_getInstance();
    this_9.width = Animations_getInstance_1().f17_1.vb_1;
    this_9.height = Animations_getInstance_1().f17_1.ac_1;
    tmp_8.s17_1 = this_9;
    var tmp_9 = this;
    // Inline function 'kotlin.apply' call
    var this_10 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texBoat.<anonymous>' call
    this_10.name = 'boat';
    this_10.fileName = 'boat';
    this_10.format = TextureFormat_ASTC_getInstance();
    this_10.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_10.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_10.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_10.mipmaps = 8;
    tmp_9.t17_1 = this_10;
    var tmp_10 = this;
    // Inline function 'kotlin.apply' call
    var this_11 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texBlack.<anonymous>' call
    this_11.name = 'black';
    this_11.fileName = 'black';
    this_11.format = TextureFormat_ASTC_getInstance();
    this_11.wrapping = TextureWrapping_REPEAT_getInstance();
    this_11.minFilter = TextureFiltering_NEAREST_getInstance();
    this_11.magFilter = TextureFiltering_NEAREST_getInstance();
    tmp_10.u17_1 = this_11;
    var tmp_11 = this;
    // Inline function 'kotlin.apply' call
    var this_12 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texLM.<anonymous>' call
    this_12.name = 'Lightmap';
    this_12.fileName = 'lm';
    this_12.format = TextureFormat_RGBA8_getInstance();
    this_12.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_12.minFilter = TextureFiltering_LINEAR_getInstance();
    this_12.magFilter = TextureFiltering_LINEAR_getInstance();
    tmp_11.v17_1 = this_12;
    var tmp_12 = this;
    // Inline function 'kotlin.apply' call
    var this_13 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texLeaves.<anonymous>' call
    this_13.name = 'Leaves';
    this_13.fileName = 'leaves';
    this_13.format = TextureFormat_RGBA8_getInstance();
    this_13.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_13.minFilter = TextureFiltering_LINEAR_getInstance();
    this_13.magFilter = TextureFiltering_LINEAR_getInstance();
    tmp_12.w17_1 = this_13;
    var tmp_13 = this;
    // Inline function 'kotlin.apply' call
    var this_14 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.example.Textures.texGhost.<anonymous>' call
    this_14.name = 'ghost';
    this_14.fileName = 'ghost_eyes';
    this_14.format = TextureFormat_RGBA8_getInstance();
    this_14.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_14.minFilter = TextureFiltering_LINEAR_getInstance();
    this_14.magFilter = TextureFiltering_LINEAR_getInstance();
    tmp_13.x17_1 = this_14;
    this.y17_1 = mutableListOf([this.k17_1, this.j17_1, this.l17_1, this.m17_1, this.n17_1, this.o17_1, this.p17_1, this.q17_1, this.r17_1, this.t17_1, this.u17_1, this.s17_1, this.v17_1, this.w17_1, this.x17_1]);
  }
  var Textures_instance_3;
  function Textures_getInstance_3() {
    if (Textures_instance_3 == null)
      new Textures_3();
    return Textures_instance_3;
  }
  var Timers_Camera_instance_2;
  var Timers_Water_instance_1;
  var Timers_BouysBobbing_instance_0;
  var Timers_BouysRotation_instance_0;
  var Timers_WindMove1_instance_0;
  var Timers_WindMove2_instance_0;
  var Timers_WindMove3_instance_0;
  var Timers_OrbitingCameraZ_instance_1;
  var Timers_OrbitingCameraX_instance_1;
  var Timers_Flag1_instance;
  var Timers_Flag2_instance;
  var Timers_Flag3_instance;
  var Timers_Flag4_instance;
  var Timers_BirdWings1_instance_1;
  var Timers_BirdWings2_instance_1;
  var Timers_BirdsFly_instance_1;
  var Timers_ProjectionOffsetTransition_instance_1;
  var Timers_FlameFlicker_instance_0;
  var Timers_GhostAnim1_instance_0;
  var Timers_GhostAnim2_instance_0;
  var Timers_GhostMove_instance_0;
  var Timers_GhostBob_instance_0;
  var Timers_BirdsBob_instance_0;
  function Companion_5() {
    this.e1d_1 = 27800.0;
  }
  protoOf(Companion_5).f1d = function (timers) {
    timers.mj(Timers_Camera_getInstance_1(), this.e1d_1, true);
    timers.mj(Timers_Water_getInstance_1(), 25000.0, true);
    timers.mj(Timers_BouysBobbing_getInstance_0(), 2000.0, true);
    timers.mj(Timers_BouysRotation_getInstance_0(), 8000.0, true);
    timers.mj(Timers_WindMove1_getInstance_0(), 7000.0, true);
    timers.mj(Timers_WindMove2_getInstance_0(), 7500.0, true);
    timers.mj(Timers_WindMove3_getInstance_0(), 8000.0, true);
    timers.mj(Timers_OrbitingCameraZ_getInstance_1(), 42000.0, true);
    timers.mj(Timers_OrbitingCameraX_getInstance_1(), 32000.0, true);
    timers.mj(Timers_ProjectionOffsetTransition_getInstance_1(), 2000.0, false);
    timers.mj(Timers_Flag1_getInstance(), 300.0, true);
    timers.mj(Timers_Flag2_getInstance(), 366.0, true);
    timers.mj(Timers_Flag3_getInstance(), 399.0, true);
    timers.mj(Timers_Flag4_getInstance(), 333.0, true);
    timers.mj(Timers_BirdWings1_getInstance_1(), 900.0, true);
    timers.mj(Timers_BirdWings2_getInstance_1(), 800.0, true);
    timers.mj(Timers_BirdsFly_getInstance_1(), 19000.0, true);
    timers.mj(Timers_BirdsBob_getInstance_0(), 2800.0, true);
    timers.mj(Timers_FlameFlicker_getInstance_0(), 900.0, true);
    timers.mj(Timers_GhostAnim1_getInstance_0(), 4000.0, true);
    timers.mj(Timers_GhostAnim2_getInstance_0(), 5000.0, true);
    timers.mj(Timers_GhostMove_getInstance_0(), 58000.0, true);
    timers.mj(Timers_GhostBob_getInstance_0(), 4000.0, true);
  };
  var Companion_instance_8;
  function Companion_getInstance_5() {
    return Companion_instance_8;
  }
  var Timers_entriesInitialized_3;
  function Timers_initEntries_3() {
    if (Timers_entriesInitialized_3)
      return Unit_instance;
    Timers_entriesInitialized_3 = true;
    Timers_Camera_instance_2 = new Timers_3('Camera', 0);
    Timers_Water_instance_1 = new Timers_3('Water', 1);
    Timers_BouysBobbing_instance_0 = new Timers_3('BouysBobbing', 2);
    Timers_BouysRotation_instance_0 = new Timers_3('BouysRotation', 3);
    Timers_WindMove1_instance_0 = new Timers_3('WindMove1', 4);
    Timers_WindMove2_instance_0 = new Timers_3('WindMove2', 5);
    Timers_WindMove3_instance_0 = new Timers_3('WindMove3', 6);
    Timers_OrbitingCameraZ_instance_1 = new Timers_3('OrbitingCameraZ', 7);
    Timers_OrbitingCameraX_instance_1 = new Timers_3('OrbitingCameraX', 8);
    Timers_Flag1_instance = new Timers_3('Flag1', 9);
    Timers_Flag2_instance = new Timers_3('Flag2', 10);
    Timers_Flag3_instance = new Timers_3('Flag3', 11);
    Timers_Flag4_instance = new Timers_3('Flag4', 12);
    Timers_BirdWings1_instance_1 = new Timers_3('BirdWings1', 13);
    Timers_BirdWings2_instance_1 = new Timers_3('BirdWings2', 14);
    Timers_BirdsFly_instance_1 = new Timers_3('BirdsFly', 15);
    Timers_ProjectionOffsetTransition_instance_1 = new Timers_3('ProjectionOffsetTransition', 16);
    Timers_FlameFlicker_instance_0 = new Timers_3('FlameFlicker', 17);
    Timers_GhostAnim1_instance_0 = new Timers_3('GhostAnim1', 18);
    Timers_GhostAnim2_instance_0 = new Timers_3('GhostAnim2', 19);
    Timers_GhostMove_instance_0 = new Timers_3('GhostMove', 20);
    Timers_GhostBob_instance_0 = new Timers_3('GhostBob', 21);
    Timers_BirdsBob_instance_0 = new Timers_3('BirdsBob', 22);
  }
  function Timers_3(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Timers_Camera_getInstance_1() {
    Timers_initEntries_3();
    return Timers_Camera_instance_2;
  }
  function Timers_Water_getInstance_1() {
    Timers_initEntries_3();
    return Timers_Water_instance_1;
  }
  function Timers_BouysBobbing_getInstance_0() {
    Timers_initEntries_3();
    return Timers_BouysBobbing_instance_0;
  }
  function Timers_BouysRotation_getInstance_0() {
    Timers_initEntries_3();
    return Timers_BouysRotation_instance_0;
  }
  function Timers_WindMove1_getInstance_0() {
    Timers_initEntries_3();
    return Timers_WindMove1_instance_0;
  }
  function Timers_WindMove2_getInstance_0() {
    Timers_initEntries_3();
    return Timers_WindMove2_instance_0;
  }
  function Timers_WindMove3_getInstance_0() {
    Timers_initEntries_3();
    return Timers_WindMove3_instance_0;
  }
  function Timers_OrbitingCameraZ_getInstance_1() {
    Timers_initEntries_3();
    return Timers_OrbitingCameraZ_instance_1;
  }
  function Timers_OrbitingCameraX_getInstance_1() {
    Timers_initEntries_3();
    return Timers_OrbitingCameraX_instance_1;
  }
  function Timers_Flag1_getInstance() {
    Timers_initEntries_3();
    return Timers_Flag1_instance;
  }
  function Timers_Flag2_getInstance() {
    Timers_initEntries_3();
    return Timers_Flag2_instance;
  }
  function Timers_Flag3_getInstance() {
    Timers_initEntries_3();
    return Timers_Flag3_instance;
  }
  function Timers_Flag4_getInstance() {
    Timers_initEntries_3();
    return Timers_Flag4_instance;
  }
  function Timers_BirdWings1_getInstance_1() {
    Timers_initEntries_3();
    return Timers_BirdWings1_instance_1;
  }
  function Timers_BirdWings2_getInstance_1() {
    Timers_initEntries_3();
    return Timers_BirdWings2_instance_1;
  }
  function Timers_BirdsFly_getInstance_1() {
    Timers_initEntries_3();
    return Timers_BirdsFly_instance_1;
  }
  function Timers_ProjectionOffsetTransition_getInstance_1() {
    Timers_initEntries_3();
    return Timers_ProjectionOffsetTransition_instance_1;
  }
  function Timers_FlameFlicker_getInstance_0() {
    Timers_initEntries_3();
    return Timers_FlameFlicker_instance_0;
  }
  function Timers_GhostAnim1_getInstance_0() {
    Timers_initEntries_3();
    return Timers_GhostAnim1_instance_0;
  }
  function Timers_GhostAnim2_getInstance_0() {
    Timers_initEntries_3();
    return Timers_GhostAnim2_instance_0;
  }
  function Timers_GhostMove_getInstance_0() {
    Timers_initEntries_3();
    return Timers_GhostMove_instance_0;
  }
  function Timers_GhostBob_getInstance_0() {
    Timers_initEntries_3();
    return Timers_GhostBob_instance_0;
  }
  function Timers_BirdsBob_getInstance_0() {
    Timers_initEntries_3();
    return Timers_BirdsBob_instance_0;
  }
  function CommonAssetForgeShaders() {
    CommonAssetForgeShaders_instance = this;
    this.my_1 = ShaderConstructor2('DiffuseHalfLambertAO', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1), to(AttributeType_NORMAL_getInstance(), 2)]));
    this.ny_1 = ShaderConstructor2('DiffuseHalfLambertAoLm', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1), to(AttributeType_NORMAL_getInstance(), 2)]));
    this.oy_1 = ShaderConstructor2('DiffuseHalfLambertAoLmLit', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1), to(AttributeType_NORMAL_getInstance(), 2)]));
    this.py_1 = ShaderConstructor2('Diffuse', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1), to(AttributeType_NORMAL_getInstance(), 2)]));
    this.qy_1 = ShaderConstructor2('TestModelNormals', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_NORMAL_getInstance(), 1)]));
    this.ry_1 = ShaderConstructor2('TestLambert', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_NORMAL_getInstance(), 1)]));
    this.sy_1 = ShaderConstructor2('Leaves', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1)]));
    this.ty_1 = ShaderConstructor2('ColorFog', mapOf_0(to(AttributeType_VERTEX_getInstance(), 0)));
    this.uy_1 = ShaderConstructor2('Ghost', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1)]));
    this.vy_1 = mutableListOf([this.my_1, this.ny_1, this.oy_1, this.py_1, this.qy_1, this.ry_1, this.sy_1, this.ty_1, this.uy_1]);
    this.wy_1 = UniformFloatValueWithArray(new Float32Array(4));
    this.xy_1 = UniformFloatValueWithArray(new Float32Array(3));
    this.yy_1 = UniformFloatValueWithArray(new Float32Array(4));
    this.zy_1 = UniformFloatValueWithArray(new Float32Array(1));
    this.az_1 = UniformFloatValueWithArray(new Float32Array(1));
    this.bz_1 = UniformFloatValueWithArray(new Float32Array(2));
    this.cz_1 = UniformFloatValueWithArray(new Float32Array(3));
    this.dz_1 = UniformFloatValueWithArray(new Float32Array(2));
    this.ez_1 = UniformFloatValueWithArray(new Float32Array(1));
    this.fz_1 = UniformFloatValueWithArray(new Float32Array(4));
    this.gz_1 = UniformFloatValueWithArray(new Float32Array(2));
  }
  var CommonAssetForgeShaders_instance;
  function CommonAssetForgeShaders_getInstance() {
    if (CommonAssetForgeShaders_instance == null)
      new CommonAssetForgeShaders();
    return CommonAssetForgeShaders_instance;
  }
  function Cameras_4() {
    Cameras_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s1d_1 = [new CameraPositionPair(new CameraPosition(new Vec3(-482.396, -531.9705, 285.74268), new Vec3(0.0, 671.648, 320.67273)), new CameraPosition(new Vec3(-482.396, -531.9705, 285.74268), new Vec3(1200.0, 881.0, 320.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-333.6785, 270.80814, 80.38176), new Vec3(2326.0, -456.0, 62.0)), new CameraPosition(new Vec3(-333.6785, 270.80814, 80.38176), new Vec3(0.0, 0.0, 300.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-211.0509, -16.89734, 566.52783), new Vec3(199.0, 1991.0, 521.0)), new CameraPosition(new Vec3(-211.0509, -16.89734, 566.52783), new Vec3(2326.0, -456.0, -462.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(410.60248, 1.71905, 385.1585), new Vec3(43.76746, -47.50201, 284.52988)), new CameraPosition(new Vec3(-51.60339, -57.81422, 742.44904), new Vec3(-394.5254, -197.46364, 160.64297)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(65.21625, 420.27478, 90.77725), new Vec3(-0.084, 3.20282, 0.0)), new CameraPosition(new Vec3(39.43102, 161.92427, 128.19858), new Vec3(-159.48073, -852.85974, 247.27513)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-265.92853, 241.38824, 369.07593), new Vec3(0.0, 0.0, 100.0)), new CameraPosition(new Vec3(308.62924, 98.13493, 370.11276), new Vec3(0.0, 0.0, 380.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(250.45558, 259.55188, 176.77605), new Vec3(0.0, 0.0, 0.0)), new CameraPosition(new Vec3(154.02309, 75.40595, 588.0274), new Vec3(0.0, 0.0, 0.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-159.74187, 320.7689, 189.94376), new Vec3(441.5041, 451.1911, -80.38499)), new CameraPosition(new Vec3(-159.74187, 320.7689, 189.94376), new Vec3(-37.87353, 31.97122, 13.20067)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(535.4855, 684.2804, 144.5217), new Vec3(741.83734, -844.9926, 373.89066)), new CameraPosition(new Vec3(-750.3822, 647.2758, 144.5217), new Vec3(-703.7422, -973.4606, 330.16608)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(542.7148, 364.88196, 495.62314), new Vec3(0.0, 0.0, 300.0)), new CameraPosition(new Vec3(-501.2168, 396.2967, 495.62314), new Vec3(0.0, 0.0, 300.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-636.42206, 412.71054, 406.65588), new Vec3(2430.486, -1149.8065, 199.06757)), new CameraPosition(new Vec3(395.94238, 88.83645, 241.39832), new Vec3(2430.486, -1149.8065, 199.06757)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-748.14594, -1126.2855, 160.0), new Vec3(1984.2155, 3571.2107, 1019.94946)), new CameraPosition(new Vec3(-69.17133, 57.29704, 595.9123), new Vec3(1984.2155, 3571.2107, 1019.94946)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(321.05392, -458.26395, 104.81658), new Vec3(-402.70673, 1654.738, 950.216)), new CameraPosition(new Vec3(422.2885, 234.13013, 131.0068), new Vec3(-2424.0, -291.0, 1028.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-93.01678, 702.30444, 268.54242), new Vec3(6.0, -33.0, 180.0)), new CameraPosition(new Vec3(-731.5787, 327.39212, 90.0), new Vec3(6.0, -33.0, 240.0)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-529.09985, -677.72003, 190.77745), new Vec3(6.0, -33.0, 240.0)), new CameraPosition(new Vec3(426.14938, -555.4488, 77.87421), new Vec3(6.0, -33.0, 290.0)), 1.0)];
  }
  var Cameras_instance_4;
  function Cameras_getInstance_4() {
    if (Cameras_instance_4 == null)
      new Cameras_4();
    return Cameras_instance_4;
  }
  function get_LANTERNS() {
    _init_properties_Lanterns_kt__26v2a5();
    return LANTERNS;
  }
  var LANTERNS;
  function Lantern(position, scale) {
    this.t1d_1 = position;
    this.u1d_1 = scale;
  }
  protoOf(Lantern).toString = function () {
    return 'Lantern(position=' + this.t1d_1 + ', scale=' + this.u1d_1 + ')';
  };
  protoOf(Lantern).hashCode = function () {
    var result = this.t1d_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.u1d_1) | 0;
    return result;
  };
  protoOf(Lantern).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Lantern))
      return false;
    var tmp0_other_with_cast = other instanceof Lantern ? other : THROW_CCE();
    if (!this.t1d_1.equals(tmp0_other_with_cast.t1d_1))
      return false;
    if (!equals(this.u1d_1, tmp0_other_with_cast.u1d_1))
      return false;
    return true;
  };
  var properties_initialized_Lanterns_kt_7tp633;
  function _init_properties_Lanterns_kt__26v2a5() {
    if (!properties_initialized_Lanterns_kt_7tp633) {
      properties_initialized_Lanterns_kt_7tp633 = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      LANTERNS = [new Lantern(new Vec3(1.13116, 0.093228, 0.792876), 1.0), new Lantern(new Vec3(1.15113, 0.384016, 0.823065), 1.0), new Lantern(new Vec3(-0.800424, 0.327488, 1.30164), 0.4), new Lantern(new Vec3(-0.597262, 0.349149, 1.43555), 0.4), new Lantern(new Vec3(-0.410746, 0.376665, 1.58856), 0.4), new Lantern(new Vec3(-0.240876, 0.410035, 1.76067), 0.4), new Lantern(new Vec3(-0.061262, 0.280109, 1.67203), 0.4), new Lantern(new Vec3(-0.037124, 0.133155, 1.53059), 0.4), new Lantern(new Vec3(-0.004721, -0.027347, 1.4066), 0.4), new Lantern(new Vec3(0.655819, 0.256631, 1.47913), 0.4), new Lantern(new Vec3(0.476067, 0.126223, 1.37813), 0.4), new Lantern(new Vec3(0.290461, -0.008436, 1.29485), 0.4)];
    }
  }
  function Meshes_4() {
    Meshes_instance_4 = this;
    this.v1d_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6)]), 12);
    this.w1d_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6), new MeshAttribute(AttributeType_UV1_getInstance(), VertexFormat_HALF2_getInstance(), 10)]), 16);
    this.x1d_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_UBYTE2_NORMALIZED_getInstance(), 6)]), 8);
    this.y1d_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_UBYTE2_NORMALIZED_getInstance(), 6), new MeshAttribute(AttributeType_NORMAL_getInstance(), VertexFormat_BYTE3_NORMALIZED_getInstance(), 8)]), 12);
    this.z1d_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_FLOAT3_getInstance(), 0)), 12);
    this.a1e_1 = MeshConstructor2('boat', this.v1d_1);
    this.b1e_1 = MeshConstructor2('water', this.x1d_1);
    this.c1e_1 = MeshConstructor2('clouds', this.v1d_1);
    this.d1e_1 = MeshConstructor2('stars', this.z1d_1);
    this.e1e_1 = MeshConstructor2('bird1');
    this.f1e_1 = MeshConstructor2('flag-triangle', this.x1d_1);
    this.g1e_1 = MeshConstructor2('rocks', this.y1d_1);
    this.h1e_1 = MeshConstructor2('ship', this.w1d_1);
    this.i1e_1 = MeshConstructor2('lantern', this.w1d_1);
    this.j1e_1 = MeshConstructor2('box', this.w1d_1);
    this.k1e_1 = MeshConstructor2('ground', this.w1d_1);
    this.l1e_1 = MeshConstructor2('grass', this.w1d_1);
    this.m1e_1 = MeshConstructor2('tree_leaves', this.v1d_1);
    this.n1e_1 = MeshConstructor2('tree_trunks', this.x1d_1);
    this.o1e_1 = mutableListOf([this.a1e_1, this.b1e_1, this.c1e_1, this.d1e_1, this.e1e_1, this.f1e_1, this.g1e_1, this.h1e_1, this.i1e_1, this.j1e_1, this.k1e_1, this.l1e_1, this.m1e_1, this.n1e_1]);
  }
  var Meshes_instance_4;
  function Meshes_getInstance_4() {
    if (Meshes_instance_4 == null)
      new Meshes_4();
    return Meshes_instance_4;
  }
  function Preset_1(fogColor, waterColor, highlightColor, tintColor, cloudsColor, lightsColor, lampsColor, drawLights, drawBirds, birdsColor) {
    this.p1e_1 = fogColor;
    this.q1e_1 = waterColor;
    this.r1e_1 = highlightColor;
    this.s1e_1 = tintColor;
    this.t1e_1 = cloudsColor;
    this.u1e_1 = lightsColor;
    this.v1e_1 = lampsColor;
    this.w1e_1 = drawLights;
    this.x1e_1 = drawBirds;
    this.y1e_1 = birdsColor;
  }
  protoOf(Preset_1).toString = function () {
    return 'Preset(fogColor=' + this.p1e_1 + ', waterColor=' + this.q1e_1 + ', highlightColor=' + this.r1e_1 + ', tintColor=' + this.s1e_1 + ', cloudsColor=' + this.t1e_1 + ', lightsColor=' + this.u1e_1 + ', lampsColor=' + this.v1e_1 + ', drawLights=' + this.w1e_1 + ', drawBirds=' + this.x1e_1 + ', birdsColor=' + this.y1e_1 + ')';
  };
  protoOf(Preset_1).hashCode = function () {
    var result = this.p1e_1.hashCode();
    result = imul(result, 31) + this.q1e_1.hashCode() | 0;
    result = imul(result, 31) + this.r1e_1.hashCode() | 0;
    result = imul(result, 31) + this.s1e_1.hashCode() | 0;
    result = imul(result, 31) + this.t1e_1.hashCode() | 0;
    result = imul(result, 31) + this.u1e_1.hashCode() | 0;
    result = imul(result, 31) + this.v1e_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w1e_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x1e_1) | 0;
    result = imul(result, 31) + this.y1e_1.hashCode() | 0;
    return result;
  };
  protoOf(Preset_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Preset_1))
      return false;
    var tmp0_other_with_cast = other instanceof Preset_1 ? other : THROW_CCE();
    if (!this.p1e_1.equals(tmp0_other_with_cast.p1e_1))
      return false;
    if (!this.q1e_1.equals(tmp0_other_with_cast.q1e_1))
      return false;
    if (!this.r1e_1.equals(tmp0_other_with_cast.r1e_1))
      return false;
    if (!this.s1e_1.equals(tmp0_other_with_cast.s1e_1))
      return false;
    if (!this.t1e_1.equals(tmp0_other_with_cast.t1e_1))
      return false;
    if (!this.u1e_1.equals(tmp0_other_with_cast.u1e_1))
      return false;
    if (!this.v1e_1.equals(tmp0_other_with_cast.v1e_1))
      return false;
    if (!(this.w1e_1 === tmp0_other_with_cast.w1e_1))
      return false;
    if (!(this.x1e_1 === tmp0_other_with_cast.x1e_1))
      return false;
    if (!this.y1e_1.equals(tmp0_other_with_cast.y1e_1))
      return false;
    return true;
  };
  function Presets_1() {
    Presets_instance_1 = this;
    this.z1e_1 = new Vec4(0.56, 0.44, 0.26);
    this.a1f_1 = new Vec4(0.6, 0.6, 0.6);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b1f_1 = [new Preset_1(new Vec4(0.7647058823529411, 0.9098039215686274, 0.9450980392156862, 1.0), new Vec4(0.387, 0.75, 0.795, 1.0), new Vec4(0.7843137254901961, 0.7843137254901961, 0.7843137254901961, 1.0), new Vec4(1.0, 1.0, 1.0, 1.0), new Vec4(1.0, 1.0, 1.0, 1.0), new Vec4(0.0, 0.0, 0.0, 1.0), new Vec4(0.0, 0.0, 0.0, 1.0), false, true, new Vec4(0.3137254901960784, 0.3137254901960784, 0.3137254901960784, 1.0)), new Preset_1(new Vec4(0.03137254901960784, 0.11372549019607843, 0.1843137254901961, 1.0), new Vec4(0.03529411764705882, 0.17254901960784313, 0.3176470588235294, 1.0), new Vec4(0.3137254901960784, 0.3137254901960784, 0.3137254901960784, 1.0), new Vec4(0.5215686274509804, 0.8705882352941177, 1.0, 1.0), new Vec4(0.0784313725490196, 0.3254901960784314, 0.47058823529411764, 1.0), new Vec4(3.0, 1.2000000000000002, 0.0, 1.0), new Vec4(4.0, 2.4, 0.0, 1.0), true, false, new Vec4(0.3137254901960784, 0.3137254901960784, 0.3137254901960784, 1.0)), new Preset_1(new Vec4(1.0, 0.7686274509803922, 0.35294117647058826, 1.0), new Vec4(0.592156862745098, 0.6313725490196078, 0.5098039215686274, 1.0), new Vec4(0.5019607843137255, 0.43529411764705883, 0.23529411764705882, 1.0), new Vec4(1.0, 0.8705882352941177, 0.4745098039215686, 1.0), new Vec4(1.0, 0.8705882352941177, 0.47058823529411764, 1.0), new Vec4(0.0, 0.0, 0.0, 1.0), new Vec4(0.0, 0.0, 0.0, 1.0), false, true, new Vec4(0.4921875, 0.42578125, 0.265625, 1.0)), new Preset_1(new Vec4(0.21568627450980393, 0.2196078431372549, 0.47058823529411764, 1.0), new Vec4(0.0784313725490196, 0.20784313725490197, 0.4549019607843137, 1.0), new Vec4(0.5294117647058824, 0.3215686274509804, 0.48627450980392156, 1.0), new Vec4(0.9607843137254902, 0.7529411764705882, 0.9176470588235294, 1.0), new Vec4(0.9607843137254902, 0.7137254901960784, 0.8784313725490196, 1.0), new Vec4(3.0, 1.2000000000000002, 0.0, 1.0), new Vec4(1.6, 1.2800000000000002, 0.0, 1.0), true, false, new Vec4(0.3671875, 0.17578125, 0.20703125, 1.0))];
  }
  var Presets_instance_1;
  function Presets_getInstance_1() {
    if (Presets_instance_1 == null)
      new Presets_1();
    return Presets_instance_1;
  }
  function applySettings_3($this) {
    $this.k1g_1.w(0, $this.settings.lowQuality ? get_HINT_VRS_2X2() : get_HINT_VRS_NONE());
    $this.i1f_1.enabled = !$this.settings.blurred;
    $this.j1f_1.enabled = $this.settings.blurred;
    $this.n1f_1.enabled = $this.settings.vignette;
    $this.k1f_1.blurSize = $this.settings.lowQuality ? BlurSize_KERNEL_2_getInstance() : BlurSize_KERNEL_4_getInstance();
    $this.n1f_1.enabled = !$this.settings.lowQuality;
    $this.h1g_1.a1h_1.enabled = !$this.settings.lowQuality;
    if (!($this.cameraAnimator.minDurationCoefficient === $this.settings.cameraPeriod)) {
      $this.cameraAnimator.minDurationCoefficient = $this.settings.cameraPeriod;
    }
    if (($this.cameraAnimator.timer > 0.99 ? $this.settings.autoSwitchCameras : false) ? Default_getInstance().c6() < 0.5 : false) {
      $this.randomCamera();
    }
  }
  function animate_3($this, time) {
    applySettings_3($this);
    positionCamera_3($this, time);
    $this.calculateProjection();
    applyPreset($this);
    animateWater_0($this);
    animateLanterns($this);
    animateBox($this);
    animateBoat($this);
    animateFlags($this);
    animateBirds_0($this);
    animateWind_0($this);
    $this.updateMeshTransformations($this.commands);
  }
  function animateWind_0($this) {
    $this.h1g_1.e1h($this.h1f_1.nj(Timers_WindMove1_getInstance_1()), $this.h1f_1.nj(Timers_WindMove2_getInstance_1()), $this.h1f_1.nj(Timers_WindMove3_getInstance_1()));
  }
  function animateBirds_0($this) {
    if (!$this.e1g_1.enabled) {
      return Unit_instance;
    }
    var preset = Presets_getInstance_1().b1f_1[$this.settings.timeOfDay.n4_1];
    var tmp = $this.e1g_1.commands;
    var commands = isInterface(tmp, List) ? tmp : THROW_CCE();
    var wingTimer1 = $this.h1f_1.nj(Timers_BirdWings1_getInstance_2());
    var wingTimer2 = $this.h1f_1.nj(Timers_BirdWings2_getInstance_2());
    var angle = $this.h1f_1.nj(Timers_BirdsFly_getInstance_2()) * $this.PIf * 2.0;
    setBirdPosition_2(700.0, angle, new Vec2(1000.0, 2000.0), commands.t(0).transform.y9_1);
    setBirdPosition_2(700.0, -angle - $this.PIf, new Vec2(-400.0, 2000.0), commands.t(1).transform.y9_1);
    setBirdPosition_2(700.0, -angle - $this.PIf, new Vec2(2600.0, -300.0), commands.t(2).transform.y9_1);
    setBirdPosition_2(560.0, angle, new Vec2(2600.0, -700.0), commands.t(3).transform.y9_1);
    setBirdPosition_2(350.0, -angle - $this.PIf, new Vec2(-1000.0, -500.0), commands.t(4).transform.y9_1);
    setBirdPosition_2(420.0, angle, new Vec2(-900.0, -700.0), commands.t(5).transform.y9_1);
    commands.t(0).transform.z9_1.z = MathUtils_instance.wh(-angle + $this.PIf / 2.0);
    commands.t(1).transform.z9_1.z = MathUtils_instance.wh(angle + $this.PIf / 2.0);
    commands.t(2).transform.z9_1.z = MathUtils_instance.wh(angle + $this.PIf / 2.0);
    commands.t(3).transform.z9_1.z = MathUtils_instance.wh(-angle + $this.PIf / 2.0);
    commands.t(4).transform.z9_1.z = MathUtils_instance.wh(angle + $this.PIf / 2.0);
    commands.t(5).transform.z9_1.z = MathUtils_instance.wh(-angle + $this.PIf / 2.0);
    setUniform_4(commands.t(0).uniforms.t(1), preset.y1e_1);
    setUniform_4(commands.t(1).uniforms.t(1), preset.y1e_1);
    setUniform_4(commands.t(2).uniforms.t(1), preset.y1e_1);
    setUniform_4(commands.t(3).uniforms.t(1), preset.y1e_1);
    setUniform_4(commands.t(4).uniforms.t(1), preset.y1e_1);
    setUniform_4(commands.t(5).uniforms.t(1), preset.y1e_1);
    setColorTextureAnimationUniforms(wingTimer1, Animations_getInstance().qk_1, commands.t(0).uniforms);
    setColorTextureAnimationUniforms(wingTimer2, Animations_getInstance().qk_1, commands.t(1).uniforms);
    setColorTextureAnimationUniforms(wingTimer1 + 0.3, Animations_getInstance().qk_1, commands.t(2).uniforms);
    setColorTextureAnimationUniforms(wingTimer2 + 0.5, Animations_getInstance().qk_1, commands.t(3).uniforms);
    setColorTextureAnimationUniforms(wingTimer1 + 0.5, Animations_getInstance().qk_1, commands.t(4).uniforms);
    setColorTextureAnimationUniforms(wingTimer2 + 0.6, Animations_getInstance().qk_1, commands.t(5).uniforms);
  }
  function animateFlags($this) {
    var preset = Presets_getInstance_1().b1f_1[$this.settings.timeOfDay.n4_1];
    $this.i1g_1[0].r = 1.0 * preset.s1e_1.r;
    $this.i1g_1[0].g = 0.6 * preset.s1e_1.g;
    $this.i1g_1[0].b = 0.2 * preset.s1e_1.b;
    $this.i1g_1[0].a = 1.0;
    $this.i1g_1[1].r = 0.9 * preset.s1e_1.r;
    $this.i1g_1[1].g = 0.8 * preset.s1e_1.g;
    $this.i1g_1[1].b = 0.0 * preset.s1e_1.b;
    $this.i1g_1[1].a = 1.0;
    $this.i1g_1[2].r = 1.0 * preset.s1e_1.r;
    $this.i1g_1[2].g = 0.5 * preset.s1e_1.g;
    $this.i1g_1[2].b = 0.4 * preset.s1e_1.b;
    $this.i1g_1[2].a = 1.0;
    $this.j1g_1[0] = $this.h1f_1.nj(Timers_Flag1_getInstance_0()) * $this.PIf * -2.0;
    $this.j1g_1[1] = $this.h1f_1.nj(Timers_Flag2_getInstance_0()) * $this.PIf * -2.0;
    $this.j1g_1[2] = $this.h1f_1.nj(Timers_Flag3_getInstance_0()) * $this.PIf * -2.0;
    $this.j1g_1[3] = $this.h1f_1.nj(Timers_Flag4_getInstance_0()) * $this.PIf * -2.0;
    var iterator = $this.d1g_1.commands.j();
    var index = 0;
    while (iterator.k()) {
      var index_0 = index;
      index = index + 1 | 0;
      var command = iterator.l();
      var uniforms = (command instanceof DrawTransformedMeshCommand ? command : THROW_CCE()).uniforms;
      setUniform_4(uniforms.t(2), $this.i1g_1[index_0]);
      setUniform_5(uniforms.t(3), $this.j1g_1);
      var tmp2_array = $this.j1g_1;
      tmp2_array[0] = tmp2_array[0] + index_0 * 0.5;
      var tmp4_array = $this.j1g_1;
      tmp4_array[1] = tmp4_array[1] + index_0 * 0.5;
      var tmp6_array = $this.j1g_1;
      tmp6_array[2] = tmp6_array[2] + index_0 * 0.5;
      var tmp8_array = $this.j1g_1;
      tmp8_array[3] = tmp8_array[3] + index_0 * 0.5;
    }
  }
  function animateLanterns($this) {
    var timerRot = $this.h1f_1.nj(Timers_BouysRotation_getInstance_1());
    var iterator = $this.z1f_1.commands.j();
    var index = 0;
    while (iterator.k()) {
      var index_0 = index;
      index = index + 1 | 0;
      var command = iterator.l();
      var dayCommand = command instanceof DrawTransformedMeshCommand ? command : THROW_CCE();
      var tmp = $this.a1g_1.commands.t(index_0);
      var nightCommand = tmp instanceof DrawTransformedMeshCommand ? tmp : THROW_CCE();
      var tmp_0 = MathUtils_instance;
      // Inline function 'kotlin.math.sin' call
      var x = timerRot * $this.PIf * 6.0 + index_0;
      var tmp$ret$0 = Math.sin(x);
      var rotx = tmp_0.wh(tmp$ret$0 * 0.12);
      var tmp_1 = MathUtils_instance;
      // Inline function 'kotlin.math.cos' call
      var x_0 = timerRot * $this.PIf * 4.0 + index_0;
      var tmp$ret$1 = Math.cos(x_0);
      var roty = tmp_1.wh(tmp$ret$1 * 0.12);
      dayCommand.transform.z9_1.x = rotx;
      dayCommand.transform.z9_1.y = roty;
      nightCommand.transform.z9_1.x = rotx;
      nightCommand.transform.z9_1.y = roty;
    }
  }
  function animateBox($this) {
    var timer = $this.h1f_1.nj(Timers_BouysBobbing_getInstance_1());
    // Inline function 'kotlin.math.sin' call
    var x = timer * $this.PIf * 2.0 + 1.0;
    var bobBox = Math.sin(x) * 2.0;
    $this.b1g_1.transform.y9_1.z = 36.4329 + bobBox;
    $this.c1g_1.transform.y9_1.z = 36.4329 + bobBox;
  }
  function animateBoat($this) {
    var timer = $this.h1f_1.nj(Timers_BouysBobbing_getInstance_1());
    // Inline function 'kotlin.math.sin' call
    var x = timer * $this.PIf * 2.0;
    var bobBoat = Math.sin(x) * 2.0;
    $this.w1f_1.transform.y9_1.z = 30.0 + bobBoat;
  }
  function animateWater_0($this) {
    var preset = Presets_getInstance_1().b1f_1[$this.settings.timeOfDay.n4_1];
    var time = $this.h1f_1.nj(Timers_Water_getInstance_2());
    setUniform_1($this.r1f_1.uniforms.t(1), time);
    setUniform_4($this.r1f_1.uniforms.t(6), preset.q1e_1);
    setUniform_4($this.r1f_1.uniforms.t(7), preset.r1e_1);
    setUniform_4($this.r1f_1.uniforms.t(8), preset.p1e_1);
    setUniform_4($this.q1f_1.uniforms.t(2), preset.t1e_1);
    $this.m1f_1.color = preset.p1e_1;
    if ($this.settings.colorMode.equals(ColorMode_Greyscale_getInstance_2())) {
      $this.m1f_1.color = Presets_getInstance_1().a1f_1;
      setUniform_4($this.r1f_1.uniforms.t(8), Presets_getInstance_1().a1f_1);
    } else if ($this.settings.colorMode.equals(ColorMode_Sepia_getInstance_3())) {
      $this.m1f_1.color = Presets_getInstance_1().z1e_1;
      setUniform_4($this.r1f_1.uniforms.t(8), Presets_getInstance_1().z1e_1);
    }
    $this.l1g_1.value[0] = preset.s1e_1.r;
    $this.l1g_1.value[1] = preset.s1e_1.g;
    $this.l1g_1.value[2] = preset.s1e_1.b;
  }
  function applyPreset($this) {
    var preset = Presets_getInstance_1().b1f_1[$this.settings.timeOfDay.n4_1];
    $this.f1g_1.enabled = preset.w1e_1 ? !$this.settings.lowQuality : false;
    $this.g1g_1.enabled = preset.w1e_1 ? !$this.settings.lowQuality : false;
    $this.e1g_1.enabled = preset.x1e_1 ? !$this.settings.lowQuality : false;
    $this.p1f_1.enabled = $this.settings.timeOfDay === TimeOfDay_Night_getInstance_4();
    $this.x1f_1.enabled = !preset.w1e_1;
    $this.y1f_1.enabled = preset.w1e_1;
    $this.m1g_1.value[0] = preset.u1e_1.r;
    $this.m1g_1.value[1] = preset.u1e_1.g;
    $this.m1g_1.value[2] = preset.u1e_1.b;
    $this.n1g_1.value[0] = preset.v1e_1.r;
    $this.n1g_1.value[1] = preset.v1e_1.g;
    $this.n1g_1.value[2] = preset.v1e_1.b;
    $this.m1f_1.color = preset.p1e_1;
    setUniform_4($this.q1f_1.uniforms.t(2), preset.t1e_1);
    $this.l1g_1.value[0] = preset.s1e_1.r;
    $this.l1g_1.value[1] = preset.s1e_1.g;
    $this.l1g_1.value[2] = preset.s1e_1.b;
  }
  function positionCamera_3($this, time) {
    if ($this.useExternalViewMatrix) {
      return Unit_instance;
    }
    if ($this.settings.cameraMode.equals(CameraMode_Random_getInstance_2())) {
      var cameraPositionInterpolator = $this.cameraAnimator.positionInterpolator;
      var eye = cameraPositionInterpolator.cameraPosition;
      var lookat = cameraPositionInterpolator.cameraRotation;
      Matrix_getInstance().di($this.matView, 0, eye.x, eye.y, eye.z, lookat.x, lookat.y, lookat.z, 0.0, 0.0, 1.0);
    } else if ($this.settings.cameraMode.equals(CameraMode_Orbiting_getInstance_2())) {
      var deltaTime = time - $this.lastFrameTime;
      var timerBobX = $this.h1f_1.nj(Timers_OrbitingCameraX_getInstance_2());
      var timerBobZ = $this.h1f_1.nj(Timers_OrbitingCameraZ_getInstance_2());
      $this.orbitingCamera.uj_1.fk_1 = $this.settings.cameraPeriod;
      $this.orbitingCamera.yj(deltaTime, timerBobX, timerBobZ);
      Matrix_getInstance().xh($this.orbitingCamera.xj_1, 0, $this.matView, 0, 16);
    }
  }
  function randomizeCamera_1($this) {
    if ($this.h1f_1.nj(Timers_Camera_getInstance_2()) === 0.0) {
      $this.o1g_1 = Default_getInstance().c6() * $this.PIf * 2.0;
      $this.p1g_1 = (Default_getInstance().c6() - 0.3) * $this.PIf * 0.9;
      $this.q1g_1 = Default_getInstance().c6() * $this.PIf * 2.0;
      $this.r1g_1 = (Default_getInstance().c6() - 0.3) * $this.PIf * 0.9;
    } else {
      $this.o1g_1 = $this.q1g_1;
      $this.p1g_1 = $this.r1g_1;
      $this.q1g_1 = Default_getInstance().c6() * $this.PIf * 2.0;
      $this.r1g_1 = (Default_getInstance().c6() - 0.3) * $this.PIf * 0.9;
    }
    $this.s1g_1 = 3300.0;
    $this.s1g_1 = 3300.0;
  }
  function ShipwreckScene() {
    Scene.call(this);
    this.h1f_1 = new TimersMap();
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i1g_1 = [new Vec4(), new Vec4(), new Vec4()];
    var tmp_0 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_0.j1g_1 = new Float32Array([0.0, 0.0, 0.0, 0.0]);
    this.k1g_1 = mutableListOf([get_HINT_VRS_NONE()]);
    this.PIf = 3.1415927;
    var tmp_1 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$4 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    tmp_1.l1g_1 = UniformFloatValueWithArray(tmp$ret$4);
    var tmp_2 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$5 = new Float32Array([3.0, 1.2000000000000002, 0.0, 1.0]);
    tmp_2.m1g_1 = UniformFloatValueWithArray(tmp$ret$5);
    var tmp_3 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$6 = new Float32Array([3.0, 1.2000000000000002, 0.0, 1.0]);
    tmp_3.n1g_1 = UniformFloatValueWithArray(tmp$ret$6);
    this.o1g_1 = 0.0;
    this.p1g_1 = 0.0;
    this.q1g_1 = 0.0;
    this.r1g_1 = 0.0;
    this.s1g_1 = 3000.0;
    this.t1g_1 = 1000000.0;
    this.u1g_1 = 23000.0;
    this.v1g_1 = 2000.0;
    this.meshes = Meshes_getInstance_4().o1e_1;
    this.textures = Textures_getInstance_4().s1h_1;
    this.shaders = Shaders_getInstance_4().d1i_1;
    Companion_instance_9.f1i(this.h1f_1);
    this.Z_NEAR = 10.0;
    this.Z_FAR = 12000.0;
    this.FOV_LANDSCAPE = 70.0;
    this.FOV_PORTRAIT = 100.0;
    var tmp_4 = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new ShipwreckSettings_0();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_0.cameraPeriod = 1.0;
    this_0.vignette = true;
    this_0.blurred = false;
    this_0.autoSwitchCameras = true;
    this_0.lowQuality = false;
    this_0.clock = false;
    this_0.timeOfDay = TimeOfDay_Day_getInstance_4();
    this_0.cameraMode = CameraMode_Orbiting_getInstance_2();
    tmp_4.settings = this_0;
    var tmp_5 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new OrbitingCameraConfig();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_1.ck_1 = 550.0;
    this_1.bk_1 = 400.0;
    this_1.gk_1 = new Vec3(0.0, 0.0, 300.0);
    tmp_5.orbitingCamera = new OrbitingCamera(this_1);
    this.cameraAnimator = new CameraPathAnimator(this.t1g_1, this.u1g_1, this.v1g_1, true);
    this.cameraAnimator.setCameras(Cameras_getInstance_4().s1d_1);
    this.cameraAnimator.minDurationCoefficient = this.settings.cameraPeriod;
    var tmp_6 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new ClearColorCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_2.color = new Vec4(0.0, 0.7843137254901961, 0.0, 1.0);
    this_2.name = 'clear color';
    this_2.enabled = true;
    tmp_6.m1f_1 = this_2;
    var txOrigin = new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(10.0, 10.0, 10.0));
    var commonVertexAttributesDescriptor = new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_HALF2_getInstance(), 6)]), 12);
    var stateDiffuseColoredFp16 = new DrawMeshState(Shaders_getInstance_4().v1h_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), commonVertexAttributesDescriptor);
    var stateDiffuseColoredAtFp16 = new DrawMeshState(Shaders_getInstance_4().w1h_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_DISABLED_getInstance(), commonVertexAttributesDescriptor);
    var tmp_7 = this;
    // Inline function 'kotlin.apply' call
    var tmp_8 = Meshes_getInstance_4().d1e_1;
    var tmp_9 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$10 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var this_3 = DrawStaticMeshCommandConstructor(tmp_8, listOf([tmp_9, UniformFloatValueWithArray(tmp$ret$10)]), Companion_instance_0.forSolidGeometry(Meshes_getInstance_4().d1e_1, Shaders_getInstance_4().a1i_1), new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(0.13, 0.13, 0.13)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_3.hints = this.k1g_1;
    tmp_7.p1f_1 = this_3;
    var tmp_10 = this;
    // Inline function 'kotlin.apply' call
    var tmp_11 = Meshes_getInstance_4().c1e_1;
    var tmp_12 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_13 = new UniformTextureValue(Textures_getInstance_4().h1h_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$12 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var this_4 = DrawStaticMeshCommandConstructor(tmp_11, listOf([tmp_12, tmp_13, UniformFloatValueWithArray(tmp$ret$12)]), stateDiffuseColoredAtFp16, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(130.0, 130.0, 130.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_4.hints = this.k1g_1;
    tmp_10.q1f_1 = this_4;
    var tmp_14 = this;
    // Inline function 'kotlin.apply' call
    var tmp_15 = Companion_instance_1;
    var tmp_16 = Meshes_getInstance_4().b1e_1;
    var tmp_17 = Shaders_getInstance_4().y1h_1;
    var tmp_18 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$14 = new Float32Array([0.0]);
    var tmp_19 = UniformFloatValueWithArray(tmp$ret$14);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$15 = new Float32Array([0.002, 0.003]);
    var this_5 = tmp_15.forSolidGeometry(tmp_16, tmp_17, listOf([tmp_18, tmp_19, UniformFloatValueWithArray(tmp$ret$15), UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().f1h_1), new UniformTextureValue(Textures_getInstance_4().g1h_1), UniformFloatValueWithArray(new Float32Array(4)), UniformFloatValueWithArray(new Float32Array(4)), UniformFloatValueWithArray(new Float32Array(4))]), new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(300.0, 300.0, 300.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_5.indexUniformModel = 3;
    tmp_14.r1f_1 = this_5;
    var tmp_20 = this;
    // Inline function 'kotlin.apply' call
    var this_6 = Companion_instance_1.forSolidGeometry(Meshes_getInstance_4().n1e_1, Shaders_getInstance_4().v1h_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().i1h_1), this.l1g_1]), new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(150.0, 150.0, 150.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_6.hints = this.k1g_1;
    tmp_20.s1f_1 = this_6;
    var tmp_21 = this;
    // Inline function 'kotlin.apply' call
    var this_7 = Companion_instance_1.forSolidGeometry(Meshes_getInstance_4().m1e_1, Shaders_getInstance_4().w1h_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().j1h_1), this.l1g_1]), new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(150.0, 150.0, 150.0)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_7.state.culling = CullFace_DISABLED_getInstance();
    tmp_21.t1f_1 = this_7;
    var tmp_22 = this;
    var tmp_23 = Companion_instance_1;
    var tmp_24 = Meshes_getInstance_4().g1e_1;
    var tmp_25 = Shaders_getInstance_4().z1h_1;
    var tmp_26 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$19 = new Float32Array([-0.7071, 0.7071, 0.0, 1.0]);
    var tmp_27 = UniformFloatValueWithArray(tmp$ret$19);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$20 = new Float32Array([0.735]);
    tmp_22.u1f_1 = tmp_23.forSolidGeometry(tmp_24, tmp_25, listOf([tmp_26, this.l1g_1, tmp_27, UniformFloatValueWithArray(tmp$ret$20), new UniformTextureValue(Textures_getInstance_4().k1h_1)]), new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(150.0, 150.0, 150.0)));
    var tmp_28 = this;
    var tmp_29 = Meshes_getInstance_4().l1e_1;
    var tmp_30 = listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().l1h_1), new UniformTextureValue(Textures_getInstance_4().m1h_1), this.l1g_1]);
    var tmp_31 = Shaders_getInstance_4().t1h_1;
    // Inline function 'kotlin.apply' call
    var this_8 = new Blending();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_8.enabled = true;
    this_8.equationColor = BlendingEquation_ADD_getInstance();
    this_8.sourceFactorColor = BlendingFactor_SRC_ALPHA_getInstance();
    this_8.destinationFactorColor = BlendingFactor_ONE_MINUS_SRC_ALPHA_getInstance();
    tmp_28.v1f_1 = DrawStaticMeshCommandConstructor(tmp_29, tmp_30, new DrawMeshState(tmp_31, this_8, get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), Companion_instance.fromMeshAndShader(Meshes_getInstance_4().l1e_1, Shaders_getInstance_4().t1h_1)), new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(300.0, 300.0, 300.0)));
    this.w1f_1 = new DrawTransformedMeshCommand(Meshes_getInstance_4().a1e_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().q1h_1), this.l1g_1]), stateDiffuseColoredFp16, new AffineTranformation(new Vec3(140.0, 60.0, 30.0), new Vec3(0.0, 0.0, 0.0), new Vec3(20.0, 20.0, 20.0)));
    var stateLM = Companion_instance_0.forSolidGeometry(Meshes_getInstance_4().k1e_1, Shaders_getInstance_4().t1h_1);
    var stateLmNight = Companion_instance_0.forSolidGeometry(Meshes_getInstance_4().k1e_1, Shaders_getInstance_4().u1h_1);
    var stateLanternsNight = Companion_instance_0.forSolidGeometry(Meshes_getInstance_4().i1e_1, Shaders_getInstance_4().v1h_1);
    var tmp_32 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_9 = get_LANTERNS();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(this_9.length);
    var inductionVariable = 0;
    var last = this_9.length;
    while (inductionVariable < last) {
      var item = this_9[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
      var tmp$ret$22 = new DrawTransformedMeshCommand(Meshes_getInstance_4().i1e_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().n1h_1), new UniformTextureValue(Textures_getInstance_4().m1h_1), this.l1g_1]), stateLM, new AffineTranformation(new Vec3(item.t1d_1.x * -300.0, item.t1d_1.y * -300.0, item.t1d_1.z * 300.0), new Vec3(0.0, 0.0, 0.0), new Vec3(item.u1d_1 * 300.0, item.u1d_1 * 300.0, item.u1d_1 * 300.0)));
      destination.g(tmp$ret$22);
    }
    var tmp$ret$25 = copyToArray(destination);
    tmp_32.z1f_1 = GroupCommandArr(true, tmp$ret$25.slice());
    var tmp_33 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_10 = get_LANTERNS();
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(this_10.length);
    var inductionVariable_0 = 0;
    var last_0 = this_10.length;
    while (inductionVariable_0 < last_0) {
      var item_0 = this_10[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
      var tmp$ret$26 = new DrawTransformedMeshCommand(Meshes_getInstance_4().i1e_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().n1h_1), this.n1g_1]), stateLanternsNight, new AffineTranformation(new Vec3(item_0.t1d_1.x * -300.0, item_0.t1d_1.y * -300.0, item_0.t1d_1.z * 300.0), new Vec3(0.0, 0.0, 0.0), new Vec3(item_0.u1d_1 * 300.0, item_0.u1d_1 * 300.0, item_0.u1d_1 * 300.0)));
      destination_0.g(tmp$ret$26);
    }
    var tmp$ret$29 = copyToArray(destination_0);
    tmp_33.a1g_1 = GroupCommandArr(true, tmp$ret$29.slice());
    this.b1g_1 = new DrawTransformedMeshCommand(Meshes_getInstance_4().j1e_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().n1h_1), new UniformTextureValue(Textures_getInstance_4().m1h_1), this.l1g_1]), stateLM, new AffineTranformation(new Vec3(220.0824, 119.90639999999999, 36.4329), new Vec3(0.0, 0.0, 0.0), new Vec3(300.0, 300.0, 300.0)));
    this.c1g_1 = DrawStaticMeshCommandConstructor(Meshes_getInstance_4().j1e_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().n1h_1), new UniformTextureValue(Textures_getInstance_4().m1h_1), this.l1g_1, this.m1g_1]), stateLmNight, new AffineTranformation(new Vec3(220.0824, 119.90639999999999, 36.4329), new Vec3(0.0, 0.0, 0.0), new Vec3(300.0, 300.0, 300.0)));
    this.x1f_1 = GroupCommandArr(true, [DrawStaticMeshCommandConstructor(Meshes_getInstance_4().h1e_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().n1h_1), new UniformTextureValue(Textures_getInstance_4().m1h_1), this.l1g_1]), stateLM, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(300.0, 300.0, 300.0))), this.b1g_1, this.z1f_1, DrawStaticMeshCommandConstructor(Meshes_getInstance_4().k1e_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().l1h_1), new UniformTextureValue(Textures_getInstance_4().m1h_1), this.l1g_1]), stateLM, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(300.0, 300.0, 300.0))), this.v1f_1]);
    this.y1f_1 = GroupCommandArr(false, [DrawStaticMeshCommandConstructor(Meshes_getInstance_4().h1e_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().n1h_1), new UniformTextureValue(Textures_getInstance_4().m1h_1), this.l1g_1, this.m1g_1]), stateLmNight, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(300.0, 300.0, 300.0))), this.c1g_1, this.a1g_1, DrawStaticMeshCommandConstructor(Meshes_getInstance_4().k1e_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_4().l1h_1), new UniformTextureValue(Textures_getInstance_4().m1h_1), this.l1g_1, this.m1g_1]), stateLmNight, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(300.0, 300.0, 300.0))), this.v1f_1]);
    // Inline function 'kotlin.apply' call
    var this_11 = Companion_instance_0.forSolidGeometry(Meshes_getInstance_4().f1e_1, Shaders_getInstance_4().x1h_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_11.culling = CullFace_DISABLED_getInstance();
    var stateFlags = this_11;
    var halfFlagHeight = 4.172999999999993;
    var tmp_34 = this;
    var tmp_35 = Meshes_getInstance_4().f1e_1;
    var tmp_36 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_37 = new UniformTextureValue(Textures_getInstance_4().o1h_1);
    var tmp_38 = UniformFloatValueWithArray(new Float32Array(4));
    var tmp_39 = UniformFloatValueWithArray(new Float32Array(4));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$31 = new Float32Array([0.05, 0.01, 0.4, 0.1]);
    var tmp_40 = UniformFloatValueWithArray(tmp$ret$31);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$32 = new Float32Array([7.0, 11.0, 3.0, 8.0]);
    var tmp_41 = DrawStaticMeshCommandConstructor(tmp_35, listOf([tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, UniformFloatValueWithArray(tmp$ret$32)]), stateFlags, new AffineTranformation(new Vec3(181.6218, -165.6348, 547.089 + halfFlagHeight), new Vec3(0.0, 0.0, 90.0), new Vec3(60.0, 60.0, 5.0)));
    var tmp_42 = Meshes_getInstance_4().f1e_1;
    var tmp_43 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_44 = new UniformTextureValue(Textures_getInstance_4().o1h_1);
    var tmp_45 = UniformFloatValueWithArray(new Float32Array(4));
    var tmp_46 = UniformFloatValueWithArray(new Float32Array(4));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$33 = new Float32Array([0.05, 0.01, 0.4, 0.1]);
    var tmp_47 = UniformFloatValueWithArray(tmp$ret$33);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$34 = new Float32Array([7.0, 11.0, 3.0, 8.0]);
    var tmp_48 = DrawStaticMeshCommandConstructor(tmp_42, listOf([tmp_43, tmp_44, tmp_45, tmp_46, tmp_47, UniformFloatValueWithArray(tmp$ret$34)]), stateFlags, new AffineTranformation(new Vec3(-254.4384, -122.4357, 517.89 + halfFlagHeight), new Vec3(0.0, 0.0, 90.0), new Vec3(60.0, 60.0, 5.0)));
    var tmp_49 = Meshes_getInstance_4().f1e_1;
    var tmp_50 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_51 = new UniformTextureValue(Textures_getInstance_4().o1h_1);
    var tmp_52 = UniformFloatValueWithArray(new Float32Array(4));
    var tmp_53 = UniformFloatValueWithArray(new Float32Array(4));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$35 = new Float32Array([0.05, 0.01, 0.4, 0.1]);
    var tmp_54 = UniformFloatValueWithArray(tmp$ret$35);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$36 = new Float32Array([7.0, 11.0, 3.0, 8.0]);
    tmp_34.d1g_1 = GroupCommandArr(true, [tmp_41, tmp_48, DrawStaticMeshCommandConstructor(tmp_49, listOf([tmp_50, tmp_51, tmp_52, tmp_53, tmp_54, UniformFloatValueWithArray(tmp$ret$36)]), stateFlags, new AffineTranformation(new Vec3(30.674999999999997, -136.5897, 593.208 + halfFlagHeight), new Vec3(0.0, 0.0, 90.0), new Vec3(60.0, 60.0, 5.0)))]);
    var stateBird = new DrawMeshState(Shaders_getInstance_4().c1i_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), null);
    var birdScale = new Vec3(0.7, 0.35, 0.35);
    this.e1g_1 = GroupCommandArr(true, [getBirdTextureAnimatedDrawCommand(Meshes_getInstance_4().e1e_1, stateBird, 1200.0, birdScale), getBirdTextureAnimatedDrawCommand(Meshes_getInstance_4().e1e_1, stateBird, 1100.0, birdScale), getBirdTextureAnimatedDrawCommand(Meshes_getInstance_4().e1e_1, stateBird, 700.0, birdScale), getBirdTextureAnimatedDrawCommand(Meshes_getInstance_4().e1e_1, stateBird, 900.0, birdScale), getBirdTextureAnimatedDrawCommand(Meshes_getInstance_4().e1e_1, stateBird, 600.0, birdScale), getBirdTextureAnimatedDrawCommand(Meshes_getInstance_4().e1e_1, stateBird, 500.0, birdScale)]);
    var tmp_55 = this;
    var tmp_56 = Shaders_getInstance_4().b1i_1;
    var tmp_57 = new Vec3(0.0, -500.0, 0.0);
    var tmp_58 = new Vec3(10.0, 1.0, 10.0);
    var tmp_59 = new Vec3(550.0, 350.0, 450.0);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp_60 = new Float32Array([0.15, 0.25, 1.3]);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$38 = new Float32Array([0.032, 0.05, 0.02]);
    tmp_55.h1g_1 = Wind_init_$Create$(tmp_56, new WindParams(85, 0.2, tmp_57, tmp_58, tmp_59, tmp_60, tmp$ret$38, 0.25, 55.0, -20.0));
    var tmp_61 = this;
    // Inline function 'kotlin.apply' call
    var this_12 = new BlurredPassCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_12.name = 'bloom';
    this_12.enabled = true;
    this_12.minSize = 180;
    this_12.brightness = 0.92;
    this_12.blurSize = BlurSize_KERNEL_5_getInstance();
    var tmp_62 = this_12;
    // Inline function 'kotlin.apply' call
    var this_13 = new ClearColorCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>.<anonymous>' call
    this_13.color = new Vec4(0.0, 0.0, 0.0, 1.0);
    this_13.enabled = true;
    var tmp_63 = this_13;
    // Inline function 'kotlin.apply' call
    var this_14 = new ClearCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>.<anonymous>' call
    this_14.clearType = ClearCommandClearType_COLOR_AND_DEPTH_getInstance();
    var tmp_64 = this_14;
    var tmp_65 = Meshes_getInstance_4().h1e_1;
    var tmp_66 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_67 = new UniformTextureValue(Textures_getInstance_4().r1h_1);
    var tmp_68 = new UniformTextureValue(Textures_getInstance_4().r1h_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$41 = new Float32Array([0.0, 0.0, 0.0, 0.0]);
    var tmp_69 = UniformFloatValueWithArray(tmp$ret$41);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$42 = new Float32Array([0.0, 0.0, 0.0, 0.0]);
    var tmp_70 = DrawStaticMeshCommandConstructor(tmp_65, listOf([tmp_66, tmp_67, tmp_68, tmp_69, UniformFloatValueWithArray(tmp$ret$42)]), stateLmNight, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(300.0, 300.0, 300.0)));
    var tmp_71 = Companion_instance_1;
    var tmp_72 = Meshes_getInstance_4().g1e_1;
    var tmp_73 = Shaders_getInstance_4().z1h_1;
    var tmp_74 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$43 = new Float32Array([0.0, 0.0, 0.0, 0.0]);
    var tmp_75 = UniformFloatValueWithArray(tmp$ret$43);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$44 = new Float32Array([-0.7071, 0.7071, 0.0, 1.0]);
    var tmp_76 = UniformFloatValueWithArray(tmp$ret$44);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$45 = new Float32Array([0.735]);
    tmp_62.commands = mutableListOf([tmp_63, tmp_64, tmp_70, tmp_71.forSolidGeometry(tmp_72, tmp_73, listOf([tmp_74, tmp_75, tmp_76, UniformFloatValueWithArray(tmp$ret$45), new UniformTextureValue(Textures_getInstance_4().r1h_1)]), new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(150.0, 150.0, 150.0))), this.a1g_1]);
    this_12.id = 1;
    tmp_61.g1g_1 = this_12;
    var tmp_77 = this;
    // Inline function 'kotlin.apply' call
    var this_15 = new ClearCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_15.clearType = ClearCommandClearType_COLOR_AND_DEPTH_getInstance();
    tmp_77.l1f_1 = GroupCommandArr(true, [this.m1f_1, this_15]);
    var tmp_78 = this;
    // Inline function 'kotlin.apply' call
    var this_16 = new VignetteCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_16.color0 = new Vec4(0.7, 0.7, 0.7, 1.0);
    this_16.color1 = new Vec4(1.0, 1.0, 1.0, 1.0);
    tmp_78.n1f_1 = this_16;
    var tmp_79 = this;
    // Inline function 'kotlin.apply' call
    var this_17 = new DrawBlurredCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_17.name = 'draw bloom';
    var tmp_80 = this_17;
    // Inline function 'kotlin.apply' call
    var this_18 = new Blending();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>.<anonymous>' call
    this_18.enabled = true;
    this_18.equationColor = BlendingEquation_ADD_getInstance();
    this_18.sourceFactorColor = BlendingFactor_ONE_getInstance();
    this_18.destinationFactorColor = BlendingFactor_ONE_getInstance();
    tmp_80.blending = this_18;
    tmp_79.f1g_1 = this_17;
    this.i1f_1 = GroupCommandArr(true, [this.g1g_1, MainPassCommandArr(true, [this.l1f_1, this.t1f_1, this.s1f_1, this.u1f_1, this.d1g_1, this.x1f_1, this.y1f_1, this.e1g_1, this.w1f_1, this.r1f_1, this.p1f_1, this.q1f_1, this.h1g_1.a1h_1, this.f1g_1, this.n1f_1])]);
    var tmp_81 = this;
    // Inline function 'kotlin.apply' call
    var this_19 = new BlurredPassCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_19.name = 'blurred-main';
    this_19.enabled = true;
    this_19.minSize = 180;
    this_19.brightness = 0.9;
    this_19.blurSize = BlurSize_KERNEL_4_getInstance();
    this_19.commands = mutableListOf([this.l1f_1, this.t1f_1, this.s1f_1, this.u1f_1, this.d1g_1, this.x1f_1, this.y1f_1, this.e1g_1, this.w1f_1, this.r1f_1, this.q1f_1, this.n1f_1]);
    this_19.id = 0;
    tmp_81.k1f_1 = this_19;
    var tmp_82 = this;
    // Inline function 'kotlin.apply' call
    var this_20 = new DrawBlurredCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.ShipwreckScene.<anonymous>' call
    this_20.name = 'draw blurred';
    this_20.blending = get_BLENDING_NONE();
    tmp_82.o1f_1 = this_20;
    this.j1f_1 = GroupCommandArr(false, [this.k1f_1, MainPassCommandArr(true, [this.l1f_1, this.o1f_1])]);
    this.commands = mutableListOf([this.i1f_1, this.j1f_1]);
  }
  protoOf(ShipwreckScene).mo = function () {
    return this.settings;
  };
  protoOf(ShipwreckScene).cp = function () {
    return this.PIf;
  };
  protoOf(ShipwreckScene).ko = function () {
    return this.cameraAnimator;
  };
  protoOf(ShipwreckScene).yt = function () {
    return this.orbitingCamera;
  };
  protoOf(ShipwreckScene).updateTimers = function (time) {
    this.h1f_1.qj(time);
    this.cameraAnimator.animate(time);
    animate_3(this, time);
    protoOf(Scene).updateTimers.call(this, time);
  };
  protoOf(ShipwreckScene).updateViewportSize = function (width, height) {
    protoOf(Scene).updateViewportSize.call(this, width, height);
  };
  protoOf(ShipwreckScene).initialize = function () {
    randomizeCamera_1(this);
  };
  protoOf(ShipwreckScene).nextCamera = function () {
    this.randomCamera();
  };
  protoOf(ShipwreckScene).randomCamera = function () {
    if (this.cameraAnimator.state.equals(CameraState_TRANSITIONING_getInstance())) {
      return Unit_instance;
    }
    this.cameraAnimator.positionInterpolator.reverse = Default_getInstance().c6() < 0.5;
    this.cameraAnimator.randomCamera();
  };
  protoOf(ShipwreckScene).cameraImpulse = function (impulse) {
    this.orbitingCamera.wj_1 = impulse * this.settings.cameraPeriod;
  };
  var TimeOfDay_Day_instance_4;
  var TimeOfDay_Night_instance_4;
  var TimeOfDay_Sunrise_instance_4;
  var TimeOfDay_Sunset_instance_3;
  function values_12() {
    return [TimeOfDay_Day_getInstance_4(), TimeOfDay_Night_getInstance_4(), TimeOfDay_Sunrise_getInstance_4(), TimeOfDay_Sunset_getInstance_3()];
  }
  function valueOf_12(value) {
    switch (value) {
      case 'Day':
        return TimeOfDay_Day_getInstance_4();
      case 'Night':
        return TimeOfDay_Night_getInstance_4();
      case 'Sunrise':
        return TimeOfDay_Sunrise_getInstance_4();
      case 'Sunset':
        return TimeOfDay_Sunset_getInstance_3();
      default:
        TimeOfDay_initEntries_4();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var TimeOfDay_entriesInitialized_4;
  function TimeOfDay_initEntries_4() {
    if (TimeOfDay_entriesInitialized_4)
      return Unit_instance;
    TimeOfDay_entriesInitialized_4 = true;
    TimeOfDay_Day_instance_4 = new TimeOfDay_4('Day', 0, 0);
    TimeOfDay_Night_instance_4 = new TimeOfDay_4('Night', 1, 1);
    TimeOfDay_Sunrise_instance_4 = new TimeOfDay_4('Sunrise', 2, 2);
    TimeOfDay_Sunset_instance_3 = new TimeOfDay_4('Sunset', 3, 3);
  }
  function TimeOfDay_4(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  var CameraMode_Random_instance_2;
  var CameraMode_Orbiting_instance_2;
  function values_13() {
    return [CameraMode_Random_getInstance_2(), CameraMode_Orbiting_getInstance_2()];
  }
  function valueOf_13(value) {
    switch (value) {
      case 'Random':
        return CameraMode_Random_getInstance_2();
      case 'Orbiting':
        return CameraMode_Orbiting_getInstance_2();
      default:
        CameraMode_initEntries_2();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var CameraMode_entriesInitialized_2;
  function CameraMode_initEntries_2() {
    if (CameraMode_entriesInitialized_2)
      return Unit_instance;
    CameraMode_entriesInitialized_2 = true;
    CameraMode_Random_instance_2 = new CameraMode_2('Random', 0, 0);
    CameraMode_Orbiting_instance_2 = new CameraMode_2('Orbiting', 1, 1);
  }
  function CameraMode_2(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  var ColorMode_None_instance_2;
  var ColorMode_Sepia_instance_2;
  var ColorMode_Greyscale_instance_2;
  function values_14() {
    return [ColorMode_None_getInstance_2(), ColorMode_Sepia_getInstance_3(), ColorMode_Greyscale_getInstance_2()];
  }
  function valueOf_14(value) {
    switch (value) {
      case 'None':
        return ColorMode_None_getInstance_2();
      case 'Sepia':
        return ColorMode_Sepia_getInstance_3();
      case 'Greyscale':
        return ColorMode_Greyscale_getInstance_2();
      default:
        ColorMode_initEntries_2();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ColorMode_entriesInitialized_2;
  function ColorMode_initEntries_2() {
    if (ColorMode_entriesInitialized_2)
      return Unit_instance;
    ColorMode_entriesInitialized_2 = true;
    ColorMode_None_instance_2 = new ColorMode_2('None', 0, 0);
    ColorMode_Sepia_instance_2 = new ColorMode_2('Sepia', 1, 1);
    ColorMode_Greyscale_instance_2 = new ColorMode_2('Greyscale', 2, 2);
  }
  function ColorMode_2(name, ordinal, value) {
    Enum.call(this, name, ordinal);
  }
  function ShipwreckSettings_0() {
    this.cameraPeriod = 1.0;
    this.vignette = true;
    this.blurred = false;
    this.autoSwitchCameras = true;
    this.lowQuality = false;
    this.clock = false;
    this.timeOfDay = TimeOfDay_Day_getInstance_4();
    this.cameraMode = CameraMode_Random_getInstance_2();
    this.debugDouble = 1.0;
    this.debugFloat = 1.0;
    this.debugString = '';
    this.colorMode = ColorMode_None_getInstance_2();
  }
  protoOf(ShipwreckSettings_0).fp = function (_set____db54di) {
    this.cameraPeriod = _set____db54di;
  };
  protoOf(ShipwreckSettings_0).gp = function () {
    return this.cameraPeriod;
  };
  protoOf(ShipwreckSettings_0).hp = function (_set____db54di) {
    this.vignette = _set____db54di;
  };
  protoOf(ShipwreckSettings_0).ip = function () {
    return this.vignette;
  };
  protoOf(ShipwreckSettings_0).jp = function (_set____db54di) {
    this.blurred = _set____db54di;
  };
  protoOf(ShipwreckSettings_0).kp = function () {
    return this.blurred;
  };
  protoOf(ShipwreckSettings_0).lp = function (_set____db54di) {
    this.autoSwitchCameras = _set____db54di;
  };
  protoOf(ShipwreckSettings_0).mp = function () {
    return this.autoSwitchCameras;
  };
  protoOf(ShipwreckSettings_0).rp = function (_set____db54di) {
    this.lowQuality = _set____db54di;
  };
  protoOf(ShipwreckSettings_0).sp = function () {
    return this.lowQuality;
  };
  protoOf(ShipwreckSettings_0).pp = function (_set____db54di) {
    this.clock = _set____db54di;
  };
  protoOf(ShipwreckSettings_0).qp = function () {
    return this.clock;
  };
  protoOf(ShipwreckSettings_0).m1i = function (_set____db54di) {
    this.timeOfDay = _set____db54di;
  };
  protoOf(ShipwreckSettings_0).op = function () {
    return this.timeOfDay;
  };
  protoOf(ShipwreckSettings_0).n1i = function (_set____db54di) {
    this.cameraMode = _set____db54di;
  };
  protoOf(ShipwreckSettings_0).hu = function () {
    return this.cameraMode;
  };
  protoOf(ShipwreckSettings_0).iu = function (_set____db54di) {
    this.debugDouble = _set____db54di;
  };
  protoOf(ShipwreckSettings_0).ju = function () {
    return this.debugDouble;
  };
  protoOf(ShipwreckSettings_0).ku = function (_set____db54di) {
    this.debugFloat = _set____db54di;
  };
  protoOf(ShipwreckSettings_0).lu = function () {
    return this.debugFloat;
  };
  protoOf(ShipwreckSettings_0).mu = function (_set____db54di) {
    this.debugString = _set____db54di;
  };
  protoOf(ShipwreckSettings_0).nu = function () {
    return this.debugString;
  };
  protoOf(ShipwreckSettings_0).o1i = function (_set____db54di) {
    this.colorMode = _set____db54di;
  };
  protoOf(ShipwreckSettings_0).wq = function () {
    return this.colorMode;
  };
  function TimeOfDay_Day_getInstance_4() {
    TimeOfDay_initEntries_4();
    return TimeOfDay_Day_instance_4;
  }
  function TimeOfDay_Night_getInstance_4() {
    TimeOfDay_initEntries_4();
    return TimeOfDay_Night_instance_4;
  }
  function TimeOfDay_Sunrise_getInstance_4() {
    TimeOfDay_initEntries_4();
    return TimeOfDay_Sunrise_instance_4;
  }
  function TimeOfDay_Sunset_getInstance_3() {
    TimeOfDay_initEntries_4();
    return TimeOfDay_Sunset_instance_3;
  }
  function CameraMode_Random_getInstance_2() {
    CameraMode_initEntries_2();
    return CameraMode_Random_instance_2;
  }
  function CameraMode_Orbiting_getInstance_2() {
    CameraMode_initEntries_2();
    return CameraMode_Orbiting_instance_2;
  }
  function ColorMode_None_getInstance_2() {
    ColorMode_initEntries_2();
    return ColorMode_None_instance_2;
  }
  function ColorMode_Sepia_getInstance_3() {
    ColorMode_initEntries_2();
    return ColorMode_Sepia_instance_2;
  }
  function ColorMode_Greyscale_getInstance_2() {
    ColorMode_initEntries_2();
    return ColorMode_Greyscale_instance_2;
  }
  function Shaders_4() {
    Shaders_instance_4 = this;
    this.t1h_1 = ShaderConstructor2('DiffuseColoredLm', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1), to(AttributeType_UV1_getInstance(), 2)]));
    this.u1h_1 = ShaderConstructor2('DiffuseDoubleColoredLm', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1), to(AttributeType_UV1_getInstance(), 2)]));
    this.v1h_1 = ShaderConstructor2('DiffuseColored', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1)]));
    this.w1h_1 = ShaderConstructor2('DiffuseColoredAt', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1)]));
    this.x1h_1 = ShaderConstructor2('Flag', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1)]));
    this.y1h_1 = ShaderConstructor2('StylizedWater', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1)]));
    this.z1h_1 = ShaderConstructor2('Rocks', mapOf([to(AttributeType_VERTEX_getInstance(), 0), to(AttributeType_UV0_getInstance(), 1), to(AttributeType_NORMAL_getInstance(), 2)]));
    this.a1i_1 = ShaderConstructor2('Color', mapOf_0(to(AttributeType_VERTEX_getInstance(), 0)));
    this.b1i_1 = new Shader('Wind');
    this.c1i_1 = new Shader('ColorAnimatedTextureChunked');
    this.d1i_1 = mutableListOf([this.t1h_1, this.u1h_1, this.v1h_1, this.w1h_1, this.x1h_1, this.y1h_1, this.z1h_1, this.a1i_1, this.b1i_1, this.c1i_1]);
  }
  var Shaders_instance_4;
  function Shaders_getInstance_4() {
    if (Shaders_instance_4 == null)
      new Shaders_4();
    return Shaders_instance_4;
  }
  function Textures_4() {
    Textures_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texWaterNoise.<anonymous>' call
    this_0.name = 'water-noise';
    this_0.fileName = 'water-noise';
    this_0.format = TextureFormat_ASTC_getInstance();
    this_0.wrapping = TextureWrapping_REPEAT_getInstance();
    this_0.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_0.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_0.mipmaps = 7;
    tmp.f1h_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texWaterAO.<anonymous>' call
    this_1.name = 'water-ao';
    this_1.fileName = 'water-ao';
    this_1.format = TextureFormat_ASTC_getInstance();
    this_1.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_1.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_1.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_1.anisotropy = 3;
    this_1.mipmaps = 8;
    tmp_0.g1h_1 = this_1;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texClouds.<anonymous>' call
    this_2.name = 'clouds';
    this_2.fileName = 'clouds';
    this_2.format = TextureFormat_ASTC_getInstance();
    this_2.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_2.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_2.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_2.mipmaps = 8;
    tmp_1.h1h_1 = this_2;
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texTreeTrunks.<anonymous>' call
    this_3.name = 'tree_trunk';
    this_3.fileName = 'tree_trunk';
    this_3.format = TextureFormat_ASTC_getInstance();
    this_3.wrapping = TextureWrapping_REPEAT_getInstance();
    this_3.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_3.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_3.mipmaps = 3;
    tmp_2.i1h_1 = this_3;
    var tmp_3 = this;
    // Inline function 'kotlin.apply' call
    var this_4 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texTreeLeaves.<anonymous>' call
    this_4.name = 'tree_leaves';
    this_4.fileName = 'tree_leaves';
    this_4.format = TextureFormat_ASTC_getInstance();
    this_4.wrapping = TextureWrapping_REPEAT_getInstance();
    this_4.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_4.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_4.mipmaps = 7;
    tmp_3.j1h_1 = this_4;
    var tmp_4 = this;
    // Inline function 'kotlin.apply' call
    var this_5 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texRocks.<anonymous>' call
    this_5.name = 'rocks';
    this_5.fileName = 'rocks';
    this_5.format = TextureFormat_ASTC_getInstance();
    this_5.wrapping = TextureWrapping_REPEAT_getInstance();
    this_5.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_5.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_5.mipmaps = 9;
    tmp_4.k1h_1 = this_5;
    var tmp_5 = this;
    // Inline function 'kotlin.apply' call
    var this_6 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texGround.<anonymous>' call
    this_6.name = 'ground';
    this_6.fileName = 'ground';
    this_6.format = TextureFormat_ASTC_getInstance();
    this_6.wrapping = TextureWrapping_REPEAT_getInstance();
    this_6.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_6.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_6.mipmaps = 8;
    tmp_5.l1h_1 = this_6;
    var tmp_6 = this;
    // Inline function 'kotlin.apply' call
    var this_7 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texLM.<anonymous>' call
    this_7.name = 'ship-lm-combined';
    this_7.fileName = 'ship-lm-combined';
    this_7.format = TextureFormat_ASTC_getInstance();
    this_7.wrapping = TextureWrapping_REPEAT_getInstance();
    this_7.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_7.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_7.mipmaps = 11;
    tmp_6.m1h_1 = this_7;
    var tmp_7 = this;
    // Inline function 'kotlin.apply' call
    var this_8 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texShip.<anonymous>' call
    this_8.name = 'ship';
    this_8.fileName = 'ship';
    this_8.format = TextureFormat_ASTC_getInstance();
    this_8.wrapping = TextureWrapping_REPEAT_getInstance();
    this_8.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_8.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_8.mipmaps = 9;
    tmp_7.n1h_1 = this_8;
    var tmp_8 = this;
    // Inline function 'kotlin.apply' call
    var this_9 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texFlag.<anonymous>' call
    this_9.name = 'flag';
    this_9.fileName = 'flag';
    this_9.format = TextureFormat_ASTC_getInstance();
    this_9.wrapping = TextureWrapping_REPEAT_getInstance();
    this_9.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_9.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_9.mipmaps = 3;
    tmp_8.o1h_1 = this_9;
    var tmp_9 = this;
    // Inline function 'kotlin.apply' call
    var this_10 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texBird.<anonymous>' call
    this_10.name = 'bird';
    this_10.fileName = 'bird.rgba.fp16';
    this_10.format = TextureFormat_RGBA16F_getInstance();
    this_10.minFilter = TextureFiltering_NEAREST_getInstance();
    this_10.magFilter = TextureFiltering_NEAREST_getInstance();
    this_10.width = Animations_getInstance().qk_1.vb_1;
    this_10.height = Animations_getInstance().qk_1.ac_1;
    tmp_9.p1h_1 = this_10;
    var tmp_10 = this;
    // Inline function 'kotlin.apply' call
    var this_11 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texBoat.<anonymous>' call
    this_11.name = 'boat';
    this_11.fileName = 'boat';
    this_11.format = TextureFormat_ASTC_getInstance();
    this_11.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    this_11.minFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_11.magFilter = TextureFiltering_LINEAR_MIPMAP_NEAREST_getInstance();
    this_11.mipmaps = 8;
    tmp_10.q1h_1 = this_11;
    var tmp_11 = this;
    // Inline function 'kotlin.apply' call
    var this_12 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.shipwreck.Textures.texBlack.<anonymous>' call
    this_12.name = 'black';
    this_12.fileName = 'black';
    this_12.format = TextureFormat_ASTC_getInstance();
    this_12.wrapping = TextureWrapping_REPEAT_getInstance();
    this_12.minFilter = TextureFiltering_NEAREST_getInstance();
    this_12.magFilter = TextureFiltering_NEAREST_getInstance();
    tmp_11.r1h_1 = this_12;
    this.s1h_1 = mutableListOf([this.g1h_1, this.f1h_1, this.h1h_1, this.i1h_1, this.j1h_1, this.k1h_1, this.l1h_1, this.m1h_1, this.n1h_1, this.o1h_1, this.p1h_1, this.q1h_1, this.r1h_1]);
  }
  var Textures_instance_4;
  function Textures_getInstance_4() {
    if (Textures_instance_4 == null)
      new Textures_4();
    return Textures_instance_4;
  }
  var Timers_Camera_instance_3;
  var Timers_Water_instance_2;
  var Timers_BouysBobbing_instance_1;
  var Timers_BouysRotation_instance_1;
  var Timers_WindMove1_instance_1;
  var Timers_WindMove2_instance_1;
  var Timers_WindMove3_instance_1;
  var Timers_OrbitingCameraZ_instance_2;
  var Timers_OrbitingCameraX_instance_2;
  var Timers_Flag1_instance_0;
  var Timers_Flag2_instance_0;
  var Timers_Flag3_instance_0;
  var Timers_Flag4_instance_0;
  var Timers_BirdWings1_instance_2;
  var Timers_BirdWings2_instance_2;
  var Timers_BirdsFly_instance_2;
  var Timers_ProjectionOffsetTransition_instance_2;
  function Companion_6() {
    this.e1i_1 = 27800.0;
  }
  protoOf(Companion_6).f1i = function (timers) {
    timers.mj(Timers_Camera_getInstance_2(), this.e1i_1, true);
    timers.mj(Timers_Water_getInstance_2(), 25000.0, true);
    timers.mj(Timers_BouysBobbing_getInstance_1(), 2000.0, true);
    timers.mj(Timers_BouysRotation_getInstance_1(), 8000.0, true);
    timers.mj(Timers_WindMove1_getInstance_1(), 7000.0, true);
    timers.mj(Timers_WindMove2_getInstance_1(), 7500.0, true);
    timers.mj(Timers_WindMove3_getInstance_1(), 8000.0, true);
    timers.mj(Timers_OrbitingCameraZ_getInstance_2(), 42000.0, true);
    timers.mj(Timers_OrbitingCameraX_getInstance_2(), 32000.0, true);
    timers.mj(Timers_ProjectionOffsetTransition_getInstance_2(), 2000.0, false);
    timers.mj(Timers_Flag1_getInstance_0(), 300.0, true);
    timers.mj(Timers_Flag2_getInstance_0(), 366.0, true);
    timers.mj(Timers_Flag3_getInstance_0(), 399.0, true);
    timers.mj(Timers_Flag4_getInstance_0(), 333.0, true);
    timers.mj(Timers_BirdWings1_getInstance_2(), 900.0, true);
    timers.mj(Timers_BirdWings2_getInstance_2(), 800.0, true);
    timers.mj(Timers_BirdsFly_getInstance_2(), 11000.0, true);
  };
  var Companion_instance_9;
  function Companion_getInstance_6() {
    return Companion_instance_9;
  }
  var Timers_entriesInitialized_4;
  function Timers_initEntries_4() {
    if (Timers_entriesInitialized_4)
      return Unit_instance;
    Timers_entriesInitialized_4 = true;
    Timers_Camera_instance_3 = new Timers_4('Camera', 0);
    Timers_Water_instance_2 = new Timers_4('Water', 1);
    Timers_BouysBobbing_instance_1 = new Timers_4('BouysBobbing', 2);
    Timers_BouysRotation_instance_1 = new Timers_4('BouysRotation', 3);
    Timers_WindMove1_instance_1 = new Timers_4('WindMove1', 4);
    Timers_WindMove2_instance_1 = new Timers_4('WindMove2', 5);
    Timers_WindMove3_instance_1 = new Timers_4('WindMove3', 6);
    Timers_OrbitingCameraZ_instance_2 = new Timers_4('OrbitingCameraZ', 7);
    Timers_OrbitingCameraX_instance_2 = new Timers_4('OrbitingCameraX', 8);
    Timers_Flag1_instance_0 = new Timers_4('Flag1', 9);
    Timers_Flag2_instance_0 = new Timers_4('Flag2', 10);
    Timers_Flag3_instance_0 = new Timers_4('Flag3', 11);
    Timers_Flag4_instance_0 = new Timers_4('Flag4', 12);
    Timers_BirdWings1_instance_2 = new Timers_4('BirdWings1', 13);
    Timers_BirdWings2_instance_2 = new Timers_4('BirdWings2', 14);
    Timers_BirdsFly_instance_2 = new Timers_4('BirdsFly', 15);
    Timers_ProjectionOffsetTransition_instance_2 = new Timers_4('ProjectionOffsetTransition', 16);
  }
  function Timers_4(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Timers_Camera_getInstance_2() {
    Timers_initEntries_4();
    return Timers_Camera_instance_3;
  }
  function Timers_Water_getInstance_2() {
    Timers_initEntries_4();
    return Timers_Water_instance_2;
  }
  function Timers_BouysBobbing_getInstance_1() {
    Timers_initEntries_4();
    return Timers_BouysBobbing_instance_1;
  }
  function Timers_BouysRotation_getInstance_1() {
    Timers_initEntries_4();
    return Timers_BouysRotation_instance_1;
  }
  function Timers_WindMove1_getInstance_1() {
    Timers_initEntries_4();
    return Timers_WindMove1_instance_1;
  }
  function Timers_WindMove2_getInstance_1() {
    Timers_initEntries_4();
    return Timers_WindMove2_instance_1;
  }
  function Timers_WindMove3_getInstance_1() {
    Timers_initEntries_4();
    return Timers_WindMove3_instance_1;
  }
  function Timers_OrbitingCameraZ_getInstance_2() {
    Timers_initEntries_4();
    return Timers_OrbitingCameraZ_instance_2;
  }
  function Timers_OrbitingCameraX_getInstance_2() {
    Timers_initEntries_4();
    return Timers_OrbitingCameraX_instance_2;
  }
  function Timers_Flag1_getInstance_0() {
    Timers_initEntries_4();
    return Timers_Flag1_instance_0;
  }
  function Timers_Flag2_getInstance_0() {
    Timers_initEntries_4();
    return Timers_Flag2_instance_0;
  }
  function Timers_Flag3_getInstance_0() {
    Timers_initEntries_4();
    return Timers_Flag3_instance_0;
  }
  function Timers_Flag4_getInstance_0() {
    Timers_initEntries_4();
    return Timers_Flag4_instance_0;
  }
  function Timers_BirdWings1_getInstance_2() {
    Timers_initEntries_4();
    return Timers_BirdWings1_instance_2;
  }
  function Timers_BirdWings2_getInstance_2() {
    Timers_initEntries_4();
    return Timers_BirdWings2_instance_2;
  }
  function Timers_BirdsFly_getInstance_2() {
    Timers_initEntries_4();
    return Timers_BirdsFly_instance_2;
  }
  function Timers_ProjectionOffsetTransition_getInstance_2() {
    Timers_initEntries_4();
    return Timers_ProjectionOffsetTransition_instance_2;
  }
  function Cameras_5() {
    Cameras_instance_5 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p1i_1 = [new CameraPositionPair(new CameraPosition(new Vec3(182.522, 451.945, 100.426994), new Vec3(95.628395, -240.9175, 179.154)), new CameraPosition(new Vec3(-343.592, 309.3397, 121.102), new Vec3(-48.3742, -284.307, 183.019)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(466.2929, -304.8695, 30.390701), new Vec3(-343.613, 27.9626, 220.6635)), new CameraPosition(new Vec3(563.2295, 19.3432, 24.534698), new Vec3(-218.45789, 183.19339, 193.65689)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-17.8381, -512.5913, 60.937397), new Vec3(-276.7568, 195.7981, 179.154)), new CameraPosition(new Vec3(502.0434, -225.924, 73.5525), new Vec3(-59.8787, 269.7749, 205.40071)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-620.36957, -208.8635, 52.049202), new Vec3(216.4319, -70.2999, 243.01979)), new CameraPosition(new Vec3(-536.29553, -347.5239, 66.9248), new Vec3(245.4221, 141.5389, 220.25499)), 1.0), new CameraPositionPair(new CameraPosition(new Vec3(-405.834, 809.1909, 140.3126), new Vec3(195.42691, -167.5669, 264.4845)), new CameraPosition(new Vec3(-586.92596, -130.8418, 24.389801), new Vec3(195.42691, -167.5669, 220.6635)), 1.0)];
  }
  var Cameras_instance_5;
  function Cameras_getInstance_5() {
    if (Cameras_instance_5 == null)
      new Cameras_5();
    return Cameras_instance_5;
  }
  function Meshes_5() {
    Meshes_instance_5 = this;
    this.q1i_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6)]), 12);
    this.r1i_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0)), 8);
    this.s1i_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_FLOAT3_getInstance(), 0)), 12);
    this.t1i_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_HALF2_getInstance(), 6), new MeshAttribute(AttributeType_NORMAL_getInstance(), VertexFormat_HALF3_getInstance(), 10)]), 16);
    this.u1i_1 = new MeshAttributes(listOf([new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_HALF3_getInstance(), 0), new MeshAttribute(AttributeType_UV0_getInstance(), VertexFormat_UBYTE2_NORMALIZED_getInstance(), 6)]), 8);
    this.v1i_1 = new MeshAttributes(listOf_0(new MeshAttribute(AttributeType_VERTEX_getInstance(), VertexFormat_FLOAT3_getInstance(), 0)), 12);
    this.w1i_1 = MeshConstructor2('sky', this.q1i_1);
    this.x1i_1 = MeshConstructor2('stars', this.s1i_1);
    this.y1i_1 = MeshConstructor2('building-1', this.t1i_1);
    this.z1i_1 = MeshConstructor2('buildings-distant', this.u1i_1);
    this.a1j_1 = MeshConstructor2('red-lamps', this.r1i_1);
    this.b1j_1 = MeshConstructor2('islands', this.r1i_1);
    this.c1j_1 = MeshConstructor2('water', this.r1i_1);
    this.d1j_1 = MeshConstructor2('neon-signs', this.u1i_1);
    this.e1j_1 = MeshConstructor2('red-lights', this.v1i_1);
    this.f1j_1 = mutableListOf([this.w1i_1, this.x1i_1, this.y1i_1, this.z1i_1, this.a1j_1, this.b1j_1, this.c1j_1, this.d1j_1, this.e1j_1]);
  }
  var Meshes_instance_5;
  function Meshes_getInstance_5() {
    if (Meshes_instance_5 == null)
      new Meshes_5();
    return Meshes_instance_5;
  }
  function SkyscrapersScene() {
    Scene.call(this);
    this.l1j_1 = new TimersMap();
    this.m1j_1 = 1000000.0;
    this.n1j_1 = 29000.0;
    this.o1j_1 = 2600.0;
    this.y1j_1 = mutableListOf([get_HINT_VRS_2X2()]);
    this.z1j_1 = 100.0;
    this.PIf = 3.1415927;
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.a1k_1 = new Float32Array([0.145, 0.137, 0.141, 1.0]);
    this.b1k_1 = 2300.0;
    this.c1k_1 = 2500.0;
    var tmp_0 = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_1 = UniformFloatValueWithArray(this.a1k_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$1 = new Float32Array([this.b1k_1]);
    var tmp_2 = UniformFloatValueWithArray(tmp$ret$1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$2 = new Float32Array([this.c1k_1]);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.d1k_1 = [tmp_1, tmp_2, UniformFloatValueWithArray(tmp$ret$2)];
    this.e1k_1 = 990.0;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$6 = new Float32Array([3.0]);
    var tmp_4 = UniformFloatValueWithArray(tmp$ret$6);
    var tmp_5 = new UniformTextureValue(Textures_getInstance_5().u1k_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$7 = new Float32Array([1.2, 1.2, 1.2, 1.0]);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_3.l1k_1 = [tmp_4, tmp_5, UniformFloatValueWithArray(tmp$ret$7)];
    this.meshes = Meshes_getInstance_5().f1j_1;
    this.textures = Textures_getInstance_5().w1k_1;
    this.shaders = Shaders_getInstance_5().f1l_1;
    Companion_instance_10.g1l(this.l1j_1);
    this.Z_NEAR = 100.0;
    this.Z_FAR = 20000.0;
    this.FOV_LANDSCAPE = 25.0;
    this.FOV_PORTRAIT = 25.0;
    var tmp_6 = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new SkyscrapersSettings();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_0.cameraPeriod = 1.0;
    this_0.vignette = true;
    this_0.blurred = false;
    this_0.autoSwitchCameras = true;
    this_0.lowQuality = false;
    this_0.clock = false;
    tmp_6.settings = this_0;
    this.cameraAnimator = new CameraPathAnimator(this.m1j_1, this.n1j_1, this.o1j_1, true);
    this.cameraAnimator.setCameras(Cameras_getInstance_5().p1i_1);
    this.cameraAnimator.minDurationCoefficient = this.settings.cameraPeriod;
    var tmp_7 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new ClearColorCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_1.color = new Vec4(0.0, 0.0392156862745098, 0.0784313725490196, 1.0);
    this_1.name = 'clear color';
    this_1.enabled = true;
    tmp_7.u1j_1 = this_1;
    // Inline function 'kotlin.apply' call
    var this_2 = new ClearColorCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_2.color = new Vec4(0.0, 0.0, 0.0, 1.0);
    this_2.name = 'clear color bloom';
    this_2.enabled = true;
    var clearColorBloomCommand = this_2;
    var txSceneObjects = new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.z1j_1, this.z1j_1, this.z1j_1));
    var stateSky = new DrawMeshState(Shaders_getInstance_5().y1k_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_HALF2_getInstance(), 6)]), 12));
    var commandSky = DrawStaticMeshCommandConstructor(Meshes_getInstance_5().w1i_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_5().m1k_1), new UniformTextureValue(Textures_getInstance_5().n1k_1)]), stateSky, txSceneObjects);
    var stateStars = new DrawMeshState(Shaders_getInstance_5().z1k_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf_0(new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_FLOAT3_getInstance(), 0)), 12));
    var tmp_8 = this;
    // Inline function 'kotlin.apply' call
    var tmp_9 = Meshes_getInstance_5().x1i_1;
    var tmp_10 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$14 = new Float32Array([0.35, 0.35, 0.35, 1.0]);
    var this_3 = new DrawTransformedMeshCommand(tmp_9, listOf([tmp_10, UniformFloatValueWithArray(tmp$ret$14)]), stateStars, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 0.0), new Vec3(0.055, 0.055, 0.055)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_3.hints = this.y1j_1;
    tmp_8.commandStars = this_3;
    var stateBuilding = new DrawMeshState(Shaders_getInstance_5().a1l_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_HALF2_getInstance(), 6), new VertexAttribute(AttributeType_NORMAL_getInstance(), 2, VertexFormat_HALF3_getInstance(), 10)]), 16));
    var tmp_11 = this;
    // Inline function 'kotlin.apply' call
    var tmp_12 = Meshes_getInstance_5().y1i_1;
    var tmp_13 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_14 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$16 = new Float32Array([0.707106, 0.707106, 0.0]);
    var tmp_15 = UniformFloatValueWithArray(tmp$ret$16);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$17 = new Float32Array([0.05, 0.6]);
    var tmp_16 = UniformFloatValueWithArray(tmp$ret$17);
    var tmp_17 = UniformFloatValueWithArray(new Float32Array(3));
    var tmp_18 = new UniformTextureValue(Textures_getInstance_5().o1k_1);
    var tmp_19 = new UniformTextureValue(Textures_getInstance_5().p1k_1);
    var tmp_20 = new UniformTextureValue(Textures_getInstance_5().q1k_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$18 = new Float32Array([0.33, 0.33, 0.33, 1.0]);
    var tmp_21 = UniformFloatValueWithArray(tmp$ret$18);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$19 = new Float32Array([0.3, 0.3, 0.3, 1.0]);
    var tmp_22 = UniformFloatValueWithArray(tmp$ret$19);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$20 = new Float32Array([1.8]);
    var tmp_23 = UniformFloatValueWithArray(tmp$ret$20);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$21 = new Float32Array([0.0]);
    var this_4 = DrawStaticMeshCommandConstructor(tmp_12, listOf([tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, UniformFloatValueWithArray(tmp$ret$21)]), stateBuilding, txSceneObjects);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_4.indexUniformModel = 1;
    tmp_11.commandBuildings = this_4;
    var tmp_24 = this;
    // Inline function 'kotlin.apply' call
    var tmp_25 = Meshes_getInstance_5().y1i_1;
    var tmp_26 = UniformFloatValueWithArray(new Float32Array(16));
    var tmp_27 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$23 = new Float32Array([0.707106, 0.707106, 0.0]);
    var tmp_28 = UniformFloatValueWithArray(tmp$ret$23);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$24 = new Float32Array([0.05, 0.6]);
    var tmp_29 = UniformFloatValueWithArray(tmp$ret$24);
    var tmp_30 = UniformFloatValueWithArray(new Float32Array(3));
    var tmp_31 = new UniformTextureValue(Textures_getInstance_5().o1k_1);
    var tmp_32 = new UniformTextureValue(Textures_getInstance_5().p1k_1);
    var tmp_33 = new UniformTextureValue(Textures_getInstance_5().q1k_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$25 = new Float32Array([0.0, 0.0, 0.0, 1.0]);
    var tmp_34 = UniformFloatValueWithArray(tmp$ret$25);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$26 = new Float32Array([0.0, 0.0, 0.0, 1.0]);
    var tmp_35 = UniformFloatValueWithArray(tmp$ret$26);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$27 = new Float32Array([2.0]);
    var tmp_36 = UniformFloatValueWithArray(tmp$ret$27);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$28 = new Float32Array([0.0]);
    var this_5 = DrawStaticMeshCommandConstructor(tmp_25, listOf([tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, UniformFloatValueWithArray(tmp$ret$28)]), stateBuilding, txSceneObjects);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_5.indexUniformModel = 1;
    tmp_24.commandBuildingsBloom = this_5;
    var stateRed = new DrawMeshState(Shaders_getInstance_5().z1k_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf_0(new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0)), 8));
    // Inline function 'kotlin.apply' call
    var tmp_37 = Meshes_getInstance_5().a1j_1;
    var tmp_38 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$30 = new Float32Array([1.0, 0.3, 0.3, 1.0]);
    var this_6 = new DrawTransformedMeshCommand(tmp_37, listOf([tmp_38, UniformFloatValueWithArray(tmp$ret$30)]), stateRed, txSceneObjects);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_6.hints = this.y1j_1;
    var commandRed = this_6;
    var stateDistant = new DrawMeshState(Shaders_getInstance_5().b1l_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_BYTE2_NORMALIZED_getInstance(), 6)]), 8));
    var commandBuildingsDistant = DrawStaticMeshCommandConstructor(Meshes_getInstance_5().z1i_1, listOf(arrayConcat([[UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_5().r1k_1)], this.d1k_1])), stateDistant, txSceneObjects);
    var commandBuildingsDistant2 = DrawStaticMeshCommandConstructor(Meshes_getInstance_5().z1i_1, listOf(arrayConcat([[UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_5().r1k_1)], this.d1k_1])), stateDistant, new AffineTranformation(new Vec3(0.0, 0.0, 0.0), new Vec3(0.0, 0.0, 180.0), new Vec3(this.z1j_1, this.z1j_1, this.z1j_1)));
    var stateGround = new DrawMeshState(Shaders_getInstance_5().c1l_1, get_BLENDING_NONE(), get_DEPTH_TEST_ENABLED(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf_0(new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0)), 8));
    var tmp_39 = Meshes_getInstance_5().b1j_1;
    var tmp_40 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$32 = new Float32Array([0.1171875, 0.1171875, 0.1171875, 1.0]);
    var commandIslands1 = DrawStaticMeshCommandConstructor(tmp_39, listOf(arrayConcat([[tmp_40, UniformFloatValueWithArray(tmp$ret$32)], this.d1k_1])), stateGround, txSceneObjects);
    var tmp_41 = Meshes_getInstance_5().c1j_1;
    var tmp_42 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$33 = new Float32Array([0.0, 0.01953125, 0.01953125, 1.0]);
    var commandWater = DrawStaticMeshCommandConstructor(tmp_41, listOf(arrayConcat([[tmp_42, UniformFloatValueWithArray(tmp$ret$33)], this.d1k_1])), stateGround, txSceneObjects);
    var tmp_43 = Shaders_getInstance_5().x1k_1;
    // Inline function 'kotlin.apply' call
    var this_7 = new Blending();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_7.enabled = true;
    this_7.sourceFactorColor = BlendingFactor_ONE_getInstance();
    this_7.destinationFactorColor = BlendingFactor_ONE_getInstance();
    this_7.isSeparateAlpha = false;
    var stateNeon = new DrawMeshState(tmp_43, this_7, get_DEPTH_NO_WRITE(), CullFace_BACK_getInstance(), new VertexAttributesDescriptor(listOf([new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_HALF3_getInstance(), 0), new VertexAttribute(AttributeType_UV0_getInstance(), 1, VertexFormat_UBYTE2_NORMALIZED_getInstance(), 6)]), 8));
    var commandNeon = DrawStaticMeshCommandConstructor(Meshes_getInstance_5().d1j_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_5().s1k_1)]), stateNeon, txSceneObjects);
    var commandNeonBloom = DrawStaticMeshCommandConstructor(Meshes_getInstance_5().d1j_1, listOf([UniformFloatValueWithArray(new Float32Array(16)), new UniformTextureValue(Textures_getInstance_5().v1k_1)]), stateNeon, txSceneObjects);
    var tmp_44 = Shaders_getInstance_5().d1l_1;
    // Inline function 'kotlin.apply' call
    var this_8 = new Blending();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_8.enabled = true;
    this_8.sourceFactorColor = BlendingFactor_ONE_getInstance();
    this_8.destinationFactorColor = BlendingFactor_ONE_getInstance();
    this_8.isSeparateAlpha = false;
    var stateRedSprites = new DrawMeshState(tmp_44, this_8, get_DEPTH_NO_WRITE(), CullFace_DISABLED_getInstance(), new VertexAttributesDescriptor(listOf_0(new VertexAttribute(AttributeType_VERTEX_getInstance(), 0, VertexFormat_FLOAT3_getInstance(), 0)), 12));
    // Inline function 'kotlin.apply' call
    var tmp_45 = Meshes_getInstance_5().e1j_1;
    var tmp_46 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$36 = new Float32Array([4.0]);
    var tmp_47 = UniformFloatValueWithArray(tmp$ret$36);
    var tmp_48 = new UniformTextureValue(Textures_getInstance_5().t1k_1);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$37 = new Float32Array([1.0, 0.2, 0.2, 1.0]);
    var this_9 = DrawStaticMeshCommandConstructor(tmp_45, listOf([tmp_46, tmp_47, tmp_48, UniformFloatValueWithArray(tmp$ret$37)]), stateRedSprites, txSceneObjects);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_9.primitiveType = PrimitiveType_POINTS_getInstance();
    var commandRedSprites = this_9;
    var tmp_49 = Shaders_getInstance_5().e1l_1;
    // Inline function 'kotlin.apply' call
    var this_10 = new Blending();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_10.enabled = true;
    this_10.sourceFactorColor = BlendingFactor_ONE_getInstance();
    this_10.destinationFactorColor = BlendingFactor_ONE_getInstance();
    this_10.isSeparateAlpha = false;
    var statePlanes = new DrawMeshState(tmp_49, this_10, get_DEPTH_NO_WRITE(), CullFace_DISABLED_getInstance(), null);
    var tmp_50 = this;
    // Inline function 'kotlin.apply' call
    var this_11 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[UniformFloatValueWithArray(new Float32Array(16))], this.l1k_1])), statePlanes, new AffineTranformation(new Vec3(0.0, 0.0, 380.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.z1j_1, this.z1j_1, this.z1j_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_11.primitiveType = PrimitiveType_POINTS_getInstance();
    this_11.primitiveCount = 1;
    tmp_50.f1k_1 = this_11;
    var tmp_51 = this;
    // Inline function 'kotlin.apply' call
    var this_12 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[UniformFloatValueWithArray(new Float32Array(16))], this.l1k_1])), statePlanes, new AffineTranformation(new Vec3(0.0, 0.0, 400.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.z1j_1, this.z1j_1, this.z1j_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_12.primitiveType = PrimitiveType_POINTS_getInstance();
    this_12.primitiveCount = 1;
    tmp_51.g1k_1 = this_12;
    var tmp_52 = this;
    // Inline function 'kotlin.apply' call
    var this_13 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[UniformFloatValueWithArray(new Float32Array(16))], this.l1k_1])), statePlanes, new AffineTranformation(new Vec3(0.0, 0.0, 350.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.z1j_1, this.z1j_1, this.z1j_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_13.primitiveType = PrimitiveType_POINTS_getInstance();
    this_13.primitiveCount = 1;
    tmp_52.h1k_1 = this_13;
    var tmp_53 = this;
    // Inline function 'kotlin.apply' call
    var this_14 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[UniformFloatValueWithArray(new Float32Array(16))], this.l1k_1])), statePlanes, new AffineTranformation(new Vec3(0.0, 0.0, 450.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.z1j_1, this.z1j_1, this.z1j_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_14.primitiveType = PrimitiveType_POINTS_getInstance();
    this_14.primitiveCount = 1;
    tmp_53.i1k_1 = this_14;
    var tmp_54 = this;
    // Inline function 'kotlin.apply' call
    var this_15 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[UniformFloatValueWithArray(new Float32Array(16))], this.l1k_1])), statePlanes, new AffineTranformation(new Vec3(0.0, 0.0, 430.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.z1j_1, this.z1j_1, this.z1j_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_15.primitiveType = PrimitiveType_POINTS_getInstance();
    this_15.primitiveCount = 1;
    tmp_54.j1k_1 = this_15;
    var tmp_55 = this;
    // Inline function 'kotlin.apply' call
    var this_16 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[UniformFloatValueWithArray(new Float32Array(16))], this.l1k_1])), statePlanes, new AffineTranformation(new Vec3(0.0, 0.0, 500.0), new Vec3(0.0, 0.0, 0.0), new Vec3(this.z1j_1, this.z1j_1, this.z1j_1)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_16.primitiveType = PrimitiveType_POINTS_getInstance();
    this_16.primitiveCount = 1;
    tmp_55.k1k_1 = this_16;
    var tmp_56 = this;
    // Inline function 'kotlin.apply' call
    var this_17 = new ClearCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_17.clearType = ClearCommandClearType_COLOR_AND_DEPTH_getInstance();
    tmp_56.t1j_1 = GroupCommandArr(true, [this.u1j_1, this_17]);
    // Inline function 'kotlin.apply' call
    var this_18 = new ClearCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_18.clearType = ClearCommandClearType_COLOR_AND_DEPTH_getInstance();
    var groupClearBloom = GroupCommandArr(true, [clearColorBloomCommand, this_18]);
    var tmp_57 = this;
    // Inline function 'kotlin.apply' call
    var this_19 = new VignetteCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_19.color0 = new Vec4(0.45, 0.45, 0.45, 1.0);
    this_19.color1 = new Vec4(1.0, 1.0, 1.0, 1.0);
    tmp_57.v1j_1 = this_19;
    var groupBloomPass = GroupCommandArr(true, [this.commandBuildingsBloom, commandRedSprites, commandNeonBloom]);
    var tmp_58 = this;
    // Inline function 'kotlin.apply' call
    var this_20 = new BlurredPassCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_20.name = 'bloom-objects';
    this_20.enabled = true;
    this_20.minSize = 180;
    this_20.brightness = 1.0;
    this_20.blurSize = BlurSize_KERNEL_4_getInstance();
    this_20.commands = mutableListOf([groupClearBloom, groupBloomPass]);
    this_20.id = 0;
    tmp_58.s1j_1 = this_20;
    var tmp_59 = this;
    // Inline function 'kotlin.apply' call
    var this_21 = new DrawBlurredCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_21.name = 'draw bloom';
    var tmp_60 = this_21;
    // Inline function 'kotlin.apply' call
    var this_22 = new Blending();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>.<anonymous>' call
    this_22.enabled = true;
    this_22.equationColor = BlendingEquation_ADD_getInstance();
    this_22.sourceFactorColor = BlendingFactor_ONE_getInstance();
    this_22.destinationFactorColor = BlendingFactor_ONE_getInstance();
    tmp_60.blending = this_22;
    tmp_59.x1j_1 = this_21;
    this.p1j_1 = GroupCommandArr(true, [this.s1j_1, MainPassCommandArr(true, [this.t1j_1, this.commandBuildings, commandRed, commandBuildingsDistant, commandBuildingsDistant2, commandIslands1, commandWater, this.commandStars, commandSky, this.f1k_1, this.g1k_1, this.h1k_1, this.i1k_1, this.j1k_1, this.k1k_1, commandNeon, this.x1j_1, this.v1j_1])]);
    var tmp_61 = this;
    // Inline function 'kotlin.apply' call
    var this_23 = new BlurredPassCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_23.name = 'blurred-main';
    this_23.enabled = true;
    this_23.minSize = 180;
    this_23.brightness = 0.95;
    this_23.blurSize = BlurSize_KERNEL_4_getInstance();
    this_23.commands = mutableListOf([groupClearBloom, this.commandBuildings, commandBuildingsDistant, commandBuildingsDistant2, commandIslands1, commandWater, commandSky, commandNeon, this.v1j_1]);
    tmp_61.r1j_1 = this_23;
    var tmp_62 = this;
    // Inline function 'kotlin.apply' call
    var this_24 = new DrawBlurredCommand();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.SkyscrapersScene.<anonymous>' call
    this_24.name = 'draw blurred';
    this_24.blending = get_BLENDING_NONE();
    tmp_62.w1j_1 = this_24;
    this.q1j_1 = GroupCommandArr(false, [this.r1j_1, MainPassCommandArr(true, [this.t1j_1, this.w1j_1])]);
    this.commands = mutableListOf([this.p1j_1, this.q1j_1]);
  }
  protoOf(SkyscrapersScene).ko = function () {
    return this.cameraAnimator;
  };
  protoOf(SkyscrapersScene).mo = function () {
    return this.settings;
  };
  protoOf(SkyscrapersScene).qo = function () {
    return this.commandStars;
  };
  protoOf(SkyscrapersScene).h1l = function () {
    return this.commandBuildings;
  };
  protoOf(SkyscrapersScene).i1l = function () {
    return this.commandBuildingsBloom;
  };
  protoOf(SkyscrapersScene).cp = function () {
    return this.PIf;
  };
  protoOf(SkyscrapersScene).updateTimers = function (time) {
    this.l1j_1.qj(time);
    this.cameraAnimator.animate(time);
    this.animate();
    protoOf(Scene).updateTimers.call(this, time);
  };
  protoOf(SkyscrapersScene).updateViewportSize = function (width, height) {
    protoOf(Scene).updateViewportSize.call(this, width, height);
  };
  protoOf(SkyscrapersScene).initialize = function () {
  };
  protoOf(SkyscrapersScene).applySettings = function () {
    this.p1j_1.enabled = !this.settings.blurred;
    this.q1j_1.enabled = this.settings.blurred;
    this.v1j_1.enabled = this.settings.vignette;
    this.r1j_1.additionalBlur = !this.settings.lowQuality;
    this.s1j_1.additionalBlur = !this.settings.lowQuality;
    setUniform_1(this.commandBuildings.uniforms.t(11), 1.0 - this.settings.lights);
    setUniform_1(this.commandBuildingsBloom.uniforms.t(11), 1.0 - this.settings.lights);
    if (!(this.cameraAnimator.minDurationCoefficient === this.settings.cameraPeriod)) {
      this.cameraAnimator.minDurationCoefficient = this.settings.cameraPeriod;
    }
    if ((this.cameraAnimator.timer > 0.99 ? this.settings.autoSwitchCameras : false) ? Default_getInstance().c6() < 0.5 : false) {
      this.randomCamera();
    }
  };
  protoOf(SkyscrapersScene).animate = function () {
    this.applySettings();
    this.calculateProjection();
    var cameraPositionInterpolator = this.cameraAnimator.positionInterpolator;
    var eye = cameraPositionInterpolator.cameraPosition;
    var lookat = cameraPositionInterpolator.cameraRotation;
    if (!this.useExternalViewMatrix) {
      Matrix_getInstance().di(this.matView, 0, eye.x, eye.y, eye.z, lookat.x, lookat.y, lookat.z, 0.0, 0.0, 1.0);
    }
    this.updatePlanes();
    this.updateMeshTransformations(this.commands);
    setUniform_6(this.commandBuildings.uniforms.t(4), eye);
    setUniform_6(this.commandBuildingsBloom.uniforms.t(4), eye);
  };
  protoOf(SkyscrapersScene).updatePlanes = function () {
    var angle1 = this.l1j_1.nj(Timers_Planes1_getInstance()) * this.PIf * 2.0;
    var angle2 = this.l1j_1.nj(Timers_Planes2_getInstance()) * this.PIf * 2.0;
    this.updatePlanePosition(angle1, 0.0, 0.0, this.f1k_1.transform.y9_1);
    this.updatePlanePosition(-angle2 - this.PIf, 0.0, -400.0, this.g1k_1.transform.y9_1);
    this.updatePlanePosition(-angle1 - this.PIf, 0.0, 300.0, this.h1k_1.transform.y9_1);
    this.updatePlanePosition(angle2, 100.0, 300.0, this.i1k_1.transform.y9_1);
    this.updatePlanePosition(angle1 + this.PIf / 2.0, 100.0, 300.0, this.j1k_1.transform.y9_1);
    this.updatePlanePosition(angle2 + this.PIf / 1.5, 100.0, 300.0, this.k1k_1.transform.y9_1);
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.min' call
    var a = this.viewportWidth;
    var b = this.viewportHeight;
    var b_0 = Math.min(a, b) / 300.0;
    var size = Math.max(2.5, b_0);
    setUniform_1(this.f1k_1.uniforms.t(1), size);
  };
  protoOf(SkyscrapersScene).updatePlanePosition = function (angle, centerX, centerY, result) {
    // Inline function 'kotlin.math.sin' call
    result.x = Math.sin(angle) * this.e1k_1 + centerX;
    // Inline function 'kotlin.math.cos' call
    result.y = Math.cos(angle) * this.e1k_1 + centerY;
  };
  protoOf(SkyscrapersScene).nextCamera = function () {
    this.cameraAnimator.nextCamera();
  };
  protoOf(SkyscrapersScene).randomCamera = function () {
    if (this.cameraAnimator.state.equals(CameraState_TRANSITIONING_getInstance())) {
      return Unit_instance;
    }
    this.cameraAnimator.positionInterpolator.reverse = Default_getInstance().c6() < 0.5;
    this.cameraAnimator.randomCamera();
  };
  protoOf(SkyscrapersScene).changeSpeed = function (impulse) {
    this.cameraAnimator.changeDirection(impulse);
  };
  function SkyscrapersSettings() {
    this.cameraPeriod = 1.0;
    this.vignette = true;
    this.blurred = false;
    this.autoSwitchCameras = true;
    this.lowQuality = false;
    this.clock = false;
    this.lights = 1.0;
  }
  protoOf(SkyscrapersSettings).fp = function (_set____db54di) {
    this.cameraPeriod = _set____db54di;
  };
  protoOf(SkyscrapersSettings).gp = function () {
    return this.cameraPeriod;
  };
  protoOf(SkyscrapersSettings).hp = function (_set____db54di) {
    this.vignette = _set____db54di;
  };
  protoOf(SkyscrapersSettings).ip = function () {
    return this.vignette;
  };
  protoOf(SkyscrapersSettings).jp = function (_set____db54di) {
    this.blurred = _set____db54di;
  };
  protoOf(SkyscrapersSettings).kp = function () {
    return this.blurred;
  };
  protoOf(SkyscrapersSettings).lp = function (_set____db54di) {
    this.autoSwitchCameras = _set____db54di;
  };
  protoOf(SkyscrapersSettings).mp = function () {
    return this.autoSwitchCameras;
  };
  protoOf(SkyscrapersSettings).rp = function (_set____db54di) {
    this.lowQuality = _set____db54di;
  };
  protoOf(SkyscrapersSettings).sp = function () {
    return this.lowQuality;
  };
  protoOf(SkyscrapersSettings).pp = function (_set____db54di) {
    this.clock = _set____db54di;
  };
  protoOf(SkyscrapersSettings).qp = function () {
    return this.clock;
  };
  protoOf(SkyscrapersSettings).j1l = function (_set____db54di) {
    this.lights = _set____db54di;
  };
  protoOf(SkyscrapersSettings).k1l = function () {
    return this.lights;
  };
  function Shaders_5() {
    Shaders_instance_5 = this;
    this.x1k_1 = new Shader('Diffuse');
    this.y1k_1 = new Shader('SkyDither');
    this.z1k_1 = new Shader('Color');
    this.a1l_1 = new Shader('Building');
    this.b1l_1 = new Shader('DiffuseFog');
    this.c1l_1 = new Shader('ColorFog');
    this.d1l_1 = new Shader('PointSpritesColored');
    this.e1l_1 = new Shader('PointSpriteColored');
    this.f1l_1 = mutableListOf([this.x1k_1, this.y1k_1, this.z1k_1, this.a1l_1, this.b1l_1, this.c1l_1, this.d1l_1, this.e1l_1]);
  }
  var Shaders_instance_5;
  function Shaders_getInstance_5() {
    if (Shaders_instance_5 == null)
      new Shaders_5();
    return Shaders_instance_5;
  }
  function Textures_5() {
    Textures_instance_5 = this;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.Textures.texSky.<anonymous>' call
    this_0.name = 'sky-night';
    this_0.fileName = 'sky-night';
    this_0.format = TextureFormat_ASTC_getInstance();
    this_0.minFilter = TextureFiltering_LINEAR_getInstance();
    this_0.magFilter = TextureFiltering_LINEAR_getInstance();
    this_0.wrapping = TextureWrapping_CLAMP_TO_EDGE_getInstance();
    tmp.m1k_1 = this_0;
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.Textures.texNoise.<anonymous>' call
    this_1.name = 'blue-noise-16';
    this_1.fileName = 'blue-noise-16';
    this_1.format = TextureFormat_ASTC_getInstance();
    this_1.minFilter = TextureFiltering_NEAREST_getInstance();
    this_1.magFilter = TextureFiltering_NEAREST_getInstance();
    tmp_0.n1k_1 = this_1;
    var tmp_1 = this;
    // Inline function 'kotlin.apply' call
    var this_2 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.Textures.texBuildingsDiffuse.<anonymous>' call
    this_2.name = 'diffuse2';
    this_2.fileName = 'diffuse2';
    this_2.format = TextureFormat_ASTC_getInstance();
    this_2.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_2.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_2.mipmaps = 11;
    tmp_1.o1k_1 = this_2;
    var tmp_2 = this;
    // Inline function 'kotlin.apply' call
    var this_3 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.Textures.texBuildingsEmission.<anonymous>' call
    this_3.name = 'emission2';
    this_3.fileName = 'emission2';
    this_3.format = TextureFormat_ASTC_getInstance();
    this_3.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_3.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_3.mipmaps = 11;
    tmp_2.p1k_1 = this_3;
    var tmp_3 = this;
    // Inline function 'kotlin.apply' call
    var this_4 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.Textures.texBuildingsCubemap.<anonymous>' call
    this_4.type = TextureType_CUBEMAP_getInstance();
    this_4.name = 'cubemaps/1/sky';
    this_4.fileName = 'cubemaps/1/sky';
    this_4.format = TextureFormat_ASTC_getInstance();
    this_4.minFilter = TextureFiltering_LINEAR_getInstance();
    this_4.magFilter = TextureFiltering_LINEAR_getInstance();
    tmp_3.q1k_1 = this_4;
    var tmp_4 = this;
    // Inline function 'kotlin.apply' call
    var this_5 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.Textures.texBuildingsDistant.<anonymous>' call
    this_5.name = 'distant';
    this_5.fileName = 'distant';
    this_5.format = TextureFormat_ASTC_getInstance();
    this_5.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_5.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_5.mipmaps = 8;
    tmp_4.r1k_1 = this_5;
    var tmp_5 = this;
    // Inline function 'kotlin.apply' call
    var this_6 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.Textures.texNeon.<anonymous>' call
    this_6.name = 'neon';
    this_6.fileName = 'neon';
    this_6.format = TextureFormat_ASTC_getInstance();
    this_6.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_6.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_6.mipmaps = 9;
    tmp_5.s1k_1 = this_6;
    var tmp_6 = this;
    // Inline function 'kotlin.apply' call
    var this_7 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.Textures.texFlare.<anonymous>' call
    this_7.name = 'flare';
    this_7.fileName = 'flare';
    this_7.format = TextureFormat_ASTC_getInstance();
    this_7.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_7.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_7.mipmaps = 3;
    tmp_6.t1k_1 = this_7;
    var tmp_7 = this;
    // Inline function 'kotlin.apply' call
    var this_8 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.Textures.texDust.<anonymous>' call
    this_8.name = 'dust';
    this_8.fileName = 'dust';
    this_8.format = TextureFormat_ASTC_getInstance();
    this_8.minFilter = TextureFiltering_NEAREST_getInstance();
    this_8.magFilter = TextureFiltering_NEAREST_getInstance();
    tmp_7.u1k_1 = this_8;
    var tmp_8 = this;
    // Inline function 'kotlin.apply' call
    var this_9 = new Texture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.skyscrapers.Textures.texNeon2.<anonymous>' call
    this_9.name = 'neon2';
    this_9.fileName = 'neon2';
    this_9.format = TextureFormat_ASTC_getInstance();
    this_9.minFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_9.magFilter = TextureFiltering_LINEAR_MIPMAP_LINEAR_getInstance();
    this_9.mipmaps = 5;
    tmp_8.v1k_1 = this_9;
    this.w1k_1 = mutableListOf([this.m1k_1, this.n1k_1, this.o1k_1, this.p1k_1, this.q1k_1, this.r1k_1, this.s1k_1, this.t1k_1, this.u1k_1, this.v1k_1]);
  }
  var Textures_instance_5;
  function Textures_getInstance_5() {
    if (Textures_instance_5 == null)
      new Textures_5();
    return Textures_instance_5;
  }
  var Timers_Planes1_instance;
  var Timers_Planes2_instance;
  function Companion_7() {
  }
  protoOf(Companion_7).g1l = function (timers) {
    timers.lj(Timers_Planes1_getInstance(), 80000.0);
    timers.lj(Timers_Planes2_getInstance(), 70000.0);
  };
  var Companion_instance_10;
  function Companion_getInstance_7() {
    return Companion_instance_10;
  }
  var Timers_entriesInitialized_5;
  function Timers_initEntries_5() {
    if (Timers_entriesInitialized_5)
      return Unit_instance;
    Timers_entriesInitialized_5 = true;
    Timers_Planes1_instance = new Timers_5('Planes1', 0);
    Timers_Planes2_instance = new Timers_5('Planes2', 1);
  }
  function Timers_5(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Timers_Planes1_getInstance() {
    Timers_initEntries_5();
    return Timers_Planes1_instance;
  }
  function Timers_Planes2_getInstance() {
    Timers_initEntries_5();
    return Timers_Planes2_instance;
  }
  function setBirdPosition_2(radius, angle, center, translation) {
    // Inline function 'kotlin.math.sin' call
    translation.x = Math.sin(angle) * radius + center.x;
    // Inline function 'kotlin.math.cos' call
    translation.y = Math.cos(angle) * radius + center.y;
  }
  function getBirdTextureAnimatedDrawCommand(mesh, state, height, scale) {
    return new DrawTransformedMeshCommand(mesh, listOf([UniformFloatValueWithArray(new Float32Array(16)), UniformFloatValueWithArray(new Float32Array(4)), UniformIntValueWithArray(new Int32Array(1)), UniformFloatValueWithArray(new Float32Array(1)), new UniformTextureValue(Textures_getInstance_4().p1h_1), UniformFloatValueWithArray(new Float32Array(4))]), state, new AffineTranformation(new Vec3(0.0, 0.0, height), new Vec3(0.0, 0.0, 0.0), scale));
  }
  function setColorTextureAnimationUniforms(timerAnim, animation, uniforms, startEndStart) {
    startEndStart = startEndStart === VOID ? true : startEndStart;
    var timer = timerAnim % 1.0;
    setUniform_2(uniforms.t(2), animation.vb_1);
    setUniform_1(uniforms.t(3), 1.0 / animation.ac_1);
    setUniform(uniforms.t(5), animation.vb_1, animation.xb_1, startEndStart ? animation.cc(timer) : animation.dc(timer), animation.bc_1);
  }
  function WindParams(segments, width, start, scale, batchHeights, amplitudes, frequencies, color, xSpread, yStart) {
    this.l1l_1 = segments;
    this.m1l_1 = width;
    this.n1l_1 = start;
    this.o1l_1 = scale;
    this.p1l_1 = batchHeights;
    this.q1l_1 = amplitudes;
    this.r1l_1 = frequencies;
    this.s1l_1 = color;
    this.t1l_1 = xSpread;
    this.u1l_1 = yStart;
  }
  protoOf(WindParams).toString = function () {
    return 'WindParams(segments=' + this.l1l_1 + ', width=' + this.m1l_1 + ', start=' + this.n1l_1 + ', scale=' + this.o1l_1 + ', batchHeights=' + this.p1l_1 + ', amplitudes=' + toString(this.q1l_1) + ', frequencies=' + toString(this.r1l_1) + ', color=' + this.s1l_1 + ', xSpread=' + this.t1l_1 + ', yStart=' + this.u1l_1 + ')';
  };
  protoOf(WindParams).hashCode = function () {
    var result = this.l1l_1;
    result = imul(result, 31) + getNumberHashCode(this.m1l_1) | 0;
    result = imul(result, 31) + this.n1l_1.hashCode() | 0;
    result = imul(result, 31) + this.o1l_1.hashCode() | 0;
    result = imul(result, 31) + this.p1l_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.q1l_1) | 0;
    result = imul(result, 31) + hashCode(this.r1l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s1l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t1l_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u1l_1) | 0;
    return result;
  };
  protoOf(WindParams).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WindParams))
      return false;
    var tmp0_other_with_cast = other instanceof WindParams ? other : THROW_CCE();
    if (!(this.l1l_1 === tmp0_other_with_cast.l1l_1))
      return false;
    if (!equals(this.m1l_1, tmp0_other_with_cast.m1l_1))
      return false;
    if (!this.n1l_1.equals(tmp0_other_with_cast.n1l_1))
      return false;
    if (!this.o1l_1.equals(tmp0_other_with_cast.o1l_1))
      return false;
    if (!this.p1l_1.equals(tmp0_other_with_cast.p1l_1))
      return false;
    if (!equals(this.q1l_1, tmp0_other_with_cast.q1l_1))
      return false;
    if (!equals(this.r1l_1, tmp0_other_with_cast.r1l_1))
      return false;
    if (!equals(this.s1l_1, tmp0_other_with_cast.s1l_1))
      return false;
    if (!equals(this.t1l_1, tmp0_other_with_cast.t1l_1))
      return false;
    if (!equals(this.u1l_1, tmp0_other_with_cast.u1l_1))
      return false;
    return true;
  };
  function Wind_init_$Init$(shader, params, $this) {
    Wind.call($this);
    $this.w1g_1 = shader;
    $this.x1g_1 = params;
    var tmp = $this;
    // Inline function 'kotlin.apply' call
    var this_0 = new Blending();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.utils.Wind.<init>.<anonymous>' call
    this_0.enabled = true;
    this_0.equationColor = BlendingEquation_ADD_getInstance();
    this_0.sourceFactorColor = BlendingFactor_ONE_getInstance();
    this_0.destinationFactorColor = BlendingFactor_ONE_getInstance();
    tmp.y1g_1 = new DrawMeshState(shader, this_0, get_DEPTH_NO_WRITE(), CullFace_DISABLED_getInstance(), null);
    var tmp_0 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$1 = new Float32Array([(params.l1l_1 - 1 | 0) * 2.0, params.m1l_1]);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.z1g_1 = [UniformFloatValueWithArray(tmp$ret$1), UniformFloatValueWithArray(params.q1l_1), UniformFloatValueWithArray(params.r1l_1)];
    var tmp_1 = $this;
    // Inline function 'kotlin.apply' call
    var tmp_2 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$5 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_3 = UniformFloatValueWithArray(tmp$ret$5);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$6 = new Float32Array([0.0, 0.0, 0.0]);
    var this_1 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_2, tmp_3, UniformFloatValueWithArray(tmp$ret$6)], $this.z1g_1])), $this.y1g_1, new AffineTranformation(new Vec3(params.n1l_1.x, params.n1l_1.y, params.p1l_1.x), new Vec3(0.0, 0.0, 0.0), params.o1l_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.utils.Wind.<init>.<anonymous>' call
    this_1.primitiveCount = imul(6, params.l1l_1);
    this_1.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_4 = this_1;
    // Inline function 'kotlin.apply' call
    var tmp_5 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$8 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_6 = UniformFloatValueWithArray(tmp$ret$8);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$9 = new Float32Array([0.0, 0.0, 0.0]);
    var this_2 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_5, tmp_6, UniformFloatValueWithArray(tmp$ret$9)], $this.z1g_1])), $this.y1g_1, new AffineTranformation(new Vec3(params.n1l_1.x, params.n1l_1.y, params.p1l_1.x), new Vec3(0.0, 0.0, 0.0), params.o1l_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.utils.Wind.<init>.<anonymous>' call
    this_2.primitiveCount = imul(6, params.l1l_1);
    this_2.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_7 = this_2;
    // Inline function 'kotlin.apply' call
    var tmp_8 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$11 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_9 = UniformFloatValueWithArray(tmp$ret$11);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$12 = new Float32Array([0.0, 0.0, 0.0]);
    var this_3 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_8, tmp_9, UniformFloatValueWithArray(tmp$ret$12)], $this.z1g_1])), $this.y1g_1, new AffineTranformation(new Vec3(params.n1l_1.x, params.n1l_1.y, params.p1l_1.x), new Vec3(0.0, 0.0, 0.0), params.o1l_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.utils.Wind.<init>.<anonymous>' call
    this_3.primitiveCount = imul(6, params.l1l_1);
    this_3.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_10 = this_3;
    // Inline function 'kotlin.apply' call
    var tmp_11 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$14 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_12 = UniformFloatValueWithArray(tmp$ret$14);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$15 = new Float32Array([0.0, 0.0, 0.0]);
    var this_4 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_11, tmp_12, UniformFloatValueWithArray(tmp$ret$15)], $this.z1g_1])), $this.y1g_1, new AffineTranformation(new Vec3(params.n1l_1.x, params.n1l_1.y, params.p1l_1.y), new Vec3(0.0, 0.0, 0.0), params.o1l_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.utils.Wind.<init>.<anonymous>' call
    this_4.primitiveCount = imul(6, params.l1l_1);
    this_4.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_13 = this_4;
    // Inline function 'kotlin.apply' call
    var tmp_14 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$17 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_15 = UniformFloatValueWithArray(tmp$ret$17);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$18 = new Float32Array([0.0, 0.0, 0.0]);
    var this_5 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_14, tmp_15, UniformFloatValueWithArray(tmp$ret$18)], $this.z1g_1])), $this.y1g_1, new AffineTranformation(new Vec3(params.n1l_1.x, params.n1l_1.y, params.p1l_1.y), new Vec3(0.0, 0.0, 0.0), params.o1l_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.utils.Wind.<init>.<anonymous>' call
    this_5.primitiveCount = imul(6, params.l1l_1);
    this_5.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_16 = this_5;
    // Inline function 'kotlin.apply' call
    var tmp_17 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$20 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_18 = UniformFloatValueWithArray(tmp$ret$20);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$21 = new Float32Array([0.0, 0.0, 0.0]);
    var this_6 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_17, tmp_18, UniformFloatValueWithArray(tmp$ret$21)], $this.z1g_1])), $this.y1g_1, new AffineTranformation(new Vec3(params.n1l_1.x, params.n1l_1.y, params.p1l_1.y), new Vec3(0.0, 0.0, 0.0), params.o1l_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.utils.Wind.<init>.<anonymous>' call
    this_6.primitiveCount = imul(6, params.l1l_1);
    this_6.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_19 = this_6;
    // Inline function 'kotlin.apply' call
    var tmp_20 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$23 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_21 = UniformFloatValueWithArray(tmp$ret$23);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$24 = new Float32Array([0.0, 0.0, 0.0]);
    var this_7 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_20, tmp_21, UniformFloatValueWithArray(tmp$ret$24)], $this.z1g_1])), $this.y1g_1, new AffineTranformation(new Vec3(params.n1l_1.x, params.n1l_1.y, params.p1l_1.z), new Vec3(0.0, 0.0, 0.0), params.o1l_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.utils.Wind.<init>.<anonymous>' call
    this_7.primitiveCount = imul(6, params.l1l_1);
    this_7.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_22 = this_7;
    // Inline function 'kotlin.apply' call
    var tmp_23 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$26 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_24 = UniformFloatValueWithArray(tmp$ret$26);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$27 = new Float32Array([0.0, 0.0, 0.0]);
    var this_8 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_23, tmp_24, UniformFloatValueWithArray(tmp$ret$27)], $this.z1g_1])), $this.y1g_1, new AffineTranformation(new Vec3(params.n1l_1.x, params.n1l_1.y, params.p1l_1.z), new Vec3(0.0, 0.0, 0.0), params.o1l_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.utils.Wind.<init>.<anonymous>' call
    this_8.primitiveCount = imul(6, params.l1l_1);
    this_8.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    var tmp_25 = this_8;
    // Inline function 'kotlin.apply' call
    var tmp_26 = UniformFloatValueWithArray(new Float32Array(16));
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$29 = new Float32Array([1.0, 1.0, 1.0, 1.0]);
    var tmp_27 = UniformFloatValueWithArray(tmp$ret$29);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$30 = new Float32Array([0.0, 0.0, 0.0]);
    var this_9 = new DrawTransformedMeshCommand(null, listOf(arrayConcat([[tmp_26, tmp_27, UniformFloatValueWithArray(tmp$ret$30)], $this.z1g_1])), $this.y1g_1, new AffineTranformation(new Vec3(params.n1l_1.x, params.n1l_1.y, params.p1l_1.z), new Vec3(0.0, 0.0, 0.0), params.o1l_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.androidworks.utils.Wind.<init>.<anonymous>' call
    this_9.primitiveCount = imul(6, params.l1l_1);
    this_9.primitiveDrawType = PrimitiveDrawType_NON_INDEXED_getInstance();
    tmp_1.a1h_1 = GroupCommandArr(true, [tmp_4, tmp_7, tmp_10, tmp_13, tmp_16, tmp_19, tmp_22, tmp_25, this_9]);
    return $this;
  }
  function Wind_init_$Create$(shader, params) {
    return Wind_init_$Init$(shader, params, objectCreate(protoOf(Wind)));
  }
  function animateWindBatch_0($this, offset, timerWindMove, timerPhase, randomWindCoeff) {
    var inductionVariable = 0;
    if (inductionVariable <= 2)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = $this.a1h_1.commands.t(offset + i | 0);
        var uniforms = (tmp instanceof DrawTransformedMeshCommand ? tmp : THROW_CCE()).uniforms;
        var timer = (timerWindMove + i * timerPhase) % 1.0;
        // Inline function 'kotlin.math.pow' call
        // Inline function 'kotlin.math.sin' call
        var x = timer * get_PIf();
        var this_0 = Math.sin(x);
        var a = Math.pow(this_0, 2.0);
        var color = $this.x1g_1.s1l_1 * a;
        var offsetX = -$this.x1g_1.t1l_1 + i * $this.x1g_1.t1l_1 + $this.x1g_1.t1l_1 * randomWindCoeff;
        var offsetY = $this.x1g_1.u1l_1 + timer * 2.0 * $this.x1g_1.l1l_1;
        setUniform(uniforms.t(1), color, color, color, 1.0);
        setUniform_3(uniforms.t(2), offsetX, offsetY * 10.0, 0.0);
      }
       while (inductionVariable <= 2);
  }
  protoOf(Wind).e1h = function (timer1, timer2, timer3) {
    animateWindBatch_0(this, 0, timer1, 0.36, this.b1h_1);
    animateWindBatch_0(this, 3, timer2, 0.37, this.c1h_1);
    animateWindBatch_0(this, 6, timer3, 0.38, this.d1h_1);
  };
  function Wind() {
    this.b1h_1 = Default_getInstance().c6() - 0.5;
    this.c1h_1 = Default_getInstance().c6() - 0.5;
    this.d1h_1 = Default_getInstance().c6() - 0.5;
  }
  //region block: post-declaration
  defineProp(protoOf(TimeOfDay), 'name', protoOf(TimeOfDay).o4);
  defineProp(protoOf(TimeOfDay), 'ordinal', protoOf(TimeOfDay).p4);
  defineProp(protoOf(TimeOfDay_0), 'name', protoOf(TimeOfDay_0).o4);
  defineProp(protoOf(TimeOfDay_0), 'ordinal', protoOf(TimeOfDay_0).p4);
  defineProp(protoOf(CameraMode), 'name', protoOf(CameraMode).o4);
  defineProp(protoOf(CameraMode), 'ordinal', protoOf(CameraMode).p4);
  defineProp(protoOf(ColorMode), 'name', protoOf(ColorMode).o4);
  defineProp(protoOf(ColorMode), 'ordinal', protoOf(ColorMode).p4);
  defineProp(protoOf(TimeOfDay_1), 'name', protoOf(TimeOfDay_1).o4);
  defineProp(protoOf(TimeOfDay_1), 'ordinal', protoOf(TimeOfDay_1).p4);
  defineProp(protoOf(CemeteryScene), 'totalDrawCalls', protoOf(CemeteryScene).m15);
  defineProp(protoOf(CemeteryScene), 'culledDrawCalls', protoOf(CemeteryScene).n15);
  defineProp(protoOf(TimeOfDay_2), 'name', protoOf(TimeOfDay_2).o4);
  defineProp(protoOf(TimeOfDay_2), 'ordinal', protoOf(TimeOfDay_2).p4);
  defineProp(protoOf(CameraMode_0), 'name', protoOf(CameraMode_0).o4);
  defineProp(protoOf(CameraMode_0), 'ordinal', protoOf(CameraMode_0).p4);
  defineProp(protoOf(ColorMode_0), 'name', protoOf(ColorMode_0).o4);
  defineProp(protoOf(ColorMode_0), 'ordinal', protoOf(ColorMode_0).p4);
  defineProp(protoOf(RenderMode), 'name', protoOf(RenderMode).o4);
  defineProp(protoOf(RenderMode), 'ordinal', protoOf(RenderMode).p4);
  defineProp(protoOf(ExampleScene), 'totalDrawCalls', protoOf(ExampleScene).m15);
  defineProp(protoOf(ExampleScene), 'culledDrawCalls', protoOf(ExampleScene).n15);
  defineProp(protoOf(TimeOfDay_3), 'name', protoOf(TimeOfDay_3).o4);
  defineProp(protoOf(TimeOfDay_3), 'ordinal', protoOf(TimeOfDay_3).p4);
  defineProp(protoOf(CameraMode_1), 'name', protoOf(CameraMode_1).o4);
  defineProp(protoOf(CameraMode_1), 'ordinal', protoOf(CameraMode_1).p4);
  defineProp(protoOf(ColorMode_1), 'name', protoOf(ColorMode_1).o4);
  defineProp(protoOf(ColorMode_1), 'ordinal', protoOf(ColorMode_1).p4);
  defineProp(protoOf(RenderMode_0), 'name', protoOf(RenderMode_0).o4);
  defineProp(protoOf(RenderMode_0), 'ordinal', protoOf(RenderMode_0).p4);
  defineProp(protoOf(TimeOfDay_4), 'name', protoOf(TimeOfDay_4).o4);
  defineProp(protoOf(TimeOfDay_4), 'ordinal', protoOf(TimeOfDay_4).p4);
  defineProp(protoOf(CameraMode_2), 'name', protoOf(CameraMode_2).o4);
  defineProp(protoOf(CameraMode_2), 'ordinal', protoOf(CameraMode_2).p4);
  defineProp(protoOf(ColorMode_2), 'name', protoOf(ColorMode_2).o4);
  defineProp(protoOf(ColorMode_2), 'ordinal', protoOf(ColorMode_2).p4);
  //endregion
  //region block: init
  Companion_instance_2 = new Companion();
  Companion_instance_3 = new Companion_0();
  Companion_instance_4 = new Companion_1();
  Companion_instance_5 = new Companion_2();
  Companion_instance_6 = new Companion_3();
  Companion_instance_7 = new Companion_4();
  Companion_instance_8 = new Companion_5();
  Companion_instance_9 = new Companion_6();
  Companion_instance_10 = new Companion_7();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$arctic = $org$androidworks.arctic || ($org$androidworks.arctic = {});
    $org$androidworks$arctic.ArcticScene = ArcticScene;
    $org$androidworks$arctic.ArcticScene.setAnimationUniforms$default = setAnimationUniforms$default;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$arctic = $org$androidworks.arctic || ($org$androidworks.arctic = {});
    $org$androidworks$arctic.TimeOfDay = TimeOfDay;
    $org$androidworks$arctic.TimeOfDay.values = values;
    $org$androidworks$arctic.TimeOfDay.valueOf = valueOf;
    defineProp($org$androidworks$arctic.TimeOfDay, 'Day', TimeOfDay_Day_getInstance);
    defineProp($org$androidworks$arctic.TimeOfDay, 'Night', TimeOfDay_Night_getInstance);
    defineProp($org$androidworks$arctic.TimeOfDay, 'Sunrise', TimeOfDay_Sunrise_getInstance);
    defineProp($org$androidworks$arctic.TimeOfDay, 'Sunset', TimeOfDay_Sunset_getInstance);
    $org$androidworks$arctic.ArcticSettings = ArcticSettings;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$brutalism = $org$androidworks.brutalism || ($org$androidworks.brutalism = {});
    $org$androidworks$brutalism.DrawClockCommand = DrawClockCommand;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$brutalism = $org$androidworks.brutalism || ($org$androidworks.brutalism = {});
    $org$androidworks$brutalism.BrutalismScene = BrutalismScene;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$brutalism = $org$androidworks.brutalism || ($org$androidworks.brutalism = {});
    $org$androidworks$brutalism.BrutalismSettings = BrutalismSettings;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$cartoonlighthouse = $org$androidworks.cartoonlighthouse || ($org$androidworks.cartoonlighthouse = {});
    $org$androidworks$cartoonlighthouse.CartoonLighthouseScene = CartoonLighthouseScene;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$cartoonlighthouse = $org$androidworks.cartoonlighthouse || ($org$androidworks.cartoonlighthouse = {});
    $org$androidworks$cartoonlighthouse.TimeOfDay = TimeOfDay_0;
    $org$androidworks$cartoonlighthouse.TimeOfDay.values = values_0;
    $org$androidworks$cartoonlighthouse.TimeOfDay.valueOf = valueOf_0;
    defineProp($org$androidworks$cartoonlighthouse.TimeOfDay, 'Day', TimeOfDay_Day_getInstance_0);
    defineProp($org$androidworks$cartoonlighthouse.TimeOfDay, 'Night', TimeOfDay_Night_getInstance_0);
    defineProp($org$androidworks$cartoonlighthouse.TimeOfDay, 'Sunrise', TimeOfDay_Sunrise_getInstance_0);
    defineProp($org$androidworks$cartoonlighthouse.TimeOfDay, 'Sunset', TimeOfDay_Sunset_getInstance_0);
    $org$androidworks$cartoonlighthouse.CameraMode = CameraMode;
    $org$androidworks$cartoonlighthouse.CameraMode.values = values_1;
    $org$androidworks$cartoonlighthouse.CameraMode.valueOf = valueOf_1;
    defineProp($org$androidworks$cartoonlighthouse.CameraMode, 'Random', CameraMode_Random_getInstance);
    defineProp($org$androidworks$cartoonlighthouse.CameraMode, 'Orbiting', CameraMode_Orbiting_getInstance);
    $org$androidworks$cartoonlighthouse.ColorMode = ColorMode;
    $org$androidworks$cartoonlighthouse.ColorMode.values = values_2;
    $org$androidworks$cartoonlighthouse.ColorMode.valueOf = valueOf_2;
    defineProp($org$androidworks$cartoonlighthouse.ColorMode, 'None', ColorMode_None_getInstance);
    defineProp($org$androidworks$cartoonlighthouse.ColorMode, 'Sepia', ColorMode_Sepia_getInstance_0);
    defineProp($org$androidworks$cartoonlighthouse.ColorMode, 'Greyscale', ColorMode_Greyscale_getInstance);
    $org$androidworks$cartoonlighthouse.CartoonLighthouseSettings = CartoonLighthouseSettings;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$cartoonplanes = $org$androidworks.cartoonplanes || ($org$androidworks.cartoonplanes = {});
    $org$androidworks$cartoonplanes.CartoonPlanesScene = CartoonPlanesScene;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$cartoonplanes = $org$androidworks.cartoonplanes || ($org$androidworks.cartoonplanes = {});
    $org$androidworks$cartoonplanes.TimeOfDay = TimeOfDay_1;
    $org$androidworks$cartoonplanes.TimeOfDay.values = values_3;
    $org$androidworks$cartoonplanes.TimeOfDay.valueOf = valueOf_3;
    defineProp($org$androidworks$cartoonplanes.TimeOfDay, 'Day', TimeOfDay_Day_getInstance_1);
    defineProp($org$androidworks$cartoonplanes.TimeOfDay, 'Night', TimeOfDay_Night_getInstance_1);
    defineProp($org$androidworks$cartoonplanes.TimeOfDay, 'Sunrise', TimeOfDay_Sunrise_getInstance_1);
    $org$androidworks$cartoonplanes.CartoonPlanesSettings = CartoonPlanesSettings;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$cemetery = $org$androidworks.cemetery || ($org$androidworks.cemetery = {});
    $org$androidworks$cemetery.CemeteryScene = CemeteryScene;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$cemetery = $org$androidworks.cemetery || ($org$androidworks.cemetery = {});
    $org$androidworks$cemetery.TimeOfDay = TimeOfDay_2;
    $org$androidworks$cemetery.TimeOfDay.values = values_4;
    $org$androidworks$cemetery.TimeOfDay.valueOf = valueOf_4;
    defineProp($org$androidworks$cemetery.TimeOfDay, 'Day', TimeOfDay_Day_getInstance_2);
    defineProp($org$androidworks$cemetery.TimeOfDay, 'Night', TimeOfDay_Night_getInstance_2);
    defineProp($org$androidworks$cemetery.TimeOfDay, 'Sunrise', TimeOfDay_Sunrise_getInstance_2);
    defineProp($org$androidworks$cemetery.TimeOfDay, 'Sunset', TimeOfDay_Sunset_getInstance_1);
    $org$androidworks$cemetery.CameraMode = CameraMode_0;
    $org$androidworks$cemetery.CameraMode.values = values_5;
    $org$androidworks$cemetery.CameraMode.valueOf = valueOf_5;
    defineProp($org$androidworks$cemetery.CameraMode, 'Random', CameraMode_Random_getInstance_0);
    defineProp($org$androidworks$cemetery.CameraMode, 'Orbiting', CameraMode_Orbiting_getInstance_0);
    $org$androidworks$cemetery.ColorMode = ColorMode_0;
    $org$androidworks$cemetery.ColorMode.values = values_6;
    $org$androidworks$cemetery.ColorMode.valueOf = valueOf_6;
    defineProp($org$androidworks$cemetery.ColorMode, 'None', ColorMode_None_getInstance_0);
    defineProp($org$androidworks$cemetery.ColorMode, 'Sepia', ColorMode_Sepia_getInstance_1);
    defineProp($org$androidworks$cemetery.ColorMode, 'Greyscale', ColorMode_Greyscale_getInstance_0);
    defineProp($org$androidworks$cemetery.ColorMode, 'HighContrast', ColorMode_HighContrast_getInstance);
    defineProp($org$androidworks$cemetery.ColorMode, 'LowContrast', ColorMode_LowContrast_getInstance);
    defineProp($org$androidworks$cemetery.ColorMode, 'LimitedColors', ColorMode_LimitedColors_getInstance);
    $org$androidworks$cemetery.RenderMode = RenderMode;
    $org$androidworks$cemetery.RenderMode.values = values_7;
    $org$androidworks$cemetery.RenderMode.valueOf = valueOf_7;
    defineProp($org$androidworks$cemetery.RenderMode, 'Complete', RenderMode_Complete_getInstance);
    defineProp($org$androidworks$cemetery.RenderMode, 'DiffuseOnly', RenderMode_DiffuseOnly_getInstance);
    defineProp($org$androidworks$cemetery.RenderMode, 'ModelNormals', RenderMode_ModelNormals_getInstance);
    defineProp($org$androidworks$cemetery.RenderMode, 'Lambert', RenderMode_Lambert_getInstance);
    defineProp($org$androidworks$cemetery.RenderMode, 'CompleteWithLm', RenderMode_CompleteWithLm_getInstance);
    defineProp($org$androidworks$cemetery.RenderMode, 'SsaoOnly', RenderMode_SsaoOnly_getInstance);
    $org$androidworks$cemetery.CemeterySettings = CemeterySettings;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$example = $org$androidworks.example || ($org$androidworks.example = {});
    $org$androidworks$example.ExampleScene = ExampleScene;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$example = $org$androidworks.example || ($org$androidworks.example = {});
    $org$androidworks$example.TimeOfDay = TimeOfDay_3;
    $org$androidworks$example.TimeOfDay.values = values_8;
    $org$androidworks$example.TimeOfDay.valueOf = valueOf_8;
    defineProp($org$androidworks$example.TimeOfDay, 'Day', TimeOfDay_Day_getInstance_3);
    defineProp($org$androidworks$example.TimeOfDay, 'Night', TimeOfDay_Night_getInstance_3);
    defineProp($org$androidworks$example.TimeOfDay, 'Sunrise', TimeOfDay_Sunrise_getInstance_3);
    defineProp($org$androidworks$example.TimeOfDay, 'Sunset', TimeOfDay_Sunset_getInstance_2);
    $org$androidworks$example.CameraMode = CameraMode_1;
    $org$androidworks$example.CameraMode.values = values_9;
    $org$androidworks$example.CameraMode.valueOf = valueOf_9;
    defineProp($org$androidworks$example.CameraMode, 'Random', CameraMode_Random_getInstance_1);
    defineProp($org$androidworks$example.CameraMode, 'Orbiting', CameraMode_Orbiting_getInstance_1);
    $org$androidworks$example.ColorMode = ColorMode_1;
    $org$androidworks$example.ColorMode.values = values_10;
    $org$androidworks$example.ColorMode.valueOf = valueOf_10;
    defineProp($org$androidworks$example.ColorMode, 'None', ColorMode_None_getInstance_1);
    defineProp($org$androidworks$example.ColorMode, 'Sepia', ColorMode_Sepia_getInstance_2);
    defineProp($org$androidworks$example.ColorMode, 'Greyscale', ColorMode_Greyscale_getInstance_1);
    $org$androidworks$example.RenderMode = RenderMode_0;
    $org$androidworks$example.RenderMode.values = values_11;
    $org$androidworks$example.RenderMode.valueOf = valueOf_11;
    defineProp($org$androidworks$example.RenderMode, 'Complete', RenderMode_Complete_getInstance_0);
    defineProp($org$androidworks$example.RenderMode, 'DiffuseOnly', RenderMode_DiffuseOnly_getInstance_0);
    defineProp($org$androidworks$example.RenderMode, 'ModelNormals', RenderMode_ModelNormals_getInstance_0);
    defineProp($org$androidworks$example.RenderMode, 'Lambert', RenderMode_Lambert_getInstance_0);
    defineProp($org$androidworks$example.RenderMode, 'CompleteWithLm', RenderMode_CompleteWithLm_getInstance_0);
    defineProp($org$androidworks$example.RenderMode, 'SsaoOnly', RenderMode_SsaoOnly_getInstance_0);
    $org$androidworks$example.ShipwreckSettings = ShipwreckSettings;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$shipwreck = $org$androidworks.shipwreck || ($org$androidworks.shipwreck = {});
    $org$androidworks$shipwreck.ShipwreckScene = ShipwreckScene;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$shipwreck = $org$androidworks.shipwreck || ($org$androidworks.shipwreck = {});
    $org$androidworks$shipwreck.TimeOfDay = TimeOfDay_4;
    $org$androidworks$shipwreck.TimeOfDay.values = values_12;
    $org$androidworks$shipwreck.TimeOfDay.valueOf = valueOf_12;
    defineProp($org$androidworks$shipwreck.TimeOfDay, 'Day', TimeOfDay_Day_getInstance_4);
    defineProp($org$androidworks$shipwreck.TimeOfDay, 'Night', TimeOfDay_Night_getInstance_4);
    defineProp($org$androidworks$shipwreck.TimeOfDay, 'Sunrise', TimeOfDay_Sunrise_getInstance_4);
    defineProp($org$androidworks$shipwreck.TimeOfDay, 'Sunset', TimeOfDay_Sunset_getInstance_3);
    $org$androidworks$shipwreck.CameraMode = CameraMode_2;
    $org$androidworks$shipwreck.CameraMode.values = values_13;
    $org$androidworks$shipwreck.CameraMode.valueOf = valueOf_13;
    defineProp($org$androidworks$shipwreck.CameraMode, 'Random', CameraMode_Random_getInstance_2);
    defineProp($org$androidworks$shipwreck.CameraMode, 'Orbiting', CameraMode_Orbiting_getInstance_2);
    $org$androidworks$shipwreck.ColorMode = ColorMode_2;
    $org$androidworks$shipwreck.ColorMode.values = values_14;
    $org$androidworks$shipwreck.ColorMode.valueOf = valueOf_14;
    defineProp($org$androidworks$shipwreck.ColorMode, 'None', ColorMode_None_getInstance_2);
    defineProp($org$androidworks$shipwreck.ColorMode, 'Sepia', ColorMode_Sepia_getInstance_3);
    defineProp($org$androidworks$shipwreck.ColorMode, 'Greyscale', ColorMode_Greyscale_getInstance_2);
    $org$androidworks$shipwreck.ShipwreckSettings = ShipwreckSettings_0;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$skyscrapers = $org$androidworks.skyscrapers || ($org$androidworks.skyscrapers = {});
    $org$androidworks$skyscrapers.SkyscrapersScene = SkyscrapersScene;
    var $org = _.org || (_.org = {});
    var $org$androidworks = $org.androidworks || ($org.androidworks = {});
    var $org$androidworks$skyscrapers = $org$androidworks.skyscrapers || ($org$androidworks.skyscrapers = {});
    $org$androidworks$skyscrapers.SkyscrapersSettings = SkyscrapersSettings;
  }
  $jsExportAll$(_);
  kotlin_org_androidworks_engine_engine.$jsExportAll$(_);
  //endregion
  return _;
}));

//# sourceMappingURL=KMP-library-shared.js.map
